/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ([
/* 0 */,
/* 1 */
/***/ (function(module) {

    (function (global, factory) {
        true ? module.exports = factory() :
       0;
   }(this, (function () { 'use strict';
   
   var root = document;
   var createText = root.createTextNode.bind(root);
   
   /**
    * # setProperty
    * Apply a CSS var
    * @param {HTMLElement} el
    * @param {string} varName 
    * @param {string|number} value 
    */
   function setProperty(el, varName, value) {
       el.style.setProperty(varName, value);
   } 
   
   /**
    * 
    * @param {!HTMLElement} el 
    * @param {!HTMLElement} child 
    */
   function appendChild(el, child) {
     return el.appendChild(child);
   }
   
   /**
    * 
    * @param {!HTMLElement} parent 
    * @param {string} key 
    * @param {string} text 
    * @param {boolean} whitespace 
    */
   function createElement(parent, key, text, whitespace) {
     var el = root.createElement('span');
     key && (el.className = key); 
     if (text) { 
         !whitespace && el.setAttribute("data-" + key, text);
         el.textContent = text; 
     }
     return (parent && appendChild(parent, el)) || el;
   }
   
   /**
    * 
    * @param {!HTMLElement} el 
    * @param {string} key 
    */
   function getData(el, key) {
     return el.getAttribute("data-" + key)
   }
   
   /**
    * 
    * @param {import('../types').Target} e 
    * @param {!HTMLElement} parent
    * @returns {!Array<!HTMLElement>}
    */
   function $(e, parent) {
       return !e || e.length == 0
           ? // null or empty string returns empty array
             []
           : e.nodeName
               ? // a single element is wrapped in an array
                 [e]
               : // selector and NodeList are converted to Element[]
                 [].slice.call(e[0].nodeName ? e : (parent || root).querySelectorAll(e));
   }
   
   /**
    * Creates and fills an array with the value provided
    * @param {number} len
    * @param {() => T} valueProvider
    * @return {T}
    * @template T
    */
   function Array2D(len) {
       var a = [];
       for (; len--; ) {
           a[len] = [];
       }
       return a;
   }
   
   /**
    * A for loop wrapper used to reduce js minified size.
    * @param {!Array<T>} items 
    * @param {function(T):void} consumer
    * @template T
    */
   function each(items, consumer) {
       items && items.some(consumer);
   }
   
   /**
    * @param {T} obj 
    * @return {function(string):*}
    * @template T
    */
   function selectFrom(obj) {
       return function (key) {
           return obj[key];
       }
   }
   
   /**
    * # Splitting.index
    * Index split elements and add them to a Splitting instance.
    *
    * @param {HTMLElement} element
    * @param {string} key 
    * @param {!Array<!HTMLElement> | !Array<!Array<!HTMLElement>>} items 
    */
   function index(element, key, items) {
       var prefix = '--' + key;
       var cssVar = prefix + "-index";
   
       each(items, function (items, i) {
           if (Array.isArray(items)) {
               each(items, function(item) {
                   setProperty(item, cssVar, i);
               });
           } else {
               setProperty(items, cssVar, i);
           }
       });
   
       setProperty(element, prefix + "-total", items.length);
   }
   
   /**
    * @type {Record<string, import('./types').ISplittingPlugin>}
    */
   var plugins = {};
   
   /**
    * @param {string} by
    * @param {string} parent
    * @param {!Array<string>} deps
    * @return {!Array<string>}
    */
   function resolvePlugins(by, parent, deps) {
       // skip if already visited this dependency
       var index = deps.indexOf(by);
       if (index == -1) {
           // if new to dependency array, add to the beginning
           deps.unshift(by);
   
           // recursively call this function for all dependencies
           var plugin = plugins[by];
           if (!plugin) {
               throw new Error("plugin not loaded: " + by);
           }
           each(plugin.depends, function(p) {
               resolvePlugins(p, by, deps);
           });
       } else {
           // if this dependency was added already move to the left of
           // the parent dependency so it gets loaded in order
           var indexOfParent = deps.indexOf(parent);
           deps.splice(index, 1);
           deps.splice(indexOfParent, 0, by);
       }
       return deps;
   }
   
   /**
    * Internal utility for creating plugins... essentially to reduce
    * the size of the library
    * @param {string} by 
    * @param {string} key 
    * @param {string[]} depends 
    * @param {Function} split 
    * @returns {import('./types').ISplittingPlugin}
    */
   function createPlugin(by, depends, key, split) {
       return {
           by: by,
           depends: depends,
           key: key,
           split: split
       }
   }
   
   /**
    *
    * @param {string} by
    * @returns {import('./types').ISplittingPlugin[]}
    */
   function resolve(by) {
       return resolvePlugins(by, 0, []).map(selectFrom(plugins));
   }
   
   /**
    * Adds a new plugin to splitting
    * @param {import('./types').ISplittingPlugin} opts
    */
   function add(opts) {
       plugins[opts.by] = opts;
   }
   
   /**
    * # Splitting.split
    * Split an element's textContent into individual elements
    * @param {!HTMLElement} el  Element to split
    * @param {string} key 
    * @param {string} splitOn 
    * @param {boolean} includePrevious 
    * @param {boolean} preserveWhitespace
    * @return {!Array<!HTMLElement>}
    */
   function splitText(el, key, splitOn, includePrevious, preserveWhitespace) {
       // Combine any strange text nodes or empty whitespace.
       el.normalize();
   
       // Use fragment to prevent unnecessary DOM thrashing.
       var elements = [];
       var F = document.createDocumentFragment();
   
       if (includePrevious) {
           elements.push(el.previousSibling);
       }
   
       var allElements = [];
       $(el.childNodes).some(function(next) {
           if (next.tagName && !next.hasChildNodes()) {
               // keep elements without child nodes (no text and no children)
               allElements.push(next);
               return;
           }
           // Recursively run through child nodes
           if (next.childNodes && next.childNodes.length) {
               allElements.push(next);
               elements.push.apply(elements, splitText(next, key, splitOn, includePrevious, preserveWhitespace));
               return;
           }
   
           // Get the text to split, trimming out the whitespace
           /** @type {string} */
           var wholeText = next.wholeText || '';
           var contents = wholeText.trim();
   
           // If there's no text left after trimming whitespace, continue the loop
           if (contents.length) {
               // insert leading space if there was one
               if (wholeText[0] === ' ') {
                   allElements.push(createText(' '));
               }
               // Concatenate the split text children back into the full array
               var useSegmenter = splitOn === "" && typeof Intl.Segmenter === "function";
               each(useSegmenter ? Array.from(new Intl.Segmenter().segment(contents)).map(function(x){return x.segment}) : contents.split(splitOn), function (splitText, i) {
                   if (i && preserveWhitespace) {
                       allElements.push(createElement(F, "whitespace", " ", preserveWhitespace));
                   }
                   var splitEl = createElement(F, key, splitText);
                   elements.push(splitEl);
                   allElements.push(splitEl);
               }); 
               // insert trailing space if there was one
               if (wholeText[wholeText.length - 1] === ' ') {
                   allElements.push(createText(' '));
               }
           }
       });
   
       each(allElements, function(el) {
           appendChild(F, el);
       });
   
       // Clear out the existing element
       el.innerHTML = "";
       appendChild(el, F);
       return elements;
   }
   
   /** an empty value */
   var _ = 0;
   
   function copy(dest, src) {
       for (var k in src) {
           dest[k] = src[k];
       }
       return dest;
   }
   
   var WORDS = 'words';
   
   var wordPlugin = createPlugin(
       /* by= */ WORDS,
       /* depends= */ _,
       /* key= */ 'word', 
       /* split= */ function(el) {
           return splitText(el, 'word', /\s+/, 0, 1)
       }
   );
   
   var CHARS = "chars";
   
   var charPlugin = createPlugin(
       /* by= */ CHARS,
       /* depends= */ [WORDS],
       /* key= */ "char", 
       /* split= */ function(el, options, ctx) {
           var results = [];
   
           each(ctx[WORDS], function(word, i) {
               results.push.apply(results, splitText(word, "char", "", options.whitespace && i));
           });
   
           return results;
       }
   );
   
   /**
    * # Splitting
    * 
    * @param {import('./types').ISplittingOptions} opts
    * @return {!Array<*>}
    */
   function Splitting (opts) {
     opts = opts || {};
     var key = opts.key;
   
     return $(opts.target || '[data-splitting]').map(function(el) {
       var ctx = el['🍌'];  
       if (!opts.force && ctx) {
         return ctx;
       }
   
       ctx = el['🍌'] = { el: el };
       var by = opts.by || getData(el, 'splitting');
       if (!by || by == 'true') {
         by = CHARS;
       }
       var items = resolve(by);
       var opts2 = copy({}, opts);
       each(items, function(plugin) {
         if (plugin.split) {
           var pluginBy = plugin.by;
           var key2 = (key ? '-' + key : '') + plugin.key;
           var results = plugin.split(el, opts2, ctx);
           key2 && index(el, key2, results);
           ctx[pluginBy] = results;
           el.classList.add(pluginBy);
         } 
       });
   
       el.classList.add('splitting');
       return ctx;
     })
   }
   
   /**
    * # Splitting.html
    * 
    * @param {import('./types').ISplittingOptions} opts
    */
   function html(opts) {
     opts = opts || {};
     var parent = opts.target =  createElement();
     parent.innerHTML = opts.content;
     Splitting(opts);
     return parent.outerHTML
   }
   
   Splitting.html = html;
   Splitting.add = add;
   
   /**
    * Detects the grid by measuring which elements align to a side of it.
    * @param {!HTMLElement} el 
    * @param {import('../core/types').ISplittingOptions} options
    * @param {*} side 
    */
   function detectGrid(el, options, side) {
       var items = $(options.matching || el.children, el);
       var c = {};
   
       each(items, function(w) {
           var val = Math.round(w[side]);
           (c[val] || (c[val] = [])).push(w);
       });
   
       return Object.keys(c).map(Number).sort(byNumber).map(selectFrom(c));
   }
   
   /**
    * Sorting function for numbers.
    * @param {number} a 
    * @param {number} b
    * @return {number} 
    */
   function byNumber(a, b) {
       return a - b;
   }
   
   var linePlugin = createPlugin(
       /* by= */ 'lines',
       /* depends= */ [WORDS],
       /* key= */ 'line',
       /* split= */ function(el, options, ctx) {
         return detectGrid(el, { matching: ctx[WORDS] }, 'offsetTop')
       }
   );
   
   var itemPlugin = createPlugin(
       /* by= */ 'items',
       /* depends= */ _,
       /* key= */ 'item', 
       /* split= */ function(el, options) {
           return $(options.matching || el.children, el)
       }
   );
   
   var rowPlugin = createPlugin(
       /* by= */ 'rows',
       /* depends= */ _,
       /* key= */ 'row', 
       /* split= */ function(el, options) {
           return detectGrid(el, options, "offsetTop");
       }
   );
   
   var columnPlugin = createPlugin(
       /* by= */ 'cols',
       /* depends= */ _,
       /* key= */ "col", 
       /* split= */ function(el, options) {
           return detectGrid(el, options, "offsetLeft");
       }
   );
   
   var gridPlugin = createPlugin(
       /* by= */ 'grid',
       /* depends= */ ['rows', 'cols']
   );
   
   var LAYOUT = "layout";
   
   var layoutPlugin = createPlugin(
       /* by= */ LAYOUT,
       /* depends= */ _,
       /* key= */ _,
       /* split= */ function(el, opts) {
           // detect and set options
           var rows =  opts.rows = +(opts.rows || getData(el, 'rows') || 1);
           var columns = opts.columns = +(opts.columns || getData(el, 'columns') || 1);
   
           // Seek out the first <img> if the value is true 
           opts.image = opts.image || getData(el, 'image') || el.currentSrc || el.src;
           if (opts.image) {
               var img = $("img", el)[0];
               opts.image = img && (img.currentSrc || img.src);
           }
   
           // add optional image to background
           if (opts.image) {
               setProperty(el, "background-image", "url(" + opts.image + ")");
           }
   
           var totalCells = rows * columns;
           var elements = [];
   
           var container = createElement(_, "cell-grid");
           while (totalCells--) {
               // Create a span
               var cell = createElement(container, "cell");
               createElement(cell, "cell-inner");
               elements.push(cell);
           }
   
           // Append elements back into the parent
           appendChild(el, container);
   
           return elements;
       }
   );
   
   var cellRowPlugin = createPlugin(
       /* by= */ "cellRows",
       /* depends= */ [LAYOUT],
       /* key= */ "row",
       /* split= */ function(el, opts, ctx) {
           var rowCount = opts.rows;
           var result = Array2D(rowCount);
   
           each(ctx[LAYOUT], function(cell, i, src) {
               result[Math.floor(i / (src.length / rowCount))].push(cell);
           });
   
           return result;
       }
   );
   
   var cellColumnPlugin = createPlugin(
       /* by= */ "cellColumns",
       /* depends= */ [LAYOUT],
       /* key= */ "col",
       /* split= */ function(el, opts, ctx) {
           var columnCount = opts.columns;
           var result = Array2D(columnCount);
   
           each(ctx[LAYOUT], function(cell, i) {
               result[i % columnCount].push(cell);
           });
   
           return result;
       }
   );
   
   var cellPlugin = createPlugin(
       /* by= */ "cells",
       /* depends= */ ['cellRows', 'cellColumns'],
       /* key= */ "cell", 
       /* split= */ function(el, opt, ctx) { 
           // re-index the layout as the cells
           return ctx[LAYOUT];
       }
   );
   
   // install plugins
   // word/char plugins
   add(wordPlugin);
   add(charPlugin);
   add(linePlugin);
   // grid plugins
   add(itemPlugin);
   add(rowPlugin);
   add(columnPlugin);
   add(gridPlugin);
   // cell-layout plugins
   add(layoutPlugin);
   add(cellRowPlugin);
   add(cellColumnPlugin);
   add(cellPlugin);
   
   return Splitting;
   
   })));
   
   
   /***/ }),
   /* 2 */
   /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
   
   "use strict";
   __webpack_require__.r(__webpack_exports__);
   /* harmony export */ __webpack_require__.d(__webpack_exports__, {
   /* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
   /* harmony export */ });
   /* harmony import */ var _libs_lenis_min_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
   /* harmony import */ var _libs_lenis_min_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_libs_lenis_min_js__WEBPACK_IMPORTED_MODULE_0__);
   /* harmony import */ var lenis__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
   /* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5);
   /* harmony import */ var gsap_ScrollTrigger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8);
   function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
   function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
   function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
   function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
   function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
   function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
   
   
   
   
   var LenisController = /*#__PURE__*/function () {
     function LenisController() {
       _classCallCheck(this, LenisController);
       this.root = document.getElementById('page');
     }
     return _createClass(LenisController, [{
       key: "getHeaderOffset",
       value: function getHeaderOffset() {
         var header = document.getElementById('headerFixed');
         return header ? -header.offsetHeight : 0;
       }
     }, {
       key: "init",
       value: function init() {
         var _this = this;
         var lerp = .07;
         if (window.innerWidth < 750) {
           lerp = 1;
         }
         var easeInOutCubic = function easeInOutCubic(x) {
           return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
         };
         this.lenisInstance = new lenis__WEBPACK_IMPORTED_MODULE_1__["default"]({
           lerp: lerp,
           smooth: true,
           smoothTouch: true,
           direction: "vertical"
         });
         var scrollTrigger = document.getElementsByClassName('scroll-trigger');
         var menuTrigger = document.getElementsByClassName('menu-trigger');
         var menu = document.getElementById('menu');
         var _loop = function _loop() {
           var target = document.getElementById(scrollTrigger[i].getAttribute('data-target'));
           scrollTrigger[i].addEventListener('click', function () {
             _this.lenisInstance.scrollTo(target, {
               duration: 1,
               easing: easeInOutCubic,
               offset: _this.getHeaderOffset() // ヘッダーの高さ分オフセット
             });
           });
         };
         for (var i = 0; i < scrollTrigger.length; i++) {
           _loop();
         }
         this.lenisInstance.on('scroll', function (e) {
           gsap_ScrollTrigger__WEBPACK_IMPORTED_MODULE_3__["default"].update();
         });
         gsap__WEBPACK_IMPORTED_MODULE_2__["default"].ticker.add(function (time) {
           _this.lenisInstance.raf(time * 1000);
         });
       }
     }, {
       key: "checkPosition",
       value: function checkPosition() {
         if (window.location.hash) {
           var hashId = window.location.hash.substring(1);
           var targetElement = document.getElementById(hashId);
           if (targetElement) {
             console.log(targetElement);
             this.lenisInstance.scrollTo(targetElement, {
               immediate: true,
               offset: this.getHeaderOffset() // ヘッダーの高さ分オフセット
             });
           }
         } else {
           window.scrollTo(0, 0);
         }
       }
     }]);
   }();
   /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (LenisController);
   
   /***/ }),
   /* 3 */
   /***/ (function(module, exports, __webpack_require__) {
   
   var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
   !function (t, e) {
     "object" == ( false ? 0 : _typeof(exports)) && "undefined" != "object" ? module.exports = e() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (e),
           __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
           (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
           __WEBPACK_AMD_DEFINE_FACTORY__),
           __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : 0;
   }(this, function () {
     function t(t, e) {
       for (var i = 0; i < e.length; i++) {
         var o = e[i];
         o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, "symbol" == _typeof(n = function (t, e) {
           if ("object" != _typeof(t) || null === t) return t;
           var i = t[Symbol.toPrimitive];
           if (void 0 !== i) {
             var o = i.call(t, "string");
             if ("object" != _typeof(o)) return o;
             throw new TypeError("@@toPrimitive must return a primitive value.");
           }
           return String(t);
         }(o.key)) ? n : String(n), o);
       }
       var n;
     }
     function e(e, i, o) {
       return i && t(e.prototype, i), o && t(e, o), Object.defineProperty(e, "prototype", {
         writable: !1
       }), e;
     }
     function i() {
       return i = Object.assign ? Object.assign.bind() : function (t) {
         for (var e = 1; e < arguments.length; e++) {
           var i = arguments[e];
           for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (t[o] = i[o]);
         }
         return t;
       }, i.apply(this, arguments);
     }
     function o(t, e, i) {
       return Math.max(t, Math.min(e, i));
     }
     var n = /*#__PURE__*/function () {
         function t() {}
         var e = t.prototype;
         return e.advance = function (t) {
           var e, i, n, s;
           if (this.isRunning) {
             var r = !1;
             if (this.lerp) this.value = (i = this.value, n = this.to, (1 - (s = 1 - Math.exp(-60 * this.lerp * t))) * i + s * n), Math.round(this.value) === this.to && (this.value = this.to, r = !0);else {
               this.currentTime += t;
               var l = o(0, this.currentTime / this.duration, 1),
                 h = (r = l >= 1) ? 1 : this.easing(l);
               this.value = this.from + (this.to - this.from) * h;
             }
             null == (e = this.onUpdate) || e.call(this, this.value, r), r && this.stop();
           }
         }, e.stop = function () {
           this.isRunning = !1;
         }, e.fromTo = function (t, e, i) {
           var o = i.lerp,
             n = void 0 === o ? .1 : o,
             s = i.duration,
             r = void 0 === s ? 1 : s,
             l = i.easing,
             h = void 0 === l ? function (t) {
               return t;
             } : l,
             a = i.onStart,
             c = i.onUpdate;
           this.from = this.value = t, this.to = e, this.lerp = n, this.duration = r, this.easing = h, this.currentTime = 0, this.isRunning = !0, null == a || a(), this.onUpdate = c;
         }, t;
       }(),
       s = /*#__PURE__*/function () {
         function t(t) {
           var e,
             i,
             o = this,
             n = void 0 === t ? {} : t,
             s = n.wrapper,
             r = n.content,
             l = n.autoResize,
             h = void 0 === l || l;
           if (this.resize = function () {
             o.onWrapperResize(), o.onContentResize();
           }, this.onWrapperResize = function () {
             o.wrapper === window ? (o.width = window.innerWidth, o.height = window.innerHeight) : (o.width = o.wrapper.clientWidth, o.height = o.wrapper.clientHeight);
           }, this.onContentResize = function () {
             o.scrollHeight = o.content.scrollHeight, o.scrollWidth = o.content.scrollWidth;
           }, this.wrapper = s, this.content = r, h) {
             var a = (e = this.resize, function () {
               var t = arguments,
                 o = this;
               clearTimeout(i), i = setTimeout(function () {
                 e.apply(o, t);
               }, 250);
             });
             this.wrapper !== window && (this.wrapperResizeObserver = new ResizeObserver(a), this.wrapperResizeObserver.observe(this.wrapper)), this.contentResizeObserver = new ResizeObserver(a), this.contentResizeObserver.observe(this.content);
           }
           this.resize();
         }
         return t.prototype.destroy = function () {
           var t, e;
           null == (t = this.wrapperResizeObserver) || t.disconnect(), null == (e = this.contentResizeObserver) || e.disconnect();
         }, e(t, [{
           key: "limit",
           get: function get() {
             return {
               x: this.scrollWidth - this.width,
               y: this.scrollHeight - this.height
             };
           }
         }]), t;
       }(),
       r = /*#__PURE__*/function () {
         function t() {
           this.events = {};
         }
         var e = t.prototype;
         return e.emit = function (t) {
           for (var e = this.events[t] || [], i = 0, o = e.length; i < o; i++) e[i].apply(e, [].slice.call(arguments, 1));
         }, e.on = function (t, e) {
           var i,
             o = this;
           return (null == (i = this.events[t]) ? void 0 : i.push(e)) || (this.events[t] = [e]), function () {
             var i;
             o.events[t] = null == (i = o.events[t]) ? void 0 : i.filter(function (t) {
               return e !== t;
             });
           };
         }, e.off = function (t, e) {
           var i;
           this.events[t] = null == (i = this.events[t]) ? void 0 : i.filter(function (t) {
             return e !== t;
           });
         }, e.destroy = function () {
           this.events = {};
         }, t;
       }(),
       l = /*#__PURE__*/function () {
         function t(t, e) {
           var i = this,
             n = e.wheelMultiplier,
             s = void 0 === n ? 1 : n,
             l = e.touchMultiplier,
             h = void 0 === l ? 2 : l,
             a = e.normalizeWheel,
             c = void 0 !== a && a;
           this.onTouchStart = function (t) {
             var e = t.targetTouches ? t.targetTouches[0] : t,
               o = e.clientY;
             i.touchStart.x = e.clientX, i.touchStart.y = o, i.lastDelta = {
               x: 0,
               y: 0
             };
           }, this.onTouchMove = function (t) {
             var e = t.targetTouches ? t.targetTouches[0] : t,
               o = e.clientX,
               n = e.clientY,
               s = -(o - i.touchStart.x) * i.touchMultiplier,
               r = -(n - i.touchStart.y) * i.touchMultiplier;
             i.touchStart.x = o, i.touchStart.y = n, i.lastDelta = {
               x: s,
               y: r
             }, i.emitter.emit("scroll", {
               deltaX: s,
               deltaY: r,
               event: t
             });
           }, this.onTouchEnd = function (t) {
             i.emitter.emit("scroll", {
               deltaX: i.lastDelta.x,
               deltaY: i.lastDelta.y,
               event: t
             });
           }, this.onWheel = function (t) {
             var e = t.deltaX,
               n = t.deltaY;
             i.normalizeWheel && (e = o(-100, e, 100), n = o(-100, n, 100)), i.emitter.emit("scroll", {
               deltaX: e *= i.wheelMultiplier,
               deltaY: n *= i.wheelMultiplier,
               event: t
             });
           }, this.element = t, this.wheelMultiplier = s, this.touchMultiplier = h, this.normalizeWheel = c, this.touchStart = {
             x: null,
             y: null
           }, this.emitter = new r(), this.element.addEventListener("wheel", this.onWheel, {
             passive: !1
           }), this.element.addEventListener("touchstart", this.onTouchStart, {
             passive: !1
           }), this.element.addEventListener("touchmove", this.onTouchMove, {
             passive: !1
           }), this.element.addEventListener("touchend", this.onTouchEnd, {
             passive: !1
           });
         }
         var e = t.prototype;
         return e.on = function (t, e) {
           return this.emitter.on(t, e);
         }, e.destroy = function () {
           this.emitter.destroy(), this.element.removeEventListener("wheel", this.onWheel, {
             passive: !1
           }), this.element.removeEventListener("touchstart", this.onTouchStart, {
             passive: !1
           }), this.element.removeEventListener("touchmove", this.onTouchMove, {
             passive: !1
           }), this.element.removeEventListener("touchend", this.onTouchEnd, {
             passive: !1
           });
         }, t;
       }(); /*#__PURE__*/
     return function () {
       function t(t) {
         var e = this,
           o = void 0 === t ? {} : t,
           h = o.wrapper,
           a = void 0 === h ? window : h,
           c = o.content,
           u = void 0 === c ? document.documentElement : c,
           p = o.wheelEventsTarget,
           d = void 0 === p ? a : p,
           v = o.eventsTarget,
           f = void 0 === v ? d : v,
           m = o.smoothWheel,
           g = void 0 === m || m,
           S = o.smoothTouch,
           y = void 0 !== S && S,
           w = o.syncTouch,
           T = void 0 !== w && w,
           b = o.syncTouchLerp,
           z = void 0 === b ? .1 : b,
           M = o.__iosNoInertiaSyncTouchLerp,
           L = void 0 === M ? .4 : M,
           _ = o.touchInertiaMultiplier,
           k = void 0 === _ ? 35 : _,
           E = o.duration,
           O = o.easing,
           R = void 0 === O ? function (t) {
             return Math.min(1, 1.001 - Math.pow(2, -10 * t));
           } : O,
           W = o.lerp,
           C = void 0 === W ? !E && .1 : W,
           x = o.infinite,
           H = void 0 !== x && x,
           j = o.orientation,
           A = void 0 === j ? "vertical" : j,
           X = o.gestureOrientation,
           Y = void 0 === X ? "vertical" : X,
           D = o.touchMultiplier,
           I = void 0 === D ? 1 : D,
           P = o.wheelMultiplier,
           N = void 0 === P ? 1 : P,
           U = o.normalizeWheel,
           V = void 0 !== U && U,
           q = o.autoResize,
           B = void 0 === q || q;
         this.onVirtualScroll = function (t) {
           var o = t.deltaX,
             n = t.deltaY,
             s = t.event;
           if (!s.ctrlKey) {
             var r = s.type.includes("touch"),
               l = s.type.includes("wheel");
             if (!("both" === e.options.gestureOrientation && 0 === o && 0 === n || "vertical" === e.options.gestureOrientation && 0 === n || "horizontal" === e.options.gestureOrientation && 0 === o || r && "vertical" === e.options.gestureOrientation && 0 === e.scroll && !e.options.infinite && n <= 0)) {
               var h = s.composedPath();
               if (!(h = h.slice(0, h.indexOf(e.rootElement))).find(function (t) {
                 var e;
                 return (null == t.hasAttribute ? void 0 : t.hasAttribute("data-lenis-prevent")) || r && (null == t.hasAttribute ? void 0 : t.hasAttribute("data-lenis-prevent-touch")) || l && (null == t.hasAttribute ? void 0 : t.hasAttribute("data-lenis-prevent-wheel")) || (null == (e = t.classList) ? void 0 : e.contains("lenis"));
               })) if (e.isStopped || e.isLocked) s.preventDefault();else {
                 if (e.isSmooth = (e.options.smoothTouch || e.options.syncTouch) && r || e.options.smoothWheel && l, !e.isSmooth) return e.isScrolling = !1, void e.animate.stop();
                 s.preventDefault();
                 var a = n;
                 "both" === e.options.gestureOrientation ? a = Math.abs(n) > Math.abs(o) ? n : o : "horizontal" === e.options.gestureOrientation && (a = o);
                 var c = r && e.options.syncTouch,
                   u = r && "touchend" === s.type && Math.abs(a) > 1;
                 u && (a = e.velocity * e.options.touchInertiaMultiplier), e.scrollTo(e.targetScroll + a, i({
                   programmatic: !1
                 }, c && {
                   lerp: u ? e.syncTouchLerp : e.options.__iosNoInertiaSyncTouchLerp
                 }));
               }
             }
           }
         }, this.onScroll = function () {
           if (!e.isScrolling) {
             var t = e.animatedScroll;
             e.animatedScroll = e.targetScroll = e.actualScroll, e.velocity = 0, e.direction = Math.sign(e.animatedScroll - t), e.emit();
           }
         }, window.lenisVersion = "1.0.27", a !== document.documentElement && a !== document.body || (a = window), this.options = {
           wrapper: a,
           content: u,
           wheelEventsTarget: d,
           eventsTarget: f,
           smoothWheel: g,
           smoothTouch: y,
           syncTouch: T,
           syncTouchLerp: z,
           __iosNoInertiaSyncTouchLerp: L,
           touchInertiaMultiplier: k,
           duration: E,
           easing: R,
           lerp: C,
           infinite: H,
           gestureOrientation: Y,
           orientation: A,
           touchMultiplier: I,
           wheelMultiplier: N,
           normalizeWheel: V,
           autoResize: B
         }, this.animate = new n(), this.emitter = new r(), this.dimensions = new s({
           wrapper: a,
           content: u,
           autoResize: B
         }), this.toggleClass("lenis", !0), this.velocity = 0, this.isLocked = !1, this.isStopped = !1, this.isSmooth = T || g || y, this.isScrolling = !1, this.targetScroll = this.animatedScroll = this.actualScroll, this.options.wrapper.addEventListener("scroll", this.onScroll, {
           passive: !1
         }), this.virtualScroll = new l(f, {
           touchMultiplier: I,
           wheelMultiplier: N,
           normalizeWheel: V
         }), this.virtualScroll.on("scroll", this.onVirtualScroll);
       }
       var h = t.prototype;
       return h.destroy = function () {
         this.emitter.destroy(), this.options.wrapper.removeEventListener("scroll", this.onScroll, {
           passive: !1
         }), this.virtualScroll.destroy(), this.dimensions.destroy(), this.toggleClass("lenis", !1), this.toggleClass("lenis-smooth", !1), this.toggleClass("lenis-scrolling", !1), this.toggleClass("lenis-stopped", !1), this.toggleClass("lenis-locked", !1);
       }, h.on = function (t, e) {
         return this.emitter.on(t, e);
       }, h.off = function (t, e) {
         return this.emitter.off(t, e);
       }, h.setScroll = function (t) {
         this.isHorizontal ? this.rootElement.scrollLeft = t : this.rootElement.scrollTop = t;
       }, h.resize = function () {
         this.dimensions.resize();
       }, h.emit = function () {
         this.emitter.emit("scroll", this);
       }, h.reset = function () {
         this.isLocked = !1, this.isScrolling = !1, this.velocity = 0, this.animate.stop();
       }, h.start = function () {
         this.isStopped = !1, this.reset();
       }, h.stop = function () {
         this.isStopped = !0, this.animate.stop(), this.reset();
       }, h.raf = function (t) {
         var e = t - (this.time || t);
         this.time = t, this.animate.advance(.001 * e);
       }, h.scrollTo = function (t, e) {
         var i = this,
           n = void 0 === e ? {} : e,
           s = n.offset,
           r = void 0 === s ? 0 : s,
           l = n.immediate,
           h = void 0 !== l && l,
           a = n.lock,
           c = void 0 !== a && a,
           u = n.duration,
           p = void 0 === u ? this.options.duration : u,
           d = n.easing,
           v = void 0 === d ? this.options.easing : d,
           f = n.lerp,
           m = void 0 === f ? !p && this.options.lerp : f,
           g = n.onComplete,
           S = void 0 === g ? null : g,
           y = n.force,
           w = n.programmatic,
           T = void 0 === w || w;
         if (!this.isStopped && !this.isLocked || void 0 !== y && y) {
           if (["top", "left", "start"].includes(t)) t = 0;else if (["bottom", "right", "end"].includes(t)) t = this.limit;else {
             var b, z;
             if ("string" == typeof t ? z = document.querySelector(t) : null != (b = t) && b.nodeType && (z = t), z) {
               if (this.options.wrapper !== window) {
                 var M = this.options.wrapper.getBoundingClientRect();
                 r -= this.isHorizontal ? M.left : M.top;
               }
               var L = z.getBoundingClientRect();
               t = (this.isHorizontal ? L.left : L.top) + this.animatedScroll;
             }
           }
           if ("number" == typeof t) {
             if (t += r, t = Math.round(t), this.options.infinite ? T && (this.targetScroll = this.animatedScroll = this.scroll) : t = o(0, t, this.limit), h) return this.animatedScroll = this.targetScroll = t, this.setScroll(this.scroll), this.reset(), void (null == S || S(this));
             if (!T) {
               if (t === this.targetScroll) return;
               this.targetScroll = t;
             }
             this.animate.fromTo(this.animatedScroll, t, {
               duration: p,
               easing: v,
               lerp: m,
               onStart: function onStart() {
                 c && (i.isLocked = !0), i.isScrolling = !0;
               },
               onUpdate: function onUpdate(t, e) {
                 i.isScrolling = !0, i.velocity = t - i.animatedScroll, i.direction = Math.sign(i.velocity), i.animatedScroll = t, i.setScroll(i.scroll), T && (i.targetScroll = t), e || i.emit(), e && requestAnimationFrame(function () {
                   i.reset(), i.emit(), null == S || S(i);
                 });
               }
             });
           }
         }
       }, h.toggleClass = function (t, e) {
         this.rootElement.classList.toggle(t, e), this.emitter.emit("className change", this);
       }, e(t, [{
         key: "rootElement",
         get: function get() {
           return this.options.wrapper === window ? this.options.content : this.options.wrapper;
         }
       }, {
         key: "limit",
         get: function get() {
           return this.dimensions.limit[this.isHorizontal ? "x" : "y"];
         }
       }, {
         key: "isHorizontal",
         get: function get() {
           return "horizontal" === this.options.orientation;
         }
       }, {
         key: "actualScroll",
         get: function get() {
           return this.isHorizontal ? this.rootElement.scrollLeft : this.rootElement.scrollTop;
         }
       }, {
         key: "scroll",
         get: function get() {
           return this.options.infinite ? (this.animatedScroll % (t = this.limit) + t) % t : this.animatedScroll;
           // removed by dead control flow
    var t; 
         }
       }, {
         key: "progress",
         get: function get() {
           return 0 === this.limit ? 1 : this.scroll / this.limit;
         }
       }, {
         key: "isSmooth",
         get: function get() {
           return this.__isSmooth;
         },
         set: function set(t) {
           this.__isSmooth !== t && (this.__isSmooth = t, this.toggleClass("lenis-smooth", t));
         }
       }, {
         key: "isScrolling",
         get: function get() {
           return this.__isScrolling;
         },
         set: function set(t) {
           this.__isScrolling !== t && (this.__isScrolling = t, this.toggleClass("lenis-scrolling", t));
         }
       }, {
         key: "isStopped",
         get: function get() {
           return this.__isStopped;
         },
         set: function set(t) {
           this.__isStopped !== t && (this.__isStopped = t, this.toggleClass("lenis-stopped", t));
         }
       }, {
         key: "isLocked",
         get: function get() {
           return this.__isLocked;
         },
         set: function set(t) {
           this.__isLocked !== t && (this.__isLocked = t, this.toggleClass("lenis-locked", t));
         }
       }, {
         key: "className",
         get: function get() {
           var t = "lenis";
           return this.isStopped && (t += " lenis-stopped"), this.isLocked && (t += " lenis-locked"), this.isScrolling && (t += " lenis-scrolling"), this.isSmooth && (t += " lenis-smooth"), t;
         }
       }]), t;
     }();
   });
   
   /***/ }),
   /* 4 */
   /***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {
   
   "use strict";
   __webpack_require__.r(__webpack_exports__);
   /* harmony export */ __webpack_require__.d(__webpack_exports__, {
   /* harmony export */   "default": () => (/* binding */ Lenis)
   /* harmony export */ });
   //#region package.json
   var version = "1.3.23";
   //#endregion
   //#region packages/core/src/maths.ts
   /**
   * Clamp a value between a minimum and maximum value
   *
   * @param min Minimum value
   * @param input Value to clamp
   * @param max Maximum value
   * @returns Clamped value
   */
   function clamp(min, input, max) {
       return Math.max(min, Math.min(input, max));
   }
   /**
   *  Linearly interpolate between two values using an amount (0 <= t <= 1)
   *
   * @param x First value
   * @param y Second value
   * @param t Amount to interpolate (0 <= t <= 1)
   * @returns Interpolated value
   */
   function lerp(x, y, t) {
       return (1 - t) * x + t * y;
   }
   /**
   * Damp a value over time using a damping factor
   * {@link http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/}
   *
   * @param x Initial value
   * @param y Target value
   * @param lambda Damping factor
   * @param dt Time elapsed since the last update
   * @returns Damped value
   */
   function damp(x, y, lambda, deltaTime) {
       return lerp(x, y, 1 - Math.exp(-lambda * deltaTime));
   }
   /**
   * Calculate the modulo of the dividend and divisor while keeping the result within the same sign as the divisor
   * {@link https://anguscroll.com/just/just-modulo}
   *
   * @param n Dividend
   * @param d Divisor
   * @returns Modulo
   */
   function modulo(n, d) {
       return (n % d + d) % d;
   }
   //#endregion
   //#region packages/core/src/animate.ts
   /**
   * Animate class to handle value animations with lerping or easing
   *
   * @example
   * const animate = new Animate()
   * animate.fromTo(0, 100, { duration: 1, easing: (t) => t })
   * animate.advance(0.5) // 50
   */
   var Animate = class {
       isRunning = false;
       value = 0;
       from = 0;
       to = 0;
       currentTime = 0;
       lerp;
       duration;
       easing;
       onUpdate;
       /**
       * Advance the animation by the given delta time
       *
       * @param deltaTime - The time in seconds to advance the animation
       */
       advance(deltaTime) {
           if (!this.isRunning) return;
           let completed = false;
           if (this.duration && this.easing) {
               this.currentTime += deltaTime;
               const linearProgress = clamp(0, this.currentTime / this.duration, 1);
               completed = linearProgress >= 1;
               const easedProgress = completed ? 1 : this.easing(linearProgress);
               this.value = this.from + (this.to - this.from) * easedProgress;
           } else if (this.lerp) {
               this.value = damp(this.value, this.to, this.lerp * 60, deltaTime);
               if (Math.round(this.value) === Math.round(this.to)) {
                   this.value = this.to;
                   completed = true;
               }
           } else {
               this.value = this.to;
               completed = true;
           }
           if (completed) this.stop();
           this.onUpdate?.(this.value, completed);
       }
       /** Stop the animation */
       stop() {
           this.isRunning = false;
       }
       /**
       * Set up the animation from a starting value to an ending value
       * with optional parameters for lerping, duration, easing, and onUpdate callback
       *
       * @param from - The starting value
       * @param to - The ending value
       * @param options - Options for the animation
       */
       fromTo(from, to, { lerp, duration, easing, onStart, onUpdate }) {
           this.from = this.value = from;
           this.to = to;
           this.lerp = lerp;
           this.duration = duration;
           this.easing = easing;
           this.currentTime = 0;
           this.isRunning = true;
           onStart?.();
           this.onUpdate = onUpdate;
       }
   };
   //#endregion
   //#region packages/core/src/debounce.ts
   function debounce(callback, delay) {
       let timer;
       return function(...args) {
           clearTimeout(timer);
           timer = setTimeout(() => {
               timer = void 0;
               callback.apply(this, args);
           }, delay);
       };
   }
   //#endregion
   //#region packages/core/src/dimensions.ts
   /**
   * Dimensions class to handle the size of the content and wrapper
   *
   * @example
   * const dimensions = new Dimensions(wrapper, content)
   * dimensions.on('resize', (e) => {
   *   console.log(e.width, e.height)
   * })
   */
   var Dimensions = class {
       width = 0;
       height = 0;
       scrollHeight = 0;
       scrollWidth = 0;
       debouncedResize;
       wrapperResizeObserver;
       contentResizeObserver;
       constructor(wrapper, content, { autoResize = true, debounce: debounceValue = 250 } = {}) {
           this.wrapper = wrapper;
           this.content = content;
           if (autoResize) {
               this.debouncedResize = debounce(this.resize, debounceValue);
               if (this.wrapper instanceof Window) window.addEventListener("resize", this.debouncedResize);
               else {
                   this.wrapperResizeObserver = new ResizeObserver(this.debouncedResize);
                   this.wrapperResizeObserver.observe(this.wrapper);
               }
               this.contentResizeObserver = new ResizeObserver(this.debouncedResize);
               this.contentResizeObserver.observe(this.content);
           }
           this.resize();
       }
       destroy() {
           this.wrapperResizeObserver?.disconnect();
           this.contentResizeObserver?.disconnect();
           if (this.wrapper === window && this.debouncedResize) window.removeEventListener("resize", this.debouncedResize);
       }
       resize = () => {
           this.onWrapperResize();
           this.onContentResize();
       };
       onWrapperResize = () => {
           if (this.wrapper instanceof Window) {
               this.width = window.innerWidth;
               this.height = window.innerHeight;
           } else {
               this.width = this.wrapper.clientWidth;
               this.height = this.wrapper.clientHeight;
           }
       };
       onContentResize = () => {
           if (this.wrapper instanceof Window) {
               this.scrollHeight = this.content.scrollHeight;
               this.scrollWidth = this.content.scrollWidth;
           } else {
               this.scrollHeight = this.wrapper.scrollHeight;
               this.scrollWidth = this.wrapper.scrollWidth;
           }
       };
       get limit() {
           return {
               x: this.scrollWidth - this.width,
               y: this.scrollHeight - this.height
           };
       }
   };
   //#endregion
   //#region packages/core/src/emitter.ts
   /**
   * Emitter class to handle events
   * @example
   * const emitter = new Emitter()
   * emitter.on('event', (data) => {
   *   console.log(data)
   * })
   * emitter.emit('event', 'data')
   */
   var Emitter = class {
       events = {};
       /**
       * Emit an event with the given data
       * @param event Event name
       * @param args Data to pass to the event handlers
       */
       emit(event, ...args) {
           const callbacks = this.events[event] || [];
           for (let i = 0, length = callbacks.length; i < length; i++) callbacks[i]?.(...args);
       }
       /**
       * Add a callback to the event
       * @param event Event name
       * @param cb Callback function
       * @returns Unsubscribe function
       */
       on(event, cb) {
           if (this.events[event]) this.events[event].push(cb);
           else this.events[event] = [cb];
           return () => {
               this.events[event] = this.events[event]?.filter((i) => cb !== i);
           };
       }
       /**
       * Remove a callback from the event
       * @param event Event name
       * @param callback Callback function
       */
       off(event, callback) {
           this.events[event] = this.events[event]?.filter((i) => callback !== i);
       }
       /**
       * Remove all event listeners and clean up
       */
       destroy() {
           this.events = {};
       }
   };
   //#endregion
   //#region packages/core/src/virtual-scroll.ts
   const LINE_HEIGHT = 100 / 6;
   const listenerOptions = { passive: false };
   function getDeltaMultiplier(deltaMode, size) {
       if (deltaMode === 1) return LINE_HEIGHT;
       if (deltaMode === 2) return size;
       return 1;
   }
   var VirtualScroll = class {
       touchStart = {
           x: 0,
           y: 0
       };
       lastDelta = {
           x: 0,
           y: 0
       };
       window = {
           width: 0,
           height: 0
       };
       emitter = new Emitter();
       constructor(element, options = {
           wheelMultiplier: 1,
           touchMultiplier: 1
       }) {
           this.element = element;
           this.options = options;
           window.addEventListener("resize", this.onWindowResize);
           this.onWindowResize();
           this.element.addEventListener("wheel", this.onWheel, listenerOptions);
           this.element.addEventListener("touchstart", this.onTouchStart, listenerOptions);
           this.element.addEventListener("touchmove", this.onTouchMove, listenerOptions);
           this.element.addEventListener("touchend", this.onTouchEnd, listenerOptions);
       }
       /**
       * Add an event listener for the given event and callback
       *
       * @param event Event name
       * @param callback Callback function
       */
       on(event, callback) {
           return this.emitter.on(event, callback);
       }
       /** Remove all event listeners and clean up */
       destroy() {
           this.emitter.destroy();
           window.removeEventListener("resize", this.onWindowResize);
           this.element.removeEventListener("wheel", this.onWheel, listenerOptions);
           this.element.removeEventListener("touchstart", this.onTouchStart, listenerOptions);
           this.element.removeEventListener("touchmove", this.onTouchMove, listenerOptions);
           this.element.removeEventListener("touchend", this.onTouchEnd, listenerOptions);
       }
       /**
       * Event handler for 'touchstart' event
       *
       * @param event Touch event
       */
       onTouchStart = (event) => {
           const { clientX, clientY } = event.targetTouches ? event.targetTouches[0] : event;
           this.touchStart.x = clientX;
           this.touchStart.y = clientY;
           this.lastDelta = {
               x: 0,
               y: 0
           };
           this.emitter.emit("scroll", {
               deltaX: 0,
               deltaY: 0,
               event
           });
       };
       /** Event handler for 'touchmove' event */
       onTouchMove = (event) => {
           const { clientX, clientY } = event.targetTouches ? event.targetTouches[0] : event;
           const deltaX = -(clientX - this.touchStart.x) * this.options.touchMultiplier;
           const deltaY = -(clientY - this.touchStart.y) * this.options.touchMultiplier;
           this.touchStart.x = clientX;
           this.touchStart.y = clientY;
           this.lastDelta = {
               x: deltaX,
               y: deltaY
           };
           this.emitter.emit("scroll", {
               deltaX,
               deltaY,
               event
           });
       };
       onTouchEnd = (event) => {
           this.emitter.emit("scroll", {
               deltaX: this.lastDelta.x,
               deltaY: this.lastDelta.y,
               event
           });
       };
       /** Event handler for 'wheel' event */
       onWheel = (event) => {
           let { deltaX, deltaY, deltaMode } = event;
           const multiplierX = getDeltaMultiplier(deltaMode, this.window.width);
           const multiplierY = getDeltaMultiplier(deltaMode, this.window.height);
           deltaX *= multiplierX;
           deltaY *= multiplierY;
           deltaX *= this.options.wheelMultiplier;
           deltaY *= this.options.wheelMultiplier;
           this.emitter.emit("scroll", {
               deltaX,
               deltaY,
               event
           });
       };
       onWindowResize = () => {
           this.window = {
               width: window.innerWidth,
               height: window.innerHeight
           };
       };
   };
   //#endregion
   //#region packages/core/src/lenis.ts
   const defaultEasing = (t) => Math.min(1, 1.001 - 2 ** (-10 * t));
   var Lenis = class {
       _isScrolling = false;
       _isStopped = false;
       _isLocked = false;
       _preventNextNativeScrollEvent = false;
       _resetVelocityTimeout = null;
       _rafId = null;
       /**
       * Whether or not the user is touching the screen
       */
       isTouching;
       /**
       * The time in ms since the lenis instance was created
       */
       time = 0;
       /**
       * User data that will be forwarded through the scroll event
       *
       * @example
       * lenis.scrollTo(100, {
       *   userData: {
       *     foo: 'bar'
       *   }
       * })
       */
       userData = {};
       /**
       * The last velocity of the scroll
       */
       lastVelocity = 0;
       /**
       * The current velocity of the scroll
       */
       velocity = 0;
       /**
       * The direction of the scroll
       */
       direction = 0;
       /**
       * The options passed to the lenis instance
       */
       options;
       /**
       * The target scroll value
       */
       targetScroll;
       /**
       * The animated scroll value
       */
       animatedScroll;
       animate = new Animate();
       emitter = new Emitter();
       dimensions;
       virtualScroll;
       constructor({ wrapper = window, content = document.documentElement, eventsTarget = wrapper, smoothWheel = true, syncTouch = false, syncTouchLerp = .075, touchInertiaExponent = 1.7, duration, easing, lerp = .1, infinite = false, orientation = "vertical", gestureOrientation = orientation === "horizontal" ? "both" : "vertical", touchMultiplier = 1, wheelMultiplier = 1, autoResize = true, prevent, virtualScroll, overscroll = true, autoRaf = false, anchors = false, autoToggle = false, allowNestedScroll = false, __experimental__naiveDimensions = false, naiveDimensions = __experimental__naiveDimensions, stopInertiaOnNavigate = false } = {}) {
           window.lenisVersion = version;
           if (!window.lenis) window.lenis = {};
           window.lenis.version = version;
           if (orientation === "horizontal") window.lenis.horizontal = true;
           if (syncTouch === true) window.lenis.touch = true;
           if (!wrapper || wrapper === document.documentElement) wrapper = window;
           if (typeof duration === "number" && typeof easing !== "function") easing = defaultEasing;
           else if (typeof easing === "function" && typeof duration !== "number") duration = 1;
           this.options = {
               wrapper,
               content,
               eventsTarget,
               smoothWheel,
               syncTouch,
               syncTouchLerp,
               touchInertiaExponent,
               duration,
               easing,
               lerp,
               infinite,
               gestureOrientation,
               orientation,
               touchMultiplier,
               wheelMultiplier,
               autoResize,
               prevent,
               virtualScroll,
               overscroll,
               autoRaf,
               anchors,
               autoToggle,
               allowNestedScroll,
               naiveDimensions,
               stopInertiaOnNavigate
           };
           this.dimensions = new Dimensions(wrapper, content, { autoResize });
           this.updateClassName();
           this.targetScroll = this.animatedScroll = this.actualScroll;
           this.options.wrapper.addEventListener("scroll", this.onNativeScroll);
           this.options.wrapper.addEventListener("scrollend", this.onScrollEnd, { capture: true });
           if (this.options.anchors || this.options.stopInertiaOnNavigate) this.options.wrapper.addEventListener("click", this.onClick);
           this.options.wrapper.addEventListener("pointerdown", this.onPointerDown);
           this.virtualScroll = new VirtualScroll(eventsTarget, {
               touchMultiplier,
               wheelMultiplier
           });
           this.virtualScroll.on("scroll", this.onVirtualScroll);
           if (this.options.autoToggle) {
               this.checkOverflow();
               this.rootElement.addEventListener("transitionend", this.onTransitionEnd);
           }
           if (this.options.autoRaf) this._rafId = requestAnimationFrame(this.raf);
       }
       /**
       * Destroy the lenis instance, remove all event listeners and clean up the class name
       */
       destroy() {
           this.emitter.destroy();
           this.options.wrapper.removeEventListener("scroll", this.onNativeScroll);
           this.options.wrapper.removeEventListener("scrollend", this.onScrollEnd, { capture: true });
           this.options.wrapper.removeEventListener("pointerdown", this.onPointerDown);
           if (this.options.anchors || this.options.stopInertiaOnNavigate) this.options.wrapper.removeEventListener("click", this.onClick);
           this.virtualScroll.destroy();
           this.dimensions.destroy();
           this.cleanUpClassName();
           if (this._rafId) cancelAnimationFrame(this._rafId);
       }
       on(event, callback) {
           return this.emitter.on(event, callback);
       }
       off(event, callback) {
           return this.emitter.off(event, callback);
       }
       onScrollEnd = (e) => {
           if (!(e instanceof CustomEvent)) {
               if (this.isScrolling === "smooth" || this.isScrolling === false) e.stopPropagation();
           }
       };
       dispatchScrollendEvent = () => {
           this.options.wrapper.dispatchEvent(new CustomEvent("scrollend", {
               bubbles: this.options.wrapper === window,
               detail: { lenisScrollEnd: true }
           }));
       };
       get overflow() {
           const property = this.isHorizontal ? "overflow-x" : "overflow-y";
           return getComputedStyle(this.rootElement)[property];
       }
       checkOverflow() {
           if (["hidden", "clip"].includes(this.overflow)) this.internalStop();
           else this.internalStart();
       }
       onTransitionEnd = (event) => {
           if (event.propertyName?.includes("overflow") && event.target === this.rootElement) this.checkOverflow();
       };
       setScroll(scroll) {
           if (this.isHorizontal) this.options.wrapper.scrollTo({
               left: scroll,
               behavior: "instant"
           });
           else this.options.wrapper.scrollTo({
               top: scroll,
               behavior: "instant"
           });
       }
       onClick = (event) => {
           const linkElementsUrls = event.composedPath().filter((node) => node instanceof HTMLAnchorElement && node.href).map((element) => new URL(element.href));
           const currentUrl = new URL(window.location.href);
           if (this.options.anchors) {
               const anchorElementUrl = linkElementsUrls.find((targetUrl) => currentUrl.host === targetUrl.host && currentUrl.pathname === targetUrl.pathname && targetUrl.hash);
               if (anchorElementUrl) {
                   const options = typeof this.options.anchors === "object" && this.options.anchors ? this.options.anchors : void 0;
                   const target = `#${anchorElementUrl.hash.split("#")[1]}`;
                   this.scrollTo(target, options);
                   return;
               }
           }
           if (this.options.stopInertiaOnNavigate) {
               if (linkElementsUrls.some((targetUrl) => currentUrl.host === targetUrl.host && currentUrl.pathname !== targetUrl.pathname)) {
                   this.reset();
                   return;
               }
           }
       };
       onPointerDown = (event) => {
           if (event.button === 1) this.reset();
       };
       onVirtualScroll = (data) => {
           if (typeof this.options.virtualScroll === "function" && this.options.virtualScroll(data) === false) return;
           const { deltaX, deltaY, event } = data;
           this.emitter.emit("virtual-scroll", {
               deltaX,
               deltaY,
               event
           });
           if (event.ctrlKey) return;
           if (event.lenisStopPropagation) return;
           const isTouch = event.type.includes("touch");
           const isWheel = event.type.includes("wheel");
           this.isTouching = event.type === "touchstart" || event.type === "touchmove";
           const isClickOrTap = deltaX === 0 && deltaY === 0;
           if (this.options.syncTouch && isTouch && event.type === "touchstart" && isClickOrTap && !this.isStopped && !this.isLocked) {
               this.reset();
               return;
           }
           const isUnknownGesture = this.options.gestureOrientation === "vertical" && deltaY === 0 || this.options.gestureOrientation === "horizontal" && deltaX === 0;
           if (isClickOrTap || isUnknownGesture) return;
           let composedPath = event.composedPath();
           composedPath = composedPath.slice(0, composedPath.indexOf(this.rootElement));
           const prevent = this.options.prevent;
           const gestureOrientation = Math.abs(deltaX) >= Math.abs(deltaY) ? "horizontal" : "vertical";
           if (composedPath.find((node) => node instanceof HTMLElement && (typeof prevent === "function" && prevent?.(node) || node.hasAttribute?.("data-lenis-prevent") || gestureOrientation === "vertical" && node.hasAttribute?.("data-lenis-prevent-vertical") || gestureOrientation === "horizontal" && node.hasAttribute?.("data-lenis-prevent-horizontal") || isTouch && node.hasAttribute?.("data-lenis-prevent-touch") || isWheel && node.hasAttribute?.("data-lenis-prevent-wheel") || this.options.allowNestedScroll && this.hasNestedScroll(node, {
               deltaX,
               deltaY
           })))) return;
           if (this.isStopped || this.isLocked) {
               if (event.cancelable) event.preventDefault();
               return;
           }
           if (!(this.options.syncTouch && isTouch || this.options.smoothWheel && isWheel)) {
               this.isScrolling = "native";
               this.animate.stop();
               event.lenisStopPropagation = true;
               return;
           }
           let delta = deltaY;
           if (this.options.gestureOrientation === "both") delta = Math.abs(deltaY) > Math.abs(deltaX) ? deltaY : deltaX;
           else if (this.options.gestureOrientation === "horizontal") delta = deltaX;
           if (!this.options.overscroll || this.options.infinite || this.options.wrapper !== window && this.limit > 0 && (this.animatedScroll > 0 && this.animatedScroll < this.limit || this.animatedScroll === 0 && deltaY > 0 || this.animatedScroll === this.limit && deltaY < 0)) event.lenisStopPropagation = true;
           if (event.cancelable) event.preventDefault();
           const isSyncTouch = isTouch && this.options.syncTouch;
           const hasTouchInertia = isTouch && event.type === "touchend";
           if (hasTouchInertia) delta = Math.sign(delta) * Math.abs(this.velocity) ** this.options.touchInertiaExponent;
           this.scrollTo(this.targetScroll + delta, {
               programmatic: false,
               ...isSyncTouch ? { lerp: hasTouchInertia ? this.options.syncTouchLerp : 1 } : {
                   lerp: this.options.lerp,
                   duration: this.options.duration,
                   easing: this.options.easing
               }
           });
       };
       /**
       * Force lenis to recalculate the dimensions
       */
       resize() {
           this.dimensions.resize();
           this.animatedScroll = this.targetScroll = this.actualScroll;
           this.emit();
       }
       emit() {
           this.emitter.emit("scroll", this);
       }
       onNativeScroll = () => {
           if (this._resetVelocityTimeout !== null) {
               clearTimeout(this._resetVelocityTimeout);
               this._resetVelocityTimeout = null;
           }
           if (this._preventNextNativeScrollEvent) {
               this._preventNextNativeScrollEvent = false;
               return;
           }
           if (this.isScrolling === false || this.isScrolling === "native") {
               const lastScroll = this.animatedScroll;
               this.animatedScroll = this.targetScroll = this.actualScroll;
               this.lastVelocity = this.velocity;
               this.velocity = this.animatedScroll - lastScroll;
               this.direction = Math.sign(this.animatedScroll - lastScroll);
               if (!this.isStopped) this.isScrolling = "native";
               this.emit();
               if (this.velocity !== 0) this._resetVelocityTimeout = setTimeout(() => {
                   this.lastVelocity = this.velocity;
                   this.velocity = 0;
                   this.isScrolling = false;
                   this.emit();
               }, 400);
           }
       };
       reset() {
           this.isLocked = false;
           this.isScrolling = false;
           this.animatedScroll = this.targetScroll = this.actualScroll;
           this.lastVelocity = this.velocity = 0;
           this.animate.stop();
       }
       /**
       * Start lenis scroll after it has been stopped
       */
       start() {
           if (!this.isStopped) return;
           if (this.options.autoToggle) {
               this.rootElement.style.removeProperty("overflow");
               return;
           }
           this.internalStart();
       }
       internalStart() {
           if (!this.isStopped) return;
           this.reset();
           this.isStopped = false;
           this.emit();
       }
       /**
       * Stop lenis scroll
       */
       stop() {
           if (this.isStopped) return;
           if (this.options.autoToggle) {
               this.rootElement.style.setProperty("overflow", "clip");
               return;
           }
           this.internalStop();
       }
       internalStop() {
           if (this.isStopped) return;
           this.reset();
           this.isStopped = true;
           this.emit();
       }
       /**
       * RequestAnimationFrame for lenis
       *
       * @param time The time in ms from an external clock like `requestAnimationFrame` or Tempus
       */
       raf = (time) => {
           const deltaTime = time - (this.time || time);
           this.time = time;
           this.animate.advance(deltaTime * .001);
           if (this.options.autoRaf) this._rafId = requestAnimationFrame(this.raf);
       };
       /**
       * Scroll to a target value
       *
       * @param target The target value to scroll to
       * @param options The options for the scroll
       *
       * @example
       * lenis.scrollTo(100, {
       *   offset: 100,
       *   duration: 1,
       *   easing: (t) => 1 - Math.cos((t * Math.PI) / 2),
       *   lerp: 0.1,
       *   onStart: () => {
       *     console.log('onStart')
       *   },
       *   onComplete: () => {
       *     console.log('onComplete')
       *   },
       * })
       */
       scrollTo(_target, { offset = 0, immediate = false, lock = false, programmatic = true, lerp = programmatic ? this.options.lerp : void 0, duration = programmatic ? this.options.duration : void 0, easing = programmatic ? this.options.easing : void 0, onStart, onComplete, force = false, userData } = {}) {
           if ((this.isStopped || this.isLocked) && !force) return;
           let target = _target;
           let adjustedOffset = offset;
           if (typeof target === "string" && [
               "top",
               "left",
               "start",
               "#"
           ].includes(target)) target = 0;
           else if (typeof target === "string" && [
               "bottom",
               "right",
               "end"
           ].includes(target)) target = this.limit;
           else {
               let node = null;
               if (typeof target === "string") {
                   node = document.querySelector(target);
                   if (!node) if (target === "#top") target = 0;
                   else console.warn("Lenis: Target not found", target);
               } else if (target instanceof HTMLElement && target?.nodeType) node = target;
               if (node) {
                   if (this.options.wrapper !== window) {
                       const wrapperRect = this.rootElement.getBoundingClientRect();
                       adjustedOffset -= this.isHorizontal ? wrapperRect.left : wrapperRect.top;
                   }
                   const rect = node.getBoundingClientRect();
                   const targetStyle = getComputedStyle(node);
                   const scrollMargin = this.isHorizontal ? Number.parseFloat(targetStyle.scrollMarginLeft) : Number.parseFloat(targetStyle.scrollMarginTop);
                   const containerStyle = getComputedStyle(this.rootElement);
                   const scrollPadding = this.isHorizontal ? Number.parseFloat(containerStyle.scrollPaddingLeft) : Number.parseFloat(containerStyle.scrollPaddingTop);
                   target = (this.isHorizontal ? rect.left : rect.top) + this.animatedScroll - (Number.isNaN(scrollMargin) ? 0 : scrollMargin) - (Number.isNaN(scrollPadding) ? 0 : scrollPadding);
               }
           }
           if (typeof target !== "number") return;
           target += adjustedOffset;
           if (this.options.infinite) {
               if (programmatic) {
                   this.targetScroll = this.animatedScroll = this.scroll;
                   const distance = target - this.animatedScroll;
                   if (distance > this.limit / 2) target -= this.limit;
                   else if (distance < -this.limit / 2) target += this.limit;
               }
           } else target = clamp(0, target, this.limit);
           if (target === this.targetScroll) {
               onStart?.(this);
               onComplete?.(this);
               return;
           }
           this.userData = userData ?? {};
           if (immediate) {
               this.animatedScroll = this.targetScroll = target;
               this.setScroll(this.scroll);
               this.reset();
               this.preventNextNativeScrollEvent();
               this.emit();
               onComplete?.(this);
               this.userData = {};
               requestAnimationFrame(() => {
                   this.dispatchScrollendEvent();
               });
               return;
           }
           if (!programmatic) this.targetScroll = target;
           if (typeof duration === "number" && typeof easing !== "function") easing = defaultEasing;
           else if (typeof easing === "function" && typeof duration !== "number") duration = 1;
           this.animate.fromTo(this.animatedScroll, target, {
               duration,
               easing,
               lerp,
               onStart: () => {
                   if (lock) this.isLocked = true;
                   this.isScrolling = "smooth";
                   onStart?.(this);
               },
               onUpdate: (value, completed) => {
                   this.isScrolling = "smooth";
                   this.lastVelocity = this.velocity;
                   this.velocity = value - this.animatedScroll;
                   this.direction = Math.sign(this.velocity);
                   this.animatedScroll = value;
                   this.setScroll(this.scroll);
                   if (programmatic) this.targetScroll = value;
                   if (!completed) this.emit();
                   if (completed) {
                       this.reset();
                       this.emit();
                       onComplete?.(this);
                       this.userData = {};
                       requestAnimationFrame(() => {
                           this.dispatchScrollendEvent();
                       });
                       this.preventNextNativeScrollEvent();
                   }
               }
           });
       }
       preventNextNativeScrollEvent() {
           this._preventNextNativeScrollEvent = true;
           requestAnimationFrame(() => {
               this._preventNextNativeScrollEvent = false;
           });
       }
       hasNestedScroll(node, { deltaX, deltaY }) {
           const time = Date.now();
           if (!node._lenis) node._lenis = {};
           const cache = node._lenis;
           let hasOverflowX;
           let hasOverflowY;
           let isScrollableX;
           let isScrollableY;
           let hasOverscrollBehaviorX;
           let hasOverscrollBehaviorY;
           let scrollWidth;
           let scrollHeight;
           let clientWidth;
           let clientHeight;
           if (time - (cache.time ?? 0) > 2e3) {
               cache.time = Date.now();
               const computedStyle = window.getComputedStyle(node);
               cache.computedStyle = computedStyle;
               hasOverflowX = [
                   "auto",
                   "overlay",
                   "scroll"
               ].includes(computedStyle.overflowX);
               hasOverflowY = [
                   "auto",
                   "overlay",
                   "scroll"
               ].includes(computedStyle.overflowY);
               hasOverscrollBehaviorX = ["auto"].includes(computedStyle.overscrollBehaviorX);
               hasOverscrollBehaviorY = ["auto"].includes(computedStyle.overscrollBehaviorY);
               cache.hasOverflowX = hasOverflowX;
               cache.hasOverflowY = hasOverflowY;
               if (!(hasOverflowX || hasOverflowY)) return false;
               scrollWidth = node.scrollWidth;
               scrollHeight = node.scrollHeight;
               clientWidth = node.clientWidth;
               clientHeight = node.clientHeight;
               isScrollableX = scrollWidth > clientWidth;
               isScrollableY = scrollHeight > clientHeight;
               cache.isScrollableX = isScrollableX;
               cache.isScrollableY = isScrollableY;
               cache.scrollWidth = scrollWidth;
               cache.scrollHeight = scrollHeight;
               cache.clientWidth = clientWidth;
               cache.clientHeight = clientHeight;
               cache.hasOverscrollBehaviorX = hasOverscrollBehaviorX;
               cache.hasOverscrollBehaviorY = hasOverscrollBehaviorY;
           } else {
               isScrollableX = cache.isScrollableX;
               isScrollableY = cache.isScrollableY;
               hasOverflowX = cache.hasOverflowX;
               hasOverflowY = cache.hasOverflowY;
               scrollWidth = cache.scrollWidth;
               scrollHeight = cache.scrollHeight;
               clientWidth = cache.clientWidth;
               clientHeight = cache.clientHeight;
               hasOverscrollBehaviorX = cache.hasOverscrollBehaviorX;
               hasOverscrollBehaviorY = cache.hasOverscrollBehaviorY;
           }
           if (!(hasOverflowX && isScrollableX || hasOverflowY && isScrollableY)) return false;
           const orientation = Math.abs(deltaX) >= Math.abs(deltaY) ? "horizontal" : "vertical";
           let scroll;
           let maxScroll;
           let delta;
           let hasOverflow;
           let isScrollable;
           let hasOverscrollBehavior;
           if (orientation === "horizontal") {
               scroll = Math.round(node.scrollLeft);
               maxScroll = scrollWidth - clientWidth;
               delta = deltaX;
               hasOverflow = hasOverflowX;
               isScrollable = isScrollableX;
               hasOverscrollBehavior = hasOverscrollBehaviorX;
           } else if (orientation === "vertical") {
               scroll = Math.round(node.scrollTop);
               maxScroll = scrollHeight - clientHeight;
               delta = deltaY;
               hasOverflow = hasOverflowY;
               isScrollable = isScrollableY;
               hasOverscrollBehavior = hasOverscrollBehaviorY;
           } else return false;
           if (!hasOverscrollBehavior && (scroll >= maxScroll || scroll <= 0)) return true;
           return (delta > 0 ? scroll < maxScroll : scroll > 0) && hasOverflow && isScrollable;
       }
       /**
       * The root element on which lenis is instanced
       */
       get rootElement() {
           return this.options.wrapper === window ? document.documentElement : this.options.wrapper;
       }
       /**
       * The limit which is the maximum scroll value
       */
       get limit() {
           if (this.options.naiveDimensions) {
               if (this.isHorizontal) return this.rootElement.scrollWidth - this.rootElement.clientWidth;
               return this.rootElement.scrollHeight - this.rootElement.clientHeight;
           }
           return this.dimensions.limit[this.isHorizontal ? "x" : "y"];
       }
       /**
       * Whether or not the scroll is horizontal
       */
       get isHorizontal() {
           return this.options.orientation === "horizontal";
       }
       /**
       * The actual scroll value
       */
       get actualScroll() {
           const wrapper = this.options.wrapper;
           return this.isHorizontal ? wrapper.scrollX ?? wrapper.scrollLeft : wrapper.scrollY ?? wrapper.scrollTop;
       }
       /**
       * The current scroll value
       */
       get scroll() {
           return this.options.infinite ? modulo(this.animatedScroll, this.limit) : this.animatedScroll;
       }
       /**
       * The progress of the scroll relative to the limit
       */
       get progress() {
           return this.limit === 0 ? 1 : this.scroll / this.limit;
       }
       /**
       * Current scroll state
       */
       get isScrolling() {
           return this._isScrolling;
       }
       set isScrolling(value) {
           if (this._isScrolling !== value) {
               this._isScrolling = value;
               this.updateClassName();
           }
       }
       /**
       * Check if lenis is stopped
       */
       get isStopped() {
           return this._isStopped;
       }
       set isStopped(value) {
           if (this._isStopped !== value) {
               this._isStopped = value;
               this.updateClassName();
           }
       }
       /**
       * Check if lenis is locked
       */
       get isLocked() {
           return this._isLocked;
       }
       set isLocked(value) {
           if (this._isLocked !== value) {
               this._isLocked = value;
               this.updateClassName();
           }
       }
       /**
       * Check if lenis is smooth scrolling
       */
       get isSmooth() {
           return this.isScrolling === "smooth";
       }
       /**
       * The class name applied to the wrapper element
       */
       get className() {
           let className = "lenis";
           if (this.options.autoToggle) className += " lenis-autoToggle";
           if (this.isStopped) className += " lenis-stopped";
           if (this.isLocked) className += " lenis-locked";
           if (this.isScrolling) className += " lenis-scrolling";
           if (this.isScrolling === "smooth") className += " lenis-smooth";
           return className;
       }
       updateClassName() {
           this.cleanUpClassName();
           this.className.split(" ").forEach((className) => {
               this.rootElement.classList.add(className);
           });
       }
       cleanUpClassName() {
           for (const className of Array.from(this.rootElement.classList)) if (className === "lenis" || className.startsWith("lenis-")) this.rootElement.classList.remove(className);
       }
   };
   //#endregion
   
   
   //# sourceMappingURL=lenis.mjs.map
   
   /***/ }),
   /* 5 */
   /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
   
   "use strict";
   __webpack_require__.r(__webpack_exports__);
   /* harmony export */ __webpack_require__.d(__webpack_exports__, {
   /* harmony export */   Back: () => (/* reexport safe */ _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.Back),
   /* harmony export */   Bounce: () => (/* reexport safe */ _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.Bounce),
   /* harmony export */   CSSPlugin: () => (/* reexport safe */ _CSSPlugin_js__WEBPACK_IMPORTED_MODULE_1__.CSSPlugin),
   /* harmony export */   Circ: () => (/* reexport safe */ _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.Circ),
   /* harmony export */   Cubic: () => (/* reexport safe */ _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.Cubic),
   /* harmony export */   Elastic: () => (/* reexport safe */ _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.Elastic),
   /* harmony export */   Expo: () => (/* reexport safe */ _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.Expo),
   /* harmony export */   Linear: () => (/* reexport safe */ _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.Linear),
   /* harmony export */   Power0: () => (/* reexport safe */ _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.Power0),
   /* harmony export */   Power1: () => (/* reexport safe */ _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.Power1),
   /* harmony export */   Power2: () => (/* reexport safe */ _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.Power2),
   /* harmony export */   Power3: () => (/* reexport safe */ _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.Power3),
   /* harmony export */   Power4: () => (/* reexport safe */ _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.Power4),
   /* harmony export */   Quad: () => (/* reexport safe */ _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.Quad),
   /* harmony export */   Quart: () => (/* reexport safe */ _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.Quart),
   /* harmony export */   Quint: () => (/* reexport safe */ _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.Quint),
   /* harmony export */   Sine: () => (/* reexport safe */ _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.Sine),
   /* harmony export */   SteppedEase: () => (/* reexport safe */ _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.SteppedEase),
   /* harmony export */   Strong: () => (/* reexport safe */ _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.Strong),
   /* harmony export */   TimelineLite: () => (/* reexport safe */ _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.TimelineLite),
   /* harmony export */   TimelineMax: () => (/* reexport safe */ _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.TimelineMax),
   /* harmony export */   TweenLite: () => (/* reexport safe */ _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.TweenLite),
   /* harmony export */   TweenMax: () => (/* binding */ TweenMaxWithCSS),
   /* harmony export */   "default": () => (/* binding */ gsapWithCSS),
   /* harmony export */   gsap: () => (/* binding */ gsapWithCSS)
   /* harmony export */ });
   /* harmony import */ var _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
   /* harmony import */ var _CSSPlugin_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);
   
   
   var gsapWithCSS = _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.gsap.registerPlugin(_CSSPlugin_js__WEBPACK_IMPORTED_MODULE_1__.CSSPlugin) || _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.gsap,
       // to protect from tree shaking
   TweenMaxWithCSS = gsapWithCSS.core.Tween;
   
   
   /***/ }),
   /* 6 */
   /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
   
   "use strict";
   __webpack_require__.r(__webpack_exports__);
   /* harmony export */ __webpack_require__.d(__webpack_exports__, {
   /* harmony export */   Animation: () => (/* binding */ Animation),
   /* harmony export */   Back: () => (/* binding */ Back),
   /* harmony export */   Bounce: () => (/* binding */ Bounce),
   /* harmony export */   Circ: () => (/* binding */ Circ),
   /* harmony export */   Cubic: () => (/* binding */ Cubic),
   /* harmony export */   Elastic: () => (/* binding */ Elastic),
   /* harmony export */   Expo: () => (/* binding */ Expo),
   /* harmony export */   GSCache: () => (/* binding */ GSCache),
   /* harmony export */   Linear: () => (/* binding */ Linear),
   /* harmony export */   Power0: () => (/* binding */ Power0),
   /* harmony export */   Power1: () => (/* binding */ Power1),
   /* harmony export */   Power2: () => (/* binding */ Power2),
   /* harmony export */   Power3: () => (/* binding */ Power3),
   /* harmony export */   Power4: () => (/* binding */ Power4),
   /* harmony export */   PropTween: () => (/* binding */ PropTween),
   /* harmony export */   Quad: () => (/* binding */ Quad),
   /* harmony export */   Quart: () => (/* binding */ Quart),
   /* harmony export */   Quint: () => (/* binding */ Quint),
   /* harmony export */   Sine: () => (/* binding */ Sine),
   /* harmony export */   SteppedEase: () => (/* binding */ SteppedEase),
   /* harmony export */   Strong: () => (/* binding */ Strong),
   /* harmony export */   Timeline: () => (/* binding */ Timeline),
   /* harmony export */   TimelineLite: () => (/* binding */ Timeline),
   /* harmony export */   TimelineMax: () => (/* binding */ Timeline),
   /* harmony export */   Tween: () => (/* binding */ Tween),
   /* harmony export */   TweenLite: () => (/* binding */ Tween),
   /* harmony export */   TweenMax: () => (/* binding */ Tween),
   /* harmony export */   _checkPlugin: () => (/* binding */ _checkPlugin),
   /* harmony export */   _colorExp: () => (/* binding */ _colorExp),
   /* harmony export */   _colorStringFilter: () => (/* binding */ _colorStringFilter),
   /* harmony export */   _config: () => (/* binding */ _config),
   /* harmony export */   _forEachName: () => (/* binding */ _forEachName),
   /* harmony export */   _getCache: () => (/* binding */ _getCache),
   /* harmony export */   _getProperty: () => (/* binding */ _getProperty),
   /* harmony export */   _getSetter: () => (/* binding */ _getSetter),
   /* harmony export */   _isString: () => (/* binding */ _isString),
   /* harmony export */   _isUndefined: () => (/* binding */ _isUndefined),
   /* harmony export */   _missingPlugin: () => (/* binding */ _missingPlugin),
   /* harmony export */   _numExp: () => (/* binding */ _numExp),
   /* harmony export */   _numWithUnitExp: () => (/* binding */ _numWithUnitExp),
   /* harmony export */   _parseRelative: () => (/* binding */ _parseRelative),
   /* harmony export */   _plugins: () => (/* binding */ _plugins),
   /* harmony export */   _relExp: () => (/* binding */ _relExp),
   /* harmony export */   _removeLinkedListItem: () => (/* binding */ _removeLinkedListItem),
   /* harmony export */   _renderComplexString: () => (/* binding */ _renderComplexString),
   /* harmony export */   _replaceRandom: () => (/* binding */ _replaceRandom),
   /* harmony export */   _round: () => (/* binding */ _round),
   /* harmony export */   _roundModifier: () => (/* binding */ _roundModifier),
   /* harmony export */   _setDefaults: () => (/* binding */ _setDefaults),
   /* harmony export */   _sortPropTweensByPriority: () => (/* binding */ _sortPropTweensByPriority),
   /* harmony export */   _ticker: () => (/* binding */ _ticker),
   /* harmony export */   clamp: () => (/* binding */ clamp),
   /* harmony export */   "default": () => (/* binding */ gsap),
   /* harmony export */   distribute: () => (/* binding */ distribute),
   /* harmony export */   getUnit: () => (/* binding */ getUnit),
   /* harmony export */   gsap: () => (/* binding */ gsap),
   /* harmony export */   interpolate: () => (/* binding */ interpolate),
   /* harmony export */   mapRange: () => (/* binding */ mapRange),
   /* harmony export */   normalize: () => (/* binding */ normalize),
   /* harmony export */   pipe: () => (/* binding */ pipe),
   /* harmony export */   random: () => (/* binding */ random),
   /* harmony export */   selector: () => (/* binding */ selector),
   /* harmony export */   shuffle: () => (/* binding */ shuffle),
   /* harmony export */   snap: () => (/* binding */ snap),
   /* harmony export */   splitColor: () => (/* binding */ splitColor),
   /* harmony export */   toArray: () => (/* binding */ toArray),
   /* harmony export */   unitize: () => (/* binding */ unitize),
   /* harmony export */   wrap: () => (/* binding */ wrap),
   /* harmony export */   wrapYoyo: () => (/* binding */ wrapYoyo)
   /* harmony export */ });
   function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
   
   function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
   
   /*!
    * GSAP 3.15.0
    * https://gsap.com
    *
    * @license Copyright 2008-2026, GreenSock. All rights reserved.
    * Subject to the terms at https://gsap.com/standard-license
    * @author: Jack Doyle, jack@greensock.com
   */
   
   /* eslint-disable */
   var _config = {
     autoSleep: 120,
     force3D: "auto",
     nullTargetWarn: 1,
     units: {
       lineHeight: ""
     }
   },
       _defaults = {
     duration: .5,
     overwrite: false,
     delay: 0
   },
       _suppressOverwrites,
       _reverting,
       _context,
       _bigNum = 1e8,
       _tinyNum = 1 / _bigNum,
       _2PI = Math.PI * 2,
       _HALF_PI = _2PI / 4,
       _gsID = 0,
       _sqrt = Math.sqrt,
       _cos = Math.cos,
       _sin = Math.sin,
       _isString = function _isString(value) {
     return typeof value === "string";
   },
       _isFunction = function _isFunction(value) {
     return typeof value === "function";
   },
       _isNumber = function _isNumber(value) {
     return typeof value === "number";
   },
       _isUndefined = function _isUndefined(value) {
     return typeof value === "undefined";
   },
       _isObject = function _isObject(value) {
     return typeof value === "object";
   },
       _isNotFalse = function _isNotFalse(value) {
     return value !== false;
   },
       _windowExists = function _windowExists() {
     return typeof window !== "undefined";
   },
       _isFuncOrString = function _isFuncOrString(value) {
     return _isFunction(value) || _isString(value);
   },
       _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function () {},
       // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
   _isArray = Array.isArray,
       _randomExp = /random\([^)]+\)/g,
       _commaDelimExp = /,\s*/g,
       _strictNumExp = /(?:-?\.?\d|\.)+/gi,
       //only numbers (including negatives and decimals) but NOT relative values.
   _numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,
       //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
   _numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g,
       _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,
       //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
   _relExp = /[+-]=-?[.\d]+/,
       _delimitedValueExp = /[^,'"\[\]\s]+/gi,
       // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
   _unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i,
       _globalTimeline,
       _win,
       _coreInitted,
       _doc,
       _globals = {},
       _installScope = {},
       _coreReady,
       _install = function _install(scope) {
     return (_installScope = _merge(scope, _globals)) && gsap;
   },
       _missingPlugin = function _missingPlugin(property, value) {
     return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
   },
       _warn = function _warn(message, suppress) {
     return !suppress && console.warn(message);
   },
       _addGlobal = function _addGlobal(name, obj) {
     return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
   },
       _emptyFunc = function _emptyFunc() {
     return 0;
   },
       _startAtRevertConfig = {
     suppressEvents: true,
     isStart: true,
     kill: false
   },
       _revertConfigNoKill = {
     suppressEvents: true,
     kill: false
   },
       _revertConfig = {
     suppressEvents: true
   },
       _reservedProps = {},
       _lazyTweens = [],
       _lazyLookup = {},
       _lastRenderedFrame,
       _plugins = {},
       _effects = {},
       _nextGCFrame = 30,
       _harnessPlugins = [],
       _callbackNames = "",
       _harness = function _harness(targets) {
     var target = targets[0],
         harnessPlugin,
         i;
     _isObject(target) || _isFunction(target) || (targets = [targets]);
   
     if (!(harnessPlugin = (target._gsap || {}).harness)) {
       // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
       i = _harnessPlugins.length;
   
       while (i-- && !_harnessPlugins[i].targetTest(target)) {}
   
       harnessPlugin = _harnessPlugins[i];
     }
   
     i = targets.length;
   
     while (i--) {
       targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
     }
   
     return targets;
   },
       _getCache = function _getCache(target) {
     return target._gsap || _harness(toArray(target))[0]._gsap;
   },
       _getProperty = function _getProperty(target, property, v) {
     return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
   },
       _forEachName = function _forEachName(names, func) {
     return (names = names.split(",")).forEach(func) || names;
   },
       //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
   _round = function _round(value) {
     return Math.round(value * 100000) / 100000 || 0;
   },
       _roundPrecise = function _roundPrecise(value) {
     return Math.round(value * 10000000) / 10000000 || 0;
   },
       // increased precision mostly for timing values.
   _parseRelative = function _parseRelative(start, value) {
     var operator = value.charAt(0),
         end = parseFloat(value.substr(2));
     start = parseFloat(start);
     return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
   },
       _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
     //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
     var l = toFind.length,
         i = 0;
   
     for (; toSearch.indexOf(toFind[i]) < 0 && ++i < l;) {}
   
     return i < l;
   },
       _lazyRender = function _lazyRender() {
     var l = _lazyTweens.length,
         a = _lazyTweens.slice(0),
         i,
         tween;
   
     _lazyLookup = {};
     _lazyTweens.length = 0;
   
     for (i = 0; i < l; i++) {
       tween = a[i];
       tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
     }
   },
       _isRevertWorthy = function _isRevertWorthy(animation) {
     return !!(animation._initted || animation._startAt || animation.add);
   },
       _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
     _lazyTweens.length && !_reverting && _lazyRender();
     animation.render(time, suppressEvents, force || !!(_reverting && time < 0 && _isRevertWorthy(animation)));
     _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
   },
       _numericIfPossible = function _numericIfPossible(value) {
     var n = parseFloat(value);
     return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
   },
       _passThrough = function _passThrough(p) {
     return p;
   },
       _setDefaults = function _setDefaults(obj, defaults) {
     for (var p in defaults) {
       p in obj || (obj[p] = defaults[p]);
     }
   
     return obj;
   },
       _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
     return function (obj, defaults) {
       for (var p in defaults) {
         p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
       }
     };
   },
       _merge = function _merge(base, toMerge) {
     for (var p in toMerge) {
       base[p] = toMerge[p];
     }
   
     return base;
   },
       _mergeDeep = function _mergeDeep(base, toMerge) {
     for (var p in toMerge) {
       p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
     }
   
     return base;
   },
       _copyExcluding = function _copyExcluding(obj, excluding) {
     var copy = {},
         p;
   
     for (p in obj) {
       p in excluding || (copy[p] = obj[p]);
     }
   
     return copy;
   },
       _inheritDefaults = function _inheritDefaults(vars) {
     var parent = vars.parent || _globalTimeline,
         func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;
   
     if (_isNotFalse(vars.inherit)) {
       while (parent) {
         func(vars, parent.vars.defaults);
         parent = parent.parent || parent._dp;
       }
     }
   
     return vars;
   },
       _arraysMatch = function _arraysMatch(a1, a2) {
     var i = a1.length,
         match = i === a2.length;
   
     while (match && i-- && a1[i] === a2[i]) {}
   
     return i < 0;
   },
       _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
     if (firstProp === void 0) {
       firstProp = "_first";
     }
   
     if (lastProp === void 0) {
       lastProp = "_last";
     }
   
     var prev = parent[lastProp],
         t;
   
     if (sortBy) {
       t = child[sortBy];
   
       while (prev && prev[sortBy] > t) {
         prev = prev._prev;
       }
     }
   
     if (prev) {
       child._next = prev._next;
       prev._next = child;
     } else {
       child._next = parent[firstProp];
       parent[firstProp] = child;
     }
   
     if (child._next) {
       child._next._prev = child;
     } else {
       parent[lastProp] = child;
     }
   
     child._prev = prev;
     child.parent = child._dp = parent;
     return child;
   },
       _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
     if (firstProp === void 0) {
       firstProp = "_first";
     }
   
     if (lastProp === void 0) {
       lastProp = "_last";
     }
   
     var prev = child._prev,
         next = child._next;
   
     if (prev) {
       prev._next = next;
     } else if (parent[firstProp] === child) {
       parent[firstProp] = next;
     }
   
     if (next) {
       next._prev = prev;
     } else if (parent[lastProp] === child) {
       parent[lastProp] = prev;
     }
   
     child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
   },
       _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
     child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
     child._act = 0;
   },
       _uncache = function _uncache(animation, child) {
     if (animation && (!child || child._end > animation._dur || child._start < 0)) {
       // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
       var a = animation;
   
       while (a) {
         a._dirty = 1;
         a = a.parent;
       }
     }
   
     return animation;
   },
       _recacheAncestors = function _recacheAncestors(animation) {
     var parent = animation.parent;
   
     while (parent && parent.parent) {
       //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
       parent._dirty = 1;
       parent.totalDuration();
       parent = parent.parent;
     }
   
     return animation;
   },
       _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
     return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
   },
       _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
     return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
   },
       _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
     return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
   },
       // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
   _animationCycle = function _animationCycle(tTime, cycleDuration) {
     var whole = Math.floor(tTime = _roundPrecise(tTime / cycleDuration));
     return tTime && whole === tTime ? whole - 1 : whole;
   },
       _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
     return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
   },
       _setEnd = function _setEnd(animation) {
     return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
   },
       _alignPlayhead = function _alignPlayhead(animation, totalTime) {
     // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
     var parent = animation._dp;
   
     if (parent && parent.smoothChildTiming && animation._ts) {
       animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
   
       _setEnd(animation);
   
       parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
     }
   
     return animation;
   },
   
   /*
   _totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
       let cycleDuration = duration + repeatDelay,
           time = _round(clampedTotalTime % cycleDuration);
       if (time > duration) {
           time = duration;
       }
       return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
   },
   */
   _postAddChecks = function _postAddChecks(timeline, child) {
     var t;
   
     if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
       // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
       t = _parentToChildTotalTime(timeline.rawTime(), child);
   
       if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) {
         child.render(t, true);
       }
     } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
   
   
     if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
       //in case any of the ancestors had completed but should now be enabled...
       if (timeline._dur < timeline.duration()) {
         t = timeline;
   
         while (t._dp) {
           t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
   
           t = t._dp;
         }
       }
   
       timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
     }
   },
       _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
     child.parent && _removeFromParent(child);
     child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
     child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
   
     _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
   
     _isFromOrFromStart(child) || (timeline._recent = child);
     skipChecks || _postAddChecks(timeline, child);
     timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
   
     return timeline;
   },
       _scrollTrigger = function _scrollTrigger(animation, trigger) {
     return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
   },
       _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
     _initTween(tween, time, tTime);
   
     if (!tween._initted) {
       return 1;
     }
   
     if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
       _lazyTweens.push(tween);
   
       tween._lazy = [tTime, suppressEvents];
       return 1;
     }
   },
       _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
     var parent = _ref.parent;
     return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
   },
       // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
   _isFromOrFromStart = function _isFromOrFromStart(_ref2) {
     var data = _ref2.data;
     return data === "isFromStart" || data === "isStart";
   },
       _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
     var prevRatio = tween.ratio,
         ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1,
         // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
     repeatDelay = tween._rDelay,
         tTime = 0,
         pt,
         iteration,
         prevIteration;
   
     if (repeatDelay && tween._repeat) {
       // in case there's a zero-duration tween that has a repeat with a repeatDelay
       tTime = _clamp(0, tween._tDur, totalTime);
       iteration = _animationCycle(tTime, repeatDelay);
       tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
   
       if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
         // if iteration changed
         prevRatio = 1 - ratio;
         tween.vars.repeatRefresh && tween._initted && tween.invalidate();
       }
     }
   
     if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
       if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) {
         // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
         return;
       }
   
       prevIteration = tween._zTime;
       tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
   
       suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
   
       tween.ratio = ratio;
       tween._from && (ratio = 1 - ratio);
       tween._time = 0;
       tween._tTime = tTime;
       pt = tween._pt;
   
       while (pt) {
         pt.r(ratio, pt.d);
         pt = pt._next;
       }
   
       totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
       tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
       tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
   
       if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
         ratio && _removeFromParent(tween, 1);
   
         if (!suppressEvents && !_reverting) {
           _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
   
           tween._prom && tween._prom();
         }
       }
     } else if (!tween._zTime) {
       tween._zTime = totalTime;
     }
   },
       _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
     var child;
   
     if (time > prevTime) {
       child = animation._first;
   
       while (child && child._start <= time) {
         if (child.data === "isPause" && child._start > prevTime) {
           return child;
         }
   
         child = child._next;
       }
     } else {
       child = animation._last;
   
       while (child && child._start >= time) {
         if (child.data === "isPause" && child._start < prevTime) {
           return child;
         }
   
         child = child._prev;
       }
     }
   },
       _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
     var repeat = animation._repeat,
         dur = _roundPrecise(duration) || 0,
         totalProgress = animation._tTime / animation._tDur;
     totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
     animation._dur = dur;
     animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
     totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
     animation.parent && _setEnd(animation);
     skipUncache || _uncache(animation.parent, animation);
     return animation;
   },
       _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
     return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
   },
       _zeroPosition = {
     _start: 0,
     endTime: _emptyFunc,
     totalDuration: _emptyFunc
   },
       _parsePosition = function _parsePosition(animation, position, percentAnimation) {
     var labels = animation.labels,
         recent = animation._recent || _zeroPosition,
         clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur,
         //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
     i,
         offset,
         isPercent;
   
     if (_isString(position) && (isNaN(position) || position in labels)) {
       //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
       offset = position.charAt(0);
       isPercent = position.substr(-1) === "%";
       i = position.indexOf("=");
   
       if (offset === "<" || offset === ">") {
         i >= 0 && (position = position.replace(/=/, ""));
         return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
       }
   
       if (i < 0) {
         position in labels || (labels[position] = clippedDuration);
         return labels[position];
       }
   
       offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
   
       if (isPercent && percentAnimation) {
         offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
       }
   
       return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
     }
   
     return position == null ? clippedDuration : +position;
   },
       _createTweenType = function _createTweenType(type, params, timeline) {
     var isLegacy = _isNumber(params[1]),
         varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1),
         vars = params[varsIndex],
         irVars,
         parent;
   
     isLegacy && (vars.duration = params[1]);
     vars.parent = timeline;
   
     if (type) {
       irVars = vars;
       parent = timeline;
   
       while (parent && !("immediateRender" in irVars)) {
         // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
         irVars = parent.vars.defaults || {};
         parent = _isNotFalse(parent.vars.inherit) && parent.parent;
       }
   
       vars.immediateRender = _isNotFalse(irVars.immediateRender);
       type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
     }
   
     return new Tween(params[0], vars, params[varsIndex + 1]);
   },
       _conditionalReturn = function _conditionalReturn(value, func) {
     return value || value === 0 ? func(value) : func;
   },
       _clamp = function _clamp(min, max, value) {
     return value < min ? min : value > max ? max : value;
   },
       getUnit = function getUnit(value, v) {
     return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
   },
       // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
   clamp = function clamp(min, max, value) {
     return _conditionalReturn(value, function (v) {
       return _clamp(min, max, v);
     });
   },
       _slice = [].slice,
       _isArrayLike = function _isArrayLike(value, nonEmpty) {
     return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
   },
       _flatten = function _flatten(ar, leaveStrings, accumulator) {
     if (accumulator === void 0) {
       accumulator = [];
     }
   
     return ar.forEach(function (value) {
       var _accumulator;
   
       return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
     }) || accumulator;
   },
       // takes any value and returns an Array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
   toArray = function toArray(value, scope, leaveStrings) {
     return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [value] : [];
   },
       selector = function selector(value) {
     value = toArray(value)[0] || _warn("Invalid scope") || {};
     return function (v) {
       var el = value.current || value.nativeElement || value;
       return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
     };
   },
       shuffle = function shuffle(a) {
     return a.sort(function () {
       return .5 - Math.random();
     });
   },
       // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = (Math.random() * i) | 0, v = a[--i], a[i] = a[j], a[j] = v); return a;
   // for distributing values across an Array. Can accept a number, a function or (most commonly) an object which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array.
   distribute = function distribute(v) {
     if (_isFunction(v)) {
       return v;
     }
   
     var vars = _isObject(v) ? v : {
       each: v
     },
         //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
     ease = _parseEase(vars.ease),
         from = vars.from || 0,
         base = parseFloat(vars.base) || 0,
         cache = {},
         isDecimal = from > 0 && from < 1,
         ratios = isNaN(from) || isDecimal,
         axis = vars.axis,
         ratioX = from,
         ratioY = from;
   
     if (_isString(from)) {
       ratioX = ratioY = {
         center: .5,
         edges: .5,
         end: 1
       }[from] || 0;
     } else if (!isDecimal && ratios) {
       ratioX = from[0];
       ratioY = from[1];
     }
   
     return function (i, target, a) {
       var l = (a || vars).length,
           distances = cache[l],
           originX,
           originY,
           x,
           y,
           d,
           j,
           max,
           min,
           wrapAt;
   
       if (!distances) {
         wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [1, _bigNum])[1];
   
         if (!wrapAt) {
           max = -_bigNum;
   
           while (max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l) {}
   
           wrapAt < l && wrapAt--;
         }
   
         distances = cache[l] = [];
         originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
         originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
         max = 0;
         min = _bigNum;
   
         for (j = 0; j < l; j++) {
           x = j % wrapAt - originX;
           y = originY - (j / wrapAt | 0);
           distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
           d > max && (max = d);
           d < min && (min = d);
         }
   
         from === "random" && shuffle(distances);
         distances.max = max - min;
         distances.min = min;
         distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
         distances.b = l < 0 ? base - l : base;
         distances.u = getUnit(vars.amount || vars.each) || 0; //unit
   
         ease = ease && l < 0 ? _invertEase(ease) : ease;
       }
   
       l = (distances[i] - distances.min) / distances.max || 0;
       return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
     };
   },
       _roundModifier = function _roundModifier(v) {
     //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
     var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
   
     return function (raw) {
       var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
   
       return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
     };
   },
       snap = function snap(snapTo, value) {
     var isArray = _isArray(snapTo),
         radius,
         is2D;
   
     if (!isArray && _isObject(snapTo)) {
       radius = isArray = snapTo.radius || _bigNum;
   
       if (snapTo.values) {
         snapTo = toArray(snapTo.values);
   
         if (is2D = !_isNumber(snapTo[0])) {
           radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
         }
       } else {
         snapTo = _roundModifier(snapTo.increment);
       }
     }
   
     return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function (raw) {
       is2D = snapTo(raw);
       return Math.abs(is2D - raw) <= radius ? is2D : raw;
     } : function (raw) {
       var x = parseFloat(is2D ? raw.x : raw),
           y = parseFloat(is2D ? raw.y : 0),
           min = _bigNum,
           closest = 0,
           i = snapTo.length,
           dx,
           dy;
   
       while (i--) {
         if (is2D) {
           dx = snapTo[i].x - x;
           dy = snapTo[i].y - y;
           dx = dx * dx + dy * dy;
         } else {
           dx = Math.abs(snapTo[i] - x);
         }
   
         if (dx < min) {
           min = dx;
           closest = i;
         }
       }
   
       closest = !radius || min <= radius ? snapTo[closest] : raw;
       return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
     });
   },
       random = function random(min, max, roundingIncrement, returnFunction) {
     return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? !!(roundingIncrement = 0) : !returnFunction, function () {
       return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5) && (returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
     });
   },
       pipe = function pipe() {
     for (var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++) {
       functions[_key] = arguments[_key];
     }
   
     return function (value) {
       return functions.reduce(function (v, f) {
         return f(v);
       }, value);
     };
   },
       unitize = function unitize(func, unit) {
     return function (value) {
       return func(parseFloat(value)) + (unit || getUnit(value));
     };
   },
       normalize = function normalize(min, max, value) {
     return mapRange(min, max, 0, 1, value);
   },
       _wrapArray = function _wrapArray(a, wrapper, value) {
     return _conditionalReturn(value, function (index) {
       return a[~~wrapper(index)];
     });
   },
       wrap = function wrap(min, max, value) {
     // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
     var range = max - min;
     return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function (value) {
       return (range + (value - min) % range) % range + min;
     });
   },
       wrapYoyo = function wrapYoyo(min, max, value) {
     var range = max - min,
         total = range * 2;
     return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function (value) {
       value = (total + (value - min) % total) % total || 0;
       return min + (value > range ? total - value : value);
     });
   },
       _replaceRandom = function _replaceRandom(s) {
     return s.replace(_randomExp, function (match) {
       //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
       var arIndex = match.indexOf("[") + 1,
           values = match.substring(arIndex || 7, arIndex ? match.indexOf("]") : match.length - 1).split(_commaDelimExp);
       return random(arIndex ? values : +values[0], arIndex ? 0 : +values[1], +values[2] || 1e-5);
     });
   },
       mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
     var inRange = inMax - inMin,
         outRange = outMax - outMin;
     return _conditionalReturn(value, function (value) {
       return outMin + ((value - inMin) / inRange * outRange || 0);
     });
   },
       interpolate = function interpolate(start, end, progress, mutate) {
     var func = isNaN(start + end) ? 0 : function (p) {
       return (1 - p) * start + p * end;
     };
   
     if (!func) {
       var isString = _isString(start),
           master = {},
           p,
           i,
           interpolators,
           l,
           il;
   
       progress === true && (mutate = 1) && (progress = null);
   
       if (isString) {
         start = {
           p: start
         };
         end = {
           p: end
         };
       } else if (_isArray(start) && !_isArray(end)) {
         interpolators = [];
         l = start.length;
         il = l - 2;
   
         for (i = 1; i < l; i++) {
           interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
         }
   
         l--;
   
         func = function func(p) {
           p *= l;
           var i = Math.min(il, ~~p);
           return interpolators[i](p - i);
         };
   
         progress = end;
       } else if (!mutate) {
         start = _merge(_isArray(start) ? [] : {}, start);
       }
   
       if (!interpolators) {
         for (p in end) {
           _addPropTween.call(master, start, p, "get", end[p]);
         }
   
         func = function func(p) {
           return _renderPropTweens(p, master) || (isString ? start.p : start);
         };
       }
     }
   
     return _conditionalReturn(progress, func);
   },
       _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
     //used for nextLabel() and previousLabel()
     var labels = timeline.labels,
         min = _bigNum,
         p,
         distance,
         label;
   
     for (p in labels) {
       distance = labels[p] - fromTime;
   
       if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
         label = p;
         min = distance;
       }
     }
   
     return label;
   },
       _callback = function _callback(animation, type, executeLazyFirst) {
     var v = animation.vars,
         callback = v[type],
         prevContext = _context,
         context = animation._ctx,
         params,
         scope,
         result;
   
     if (!callback) {
       return;
     }
   
     params = v[type + "Params"];
     scope = v.callbackScope || animation;
     executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
   
     context && (_context = context);
     result = params ? callback.apply(scope, params) : callback.call(scope);
     _context = prevContext;
     return result;
   },
       _interrupt = function _interrupt(animation) {
     _removeFromParent(animation);
   
     animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
     animation.progress() < 1 && _callback(animation, "onInterrupt");
     return animation;
   },
       _quickTween,
       _registerPluginQueue = [],
       _createPlugin = function _createPlugin(config) {
     if (!config) return;
     config = !config.name && config["default"] || config; // UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
   
     if (_windowExists() || config.headless) {
       // edge case: some build tools may pass in a null/undefined value
       var name = config.name,
           isFunc = _isFunction(config),
           Plugin = name && !isFunc && config.init ? function () {
         this._props = [];
       } : config,
           //in case someone passes in an object that's not a plugin, like CustomEase
       instanceDefaults = {
         init: _emptyFunc,
         render: _renderPropTweens,
         add: _addPropTween,
         kill: _killPropTweensOf,
         modifier: _addPluginModifier,
         rawVars: 0
       },
           statics = {
         targetTest: 0,
         get: 0,
         getSetter: _getSetter,
         aliases: {},
         register: 0
       };
   
       _wake();
   
       if (config !== Plugin) {
         if (_plugins[name]) {
           return;
         }
   
         _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods
   
   
         _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods
   
   
         _plugins[Plugin.prop = name] = Plugin;
   
         if (config.targetTest) {
           _harnessPlugins.push(Plugin);
   
           _reservedProps[name] = 1;
         }
   
         name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
       }
   
       _addGlobal(name, Plugin);
   
       config.register && config.register(gsap, Plugin, PropTween);
     } else {
       _registerPluginQueue.push(config);
     }
   },
   
   /*
    * --------------------------------------------------------------------------------------
    * COLORS
    * --------------------------------------------------------------------------------------
    */
   _255 = 255,
       _colorLookup = {
     aqua: [0, _255, _255],
     lime: [0, _255, 0],
     silver: [192, 192, 192],
     black: [0, 0, 0],
     maroon: [128, 0, 0],
     teal: [0, 128, 128],
     blue: [0, 0, _255],
     navy: [0, 0, 128],
     white: [_255, _255, _255],
     olive: [128, 128, 0],
     yellow: [_255, _255, 0],
     orange: [_255, 165, 0],
     gray: [128, 128, 128],
     purple: [128, 0, 128],
     green: [0, 128, 0],
     red: [_255, 0, 0],
     pink: [_255, 192, 203],
     cyan: [0, _255, _255],
     transparent: [_255, _255, _255, 0]
   },
       // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
   // let ctx = _doc.createElement("canvas").getContext("2d");
   // _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
   _hue = function _hue(h, m1, m2) {
     h += h < 0 ? 1 : h > 1 ? -1 : 0;
     return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
   },
       splitColor = function splitColor(v, toHSL, forceAlpha) {
     var a = !v ? _colorLookup.black : _isNumber(v) ? [v >> 16, v >> 8 & _255, v & _255] : 0,
         r,
         g,
         b,
         h,
         s,
         l,
         max,
         min,
         d,
         wasHSL;
   
     if (!a) {
       if (v.substr(-1) === ",") {
         //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
         v = v.substr(0, v.length - 1);
       }
   
       if (_colorLookup[v]) {
         a = _colorLookup[v];
       } else if (v.charAt(0) === "#") {
         if (v.length < 6) {
           //for shorthand like #9F0 or #9F0F (could have alpha)
           r = v.charAt(1);
           g = v.charAt(2);
           b = v.charAt(3);
           v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
         }
   
         if (v.length === 9) {
           // hex with alpha, like #fd5e53ff
           a = parseInt(v.substr(1, 6), 16);
           return [a >> 16, a >> 8 & _255, a & _255, parseInt(v.substr(7), 16) / 255];
         }
   
         v = parseInt(v.substr(1), 16);
         a = [v >> 16, v >> 8 & _255, v & _255];
       } else if (v.substr(0, 3) === "hsl") {
         a = wasHSL = v.match(_strictNumExp);
   
         if (!toHSL) {
           h = +a[0] % 360 / 360;
           s = +a[1] / 100;
           l = +a[2] / 100;
           g = l <= .5 ? l * (s + 1) : l + s - l * s;
           r = l * 2 - g;
           a.length > 3 && (a[3] *= 1); //cast as number
   
           a[0] = _hue(h + 1 / 3, r, g);
           a[1] = _hue(h, r, g);
           a[2] = _hue(h - 1 / 3, r, g);
         } else if (~v.indexOf("=")) {
           //if relative values are found, just return the raw strings with the relative prefixes in place.
           a = v.match(_numExp);
           forceAlpha && a.length < 4 && (a[3] = 1);
           return a;
         }
       } else {
         a = v.match(_strictNumExp) || _colorLookup.transparent;
       }
   
       a = a.map(Number);
     }
   
     if (toHSL && !wasHSL) {
       r = a[0] / _255;
       g = a[1] / _255;
       b = a[2] / _255;
       max = Math.max(r, g, b);
       min = Math.min(r, g, b);
       l = (max + min) / 2;
   
       if (max === min) {
         h = s = 0;
       } else {
         d = max - min;
         s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
         h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
         h *= 60;
       }
   
       a[0] = ~~(h + .5);
       a[1] = ~~(s * 100 + .5);
       a[2] = ~~(l * 100 + .5);
     }
   
     forceAlpha && a.length < 4 && (a[3] = 1);
     return a;
   },
       _colorOrderData = function _colorOrderData(v) {
     // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
     var values = [],
         c = [],
         i = -1;
     v.split(_colorExp).forEach(function (v) {
       var a = v.match(_numWithUnitExp) || [];
       values.push.apply(values, a);
       c.push(i += a.length + 1);
     });
     values.c = c;
     return values;
   },
       _formatColors = function _formatColors(s, toHSL, orderMatchData) {
     var result = "",
         colors = (s + result).match(_colorExp),
         type = toHSL ? "hsla(" : "rgba(",
         i = 0,
         c,
         shell,
         d,
         l;
   
     if (!colors) {
       return s;
     }
   
     colors = colors.map(function (color) {
       return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
     });
   
     if (orderMatchData) {
       d = _colorOrderData(s);
       c = orderMatchData.c;
   
       if (c.join(result) !== d.c.join(result)) {
         shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
         l = shell.length - 1;
   
         for (; i < l; i++) {
           result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
         }
       }
     }
   
     if (!shell) {
       shell = s.split(_colorExp);
       l = shell.length - 1;
   
       for (; i < l; i++) {
         result += shell[i] + colors[i];
       }
     }
   
     return result + shell[l];
   },
       _colorExp = function () {
     var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b",
         //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
     p;
   
     for (p in _colorLookup) {
       s += "|" + p + "\\b";
     }
   
     return new RegExp(s + ")", "gi");
   }(),
       _hslExp = /hsl[a]?\(/,
       _colorStringFilter = function _colorStringFilter(a) {
     var combined = a.join(" "),
         toHSL;
     _colorExp.lastIndex = 0;
   
     if (_colorExp.test(combined)) {
       toHSL = _hslExp.test(combined);
       a[1] = _formatColors(a[1], toHSL);
       a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
   
       return true;
     }
   },
   
   /*
    * --------------------------------------------------------------------------------------
    * TICKER
    * --------------------------------------------------------------------------------------
    */
   _tickerActive,
       _ticker = function () {
     var _getTime = Date.now,
         _lagThreshold = 500,
         _adjustedLag = 33,
         _startTime = _getTime(),
         _lastUpdate = _startTime,
         _gap = 1000 / 240,
         _nextTime = _gap,
         _listeners = [],
         _id,
         _req,
         _raf,
         _self,
         _delta,
         _i,
         _tick = function _tick(v) {
       var elapsed = _getTime() - _lastUpdate,
           manual = v === true,
           overlap,
           dispatch,
           time,
           frame;
   
       (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
       _lastUpdate += elapsed;
       time = _lastUpdate - _startTime;
       overlap = time - _nextTime;
   
       if (overlap > 0 || manual) {
         frame = ++_self.frame;
         _delta = time - _self.time * 1000;
         _self.time = time = time / 1000;
         _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
         dispatch = 1;
       }
   
       manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
   
       if (dispatch) {
         for (_i = 0; _i < _listeners.length; _i++) {
           // use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
           _listeners[_i](time, _delta, frame, v);
         }
       }
     };
   
     _self = {
       time: 0,
       frame: 0,
       tick: function tick() {
         _tick(true);
       },
       deltaRatio: function deltaRatio(fps) {
         return _delta / (1000 / (fps || 60));
       },
       wake: function wake() {
         if (_coreReady) {
           if (!_coreInitted && _windowExists()) {
             _win = _coreInitted = window;
             _doc = _win.document || {};
             _globals.gsap = gsap;
             (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
   
             _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});
   
             _registerPluginQueue.forEach(_createPlugin);
           }
   
           _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
           _id && _self.sleep();
   
           _req = _raf || function (f) {
             return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
           };
   
           _tickerActive = 1;
   
           _tick(2);
         }
       },
       sleep: function sleep() {
         (_raf ? cancelAnimationFrame : clearTimeout)(_id);
         _tickerActive = 0;
         _req = _emptyFunc;
       },
       lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
         _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
   
         _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
       },
       fps: function fps(_fps) {
         _gap = 1000 / (_fps || 240);
         _nextTime = _self.time * 1000 + _gap;
       },
       add: function add(callback, once, prioritize) {
         var func = once ? function (t, d, f, v) {
           callback(t, d, f, v);
   
           _self.remove(func);
         } : callback;
   
         _self.remove(callback);
   
         _listeners[prioritize ? "unshift" : "push"](func);
   
         _wake();
   
         return func;
       },
       remove: function remove(callback, i) {
         ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
       },
       _listeners: _listeners
     };
     return _self;
   }(),
       _wake = function _wake() {
     return !_tickerActive && _ticker.wake();
   },
       //also ensures the core classes are initialized.
   
   /*
   * -------------------------------------------------
   * EASING
   * -------------------------------------------------
   */
   _easeMap = {},
       _customEaseExp = /^[\d.\-M][\d.\-,\s]/,
       _quotesExp = /["']/g,
       _parseObjectInString = function _parseObjectInString(value) {
     //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
     var obj = {},
         split = value.substr(1, value.length - 3).split(":"),
         key = split[0],
         i = 1,
         l = split.length,
         index,
         val,
         parsedVal;
   
     for (; i < l; i++) {
       val = split[i];
       index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
       parsedVal = val.substr(0, index);
       obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
       key = val.substr(index + 1).trim();
     }
   
     return obj;
   },
       _valueInParentheses = function _valueInParentheses(value) {
     var open = value.indexOf("(") + 1,
         close = value.indexOf(")"),
         nested = value.indexOf("(", open);
     return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
   },
       _configEaseFromString = function _configEaseFromString(name) {
     //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
     var split = (name + "").split("("),
         ease = _easeMap[split[0]];
     return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [_parseObjectInString(split[1])] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
   },
       _invertEase = function _invertEase(ease) {
     return function (p) {
       return 1 - ease(1 - p);
     };
   },
       _parseEase = function _parseEase(ease, defaultEase) {
     return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
   },
       _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
     if (easeOut === void 0) {
       easeOut = function easeOut(p) {
         return 1 - easeIn(1 - p);
       };
     }
   
     if (easeInOut === void 0) {
       easeInOut = function easeInOut(p) {
         return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
       };
     }
   
     var ease = {
       easeIn: easeIn,
       easeOut: easeOut,
       easeInOut: easeInOut
     },
         lowercaseName;
   
     _forEachName(names, function (name) {
       _easeMap[name] = _globals[name] = ease;
       _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
   
       for (var p in ease) {
         _easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
       }
     });
   
     return ease;
   },
       _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
     return function (p) {
       return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
     };
   },
       _configElastic = function _configElastic(type, amplitude, period) {
     var p1 = amplitude >= 1 ? amplitude : 1,
         //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
     p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1),
         p3 = p2 / _2PI * (Math.asin(1 / p1) || 0),
         easeOut = function easeOut(p) {
       return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
     },
         ease = type === "out" ? easeOut : type === "in" ? function (p) {
       return 1 - easeOut(1 - p);
     } : _easeInOutFromOut(easeOut);
   
     p2 = _2PI / p2; //precalculate to optimize
   
     ease.config = function (amplitude, period) {
       return _configElastic(type, amplitude, period);
     };
   
     return ease;
   },
       _configBack = function _configBack(type, overshoot) {
     if (overshoot === void 0) {
       overshoot = 1.70158;
     }
   
     var easeOut = function easeOut(p) {
       return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
     },
         ease = type === "out" ? easeOut : type === "in" ? function (p) {
       return 1 - easeOut(1 - p);
     } : _easeInOutFromOut(easeOut);
   
     ease.config = function (overshoot) {
       return _configBack(type, overshoot);
     };
   
     return ease;
   }; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
   // _weightedEase = ratio => {
   // 	let y = 0.5 + ratio / 2;
   // 	return p => (2 * (1 - p) * p * y + p * p);
   // },
   // a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
   // _weightedEaseStrong = ratio => {
   // 	ratio = .5 + ratio / 2;
   // 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
   // 		b = ratio - o,
   // 		c = ratio + o;
   // 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
   // };
   
   
   _forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function (name, i) {
     var power = i < 5 ? i + 1 : i;
   
     _insertEase(name + ",Power" + (power - 1), i ? function (p) {
       return Math.pow(p, power);
     } : function (p) {
       return p;
     }, function (p) {
       return 1 - Math.pow(1 - p, power);
     }, function (p) {
       return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
     });
   });
   
   _easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
   
   _insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
   
   (function (n, c) {
     var n1 = 1 / c,
         n2 = 2 * n1,
         n3 = 2.5 * n1,
         easeOut = function easeOut(p) {
       return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
     };
   
     _insertEase("Bounce", function (p) {
       return 1 - easeOut(1 - p);
     }, easeOut);
   })(7.5625, 2.75);
   
   _insertEase("Expo", function (p) {
     return Math.pow(2, 10 * (p - 1)) * p + p * p * p * p * p * p * (1 - p);
   }); // previously 2 ** (10 * (p - 1)) but that doesn't end up with the value quite at the right spot so we do a blended ease to ensure it lands where it should perfectly.
   
   
   _insertEase("Circ", function (p) {
     return -(_sqrt(1 - p * p) - 1);
   });
   
   _insertEase("Sine", function (p) {
     return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
   });
   
   _insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
   
   _easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
     config: function config(steps, immediateStart) {
       if (steps === void 0) {
         steps = 1;
       }
   
       var p1 = 1 / steps,
           p2 = steps + (immediateStart ? 0 : 1),
           p3 = immediateStart ? 1 : 0,
           max = 1 - _tinyNum;
       return function (p) {
         return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
       };
     }
   };
   _defaults.ease = _easeMap["quad.out"];
   
   _forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function (name) {
     return _callbackNames += name + "," + name + "Params,";
   });
   /*
    * --------------------------------------------------------------------------------------
    * CACHE
    * --------------------------------------------------------------------------------------
    */
   
   
   var GSCache = function GSCache(target, harness) {
     this.id = _gsID++;
     target._gsap = this;
     this.target = target;
     this.harness = harness;
     this.get = harness ? harness.get : _getProperty;
     this.set = harness ? harness.getSetter : _getSetter;
   };
   /*
    * --------------------------------------------------------------------------------------
    * ANIMATION
    * --------------------------------------------------------------------------------------
    */
   
   var Animation = /*#__PURE__*/function () {
     function Animation(vars) {
       this.vars = vars;
       this._delay = +vars.delay || 0;
   
       if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
         // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
         this._rDelay = vars.repeatDelay || 0;
         this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
       }
   
       this._ts = 1;
   
       _setDuration(this, +vars.duration, 1, 1);
   
       this.data = vars.data;
   
       if (_context) {
         this._ctx = _context;
   
         _context.data.push(this);
       }
   
       _tickerActive || _ticker.wake();
     }
   
     var _proto = Animation.prototype;
   
     _proto.delay = function delay(value) {
       if (value || value === 0) {
         this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
         this._delay = value;
         return this;
       }
   
       return this._delay;
     };
   
     _proto.duration = function duration(value) {
       return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
     };
   
     _proto.totalDuration = function totalDuration(value) {
       if (!arguments.length) {
         return this._tDur;
       }
   
       this._dirty = 0;
       return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
     };
   
     _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
       _wake();
   
       if (!arguments.length) {
         return this._tTime;
       }
   
       var parent = this._dp;
   
       if (parent && parent.smoothChildTiming && this._ts) {
         _alignPlayhead(this, _totalTime);
   
         !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
         //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
   
         while (parent && parent.parent) {
           if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) {
             parent.totalTime(parent._tTime, true);
           }
   
           parent = parent.parent;
         }
   
         if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) {
           //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
           _addToTimeline(this._dp, this, this._start - this._delay);
         }
       }
   
       if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !this._initted && this._dur && _totalTime || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
         // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
         this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
         //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
         //   this._lock = 1;
   
         _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
         //}
   
       }
   
       return this;
     };
   
     _proto.time = function time(value, suppressEvents) {
       return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
     };
   
     _proto.totalProgress = function totalProgress(value, suppressEvents) {
       return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() >= 0 && this._initted ? 1 : 0;
     };
   
     _proto.progress = function progress(value, suppressEvents) {
       return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
     };
   
     _proto.iteration = function iteration(value, suppressEvents) {
       var cycleDuration = this.duration() + this._rDelay;
   
       return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
     } // potential future addition:
     // isPlayingBackwards() {
     // 	let animation = this,
     // 		orientation = 1; // 1 = forward, -1 = backward
     // 	while (animation) {
     // 		orientation *= animation.reversed() || (animation.repeat() && !(animation.iteration() & 1)) ? -1 : 1;
     // 		animation = animation.parent;
     // 	}
     // 	return orientation < 0;
     // }
     ;
   
     _proto.timeScale = function timeScale(value, suppressEvents) {
       if (!arguments.length) {
         return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
       }
   
       if (this._rts === value) {
         return this;
       }
   
       var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
       // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
       //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
       // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
   
       this._rts = +value || 0;
       this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
   
       this.totalTime(_clamp(-Math.abs(this._delay), this.totalDuration(), tTime), suppressEvents !== false);
   
       _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
   
   
       return _recacheAncestors(this);
     };
   
     _proto.paused = function paused(value) {
       if (!arguments.length) {
         return this._ps;
       } // possible future addition - if an animation is removed from its parent and then .restart() or .play() or .resume() is called, perhaps we should force it back into the globalTimeline but be careful because what if it's already at its end? We don't want it to just persist forever and not get released for GC.
       // !this.parent && !value && this._tTime < this._tDur && this !== _globalTimeline && _globalTimeline.add(this);
   
   
       if (this._ps !== value) {
         this._ps = value;
   
         if (value) {
           this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
   
           this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
         } else {
           _wake();
   
           this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
   
           this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
         }
       }
   
       return this;
     };
   
     _proto.startTime = function startTime(value) {
       if (arguments.length) {
         this._start = _roundPrecise(value);
         var parent = this.parent || this._dp;
         parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, this._start - this._delay);
         return this;
       }
   
       return this._start;
     };
   
     _proto.endTime = function endTime(includeRepeats) {
       return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
     };
   
     _proto.rawTime = function rawTime(wrapRepeats) {
       var parent = this.parent || this._dp; // _dp = detached parent
   
       return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
     };
   
     _proto.revert = function revert(config) {
       if (config === void 0) {
         config = _revertConfig;
       }
   
       var prevIsReverting = _reverting;
       _reverting = config;
   
       if (_isRevertWorthy(this)) {
         this.timeline && this.timeline.revert(config);
         this.totalTime(-0.01, config.suppressEvents);
       }
   
       this.data !== "nested" && config.kill !== false && this.kill();
       _reverting = prevIsReverting;
       return this;
     };
   
     _proto.globalTime = function globalTime(rawTime) {
       var animation = this,
           time = arguments.length ? rawTime : animation.rawTime();
   
       while (animation) {
         time = animation._start + time / (Math.abs(animation._ts) || 1);
         animation = animation._dp;
       }
   
       return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
     };
   
     _proto.repeat = function repeat(value) {
       if (arguments.length) {
         this._repeat = value === Infinity ? -2 : value;
         return _onUpdateTotalDuration(this);
       }
   
       return this._repeat === -2 ? Infinity : this._repeat;
     };
   
     _proto.repeatDelay = function repeatDelay(value) {
       if (arguments.length) {
         var time = this._time;
         this._rDelay = value;
   
         _onUpdateTotalDuration(this);
   
         return time ? this.time(time) : this;
       }
   
       return this._rDelay;
     };
   
     _proto.yoyo = function yoyo(value) {
       if (arguments.length) {
         this._yoyo = value;
         return this;
       }
   
       return this._yoyo;
     };
   
     _proto.seek = function seek(position, suppressEvents) {
       return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
     };
   
     _proto.restart = function restart(includeDelay, suppressEvents) {
       this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
       this._dur || (this._zTime = -_tinyNum); // ensures onComplete fires on a zero-duration animation that gets restarted.
   
       return this;
     };
   
     _proto.play = function play(from, suppressEvents) {
       from != null && this.seek(from, suppressEvents);
       return this.reversed(false).paused(false);
     };
   
     _proto.reverse = function reverse(from, suppressEvents) {
       from != null && this.seek(from || this.totalDuration(), suppressEvents);
       return this.reversed(true).paused(false);
     };
   
     _proto.pause = function pause(atTime, suppressEvents) {
       atTime != null && this.seek(atTime, suppressEvents);
       return this.paused(true);
     };
   
     _proto.resume = function resume() {
       return this.paused(false);
     };
   
     _proto.reversed = function reversed(value) {
       if (arguments.length) {
         !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
   
         return this;
       }
   
       return this._rts < 0;
     };
   
     _proto.invalidate = function invalidate() {
       this._initted = this._act = 0;
       this._zTime = -_tinyNum;
       return this;
     };
   
     _proto.isActive = function isActive() {
       var parent = this.parent || this._dp,
           start = this._start,
           rawTime;
       return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
     };
   
     _proto.eventCallback = function eventCallback(type, callback, params) {
       var vars = this.vars;
   
       if (arguments.length > 1) {
         if (!callback) {
           delete vars[type];
         } else {
           vars[type] = callback;
           params && (vars[type + "Params"] = params);
           type === "onUpdate" && (this._onUpdate = callback);
         }
   
         return this;
       }
   
       return vars[type];
     };
   
     _proto.then = function then(onFulfilled) {
       var self = this,
           prevProm = self._prom;
       return new Promise(function (resolve) {
         var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough,
             _resolve = function _resolve() {
           var _then = self.then;
           self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
   
           prevProm && prevProm();
           _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
           resolve(f);
           self.then = _then;
         };
   
         if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) {
           _resolve();
         } else {
           self._prom = _resolve;
         }
       });
     };
   
     _proto.kill = function kill() {
       _interrupt(this);
     };
   
     return Animation;
   }();
   
   _setDefaults(Animation.prototype, {
     _time: 0,
     _start: 0,
     _end: 0,
     _tTime: 0,
     _tDur: 0,
     _dirty: 0,
     _repeat: 0,
     _yoyo: false,
     parent: null,
     _initted: false,
     _rDelay: 0,
     _ts: 1,
     _dp: 0,
     ratio: 0,
     _zTime: -_tinyNum,
     _prom: 0,
     _ps: false,
     _rts: 1
   });
   /*
    * -------------------------------------------------
    * TIMELINE
    * -------------------------------------------------
    */
   
   
   var Timeline = /*#__PURE__*/function (_Animation) {
     _inheritsLoose(Timeline, _Animation);
   
     function Timeline(vars, position) {
       var _this;
   
       if (vars === void 0) {
         vars = {};
       }
   
       _this = _Animation.call(this, vars) || this;
       _this.labels = {};
       _this.smoothChildTiming = !!vars.smoothChildTiming;
       _this.autoRemoveChildren = !!vars.autoRemoveChildren;
       _this._sort = _isNotFalse(vars.sortChildren);
       _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
       vars.reversed && _this.reverse();
       vars.paused && _this.paused(true);
       vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
       return _this;
     }
   
     var _proto2 = Timeline.prototype;
   
     _proto2.to = function to(targets, vars, position) {
       _createTweenType(0, arguments, this);
   
       return this;
     };
   
     _proto2.from = function from(targets, vars, position) {
       _createTweenType(1, arguments, this);
   
       return this;
     };
   
     _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
       _createTweenType(2, arguments, this);
   
       return this;
     };
   
     _proto2.set = function set(targets, vars, position) {
       vars.duration = 0;
       vars.parent = this;
       _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
       vars.immediateRender = !!vars.immediateRender;
       new Tween(targets, vars, _parsePosition(this, position), 1);
       return this;
     };
   
     _proto2.call = function call(callback, params, position) {
       return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
     } //ONLY for backward compatibility! Maybe delete?
     ;
   
     _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
       vars.duration = duration;
       vars.stagger = vars.stagger || stagger;
       vars.onComplete = onCompleteAll;
       vars.onCompleteParams = onCompleteAllParams;
       vars.parent = this;
       new Tween(targets, vars, _parsePosition(this, position));
       return this;
     };
   
     _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
       vars.runBackwards = 1;
       _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
       return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
     };
   
     _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
       toVars.startAt = fromVars;
       _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
       return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
     };
   
     _proto2.render = function render(totalTime, suppressEvents, force) {
       var prevTime = this._time,
           tDur = this._dirty ? this.totalDuration() : this._tDur,
           dur = this._dur,
           tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime),
           // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
       crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur),
           time,
           child,
           next,
           iteration,
           cycleDuration,
           prevPaused,
           pauseTween,
           timeScale,
           prevStart,
           prevIteration,
           yoyo,
           isYoyo;
       this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
   
       if (tTime !== this._tTime || force || crossingStart) {
         if (prevTime !== this._time && dur) {
           //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
           tTime += this._time - prevTime;
           totalTime += this._time - prevTime;
         }
   
         time = tTime;
         prevStart = this._start;
         timeScale = this._ts;
         prevPaused = !timeScale;
   
         if (crossingStart) {
           dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
   
           (totalTime || !suppressEvents) && (this._zTime = totalTime);
         }
   
         if (this._repeat) {
           //adjust the time for repeats and yoyos
           yoyo = this._yoyo;
           cycleDuration = dur + this._rDelay;
   
           if (this._repeat < -1 && totalTime < 0) {
             return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
           }
   
           time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
   
           if (tTime === tDur) {
             // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
             iteration = this._repeat;
             time = dur;
           } else {
             prevIteration = _roundPrecise(tTime / cycleDuration); // full decimal version of iterations, not the previous iteration (we're reusing prevIteration variable for efficiency)
   
             iteration = ~~prevIteration;
   
             if (iteration && iteration === prevIteration) {
               time = dur;
               iteration--;
             }
   
             time > dur && (time = dur);
           }
   
           prevIteration = _animationCycle(this._tTime, cycleDuration);
           !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://gsap.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
   
           if (yoyo && iteration & 1) {
             time = dur - time;
             isYoyo = 1;
           }
           /*
           make sure children at the end/beginning of the timeline are rendered properly. If, for example,
           a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
           would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
           could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
           we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
           ensure that zero-duration tweens at the very beginning or end of the Timeline work.
           */
   
   
           if (iteration !== prevIteration && !this._lock) {
             var rewinding = yoyo && prevIteration & 1,
                 doesWrap = rewinding === (yoyo && iteration & 1);
             iteration < prevIteration && (rewinding = !rewinding);
             prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
   
             this._lock = 1;
             this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
             this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
   
             !suppressEvents && this.parent && _callback(this, "onRepeat");
   
             if (this.vars.repeatRefresh && !isYoyo) {
               this.invalidate()._lock = 1;
               prevIteration = iteration; // otherwise, the onStart() may fire on the 2nd iteration.
             }
   
             if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) {
               // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
               return this;
             }
   
             dur = this._dur; // in case the duration changed in the onRepeat
   
             tDur = this._tDur;
   
             if (doesWrap) {
               this._lock = 2;
               prevTime = rewinding ? dur : -0.0001;
               this.render(prevTime, true);
               this.vars.repeatRefresh && !isYoyo && this.invalidate();
             }
   
             this._lock = 0;
   
             if (!this._ts && !prevPaused) {
               return this;
             }
           }
         }
   
         if (this._hasPause && !this._forcing && this._lock < 2) {
           pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
   
           if (pauseTween) {
             tTime -= time - (time = pauseTween._start);
           }
         }
   
         this._tTime = tTime;
         this._time = time;
         this._act = !!timeScale; // as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
   
         if (!this._initted) {
           this._onUpdate = this.vars.onUpdate;
           this._initted = 1;
           this._zTime = totalTime;
           prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
         }
   
         if (!prevTime && tTime && dur && !suppressEvents && !prevIteration) {
           _callback(this, "onStart");
   
           if (this._tTime !== tTime) {
             // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
             return this;
           }
         }
   
         if (time >= prevTime && totalTime >= 0) {
           child = this._first;
   
           while (child) {
             next = child._next;
   
             if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
               if (child.parent !== this) {
                 // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                 return this.render(totalTime, suppressEvents, force);
               }
   
               child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
   
               if (time !== this._time || !this._ts && !prevPaused) {
                 //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                 pauseTween = 0;
                 next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that the next time render() is called it'll be forced (to render any remaining children)
   
                 break;
               }
             }
   
             child = next;
           }
         } else {
           child = this._last;
           var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
   
           while (child) {
             next = child._prev;
   
             if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
               if (child.parent !== this) {
                 // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                 return this.render(totalTime, suppressEvents, force);
               }
   
               child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && _isRevertWorthy(child)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
   
               if (time !== this._time || !this._ts && !prevPaused) {
                 //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                 pauseTween = 0;
                 next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
   
                 break;
               }
             }
   
             child = next;
           }
         }
   
         if (pauseTween && !suppressEvents) {
           this.pause();
           pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
   
           if (this._ts) {
             //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
             this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
   
             _setEnd(this);
   
             return this.render(totalTime, suppressEvents, force);
           }
         }
   
         this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
         if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) if (!this._lock) {
           // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
           (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
   
           if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
             _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
   
             this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
           }
         }
       }
   
       return this;
     };
   
     _proto2.add = function add(child, position) {
       var _this2 = this;
   
       _isNumber(position) || (position = _parsePosition(this, position, child));
   
       if (!(child instanceof Animation)) {
         if (_isArray(child)) {
           child.forEach(function (obj) {
             return _this2.add(obj, position);
           });
           return this;
         }
   
         if (_isString(child)) {
           return this.addLabel(child, position);
         }
   
         if (_isFunction(child)) {
           child = Tween.delayedCall(0, child);
         } else {
           return this;
         }
       }
   
       return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
     };
   
     _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
       if (nested === void 0) {
         nested = true;
       }
   
       if (tweens === void 0) {
         tweens = true;
       }
   
       if (timelines === void 0) {
         timelines = true;
       }
   
       if (ignoreBeforeTime === void 0) {
         ignoreBeforeTime = -_bigNum;
       }
   
       var a = [],
           child = this._first;
   
       while (child) {
         if (child._start >= ignoreBeforeTime) {
           if (child instanceof Tween) {
             tweens && a.push(child);
           } else {
             timelines && a.push(child);
             nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
           }
         }
   
         child = child._next;
       }
   
       return a;
     };
   
     _proto2.getById = function getById(id) {
       var animations = this.getChildren(1, 1, 1),
           i = animations.length;
   
       while (i--) {
         if (animations[i].vars.id === id) {
           return animations[i];
         }
       }
     };
   
     _proto2.remove = function remove(child) {
       if (_isString(child)) {
         return this.removeLabel(child);
       }
   
       if (_isFunction(child)) {
         return this.killTweensOf(child);
       }
   
       child.parent === this && _removeLinkedListItem(this, child);
   
       if (child === this._recent) {
         this._recent = this._last;
       }
   
       return _uncache(this);
     };
   
     _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
       if (!arguments.length) {
         return this._tTime;
       }
   
       this._forcing = 1;
   
       if (!this._dp && this._ts) {
         //special case for the global timeline (or any other that has no parent or detached parent).
         this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
       }
   
       _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
   
       this._forcing = 0;
       return this;
     };
   
     _proto2.addLabel = function addLabel(label, position) {
       this.labels[label] = _parsePosition(this, position);
       return this;
     };
   
     _proto2.removeLabel = function removeLabel(label) {
       delete this.labels[label];
       return this;
     };
   
     _proto2.addPause = function addPause(position, callback, params) {
       var t = Tween.delayedCall(0, callback || _emptyFunc, params);
       t.data = "isPause";
       this._hasPause = 1;
       return _addToTimeline(this, t, _parsePosition(this, position));
     };
   
     _proto2.removePause = function removePause(position) {
       var child = this._first;
       position = _parsePosition(this, position);
   
       while (child) {
         if (child._start === position && child.data === "isPause") {
           _removeFromParent(child);
         }
   
         child = child._next;
       }
     };
   
     _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
       var tweens = this.getTweensOf(targets, onlyActive),
           i = tweens.length;
   
       while (i--) {
         _overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
       }
   
       return this;
     };
   
     _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
       var a = [],
           parsedTargets = toArray(targets),
           child = this._first,
           isGlobalTime = _isNumber(onlyActive),
           // a number is interpreted as a global time. If the animation spans
       children;
   
       while (child) {
         if (child instanceof Tween) {
           if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) {
             // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
             a.push(child);
           }
         } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) {
           a.push.apply(a, children);
         }
   
         child = child._next;
       }
   
       return a;
     } // potential future feature - targets() on timelines
     // targets() {
     // 	let result = [];
     // 	this.getChildren(true, true, false).forEach(t => result.push(...t.targets()));
     // 	return result.filter((v, i) => result.indexOf(v) === i);
     // }
     ;
   
     _proto2.tweenTo = function tweenTo(position, vars) {
       vars = vars || {};
   
       var tl = this,
           endTime = _parsePosition(tl, position),
           _vars = vars,
           startAt = _vars.startAt,
           _onStart = _vars.onStart,
           onStartParams = _vars.onStartParams,
           immediateRender = _vars.immediateRender,
           initted,
           tween = Tween.to(tl, _setDefaults({
         ease: vars.ease || "none",
         lazy: false,
         immediateRender: false,
         time: endTime,
         overwrite: "auto",
         duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
         onStart: function onStart() {
           tl.pause();
   
           if (!initted) {
             var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
             tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
             initted = 1;
           }
   
           _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
         }
       }, vars));
   
       return immediateRender ? tween.render(0) : tween;
     };
   
     _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
       return this.tweenTo(toPosition, _setDefaults({
         startAt: {
           time: _parsePosition(this, fromPosition)
         }
       }, vars));
     };
   
     _proto2.recent = function recent() {
       return this._recent;
     };
   
     _proto2.nextLabel = function nextLabel(afterTime) {
       if (afterTime === void 0) {
         afterTime = this._time;
       }
   
       return _getLabelInDirection(this, _parsePosition(this, afterTime));
     };
   
     _proto2.previousLabel = function previousLabel(beforeTime) {
       if (beforeTime === void 0) {
         beforeTime = this._time;
       }
   
       return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
     };
   
     _proto2.currentLabel = function currentLabel(value) {
       return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
     };
   
     _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
       if (ignoreBeforeTime === void 0) {
         ignoreBeforeTime = 0;
       }
   
       var child = this._first,
           labels = this.labels,
           p;
       amount = _roundPrecise(amount);
   
       while (child) {
         if (child._start >= ignoreBeforeTime) {
           child._start += amount;
           child._end += amount;
         }
   
         child = child._next;
       }
   
       if (adjustLabels) {
         for (p in labels) {
           if (labels[p] >= ignoreBeforeTime) {
             labels[p] += amount;
           }
         }
       }
   
       return _uncache(this);
     };
   
     _proto2.invalidate = function invalidate(soft) {
       var child = this._first;
       this._lock = 0;
   
       while (child) {
         child.invalidate(soft);
         child = child._next;
       }
   
       return _Animation.prototype.invalidate.call(this, soft);
     };
   
     _proto2.clear = function clear(includeLabels) {
       if (includeLabels === void 0) {
         includeLabels = true;
       }
   
       var child = this._first,
           next;
   
       while (child) {
         next = child._next;
         this.remove(child);
         child = next;
       }
   
       this._dp && (this._time = this._tTime = this._pTime = 0);
       includeLabels && (this.labels = {});
       return _uncache(this);
     };
   
     _proto2.totalDuration = function totalDuration(value) {
       var max = 0,
           self = this,
           child = self._last,
           prevStart = _bigNum,
           prev,
           start,
           parent;
   
       if (arguments.length) {
         return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
       }
   
       if (self._dirty) {
         parent = self.parent;
   
         while (child) {
           prev = child._prev; //record it here in case the tween changes position in the sequence...
   
           child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
   
           start = child._start;
   
           if (start > prevStart && self._sort && child._ts && !self._lock) {
             //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
             self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
   
             _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
           } else {
             prevStart = start;
           }
   
           if (start < 0 && child._ts) {
             //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
             max -= start;
   
             if (!parent && !self._dp || parent && parent.smoothChildTiming) {
               self._start += _roundPrecise(start / self._ts);
               self._time -= start;
               self._tTime -= start;
             }
   
             self.shiftChildren(-start, false, -1e999);
             prevStart = 0;
           }
   
           child._end > max && child._ts && (max = child._end);
           child = prev;
         }
   
         _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);
   
         self._dirty = 0;
       }
   
       return self._tDur;
     };
   
     Timeline.updateRoot = function updateRoot(time) {
       if (_globalTimeline._ts) {
         _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
   
         _lastRenderedFrame = _ticker.frame;
       }
   
       if (_ticker.frame >= _nextGCFrame) {
         _nextGCFrame += _config.autoSleep || 120;
         var child = _globalTimeline._first;
         if (!child || !child._ts) if (_config.autoSleep && _ticker._listeners.length < 2) {
           while (child && !child._ts) {
             child = child._next;
           }
   
           child || _ticker.sleep();
         }
       }
     };
   
     return Timeline;
   }(Animation);
   
   _setDefaults(Timeline.prototype, {
     _lock: 0,
     _hasPause: 0,
     _forcing: 0
   });
   
   var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
     //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
     var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter),
         index = 0,
         matchIndex = 0,
         result,
         startNums,
         color,
         endNum,
         chunk,
         startNum,
         hasRandom,
         a;
     pt.b = start;
     pt.e = end;
     start += ""; //ensure values are strings
   
     end += "";
   
     if (hasRandom = ~end.indexOf("random(")) {
       end = _replaceRandom(end);
     }
   
     if (stringFilter) {
       a = [start, end];
       stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
   
       start = a[0];
       end = a[1];
     }
   
     startNums = start.match(_complexStringNumExp) || [];
   
     while (result = _complexStringNumExp.exec(end)) {
       endNum = result[0];
       chunk = end.substring(index, result.index);
   
       if (color) {
         color = (color + 1) % 5;
       } else if (chunk.substr(-5) === "rgba(") {
         color = 1;
       }
   
       if (endNum !== startNums[matchIndex++]) {
         startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
   
         pt._pt = {
           _next: pt._pt,
           p: chunk || matchIndex === 1 ? chunk : ",",
           //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
           s: startNum,
           c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
           m: color && color < 4 ? Math.round : 0
         };
         index = _complexStringNumExp.lastIndex;
       }
     }
   
     pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
   
     pt.fp = funcParam;
   
     if (_relExp.test(end) || hasRandom) {
       pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
     }
   
     this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
   
     return pt;
   },
       _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
     _isFunction(end) && (end = end(index || 0, target, targets));
     var currentValue = target[prop],
         parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](),
         setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc,
         pt;
   
     if (_isString(end)) {
       if (~end.indexOf("random(")) {
         end = _replaceRandom(end);
       }
   
       if (end.charAt(1) === "=") {
         pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);
   
         if (pt || pt === 0) {
           // to avoid isNaN, like if someone passes in a value like "!= whatever"
           end = pt;
         }
       }
     }
   
     if (!optional || parsedStart !== end || _forceAllPropTweens) {
       if (!isNaN(parsedStart * end) && end !== "") {
         // fun fact: any number multiplied by "" is evaluated as the number 0!
         pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
         funcParam && (pt.fp = funcParam);
         modifier && pt.modifier(modifier, this, target);
         return this._pt = pt;
       }
   
       !currentValue && !(prop in target) && _missingPlugin(prop, end);
       return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
     }
   },
       //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
   _processVars = function _processVars(vars, index, target, targets, tween) {
     _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
   
     if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) {
       return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
     }
   
     var copy = {},
         p;
   
     for (p in vars) {
       copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
     }
   
     return copy;
   },
       _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
     var plugin, pt, ptLookup, i;
   
     if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
       tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
   
       if (tween !== _quickTween) {
         ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
   
         i = plugin._props.length;
   
         while (i--) {
           ptLookup[plugin._props[i]] = pt;
         }
       }
     }
   
     return plugin;
   },
       _overwritingTween,
       //store a reference temporarily so we can avoid overwriting itself.
   _forceAllPropTweens,
       _initTween = function _initTween(tween, time, tTime) {
     var vars = tween.vars,
         ease = vars.ease,
         startAt = vars.startAt,
         immediateRender = vars.immediateRender,
         lazy = vars.lazy,
         onUpdate = vars.onUpdate,
         runBackwards = vars.runBackwards,
         yoyoEase = vars.yoyoEase,
         keyframes = vars.keyframes,
         autoRevert = vars.autoRevert,
         dur = tween._dur,
         prevStartAt = tween._startAt,
         targets = tween._targets,
         parent = tween.parent,
         fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets,
         autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites,
         tl = tween.timeline,
         reverseEase = vars.easeReverse || yoyoEase,
         cleanVars,
         i,
         p,
         pt,
         target,
         hasPriority,
         gsData,
         harness,
         plugin,
         ptLookup,
         index,
         harnessVars,
         overwritten;
     tl && (!keyframes || !ease) && (ease = "none");
     tween._ease = _parseEase(ease, _defaults.ease);
     tween._rEase = reverseEase && (_parseEase(reverseEase) || tween._ease);
     tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
   
     if (tween._from) tween.ratio = 1;
   
     if (!tl || keyframes && !vars.stagger) {
       //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
       harness = targets[0] ? _getCache(targets[0]).harness : 0;
       harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
   
       cleanVars = _copyExcluding(vars, _reservedProps);
   
       if (prevStartAt) {
         prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
   
         time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
         // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
   
         prevStartAt._lazy = 0;
       }
   
       if (startAt) {
         _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
           data: "isStart",
           overwrite: false,
           parent: parent,
           immediateRender: true,
           lazy: !prevStartAt && _isNotFalse(lazy),
           startAt: null,
           delay: 0,
           onUpdate: onUpdate && function () {
             return _callback(tween, "onUpdate");
           },
           stagger: 0
         }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
   
   
         tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
   
         tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
   
         time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
   
         if (immediateRender) {
           if (dur && time <= 0 && tTime <= 0) {
             // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
             time && (tween._zTime = time);
             return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
           }
         }
       } else if (runBackwards && dur) {
         // from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
         if (!prevStartAt) {
           time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
   
           p = _setDefaults({
             overwrite: false,
             data: "isFromStart",
             //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
             lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
             immediateRender: immediateRender,
             //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
             stagger: 0,
             parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
   
           }, cleanVars);
           harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
   
           _removeFromParent(tween._startAt = Tween.set(targets, p));
   
           tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
   
           tween._startAt._sat = tween; // used in globalTime()
   
           time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
           tween._zTime = time;
   
           if (!immediateRender) {
             _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded
   
           } else if (!time) {
             return;
           }
         }
       }
   
       tween._pt = tween._ptCache = 0;
       lazy = dur && _isNotFalse(lazy) || lazy && !dur;
   
       for (i = 0; i < targets.length; i++) {
         target = targets[i];
         gsData = target._gsap || _harness(targets)[i]._gsap;
         tween._ptLookup[i] = ptLookup = {};
         _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
   
         index = fullTargets === targets ? i : fullTargets.indexOf(target);
   
         if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
           tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
   
           plugin._props.forEach(function (name) {
             ptLookup[name] = pt;
           });
   
           plugin.priority && (hasPriority = 1);
         }
   
         if (!harness || harnessVars) {
           for (p in cleanVars) {
             if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) {
               plugin.priority && (hasPriority = 1);
             } else {
               ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
             }
           }
         }
   
         tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
   
         if (autoOverwrite && tween._pt) {
           _overwritingTween = tween;
   
           _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
   
   
           overwritten = !tween.parent;
           _overwritingTween = 0;
         }
   
         tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
       }
   
       hasPriority && _sortPropTweensByPriority(tween);
       tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
     }
   
     tween._onUpdate = onUpdate;
     tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
   
     keyframes && time <= 0 && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
   },
       _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
     var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property],
         pt,
         rootPT,
         lookup,
         i;
   
     if (!ptCache) {
       ptCache = tween._ptCache[property] = [];
       lookup = tween._ptLookup;
       i = tween._targets.length;
   
       while (i--) {
         pt = lookup[i][property];
   
         if (pt && pt.d && pt.d._pt) {
           // it's a plugin, so find the nested PropTween
           pt = pt.d._pt;
   
           while (pt && pt.p !== property && pt.fp !== property) {
             // "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
             pt = pt._next;
           }
         }
   
         if (!pt) {
           // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
           // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
           _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
   
           tween.vars[property] = "+=0";
   
           _initTween(tween, time);
   
           _forceAllPropTweens = 0;
           return skipRecursion ? _warn(property + " not eligible for reset. Try splitting into individual properties") : 1; // if someone tries to do a quickTo() on a special property like borderRadius which must get split into 4 different properties, that's not eligible for .resetTo().
         }
   
         ptCache.push(pt);
       }
     }
   
     i = ptCache.length;
   
     while (i--) {
       rootPT = ptCache[i];
       pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
   
       pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
       pt.c = value - pt.s;
       rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)
   
       rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
     }
   },
       _addAliasesToVars = function _addAliasesToVars(targets, vars) {
     var harness = targets[0] ? _getCache(targets[0]).harness : 0,
         propertyAliases = harness && harness.aliases,
         copy,
         p,
         i,
         aliases;
   
     if (!propertyAliases) {
       return vars;
     }
   
     copy = _merge({}, vars);
   
     for (p in propertyAliases) {
       if (p in copy) {
         aliases = propertyAliases[p].split(",");
         i = aliases.length;
   
         while (i--) {
           copy[aliases[i]] = copy[p];
         }
       }
     }
   
     return copy;
   },
       // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
   _parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
     var ease = obj.ease || easeEach || "power1.inOut",
         p,
         a;
   
     if (_isArray(obj)) {
       a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
   
       obj.forEach(function (value, i) {
         return a.push({
           t: i / (obj.length - 1) * 100,
           v: value,
           e: ease
         });
       });
     } else {
       for (p in obj) {
         a = allProps[p] || (allProps[p] = []);
         p === "ease" || a.push({
           t: parseFloat(prop),
           v: obj[p],
           e: ease
         });
       }
     }
   },
       _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
     return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
   },
       _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,easeReverse,autoRevert",
       _staggerPropsToSkip = {};
   
   _forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function (name) {
     return _staggerPropsToSkip[name] = 1;
   });
   /*
    * --------------------------------------------------------------------------------------
    * TWEEN
    * --------------------------------------------------------------------------------------
    */
   
   
   var Tween = /*#__PURE__*/function (_Animation2) {
     _inheritsLoose(Tween, _Animation2);
   
     function Tween(targets, vars, position, skipInherit) {
       var _this3;
   
       if (typeof vars === "number") {
         position.duration = vars;
         vars = position;
         position = null;
       }
   
       _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
       var _this3$vars = _this3.vars,
           duration = _this3$vars.duration,
           delay = _this3$vars.delay,
           immediateRender = _this3$vars.immediateRender,
           stagger = _this3$vars.stagger,
           overwrite = _this3$vars.overwrite,
           keyframes = _this3$vars.keyframes,
           defaults = _this3$vars.defaults,
           scrollTrigger = _this3$vars.scrollTrigger,
           parent = vars.parent || _globalTimeline,
           parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [targets] : toArray(targets),
           tl,
           i,
           copy,
           l,
           p,
           curTarget,
           staggerFunc,
           staggerVarsToMerge;
       _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
       _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
   
       _this3._overwrite = overwrite;
   
       if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
         vars = _this3.vars;
         var easeReverse = vars.easeReverse || vars.yoyoEase;
         tl = _this3.timeline = new Timeline({
           data: "nested",
           defaults: defaults || {},
           targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
         }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
   
         tl.kill();
         tl.parent = tl._dp = _assertThisInitialized(_this3);
         tl._start = 0;
   
         if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
           l = parsedTargets.length;
           staggerFunc = stagger && distribute(stagger);
   
           if (_isObject(stagger)) {
             //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
             for (p in stagger) {
               if (~_staggerTweenProps.indexOf(p)) {
                 staggerVarsToMerge || (staggerVarsToMerge = {});
                 staggerVarsToMerge[p] = stagger[p];
               }
             }
           }
   
           for (i = 0; i < l; i++) {
             copy = _copyExcluding(vars, _staggerPropsToSkip);
             copy.stagger = 0;
             easeReverse && (copy.easeReverse = easeReverse);
             staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
             curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
   
             copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
             copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
   
             if (!stagger && l === 1 && copy.delay) {
               // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
               _this3._delay = delay = copy.delay;
               _this3._start += delay;
               copy.delay = 0;
             }
   
             tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
             tl._ease = _easeMap.none;
           }
   
           tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
         } else if (keyframes) {
           _inheritDefaults(_setDefaults(tl.vars.defaults, {
             ease: "none"
           }));
   
           tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
           var time = 0,
               a,
               kf,
               v;
   
           if (_isArray(keyframes)) {
             keyframes.forEach(function (frame) {
               return tl.to(parsedTargets, frame, ">");
             });
             tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
           } else {
             copy = {};
   
             for (p in keyframes) {
               p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
             }
   
             for (p in copy) {
               a = copy[p].sort(function (a, b) {
                 return a.t - b.t;
               });
               time = 0;
   
               for (i = 0; i < a.length; i++) {
                 kf = a[i];
                 v = {
                   ease: kf.e,
                   duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                 };
                 v[p] = kf.v;
                 tl.to(parsedTargets, v, time);
                 time += v.duration;
               }
             }
   
             tl.duration() < duration && tl.to({}, {
               duration: duration - tl.duration()
             }); // in case keyframes didn't go to 100%
           }
         }
   
         duration || _this3.duration(duration = tl.duration());
       } else {
         _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
       }
   
       if (overwrite === true && !_suppressOverwrites) {
         _overwritingTween = _assertThisInitialized(_this3);
   
         _globalTimeline.killTweensOf(parsedTargets);
   
         _overwritingTween = 0;
       }
   
       _addToTimeline(parent, _assertThisInitialized(_this3), position);
   
       vars.reversed && _this3.reverse();
       vars.paused && _this3.paused(true);
   
       if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
         _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
   
         _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
   
       }
   
       scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
       return _this3;
     }
   
     var _proto3 = Tween.prototype;
   
     _proto3.render = function render(totalTime, suppressEvents, force) {
       var prevTime = this._time,
           tDur = this._tDur,
           dur = this._dur,
           isNegative = totalTime < 0,
           tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime,
           time,
           pt,
           iteration,
           cycleDuration,
           prevIteration,
           isYoyo,
           ratio,
           timeline;
   
       if (!dur) {
         _renderZeroDurationTween(this, totalTime, suppressEvents, force);
       } else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative || this._lazy) {
         // this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
         time = tTime;
         timeline = this.timeline;
   
         if (this._repeat) {
           //adjust the time for repeats and yoyos
           cycleDuration = dur + this._rDelay;
   
           if (this._repeat < -1 && isNegative) {
             return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
           }
   
           time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
   
           if (tTime === tDur) {
             // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
             iteration = this._repeat;
             time = dur;
           } else {
             prevIteration = _roundPrecise(tTime / cycleDuration); // full decimal version of iterations, not the previous iteration (we're reusing prevIteration variable for efficiency)
   
             iteration = ~~prevIteration;
   
             if (iteration && iteration === prevIteration) {
               time = dur;
               iteration--;
             } else if (time > dur) {
               time = dur;
             }
           }
   
           isYoyo = this._yoyo && iteration & 1;
           if (isYoyo) time = dur - time;
           prevIteration = _animationCycle(this._tTime, cycleDuration);
   
           if (time === prevTime && !force && this._initted && iteration === prevIteration) {
             //could be during the repeatDelay part. No need to render and fire callbacks.
             this._tTime = tTime;
             return this;
           }
   
           if (iteration !== prevIteration) {
             //repeatRefresh functionality
             if (this.vars.repeatRefresh && !isYoyo && !this._lock && time !== cycleDuration && this._initted) {
               // this._time will === cycleDuration when we render at EXACTLY the end of an iteration. Without this condition, it'd often do the repeatRefresh render TWICE (again on the very next tick).
               this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
   
               this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
             }
           }
         }
   
         if (!this._initted) {
           if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
             this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
   
             return this;
           }
   
           if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) {
             // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values. But we also don't want to dump if we're doing a repeatRefresh render!
             return this;
           }
   
           if (dur !== this._dur) {
             // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
             return this.render(totalTime, suppressEvents, force);
           }
         }
   
         if (this._rEase) {
           var inv = time < prevTime;
   
           if (inv !== this._inv) {
             var segDur = inv ? prevTime : dur - prevTime;
             this._inv = inv;
             if (this._from) this.ratio = 1 - this.ratio;
             this._invRatio = this.ratio;
             this._invTime = prevTime;
             this._invRecip = segDur ? (inv ? -1 : 1) / segDur : 0;
             this._invScale = inv ? -this.ratio : 1 - this.ratio;
             this._invEase = inv ? this._rEase : this._ease;
           }
   
           this.ratio = ratio = this._invRatio + this._invScale * this._invEase((time - this._invTime) * this._invRecip);
         } else {
           this.ratio = ratio = this._ease(time / dur);
         }
   
         if (this._from) this.ratio = ratio = 1 - ratio;
         this._tTime = tTime;
         this._time = time;
   
         if (!this._act && this._ts) {
           this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
   
           this._lazy = 0;
         }
   
         if (!prevTime && tTime && !suppressEvents && !prevIteration) {
           _callback(this, "onStart");
   
           if (this._tTime !== tTime) {
             // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
             return this;
           }
         }
   
         pt = this._pt;
   
         while (pt) {
           pt.r(ratio, pt.d);
           pt = pt._next;
         }
   
         timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
   
         if (this._onUpdate && !suppressEvents) {
           isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
   
           _callback(this, "onUpdate");
         }
   
         this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
   
         if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
           isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
           (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
   
           if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
             // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
             _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
   
             this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
           }
         }
       }
   
       return this;
     };
   
     _proto3.targets = function targets() {
       return this._targets;
     };
   
     _proto3.invalidate = function invalidate(soft) {
       // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
       (!soft || !this.vars.runBackwards) && (this._startAt = 0);
       this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
       this._ptLookup = [];
       this.timeline && this.timeline.invalidate(soft);
       return _Animation2.prototype.invalidate.call(this, soft);
     };
   
     _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
       _tickerActive || _ticker.wake();
       this._ts || this.play();
       var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts),
           ratio;
       this._initted || _initTween(this, time);
       ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
       // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
       // if (_isObject(property)) { // performance optimization
       // 	for (p in property) {
       // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
       // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
       // 		}
       // 	}
       // } else {
   
       if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) {
         return this.resetTo(property, value, start, startIsRelative, 1); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
       } //}
   
   
       _alignPlayhead(this, 0);
   
       this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
       return this.render(0);
     };
   
     _proto3.kill = function kill(targets, vars) {
       if (vars === void 0) {
         vars = "all";
       }
   
       if (!targets && (!vars || vars === "all")) {
         this._lazy = this._pt = 0;
         this.parent ? _interrupt(this) : this.scrollTrigger && this.scrollTrigger.kill(!!_reverting);
         return this;
       }
   
       if (this.timeline) {
         var tDur = this.timeline.totalDuration();
         this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.
   
         this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
   
         return this;
       }
   
       var parsedTargets = this._targets,
           killingTargets = targets ? toArray(targets) : parsedTargets,
           propTweenLookup = this._ptLookup,
           firstPT = this._pt,
           overwrittenProps,
           curLookup,
           curOverwriteProps,
           props,
           p,
           pt,
           i;
   
       if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
         vars === "all" && (this._pt = 0);
         return _interrupt(this);
       }
   
       overwrittenProps = this._op = this._op || [];
   
       if (vars !== "all") {
         //so people can pass in a comma-delimited list of property names
         if (_isString(vars)) {
           p = {};
   
           _forEachName(vars, function (name) {
             return p[name] = 1;
           });
   
           vars = p;
         }
   
         vars = _addAliasesToVars(parsedTargets, vars);
       }
   
       i = parsedTargets.length;
   
       while (i--) {
         if (~killingTargets.indexOf(parsedTargets[i])) {
           curLookup = propTweenLookup[i];
   
           if (vars === "all") {
             overwrittenProps[i] = vars;
             props = curLookup;
             curOverwriteProps = {};
           } else {
             curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
             props = vars;
           }
   
           for (p in props) {
             pt = curLookup && curLookup[p];
   
             if (pt) {
               if (!("kill" in pt.d) || pt.d.kill(p) === true) {
                 _removeLinkedListItem(this, pt, "_pt");
               }
   
               delete curLookup[p];
             }
   
             if (curOverwriteProps !== "all") {
               curOverwriteProps[p] = 1;
             }
           }
         }
       }
   
       this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
   
       return this;
     };
   
     Tween.to = function to(targets, vars) {
       return new Tween(targets, vars, arguments[2]);
     };
   
     Tween.from = function from(targets, vars) {
       return _createTweenType(1, arguments);
     };
   
     Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
       return new Tween(callback, 0, {
         immediateRender: false,
         lazy: false,
         overwrite: false,
         delay: delay,
         onComplete: callback,
         onReverseComplete: callback,
         onCompleteParams: params,
         onReverseCompleteParams: params,
         callbackScope: scope
       }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
     };
   
     Tween.fromTo = function fromTo(targets, fromVars, toVars) {
       return _createTweenType(2, arguments);
     };
   
     Tween.set = function set(targets, vars) {
       vars.duration = 0;
       vars.repeatDelay || (vars.repeat = 0);
       return new Tween(targets, vars);
     };
   
     Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
       return _globalTimeline.killTweensOf(targets, props, onlyActive);
     };
   
     return Tween;
   }(Animation);
   
   _setDefaults(Tween.prototype, {
     _targets: [],
     _lazy: 0,
     _startAt: 0,
     _op: 0,
     _onInit: 0
   }); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
   // _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
   // 	Tween.prototype[name] = function() {
   // 		let tl = new Timeline();
   // 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
   // 	}
   // });
   //for backward compatibility. Leverage the timeline calls.
   
   
   _forEachName("staggerTo,staggerFrom,staggerFromTo", function (name) {
     Tween[name] = function () {
       var tl = new Timeline(),
           params = _slice.call(arguments, 0);
   
       params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
       return tl[name].apply(tl, params);
     };
   });
   /*
    * --------------------------------------------------------------------------------------
    * PROPTWEEN
    * --------------------------------------------------------------------------------------
    */
   
   
   var _setterPlain = function _setterPlain(target, property, value) {
     return target[property] = value;
   },
       _setterFunc = function _setterFunc(target, property, value) {
     return target[property](value);
   },
       _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
     return target[property](data.fp, value);
   },
       _setterAttribute = function _setterAttribute(target, property, value) {
     return target.setAttribute(property, value);
   },
       _getSetter = function _getSetter(target, property) {
     return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
   },
       _renderPlain = function _renderPlain(ratio, data) {
     return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
   },
       _renderBoolean = function _renderBoolean(ratio, data) {
     return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
   },
       _renderComplexString = function _renderComplexString(ratio, data) {
     var pt = data._pt,
         s = "";
   
     if (!ratio && data.b) {
       //b = beginning string
       s = data.b;
     } else if (ratio === 1 && data.e) {
       //e = ending string
       s = data.e;
     } else {
       while (pt) {
         s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
   
         pt = pt._next;
       }
   
       s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
     }
   
     data.set(data.t, data.p, s, data);
   },
       _renderPropTweens = function _renderPropTweens(ratio, data) {
     var pt = data._pt;
   
     while (pt) {
       pt.r(ratio, pt.d);
       pt = pt._next;
     }
   },
       _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
     var pt = this._pt,
         next;
   
     while (pt) {
       next = pt._next;
       pt.p === property && pt.modifier(modifier, tween, target);
       pt = next;
     }
   },
       _killPropTweensOf = function _killPropTweensOf(property) {
     var pt = this._pt,
         hasNonDependentRemaining,
         next;
   
     while (pt) {
       next = pt._next;
   
       if (pt.p === property && !pt.op || pt.op === property) {
         _removeLinkedListItem(this, pt, "_pt");
       } else if (!pt.dep) {
         hasNonDependentRemaining = 1;
       }
   
       pt = next;
     }
   
     return !hasNonDependentRemaining;
   },
       _setterWithModifier = function _setterWithModifier(target, property, value, data) {
     data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
   },
       _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
     var pt = parent._pt,
         next,
         pt2,
         first,
         last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
   
     while (pt) {
       next = pt._next;
       pt2 = first;
   
       while (pt2 && pt2.pr > pt.pr) {
         pt2 = pt2._next;
       }
   
       if (pt._prev = pt2 ? pt2._prev : last) {
         pt._prev._next = pt;
       } else {
         first = pt;
       }
   
       if (pt._next = pt2) {
         pt2._prev = pt;
       } else {
         last = pt;
       }
   
       pt = next;
     }
   
     parent._pt = first;
   }; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
   
   
   var PropTween = /*#__PURE__*/function () {
     function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
       this.t = target;
       this.s = start;
       this.c = change;
       this.p = prop;
       this.r = renderer || _renderPlain;
       this.d = data || this;
       this.set = setter || _setterPlain;
       this.pr = priority || 0;
       this._next = next;
   
       if (next) {
         next._prev = this;
       }
     }
   
     var _proto4 = PropTween.prototype;
   
     _proto4.modifier = function modifier(func, tween, target) {
       this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
   
       this.set = _setterWithModifier;
       this.m = func;
       this.mt = target; //modifier target
   
       this.tween = tween;
     };
   
     return PropTween;
   }(); //Initialization tasks
   
   _forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger,easeReverse", function (name) {
     return _reservedProps[name] = 1;
   });
   
   _globals.TweenMax = _globals.TweenLite = Tween;
   _globals.TimelineLite = _globals.TimelineMax = Timeline;
   _globalTimeline = new Timeline({
     sortChildren: false,
     defaults: _defaults,
     autoRemoveChildren: true,
     id: "root",
     smoothChildTiming: true
   });
   _config.stringFilter = _colorStringFilter;
   
   var _media = [],
       _listeners = {},
       _emptyArray = [],
       _lastMediaTime = 0,
       _contextID = 0,
       _dispatch = function _dispatch(type) {
     return (_listeners[type] || _emptyArray).map(function (f) {
       return f();
     });
   },
       _onMediaChange = function _onMediaChange() {
     var time = Date.now(),
         matches = [];
   
     if (time - _lastMediaTime > 2) {
       _dispatch("matchMediaInit");
   
       _media.forEach(function (c) {
         var queries = c.queries,
             conditions = c.conditions,
             match,
             p,
             anyMatch,
             toggled;
   
         for (p in queries) {
           match = _win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
   
           match && (anyMatch = 1);
   
           if (match !== conditions[p]) {
             conditions[p] = match;
             toggled = 1;
           }
         }
   
         if (toggled) {
           c.revert();
           anyMatch && matches.push(c);
         }
       });
   
       _dispatch("matchMediaRevert");
   
       matches.forEach(function (c) {
         return c.onMatch(c, function (func) {
           return c.add(null, func);
         });
       });
       _lastMediaTime = time;
   
       _dispatch("matchMedia");
     }
   };
   
   var Context = /*#__PURE__*/function () {
     function Context(func, scope) {
       this.selector = scope && selector(scope);
       this.data = [];
       this._r = []; // returned/cleanup functions
   
       this.isReverted = false;
       this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
   
       func && this.add(func);
     }
   
     var _proto5 = Context.prototype;
   
     _proto5.add = function add(name, func, scope) {
       // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
       // if (name && _isFunction(name.revert)) {
       // 	this.data.push(name);
       // 	return (name._ctx = this);
       // }
       if (_isFunction(name)) {
         scope = func;
         func = name;
         name = _isFunction;
       }
   
       var self = this,
           f = function f() {
         var prev = _context,
             prevSelector = self.selector,
             result;
         prev && prev !== self && prev.data.push(self);
         scope && (self.selector = selector(scope));
         _context = self;
         result = func.apply(self, arguments);
         _isFunction(result) && self._r.push(result);
         _context = prev;
         self.selector = prevSelector;
         self.isReverted = false;
         return result;
       };
   
       self.last = f;
       return name === _isFunction ? f(self, function (func) {
         return self.add(null, func);
       }) : name ? self[name] = f : f;
     };
   
     _proto5.ignore = function ignore(func) {
       var prev = _context;
       _context = null;
       func(this);
       _context = prev;
     };
   
     _proto5.getTweens = function getTweens() {
       var a = [];
       this.data.forEach(function (e) {
         return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
       });
       return a;
     };
   
     _proto5.clear = function clear() {
       this._r.length = this.data.length = 0;
     };
   
     _proto5.kill = function kill(revert, matchMedia) {
       var _this4 = this;
   
       if (revert) {
         (function () {
           var tweens = _this4.getTweens(),
               i = _this4.data.length,
               t;
   
           while (i--) {
             // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
             t = _this4.data[i];
   
             if (t.data === "isFlip") {
               t.revert();
               t.getChildren(true, true, false).forEach(function (tween) {
                 return tweens.splice(tweens.indexOf(tween), 1);
               });
             }
           } // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
   
   
           tweens.map(function (t) {
             return {
               g: t._dur || t._delay || t._sat && !t._sat.vars.immediateRender ? t.globalTime(0) : -Infinity,
               t: t
             };
           }).sort(function (a, b) {
             return b.g - a.g || -Infinity;
           }).forEach(function (o) {
             return o.t.revert(revert);
           }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
   
           i = _this4.data.length;
   
           while (i--) {
             // make sure we loop backwards so that, for example, SplitTexts that were created later on the same element get reverted first
             t = _this4.data[i];
   
             if (t instanceof Timeline) {
               if (t.data !== "nested") {
                 t.scrollTrigger && t.scrollTrigger.revert();
                 t.kill(); // don't revert() the timeline because that's duplicating efforts since we already reverted all the tweens
               }
             } else {
               !(t instanceof Tween) && t.revert && t.revert(revert);
             }
           }
   
           _this4._r.forEach(function (f) {
             return f(revert, _this4);
           });
   
           _this4.isReverted = true;
         })();
       } else {
         this.data.forEach(function (e) {
           return e.kill && e.kill();
         });
       }
   
       this.clear();
   
       if (matchMedia) {
         var i = _media.length;
   
         while (i--) {
           // previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
           _media[i].id === this.id && _media.splice(i, 1);
         }
       }
     } // killWithCleanup() {
     // 	this.kill();
     // 	this._r.forEach(f => f(false, this));
     // }
     ;
   
     _proto5.revert = function revert(config) {
       this.kill(config || {});
     };
   
     return Context;
   }();
   
   var MatchMedia = /*#__PURE__*/function () {
     function MatchMedia(scope) {
       this.contexts = [];
       this.scope = scope;
       _context && _context.data.push(this);
     }
   
     var _proto6 = MatchMedia.prototype;
   
     _proto6.add = function add(conditions, func, scope) {
       _isObject(conditions) || (conditions = {
         matches: conditions
       });
       var context = new Context(0, scope || this.scope),
           cond = context.conditions = {},
           mq,
           p,
           active;
       _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
   
       this.contexts.push(context);
       func = context.add("onMatch", func);
       context.queries = conditions;
   
       for (p in conditions) {
         if (p === "all") {
           active = 1;
         } else {
           mq = _win.matchMedia(conditions[p]);
   
           if (mq) {
             _media.indexOf(context) < 0 && _media.push(context);
             (cond[p] = mq.matches) && (active = 1);
             mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
           }
         }
       }
   
       active && func(context, function (f) {
         return context.add(null, f);
       });
       return this;
     } // refresh() {
     // 	let time = _lastMediaTime,
     // 		media = _media;
     // 	_lastMediaTime = -1;
     // 	_media = this.contexts;
     // 	_onMediaChange();
     // 	_lastMediaTime = time;
     // 	_media = media;
     // }
     ;
   
     _proto6.revert = function revert(config) {
       this.kill(config || {});
     };
   
     _proto6.kill = function kill(revert) {
       this.contexts.forEach(function (c) {
         return c.kill(revert, true);
       });
     };
   
     return MatchMedia;
   }();
   /*
    * --------------------------------------------------------------------------------------
    * GSAP
    * --------------------------------------------------------------------------------------
    */
   
   
   var _gsap = {
     registerPlugin: function registerPlugin() {
       for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
         args[_key2] = arguments[_key2];
       }
   
       args.forEach(function (config) {
         return _createPlugin(config);
       });
     },
     timeline: function timeline(vars) {
       return new Timeline(vars);
     },
     getTweensOf: function getTweensOf(targets, onlyActive) {
       return _globalTimeline.getTweensOf(targets, onlyActive);
     },
     getProperty: function getProperty(target, property, unit, uncache) {
       _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in
   
       var getter = _getCache(target || {}).get,
           format = unit ? _passThrough : _numericIfPossible;
   
       unit === "native" && (unit = "");
       return !target ? target : !property ? function (property, unit, uncache) {
         return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
       } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
     },
     quickSetter: function quickSetter(target, property, unit) {
       target = toArray(target);
   
       if (target.length > 1) {
         var setters = target.map(function (t) {
           return gsap.quickSetter(t, property, unit);
         }),
             l = setters.length;
         return function (value) {
           var i = l;
   
           while (i--) {
             setters[i](value);
           }
         };
       }
   
       target = target[0] || {};
   
       var Plugin = _plugins[property],
           cache = _getCache(target),
           p = cache.harness && (cache.harness.aliases || {})[property] || property,
           // in case it's an alias, like "rotate" for "rotation".
       setter = Plugin ? function (value) {
         var p = new Plugin();
         _quickTween._pt = 0;
         p.init(target, unit ? value + unit : value, _quickTween, 0, [target]);
         p.render(1, p);
         _quickTween._pt && _renderPropTweens(1, _quickTween);
       } : cache.set(target, p);
   
       return Plugin ? setter : function (value) {
         return setter(target, p, unit ? value + unit : value, cache, 1);
       };
     },
     quickTo: function quickTo(target, property, vars) {
       var _setDefaults2;
   
       var tween = gsap.to(target, _setDefaults((_setDefaults2 = {}, _setDefaults2[property] = "+=0.1", _setDefaults2.paused = true, _setDefaults2.stagger = 0, _setDefaults2), vars || {})),
           func = function func(value, start, startIsRelative) {
         return tween.resetTo(property, value, start, startIsRelative);
       };
   
       func.tween = tween;
       return func;
     },
     isTweening: function isTweening(targets) {
       return _globalTimeline.getTweensOf(targets, true).length > 0;
     },
     defaults: function defaults(value) {
       value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
       return _mergeDeep(_defaults, value || {});
     },
     config: function config(value) {
       return _mergeDeep(_config, value || {});
     },
     registerEffect: function registerEffect(_ref3) {
       var name = _ref3.name,
           effect = _ref3.effect,
           plugins = _ref3.plugins,
           defaults = _ref3.defaults,
           extendTimeline = _ref3.extendTimeline;
       (plugins || "").split(",").forEach(function (pluginName) {
         return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
       });
   
       _effects[name] = function (targets, vars, tl) {
         return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
       };
   
       if (extendTimeline) {
         Timeline.prototype[name] = function (targets, vars, position) {
           return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
         };
       }
     },
     registerEase: function registerEase(name, ease) {
       _easeMap[name] = _parseEase(ease);
     },
     parseEase: function parseEase(ease, defaultEase) {
       return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
     },
     getById: function getById(id) {
       return _globalTimeline.getById(id);
     },
     exportRoot: function exportRoot(vars, includeDelayedCalls) {
       if (vars === void 0) {
         vars = {};
       }
   
       var tl = new Timeline(vars),
           child,
           next;
       tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
   
       _globalTimeline.remove(tl);
   
       tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
   
       tl._time = tl._tTime = _globalTimeline._time;
       child = _globalTimeline._first;
   
       while (child) {
         next = child._next;
   
         if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) {
           _addToTimeline(tl, child, child._start - child._delay);
         }
   
         child = next;
       }
   
       _addToTimeline(_globalTimeline, tl, 0);
   
       return tl;
     },
     context: function context(func, scope) {
       return func ? new Context(func, scope) : _context;
     },
     matchMedia: function matchMedia(scope) {
       return new MatchMedia(scope);
     },
     matchMediaRefresh: function matchMediaRefresh() {
       return _media.forEach(function (c) {
         var cond = c.conditions,
             found,
             p;
   
         for (p in cond) {
           if (cond[p]) {
             cond[p] = false;
             found = 1;
           }
         }
   
         found && c.revert();
       }) || _onMediaChange();
     },
     addEventListener: function addEventListener(type, callback) {
       var a = _listeners[type] || (_listeners[type] = []);
       ~a.indexOf(callback) || a.push(callback);
     },
     removeEventListener: function removeEventListener(type, callback) {
       var a = _listeners[type],
           i = a && a.indexOf(callback);
       i >= 0 && a.splice(i, 1);
     },
     utils: {
       wrap: wrap,
       wrapYoyo: wrapYoyo,
       distribute: distribute,
       random: random,
       snap: snap,
       normalize: normalize,
       getUnit: getUnit,
       clamp: clamp,
       splitColor: splitColor,
       toArray: toArray,
       selector: selector,
       mapRange: mapRange,
       pipe: pipe,
       unitize: unitize,
       interpolate: interpolate,
       shuffle: shuffle
     },
     install: _install,
     effects: _effects,
     ticker: _ticker,
     updateRoot: Timeline.updateRoot,
     plugins: _plugins,
     globalTimeline: _globalTimeline,
     core: {
       PropTween: PropTween,
       globals: _addGlobal,
       Tween: Tween,
       Timeline: Timeline,
       Animation: Animation,
       getCache: _getCache,
       _removeLinkedListItem: _removeLinkedListItem,
       reverting: function reverting() {
         return _reverting;
       },
       context: function context(toAdd) {
         if (toAdd && _context) {
           _context.data.push(toAdd);
   
           toAdd._ctx = _context;
         }
   
         return _context;
       },
       suppressOverwrites: function suppressOverwrites(value) {
         return _suppressOverwrites = value;
       }
     }
   };
   
   _forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function (name) {
     return _gsap[name] = Tween[name];
   });
   
   _ticker.add(Timeline.updateRoot);
   
   _quickTween = _gsap.to({}, {
     duration: 0
   }); // ---- EXTRA PLUGINS --------------------------------------------------------
   
   var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
     var pt = plugin._pt;
   
     while (pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop) {
       pt = pt._next;
     }
   
     return pt;
   },
       _addModifiers = function _addModifiers(tween, modifiers) {
     var targets = tween._targets,
         p,
         i,
         pt;
   
     for (p in modifiers) {
       i = targets.length;
   
       while (i--) {
         pt = tween._ptLookup[i][p];
   
         if (pt && (pt = pt.d)) {
           if (pt._pt) {
             // is a plugin
             pt = _getPluginPropTween(pt, p);
           }
   
           pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
         }
       }
     }
   },
       _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
     return {
       name: name,
       headless: 1,
       rawVars: 1,
       //don't pre-process function-based values or "random()" strings.
       init: function init(target, vars, tween) {
         tween._onInit = function (tween) {
           var temp, p;
   
           if (_isString(vars)) {
             temp = {};
   
             _forEachName(vars, function (name) {
               return temp[name] = 1;
             }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
   
   
             vars = temp;
           }
   
           if (modifier) {
             temp = {};
   
             for (p in vars) {
               temp[p] = modifier(vars[p]);
             }
   
             vars = temp;
           }
   
           _addModifiers(tween, vars);
         };
       }
     };
   }; //register core plugins
   
   
   var gsap = _gsap.registerPlugin({
     name: "attr",
     init: function init(target, vars, tween, index, targets) {
       var p, pt, v;
       this.tween = tween;
   
       for (p in vars) {
         v = target.getAttribute(p) || "";
         pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
         pt.op = p;
         pt.b = v; // record the beginning value so we can revert()
   
         this._props.push(p);
       }
     },
     render: function render(ratio, data) {
       var pt = data._pt;
   
       while (pt) {
         _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
   
         pt = pt._next;
       }
     }
   }, {
     name: "endArray",
     headless: 1,
     init: function init(target, value) {
       var i = value.length;
   
       while (i--) {
         this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
       }
     }
   }, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
   
   Tween.version = Timeline.version = gsap.version = "3.15.0";
   _coreReady = 1;
   _windowExists() && _wake();
   var Power0 = _easeMap.Power0,
       Power1 = _easeMap.Power1,
       Power2 = _easeMap.Power2,
       Power3 = _easeMap.Power3,
       Power4 = _easeMap.Power4,
       Linear = _easeMap.Linear,
       Quad = _easeMap.Quad,
       Cubic = _easeMap.Cubic,
       Quart = _easeMap.Quart,
       Quint = _easeMap.Quint,
       Strong = _easeMap.Strong,
       Elastic = _easeMap.Elastic,
       Back = _easeMap.Back,
       SteppedEase = _easeMap.SteppedEase,
       Bounce = _easeMap.Bounce,
       Sine = _easeMap.Sine,
       Expo = _easeMap.Expo,
       Circ = _easeMap.Circ;
   
    //export some internal methods/orojects for use in CSSPlugin so that we can externalize that file and allow custom builds that exclude it.
   
   
   
   /***/ }),
   /* 7 */
   /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
   
   "use strict";
   __webpack_require__.r(__webpack_exports__);
   /* harmony export */ __webpack_require__.d(__webpack_exports__, {
   /* harmony export */   CSSPlugin: () => (/* binding */ CSSPlugin),
   /* harmony export */   _createElement: () => (/* binding */ _createElement),
   /* harmony export */   _getBBox: () => (/* binding */ _getBBox),
   /* harmony export */   checkPrefix: () => (/* binding */ _checkPropPrefix),
   /* harmony export */   "default": () => (/* binding */ CSSPlugin)
   /* harmony export */ });
   /* harmony import */ var _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
   /*!
    * CSSPlugin 3.15.0
    * https://gsap.com
    *
    * Copyright 2008-2026, GreenSock. All rights reserved.
    * Subject to the terms at https://gsap.com/standard-license
    * @author: Jack Doyle, jack@greensock.com
   */
   
   /* eslint-disable */
   
   
   var _win,
       _doc,
       _docElement,
       _pluginInitted,
       _tempDiv,
       _tempDivStyler,
       _recentSetterPlugin,
       _reverting,
       _windowExists = function _windowExists() {
     return typeof window !== "undefined";
   },
       _transformProps = {},
       _RAD2DEG = 180 / Math.PI,
       _DEG2RAD = Math.PI / 180,
       _atan2 = Math.atan2,
       _bigNum = 1e8,
       _capsExp = /([A-Z])/g,
       _horizontalExp = /(left|right|width|margin|padding|x)/i,
       _complexExp = /[\s,\(]\S/,
       _propertyAliases = {
     autoAlpha: "opacity,visibility",
     scale: "scaleX,scaleY",
     alpha: "opacity"
   },
       _renderCSSProp = function _renderCSSProp(ratio, data) {
     return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
   },
       _renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
     return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
   },
       _renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
     return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
   },
       //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
   _renderCSSPropWithBeginningAndEnd = function _renderCSSPropWithBeginningAndEnd(ratio, data) {
     return data.set(data.t, data.p, ratio === 1 ? data.e : ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
   },
       //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
   _renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
     var value = data.s + data.c * ratio;
     data.set(data.t, data.p, ~~(value + (value < 0 ? -.5 : .5)) + data.u, data);
   },
       _renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
     return data.set(data.t, data.p, ratio ? data.e : data.b, data);
   },
       _renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
     return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
   },
       _setterCSSStyle = function _setterCSSStyle(target, property, value) {
     return target.style[property] = value;
   },
       _setterCSSProp = function _setterCSSProp(target, property, value) {
     return target.style.setProperty(property, value);
   },
       _setterTransform = function _setterTransform(target, property, value) {
     return target._gsap[property] = value;
   },
       _setterScale = function _setterScale(target, property, value) {
     return target._gsap.scaleX = target._gsap.scaleY = value;
   },
       _setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
     var cache = target._gsap;
     cache.scaleX = cache.scaleY = value;
     cache.renderTransform(ratio, cache);
   },
       _setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
     var cache = target._gsap;
     cache[property] = value;
     cache.renderTransform(ratio, cache);
   },
       _transformProp = "transform",
       _transformOriginProp = _transformProp + "Origin",
       _saveStyle = function _saveStyle(property, isNotCSS) {
     var _this = this;
   
     var target = this.target,
         style = target.style,
         cache = target._gsap;
   
     if (property in _transformProps && style) {
       this.tfm = this.tfm || {};
   
       if (property !== "transform") {
         property = _propertyAliases[property] || property;
         ~property.indexOf(",") ? property.split(",").forEach(function (a) {
           return _this.tfm[a] = _get(target, a);
         }) : this.tfm[property] = cache.x ? cache[property] : _get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
   
         property === _transformOriginProp && (this.tfm.zOrigin = cache.zOrigin);
       } else {
         return _propertyAliases.transform.split(",").forEach(function (p) {
           return _saveStyle.call(_this, p, isNotCSS);
         });
       }
   
       if (this.props.indexOf(_transformProp) >= 0) {
         return;
       }
   
       if (cache.svg) {
         this.svgo = target.getAttribute("data-svg-origin");
         this.props.push(_transformOriginProp, isNotCSS, "");
       }
   
       property = _transformProp;
     }
   
     (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
   },
       _removeIndependentTransforms = function _removeIndependentTransforms(style) {
     if (style.translate) {
       style.removeProperty("translate");
       style.removeProperty("scale");
       style.removeProperty("rotate");
     }
   },
       _revertStyle = function _revertStyle() {
     var props = this.props,
         target = this.target,
         style = target.style,
         cache = target._gsap,
         i,
         p;
   
     for (i = 0; i < props.length; i += 3) {
       // stored like this: property, isNotCSS, value
       if (!props[i + 1]) {
         props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace(_capsExp, "-$1").toLowerCase());
       } else if (props[i + 1] === 2) {
         // non-CSS value (function-based)
         target[props[i]](props[i + 2]);
       } else {
         // non-CSS value (not function-based)
         target[props[i]] = props[i + 2];
       }
     }
   
     if (this.tfm) {
       for (p in this.tfm) {
         cache[p] = this.tfm[p];
       }
   
       if (cache.svg) {
         cache.renderTransform();
         target.setAttribute("data-svg-origin", this.svgo || "");
       }
   
       i = _reverting();
   
       if ((!i || !i.isStart) && !style[_transformProp]) {
         _removeIndependentTransforms(style);
   
         if (cache.zOrigin && style[_transformOriginProp]) {
           style[_transformOriginProp] += " " + cache.zOrigin + "px"; // since we're uncaching, we must put the zOrigin back into the transformOrigin so that we can pull it out accurately when we parse again. Otherwise, we'd lose the z portion of the origin since we extract it to protect from Safari bugs.
   
           cache.zOrigin = 0;
           cache.renderTransform();
         }
   
         cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
       }
     }
   },
       _getStyleSaver = function _getStyleSaver(target, properties) {
     var saver = {
       target: target,
       props: [],
       revert: _revertStyle,
       save: _saveStyle
     };
     target._gsap || _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.gsap.core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
   
     properties && target.style && target.nodeType && properties.split(",").forEach(function (p) {
       return saver.save(p);
     }); // make sure it's a DOM node too.
   
     return saver;
   },
       _supports3D,
       _createElement = function _createElement(type, ns) {
     var e = _doc.createElementNS ? _doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : _doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
   
     return e && e.style ? e : _doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://gsap.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
   },
       _getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
     var cs = getComputedStyle(target);
     return cs[property] || cs.getPropertyValue(property.replace(_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, _checkPropPrefix(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
   },
       _prefixes = "O,Moz,ms,Ms,Webkit".split(","),
       _checkPropPrefix = function _checkPropPrefix(property, element, preferPrefix) {
     var e = element || _tempDiv,
         s = e.style,
         i = 5;
   
     if (property in s && !preferPrefix) {
       return property;
     }
   
     property = property.charAt(0).toUpperCase() + property.substr(1);
   
     while (i-- && !(_prefixes[i] + property in s)) {}
   
     return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? _prefixes[i] : "") + property;
   },
       _initCore = function _initCore() {
     if (_windowExists() && window.document) {
       _win = window;
       _doc = _win.document;
       _docElement = _doc.documentElement;
       _tempDiv = _createElement("div") || {
         style: {}
       };
       _tempDivStyler = _createElement("div");
       _transformProp = _checkPropPrefix(_transformProp);
       _transformOriginProp = _transformProp + "Origin";
       _tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
   
       _supports3D = !!_checkPropPrefix("perspective");
       _reverting = _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.gsap.core.reverting;
       _pluginInitted = 1;
     }
   },
       _getReparentedCloneBBox = function _getReparentedCloneBBox(target) {
     //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
     var owner = target.ownerSVGElement,
         svg = _createElement("svg", owner && owner.getAttribute("xmlns") || "http://www.w3.org/2000/svg"),
         clone = target.cloneNode(true),
         bbox;
   
     clone.style.display = "block";
     svg.appendChild(clone);
   
     _docElement.appendChild(svg);
   
     try {
       bbox = clone.getBBox();
     } catch (e) {}
   
     svg.removeChild(clone);
   
     _docElement.removeChild(svg);
   
     return bbox;
   },
       _getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
     var i = attributesArray.length;
   
     while (i--) {
       if (target.hasAttribute(attributesArray[i])) {
         return target.getAttribute(attributesArray[i]);
       }
     }
   },
       _getBBox = function _getBBox(target) {
     var bounds, cloned;
   
     try {
       bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
     } catch (error) {
       bounds = _getReparentedCloneBBox(target);
       cloned = 1;
     }
   
     bounds && (bounds.width || bounds.height) || cloned || (bounds = _getReparentedCloneBBox(target)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
   
     return bounds && !bounds.width && !bounds.x && !bounds.y ? {
       x: +_getAttributeFallbacks(target, ["x", "cx", "x1"]) || 0,
       y: +_getAttributeFallbacks(target, ["y", "cy", "y1"]) || 0,
       width: 0,
       height: 0
     } : bounds;
   },
       _isSVG = function _isSVG(e) {
     return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && _getBBox(e));
   },
       //reports if the element is an SVG on which getBBox() actually works
   _removeProperty = function _removeProperty(target, property) {
     if (property) {
       var style = target.style,
           first2Chars;
   
       if (property in _transformProps && property !== _transformOriginProp) {
         property = _transformProp;
       }
   
       if (style.removeProperty) {
         first2Chars = property.substr(0, 2);
   
         if (first2Chars === "ms" || property.substr(0, 6) === "webkit") {
           //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
           property = "-" + property;
         }
   
         style.removeProperty(first2Chars === "--" ? property : property.replace(_capsExp, "-$1").toLowerCase());
       } else {
         //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
         style.removeAttribute(property);
       }
     }
   },
       _addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
     var pt = new _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.PropTween(plugin._pt, target, property, 0, 1, onlySetAtEnd ? _renderNonTweeningValueOnlyAtEnd : _renderNonTweeningValue);
     plugin._pt = pt;
     pt.b = beginning;
     pt.e = end;
   
     plugin._props.push(property);
   
     return pt;
   },
       _nonConvertibleUnits = {
     deg: 1,
     rad: 1,
     turn: 1
   },
       _nonStandardLayouts = {
     grid: 1,
     flex: 1
   },
       //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
   _convertToUnit = function _convertToUnit(target, property, value, unit) {
     var curValue = parseFloat(value) || 0,
         curUnit = (value + "").trim().substr((curValue + "").length) || "px",
         // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
     style = _tempDiv.style,
         horizontal = _horizontalExp.test(property),
         isRootSVG = target.tagName.toLowerCase() === "svg",
         measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"),
         amount = 100,
         toPixels = unit === "px",
         toPercent = unit === "%",
         px,
         parent,
         cache,
         isSVG;
   
     if (unit === curUnit || !curValue || _nonConvertibleUnits[unit] || _nonConvertibleUnits[curUnit]) {
       return curValue;
     }
   
     curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
     isSVG = target.getCTM && _isSVG(target);
   
     if ((toPercent || curUnit === "%") && (_transformProps[property] || ~property.indexOf("adius"))) {
       px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
       return (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._round)(toPercent ? curValue / px * amount : curValue / 100 * px);
     }
   
     style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
     parent = unit !== "rem" && ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
   
     if (isSVG) {
       parent = (target.ownerSVGElement || {}).parentNode;
     }
   
     if (!parent || parent === _doc || !parent.appendChild) {
       parent = _doc.body;
     }
   
     cache = parent._gsap;
   
     if (cache && toPercent && cache.width && horizontal && cache.time === _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._ticker.time && !cache.uncache) {
       return (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._round)(curValue / cache.width * amount);
     } else {
       if (toPercent && (property === "height" || property === "width")) {
         // if we're dealing with width/height that's inside a container with padding and/or it's a flexbox/grid container, we must apply it to the target itself rather than the _tempDiv in order to ensure complete accuracy, factoring in the parent's padding.
         var v = target.style[property];
         target.style[property] = amount + unit;
         px = target[measureProperty];
         v ? target.style[property] = v : _removeProperty(target, property);
       } else {
         (toPercent || curUnit === "%") && !_nonStandardLayouts[_getComputedProperty(parent, "display")] && (style.position = _getComputedProperty(target, "position"));
         parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
   
         parent.appendChild(_tempDiv);
         px = _tempDiv[measureProperty];
         parent.removeChild(_tempDiv);
         style.position = "absolute";
       }
   
       if (horizontal && toPercent) {
         cache = (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._getCache)(parent);
         cache.time = _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._ticker.time;
         cache.width = parent[measureProperty];
       }
     }
   
     return (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._round)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
   },
       _get = function _get(target, property, unit, uncache) {
     var value;
     _pluginInitted || _initCore();
   
     if (property in _propertyAliases && property !== "transform") {
       property = _propertyAliases[property];
   
       if (~property.indexOf(",")) {
         property = property.split(",")[0];
       }
     }
   
     if (_transformProps[property] && property !== "transform") {
       value = _parseTransform(target, uncache);
       value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : _firstTwoOnly(_getComputedProperty(target, _transformOriginProp)) + " " + value.zOrigin + "px";
     } else {
       value = target.style[property];
   
       if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) {
         value = _specialProps[property] && _specialProps[property](target, property, unit) || _getComputedProperty(target, property) || (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._getProperty)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
       }
     }
   
     return unit && !~(value + "").trim().indexOf(" ") ? _convertToUnit(target, property, value, unit) + unit : value;
   },
       _tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
     // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
     if (!start || start === "none") {
       // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://gsap.com/forums/topic/18310-clippath-doesnt-work-on-ios/
       var p = _checkPropPrefix(prop, target, 1),
           s = p && _getComputedProperty(target, p, 1);
   
       if (s && s !== start) {
         prop = p;
         start = s;
       } else if (prop === "borderColor") {
         start = _getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://gsap.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
       }
     }
   
     var pt = new _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.PropTween(this._pt, target.style, prop, 0, 1, _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._renderComplexString),
         index = 0,
         matchIndex = 0,
         a,
         result,
         startValues,
         startNum,
         color,
         startValue,
         endValue,
         endNum,
         chunk,
         endUnit,
         startUnit,
         endValues;
     pt.b = start;
     pt.e = end;
     start += ""; // ensure values are strings
   
     end += "";
   
     if (end.substring(0, 6) === "var(--") {
       end = _getComputedProperty(target, end.substring(4, end.indexOf(")")));
     }
   
     if (end === "auto") {
       startValue = target.style[prop];
       target.style[prop] = end;
       end = _getComputedProperty(target, prop) || end;
       startValue ? target.style[prop] = startValue : _removeProperty(target, prop);
     }
   
     a = [start, end];
   
     (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._colorStringFilter)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
   
   
     start = a[0];
     end = a[1];
     startValues = start.match(_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._numWithUnitExp) || [];
     endValues = end.match(_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._numWithUnitExp) || [];
   
     if (endValues.length) {
       while (result = _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._numWithUnitExp.exec(end)) {
         endValue = result[0];
         chunk = end.substring(index, result.index);
   
         if (color) {
           color = (color + 1) % 5;
         } else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") {
           color = 1;
         }
   
         if (endValue !== (startValue = startValues[matchIndex++] || "")) {
           startNum = parseFloat(startValue) || 0;
           startUnit = startValue.substr((startNum + "").length);
           endValue.charAt(1) === "=" && (endValue = (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._parseRelative)(startNum, endValue) + startUnit);
           endNum = parseFloat(endValue);
           endUnit = endValue.substr((endNum + "").length);
           index = _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._numWithUnitExp.lastIndex - endUnit.length;
   
           if (!endUnit) {
             //if something like "perspective:300" is passed in and we must add a unit to the end
             endUnit = endUnit || _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._config.units[prop] || startUnit;
   
             if (index === end.length) {
               end += endUnit;
               pt.e += endUnit;
             }
           }
   
           if (startUnit !== endUnit) {
             startNum = _convertToUnit(target, prop, startValue, endUnit) || 0;
           } // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
   
   
           pt._pt = {
             _next: pt._pt,
             p: chunk || matchIndex === 1 ? chunk : ",",
             //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
             s: startNum,
             c: endNum - startNum,
             m: color && color < 4 || prop === "zIndex" ? Math.round : 0
           };
         }
       }
   
       pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
     } else {
       pt.r = prop === "display" && end === "none" ? _renderNonTweeningValueOnlyAtEnd : _renderNonTweeningValue;
     }
   
     _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._relExp.test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
   
     this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
   
     return pt;
   },
       _keywordToPercent = {
     top: "0%",
     bottom: "100%",
     left: "0%",
     right: "100%",
     center: "50%"
   },
       _convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
     var split = value.split(" "),
         x = split[0],
         y = split[1] || "50%";
   
     if (x === "top" || x === "bottom" || y === "left" || y === "right") {
       //the user provided them in the wrong order, so flip them
       value = x;
       x = y;
       y = value;
     }
   
     split[0] = _keywordToPercent[x] || x;
     split[1] = _keywordToPercent[y] || y;
     return split.join(" ");
   },
       _renderClearProps = function _renderClearProps(ratio, data) {
     if (data.tween && data.tween._time === data.tween._dur) {
       var target = data.t,
           style = target.style,
           props = data.u,
           cache = target._gsap,
           prop,
           clearTransforms,
           i;
   
       if (props === "all" || props === true) {
         style.cssText = "";
         clearTransforms = 1;
       } else {
         props = props.split(",");
         i = props.length;
   
         while (--i > -1) {
           prop = props[i];
   
           if (_transformProps[prop]) {
             clearTransforms = 1;
             prop = prop === "transformOrigin" ? _transformOriginProp : _transformProp;
           }
   
           _removeProperty(target, prop);
         }
       }
   
       if (clearTransforms) {
         _removeProperty(target, _transformProp);
   
         if (cache) {
           cache.svg && target.removeAttribute("transform");
           style.scale = style.rotate = style.translate = "none";
   
           _parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
   
   
           cache.uncache = 1;
   
           _removeIndependentTransforms(style);
         }
       }
     }
   },
       // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
   _specialProps = {
     clearProps: function clearProps(plugin, target, property, endValue, tween) {
       if (tween.data !== "isFromStart") {
         var pt = plugin._pt = new _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.PropTween(plugin._pt, target, property, 0, 0, _renderClearProps);
         pt.u = endValue;
         pt.pr = -10;
         pt.tween = tween;
   
         plugin._props.push(property);
   
         return 1;
       }
     }
     /* className feature (about 0.4kb gzipped).
     , className(plugin, target, property, endValue, tween) {
         let _renderClassName = (ratio, data) => {
                 data.css.render(ratio, data.css);
                 if (!ratio || ratio === 1) {
                     let inline = data.rmv,
                         target = data.t,
                         p;
                     target.setAttribute("class", ratio ? data.e : data.b);
                     for (p in inline) {
                         _removeProperty(target, p);
                     }
                 }
             },
             _getAllStyles = (target) => {
                 let styles = {},
                     computed = getComputedStyle(target),
                     p;
                 for (p in computed) {
                     if (isNaN(p) && p !== "cssText" && p !== "length") {
                         styles[p] = computed[p];
                     }
                 }
                 _setDefaults(styles, _parseTransform(target, 1));
                 return styles;
             },
             startClassList = target.getAttribute("class"),
             style = target.style,
             cssText = style.cssText,
             cache = target._gsap,
             classPT = cache.classPT,
             inlineToRemoveAtEnd = {},
             data = {t:target, plugin:plugin, rmv:inlineToRemoveAtEnd, b:startClassList, e:(endValue.charAt(1) !== "=") ? endValue : startClassList.replace(new RegExp("(?:\\s|^)" + endValue.substr(2) + "(?![\\w-])"), "") + ((endValue.charAt(0) === "+") ? " " + endValue.substr(2) : "")},
             changingVars = {},
             startVars = _getAllStyles(target),
             transformRelated = /(transform|perspective)/i,
             endVars, p;
         if (classPT) {
             classPT.r(1, classPT.d);
             _removeLinkedListItem(classPT.d.plugin, classPT, "_pt");
         }
         target.setAttribute("class", data.e);
         endVars = _getAllStyles(target, true);
         target.setAttribute("class", startClassList);
         for (p in endVars) {
             if (endVars[p] !== startVars[p] && !transformRelated.test(p)) {
                 changingVars[p] = endVars[p];
                 if (!style[p] && style[p] !== "0") {
                     inlineToRemoveAtEnd[p] = 1;
                 }
             }
         }
         cache.classPT = plugin._pt = new PropTween(plugin._pt, target, "className", 0, 0, _renderClassName, data, 0, -11);
         if (style.cssText !== cssText) { //only apply if things change. Otherwise, in cases like a background-image that's pulled dynamically, it could cause a refresh. See https://gsap.com/forums/topic/20368-possible-gsap-bug-switching-classnames-in-chrome/.
             style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
         }
         _parseTransform(target, true); //to clear the caching of transforms
         data.css = new gsap.plugins.css();
         data.css.init(target, changingVars, tween);
         plugin._props.push(...data.css._props);
         return 1;
     }
     */
   
   },
   
   /*
    * --------------------------------------------------------------------------------------
    * TRANSFORMS
    * --------------------------------------------------------------------------------------
    */
   _identity2DMatrix = [1, 0, 0, 1, 0, 0],
       _rotationalProperties = {},
       _isNullTransform = function _isNullTransform(value) {
     return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
   },
       _getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
     var matrixString = _getComputedProperty(target, _transformProp);
   
     return _isNullTransform(matrixString) ? _identity2DMatrix : matrixString.substr(7).match(_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._numExp).map(_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._round);
   },
       _getMatrix = function _getMatrix(target, force2D) {
     var cache = target._gsap || (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._getCache)(target),
         style = target.style,
         matrix = _getComputedTransformMatrixAsArray(target),
         parent,
         nextSibling,
         temp,
         addedToDOM;
   
     if (cache.svg && target.getAttribute("transform")) {
       temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
   
       matrix = [temp.a, temp.b, temp.c, temp.d, temp.e, temp.f];
       return matrix.join(",") === "1,0,0,1,0,0" ? _identity2DMatrix : matrix;
     } else if (matrix === _identity2DMatrix && !target.offsetParent && target !== _docElement && !cache.svg) {
       //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
       //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
       temp = style.display;
       style.display = "block";
       parent = target.parentNode;
   
       if (!parent || !target.offsetParent && !target.getBoundingClientRect().width) {
         // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375. Note: position: fixed elements report a null offsetParent but they could also be invisible because they're in an ancestor with display: none, so we check getBoundingClientRect(). We only want to alter the DOM if we absolutely have to because it can cause iframe content to reload, like a Vimeo video.
         addedToDOM = 1; //flag
   
         nextSibling = target.nextElementSibling;
   
         _docElement.appendChild(target); //we must add it to the DOM in order to get values properly
   
       }
   
       matrix = _getComputedTransformMatrixAsArray(target);
       temp ? style.display = temp : _removeProperty(target, "display");
   
       if (addedToDOM) {
         nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : _docElement.removeChild(target);
       }
     }
   
     return force2D && matrix.length > 6 ? [matrix[0], matrix[1], matrix[4], matrix[5], matrix[12], matrix[13]] : matrix;
   },
       _applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
     var cache = target._gsap,
         matrix = matrixArray || _getMatrix(target, true),
         xOriginOld = cache.xOrigin || 0,
         yOriginOld = cache.yOrigin || 0,
         xOffsetOld = cache.xOffset || 0,
         yOffsetOld = cache.yOffset || 0,
         a = matrix[0],
         b = matrix[1],
         c = matrix[2],
         d = matrix[3],
         tx = matrix[4],
         ty = matrix[5],
         originSplit = origin.split(" "),
         xOrigin = parseFloat(originSplit[0]) || 0,
         yOrigin = parseFloat(originSplit[1]) || 0,
         bounds,
         determinant,
         x,
         y;
   
     if (!originIsAbsolute) {
       bounds = _getBBox(target);
       xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
       yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin); // if (!("xOrigin" in cache) && (xOrigin || yOrigin)) { // added in 3.12.3, reverted in 3.12.4; requires more exploration
       // 	xOrigin -= bounds.x;
       // 	yOrigin -= bounds.y;
       // }
     } else if (matrix !== _identity2DMatrix && (determinant = a * d - b * c)) {
       //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
       x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
       y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
       xOrigin = x;
       yOrigin = y; // theory: we only had to do this for smoothing and it assumes that the previous one was not originIsAbsolute.
     }
   
     if (smooth || smooth !== false && cache.smooth) {
       tx = xOrigin - xOriginOld;
       ty = yOrigin - yOriginOld;
       cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
       cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
     } else {
       cache.xOffset = cache.yOffset = 0;
     }
   
     cache.xOrigin = xOrigin;
     cache.yOrigin = yOrigin;
     cache.smooth = !!smooth;
     cache.origin = origin;
     cache.originIsAbsolute = !!originIsAbsolute;
     target.style[_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
   
     if (pluginToAddPropTweensTo) {
       _addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
   
       _addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
   
       _addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
   
       _addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
     }
   
     target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
   },
       _parseTransform = function _parseTransform(target, uncache) {
     var cache = target._gsap || new _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.GSCache(target);
   
     if ("x" in cache && !uncache && !cache.uncache) {
       return cache;
     }
   
     var style = target.style,
         invertedScaleX = cache.scaleX < 0,
         px = "px",
         deg = "deg",
         cs = getComputedStyle(target),
         origin = _getComputedProperty(target, _transformOriginProp) || "0",
         x,
         y,
         z,
         scaleX,
         scaleY,
         rotation,
         rotationX,
         rotationY,
         skewX,
         skewY,
         perspective,
         xOrigin,
         yOrigin,
         matrix,
         angle,
         cos,
         sin,
         a,
         b,
         c,
         d,
         a12,
         a22,
         t1,
         t2,
         t3,
         a13,
         a23,
         a33,
         a42,
         a43,
         a32;
     x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
     scaleX = scaleY = 1;
     cache.svg = !!(target.getCTM && _isSVG(target));
   
     if (cs.translate) {
       // accommodate independent transforms by combining them into normal ones.
       if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") {
         style[_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[_transformProp] !== "none" ? cs[_transformProp] : "");
       }
   
       style.scale = style.rotate = style.translate = "none";
     }
   
     matrix = _getMatrix(target, cache.svg);
   
     if (cache.svg) {
       if (cache.uncache) {
         // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
         t2 = target.getBBox();
         origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
         t1 = "";
       } else {
         t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
       }
   
       _applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
     }
   
     xOrigin = cache.xOrigin || 0;
     yOrigin = cache.yOrigin || 0;
   
     if (matrix !== _identity2DMatrix) {
       a = matrix[0]; //a11
   
       b = matrix[1]; //a21
   
       c = matrix[2]; //a31
   
       d = matrix[3]; //a41
   
       x = a12 = matrix[4];
       y = a22 = matrix[5]; //2D matrix
   
       if (matrix.length === 6) {
         scaleX = Math.sqrt(a * a + b * b);
         scaleY = Math.sqrt(d * d + c * c);
         rotation = a || b ? _atan2(b, a) * _RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
   
         skewX = c || d ? _atan2(c, d) * _RAD2DEG + rotation : 0;
         skewX && (scaleY *= Math.abs(Math.cos(skewX * _DEG2RAD)));
   
         if (cache.svg) {
           x -= xOrigin - (xOrigin * a + yOrigin * c);
           y -= yOrigin - (xOrigin * b + yOrigin * d);
         } //3D matrix
   
       } else {
         a32 = matrix[6];
         a42 = matrix[7];
         a13 = matrix[8];
         a23 = matrix[9];
         a33 = matrix[10];
         a43 = matrix[11];
         x = matrix[12];
         y = matrix[13];
         z = matrix[14];
         angle = _atan2(a32, a33);
         rotationX = angle * _RAD2DEG; //rotationX
   
         if (angle) {
           cos = Math.cos(-angle);
           sin = Math.sin(-angle);
           t1 = a12 * cos + a13 * sin;
           t2 = a22 * cos + a23 * sin;
           t3 = a32 * cos + a33 * sin;
           a13 = a12 * -sin + a13 * cos;
           a23 = a22 * -sin + a23 * cos;
           a33 = a32 * -sin + a33 * cos;
           a43 = a42 * -sin + a43 * cos;
           a12 = t1;
           a22 = t2;
           a32 = t3;
         } //rotationY
   
   
         angle = _atan2(-c, a33);
         rotationY = angle * _RAD2DEG;
   
         if (angle) {
           cos = Math.cos(-angle);
           sin = Math.sin(-angle);
           t1 = a * cos - a13 * sin;
           t2 = b * cos - a23 * sin;
           t3 = c * cos - a33 * sin;
           a43 = d * sin + a43 * cos;
           a = t1;
           b = t2;
           c = t3;
         } //rotationZ
   
   
         angle = _atan2(b, a);
         rotation = angle * _RAD2DEG;
   
         if (angle) {
           cos = Math.cos(angle);
           sin = Math.sin(angle);
           t1 = a * cos + b * sin;
           t2 = a12 * cos + a22 * sin;
           b = b * cos - a * sin;
           a22 = a22 * cos - a12 * sin;
           a = t1;
           a12 = t2;
         }
   
         if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
           //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
           rotationX = rotation = 0;
           rotationY = 180 - rotationY;
         }
   
         scaleX = (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._round)(Math.sqrt(a * a + b * b + c * c));
         scaleY = (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._round)(Math.sqrt(a22 * a22 + a32 * a32));
         angle = _atan2(a12, a22);
         skewX = Math.abs(angle) > 0.0002 ? angle * _RAD2DEG : 0;
         perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
       }
   
       if (cache.svg) {
         //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
         t1 = target.getAttribute("transform");
         cache.forceCSS = target.setAttribute("transform", "") || !_isNullTransform(_getComputedProperty(target, _transformProp));
         t1 && target.setAttribute("transform", t1);
       }
     }
   
     if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
       if (invertedScaleX) {
         scaleX *= -1;
         skewX += rotation <= 0 ? 180 : -180;
         rotation += rotation <= 0 ? 180 : -180;
       } else {
         scaleY *= -1;
         skewX += skewX <= 0 ? 180 : -180;
       }
     }
   
     uncache = uncache || cache.uncache;
     cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
     cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
     cache.z = z + px;
     cache.scaleX = (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._round)(scaleX);
     cache.scaleY = (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._round)(scaleY);
     cache.rotation = (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._round)(rotation) + deg;
     cache.rotationX = (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._round)(rotationX) + deg;
     cache.rotationY = (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._round)(rotationY) + deg;
     cache.skewX = skewX + deg;
     cache.skewY = skewY + deg;
     cache.transformPerspective = perspective + px;
   
     if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || !uncache && cache.zOrigin || 0) {
       style[_transformOriginProp] = _firstTwoOnly(origin);
     }
   
     cache.xOffset = cache.yOffset = 0;
     cache.force3D = _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._config.force3D;
     cache.renderTransform = cache.svg ? _renderSVGTransforms : _supports3D ? _renderCSSTransforms : _renderNon3DTransforms;
     cache.uncache = 0;
     return cache;
   },
       _firstTwoOnly = function _firstTwoOnly(value) {
     return (value = value.split(" "))[0] + " " + value[1];
   },
       //for handling transformOrigin values, stripping out the 3rd dimension
   _addPxTranslate = function _addPxTranslate(target, start, value) {
     var unit = (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.getUnit)(start);
     return (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._round)(parseFloat(start) + parseFloat(_convertToUnit(target, "x", value + "px", unit))) + unit;
   },
       _renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
     cache.z = "0px";
     cache.rotationY = cache.rotationX = "0deg";
     cache.force3D = 0;
   
     _renderCSSTransforms(ratio, cache);
   },
       _zeroDeg = "0deg",
       _zeroPx = "0px",
       _endParenthesis = ") ",
       _renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
     var _ref = cache || this,
         xPercent = _ref.xPercent,
         yPercent = _ref.yPercent,
         x = _ref.x,
         y = _ref.y,
         z = _ref.z,
         rotation = _ref.rotation,
         rotationY = _ref.rotationY,
         rotationX = _ref.rotationX,
         skewX = _ref.skewX,
         skewY = _ref.skewY,
         scaleX = _ref.scaleX,
         scaleY = _ref.scaleY,
         transformPerspective = _ref.transformPerspective,
         force3D = _ref.force3D,
         target = _ref.target,
         zOrigin = _ref.zOrigin,
         transforms = "",
         use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
   
   
     if (zOrigin && (rotationX !== _zeroDeg || rotationY !== _zeroDeg)) {
       var angle = parseFloat(rotationY) * _DEG2RAD,
           a13 = Math.sin(angle),
           a33 = Math.cos(angle),
           cos;
   
       angle = parseFloat(rotationX) * _DEG2RAD;
       cos = Math.cos(angle);
       x = _addPxTranslate(target, x, a13 * cos * -zOrigin);
       y = _addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
       z = _addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
     }
   
     if (transformPerspective !== _zeroPx) {
       transforms += "perspective(" + transformPerspective + _endParenthesis;
     }
   
     if (xPercent || yPercent) {
       transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
     }
   
     if (use3D || x !== _zeroPx || y !== _zeroPx || z !== _zeroPx) {
       transforms += z !== _zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + _endParenthesis;
     }
   
     if (rotation !== _zeroDeg) {
       transforms += "rotate(" + rotation + _endParenthesis;
     }
   
     if (rotationY !== _zeroDeg) {
       transforms += "rotateY(" + rotationY + _endParenthesis;
     }
   
     if (rotationX !== _zeroDeg) {
       transforms += "rotateX(" + rotationX + _endParenthesis;
     }
   
     if (skewX !== _zeroDeg || skewY !== _zeroDeg) {
       transforms += "skew(" + skewX + ", " + skewY + _endParenthesis;
     }
   
     if (scaleX !== 1 || scaleY !== 1) {
       transforms += "scale(" + scaleX + ", " + scaleY + _endParenthesis;
     }
   
     target.style[_transformProp] = transforms || "translate(0, 0)";
   },
       _renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
     var _ref2 = cache || this,
         xPercent = _ref2.xPercent,
         yPercent = _ref2.yPercent,
         x = _ref2.x,
         y = _ref2.y,
         rotation = _ref2.rotation,
         skewX = _ref2.skewX,
         skewY = _ref2.skewY,
         scaleX = _ref2.scaleX,
         scaleY = _ref2.scaleY,
         target = _ref2.target,
         xOrigin = _ref2.xOrigin,
         yOrigin = _ref2.yOrigin,
         xOffset = _ref2.xOffset,
         yOffset = _ref2.yOffset,
         forceCSS = _ref2.forceCSS,
         tx = parseFloat(x),
         ty = parseFloat(y),
         a11,
         a21,
         a12,
         a22,
         temp;
   
     rotation = parseFloat(rotation);
     skewX = parseFloat(skewX);
     skewY = parseFloat(skewY);
   
     if (skewY) {
       //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
       skewY = parseFloat(skewY);
       skewX += skewY;
       rotation += skewY;
     }
   
     if (rotation || skewX) {
       rotation *= _DEG2RAD;
       skewX *= _DEG2RAD;
       a11 = Math.cos(rotation) * scaleX;
       a21 = Math.sin(rotation) * scaleX;
       a12 = Math.sin(rotation - skewX) * -scaleY;
       a22 = Math.cos(rotation - skewX) * scaleY;
   
       if (skewX) {
         skewY *= _DEG2RAD;
         temp = Math.tan(skewX - skewY);
         temp = Math.sqrt(1 + temp * temp);
         a12 *= temp;
         a22 *= temp;
   
         if (skewY) {
           temp = Math.tan(skewY);
           temp = Math.sqrt(1 + temp * temp);
           a11 *= temp;
           a21 *= temp;
         }
       }
   
       a11 = (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._round)(a11);
       a21 = (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._round)(a21);
       a12 = (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._round)(a12);
       a22 = (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._round)(a22);
     } else {
       a11 = scaleX;
       a22 = scaleY;
       a21 = a12 = 0;
     }
   
     if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
       tx = _convertToUnit(target, "x", x, "px");
       ty = _convertToUnit(target, "y", y, "px");
     }
   
     if (xOrigin || yOrigin || xOffset || yOffset) {
       tx = (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._round)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
       ty = (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._round)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
     }
   
     if (xPercent || yPercent) {
       //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
       temp = target.getBBox();
       tx = (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._round)(tx + xPercent / 100 * temp.width);
       ty = (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._round)(ty + yPercent / 100 * temp.height);
     }
   
     temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
     target.setAttribute("transform", temp);
     forceCSS && (target.style[_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
   },
       _addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
     var cap = 360,
         isString = (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._isString)(endValue),
         endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? _RAD2DEG : 1),
         change = endNum - startNum,
         finalValue = startNum + change + "deg",
         direction,
         pt;
   
     if (isString) {
       direction = endValue.split("_")[1];
   
       if (direction === "short") {
         change %= cap;
   
         if (change !== change % (cap / 2)) {
           change += change < 0 ? cap : -cap;
         }
       }
   
       if (direction === "cw" && change < 0) {
         change = (change + cap * _bigNum) % cap - ~~(change / cap) * cap;
       } else if (direction === "ccw" && change > 0) {
         change = (change - cap * _bigNum) % cap - ~~(change / cap) * cap;
       }
     }
   
     plugin._pt = pt = new _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.PropTween(plugin._pt, target, property, startNum, change, _renderPropWithEnd);
     pt.e = finalValue;
     pt.u = "deg";
   
     plugin._props.push(property);
   
     return pt;
   },
       _assign = function _assign(target, source) {
     // Internet Explorer doesn't have Object.assign(), so we recreate it here.
     for (var p in source) {
       target[p] = source[p];
     }
   
     return target;
   },
       _addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
     //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
     var startCache = _assign({}, target._gsap),
         exclude = "perspective,force3D,transformOrigin,svgOrigin",
         style = target.style,
         endCache,
         p,
         startValue,
         endValue,
         startNum,
         endNum,
         startUnit,
         endUnit;
   
     if (startCache.svg) {
       startValue = target.getAttribute("transform");
       target.setAttribute("transform", "");
       style[_transformProp] = transforms;
       endCache = _parseTransform(target, 1);
   
       _removeProperty(target, _transformProp);
   
       target.setAttribute("transform", startValue);
     } else {
       startValue = getComputedStyle(target)[_transformProp];
       style[_transformProp] = transforms;
       endCache = _parseTransform(target, 1);
       style[_transformProp] = startValue;
     }
   
     for (p in _transformProps) {
       startValue = startCache[p];
       endValue = endCache[p];
   
       if (startValue !== endValue && exclude.indexOf(p) < 0) {
         //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
         startUnit = (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.getUnit)(startValue);
         endUnit = (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.getUnit)(endValue);
         startNum = startUnit !== endUnit ? _convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
         endNum = parseFloat(endValue);
         plugin._pt = new _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.PropTween(plugin._pt, endCache, p, startNum, endNum - startNum, _renderCSSProp);
         plugin._pt.u = endUnit || 0;
   
         plugin._props.push(p);
       }
     }
   
     _assign(endCache, startCache);
   }; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
   
   
   (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._forEachName)("padding,margin,Width,Radius", function (name, index) {
     var t = "Top",
         r = "Right",
         b = "Bottom",
         l = "Left",
         props = (index < 3 ? [t, r, b, l] : [t + l, t + r, b + r, b + l]).map(function (side) {
       return index < 2 ? name + side : "border" + side + name;
     });
   
     _specialProps[index > 1 ? "border" + name : name] = function (plugin, target, property, endValue, tween) {
       var a, vars;
   
       if (arguments.length < 4) {
         // getter, passed target, property, and unit (from _get())
         a = props.map(function (prop) {
           return _get(plugin, prop, property);
         });
         vars = a.join(" ");
         return vars.split(a[0]).length === 5 ? a[0] : vars;
       }
   
       a = (endValue + "").split(" ");
       vars = {};
       props.forEach(function (prop, i) {
         return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
       });
       plugin.init(target, vars, tween);
     };
   });
   
   var CSSPlugin = {
     name: "css",
     register: _initCore,
     targetTest: function targetTest(target) {
       return target.style && target.nodeType;
     },
     init: function init(target, vars, tween, index, targets) {
       var props = this._props,
           style = target.style,
           startAt = tween.vars.startAt,
           startValue,
           endValue,
           endNum,
           startNum,
           type,
           specialProp,
           p,
           startUnit,
           endUnit,
           relative,
           isTransformRelated,
           transformPropTween,
           cache,
           smooth,
           hasPriority,
           inlineProps,
           finalTransformValue;
       _pluginInitted || _initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
   
       this.styles = this.styles || _getStyleSaver(target);
       inlineProps = this.styles.props;
       this.tween = tween;
   
       for (p in vars) {
         if (p === "autoRound") {
           continue;
         }
   
         endValue = vars[p];
   
         if (_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._plugins[p] && (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._checkPlugin)(p, vars, tween, index, target, targets)) {
           // plugins
           continue;
         }
   
         type = typeof endValue;
         specialProp = _specialProps[p];
   
         if (type === "function") {
           endValue = endValue.call(tween, index, target, targets);
           type = typeof endValue;
         }
   
         if (type === "string" && ~endValue.indexOf("random(")) {
           endValue = (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._replaceRandom)(endValue);
         }
   
         if (specialProp) {
           specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
         } else if (p.substr(0, 2) === "--") {
           //CSS variable
           startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
           endValue += "";
           _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._colorExp.lastIndex = 0;
   
           if (!_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._colorExp.test(startValue)) {
             // colors don't have units
             startUnit = (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.getUnit)(startValue);
             endUnit = (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.getUnit)(endValue);
             endUnit ? startUnit !== endUnit && (startValue = _convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
           }
   
           this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
           props.push(p);
           inlineProps.push(p, 0, style[p]);
         } else if (type !== "undefined") {
           if (startAt && p in startAt) {
             // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
             startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
             (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._isString)(startValue) && ~startValue.indexOf("random(") && (startValue = (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._replaceRandom)(startValue));
             (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.getUnit)(startValue + "") || startValue === "auto" || (startValue += _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._config.units[p] || (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.getUnit)(_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
   
             (startValue + "").charAt(1) === "=" && (startValue = _get(target, p)); // can't work with relative values
           } else {
             startValue = _get(target, p);
           }
   
           startNum = parseFloat(startValue);
           relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
           relative && (endValue = endValue.substr(2));
           endNum = parseFloat(endValue);
   
           if (p in _propertyAliases) {
             if (p === "autoAlpha") {
               //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
               if (startNum === 1 && _get(target, "visibility") === "hidden" && endNum) {
                 //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                 startNum = 0;
               }
   
               inlineProps.push("visibility", 0, style.visibility);
   
               _addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
             }
   
             if (p !== "scale" && p !== "transform") {
               p = _propertyAliases[p];
               ~p.indexOf(",") && (p = p.split(",")[0]);
             }
           }
   
           isTransformRelated = p in _transformProps; //--- TRANSFORM-RELATED ---
   
           if (isTransformRelated) {
             this.styles.save(p);
             finalTransformValue = endValue; // this is always the same as endValue except when it's a var(--) value, in which case we need to calculate the end value.
   
             if (type === "string" && endValue.substring(0, 6) === "var(--") {
               endValue = _getComputedProperty(target, endValue.substring(4, endValue.indexOf(")")));
   
               if (endValue.substring(0, 5) === "calc(") {
                 var origPerspective = target.style.perspective;
                 target.style.perspective = endValue;
                 endValue = _getComputedProperty(target, "perspective");
                 origPerspective ? target.style.perspective = origPerspective : _removeProperty(target, "perspective");
               }
   
               endNum = parseFloat(endValue);
             }
   
             if (!transformPropTween) {
               cache = target._gsap;
               cache.renderTransform && !vars.parseTransform || _parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
   
               smooth = vars.smoothOrigin !== false && cache.smooth;
               transformPropTween = this._pt = new _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.PropTween(this._pt, style, _transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
   
               transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
             }
   
             if (p === "scale") {
               this._pt = new _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.PropTween(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._parseRelative)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, _renderCSSProp);
               this._pt.u = 0;
               props.push("scaleY", p);
               p += "X";
             } else if (p === "transformOrigin") {
               inlineProps.push(_transformOriginProp, 0, style[_transformOriginProp]);
               endValue = _convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
   
               if (cache.svg) {
                 _applySVGOrigin(target, endValue, 0, smooth, 0, this);
               } else {
                 endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
   
                 endUnit !== cache.zOrigin && _addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
   
                 _addNonTweeningPT(this, style, p, _firstTwoOnly(startValue), _firstTwoOnly(endValue));
               }
   
               continue;
             } else if (p === "svgOrigin") {
               _applySVGOrigin(target, endValue, 1, smooth, 0, this);
   
               continue;
             } else if (p in _rotationalProperties) {
               _addRotationalPropTween(this, cache, p, startNum, relative ? (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._parseRelative)(startNum, relative + endValue) : endValue);
   
               continue;
             } else if (p === "smoothOrigin") {
               _addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
   
               continue;
             } else if (p === "force3D") {
               cache[p] = endValue;
               continue;
             } else if (p === "transform") {
               _addRawTransformPTs(this, endValue, target);
   
               continue;
             }
           } else if (!(p in style)) {
             p = _checkPropPrefix(p) || p;
           }
   
           if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !_complexExp.test(endValue) && p in style) {
             startUnit = (startValue + "").substr((startNum + "").length);
             endNum || (endNum = 0); // protect against NaN
   
             endUnit = (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.getUnit)(endValue) || (p in _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._config.units ? _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._config.units[p] : startUnit);
             startUnit !== endUnit && (startNum = _convertToUnit(target, p, startValue, endUnit));
             this._pt = new _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.PropTween(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._parseRelative)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? _renderRoundedCSSProp : _renderCSSProp);
             this._pt.u = endUnit || 0;
   
             if (isTransformRelated && finalTransformValue !== endValue) {
               this._pt.b = startValue;
               this._pt.e = finalTransformValue;
               this._pt.r = _renderCSSPropWithBeginningAndEnd;
             } else if (startUnit !== endUnit && endUnit !== "%") {
               //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
               this._pt.b = startValue;
               this._pt.r = _renderCSSPropWithBeginning;
             }
           } else if (!(p in style)) {
             if (p in target) {
               //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
               this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
             } else if (p !== "parseTransform") {
               (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._missingPlugin)(p, endValue);
   
               continue;
             }
           } else {
             _tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
           }
   
           isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : typeof target[p] === "function" ? inlineProps.push(p, 2, target[p]()) : inlineProps.push(p, 1, startValue || target[p]));
           props.push(p);
         }
       }
   
       hasPriority && (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._sortPropTweensByPriority)(this);
     },
     render: function render(ratio, data) {
       if (data.tween._time || !_reverting()) {
         var pt = data._pt;
   
         while (pt) {
           pt.r(ratio, pt.d);
           pt = pt._next;
         }
       } else {
         data.styles.revert();
       }
     },
     get: _get,
     aliases: _propertyAliases,
     getSetter: function getSetter(target, property, plugin) {
       //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
       var p = _propertyAliases[property];
       p && p.indexOf(",") < 0 && (property = p);
       return property in _transformProps && property !== _transformOriginProp && (target._gsap.x || _get(target, "x")) ? plugin && _recentSetterPlugin === plugin ? property === "scale" ? _setterScale : _setterTransform : (_recentSetterPlugin = plugin || {}) && (property === "scale" ? _setterScaleWithRender : _setterTransformWithRender) : target.style && !(0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._isUndefined)(target.style[property]) ? _setterCSSStyle : ~property.indexOf("-") ? _setterCSSProp : (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._getSetter)(target, property);
     },
     core: {
       _removeProperty: _removeProperty,
       _getMatrix: _getMatrix
     }
   };
   _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.gsap.utils.checkPrefix = _checkPropPrefix;
   _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.gsap.core.getStyleSaver = _getStyleSaver;
   
   (function (positionAndScale, rotation, others, aliases) {
     var all = (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._forEachName)(positionAndScale + "," + rotation + "," + others, function (name) {
       _transformProps[name] = 1;
     });
   
     (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._forEachName)(rotation, function (name) {
       _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._config.units[name] = "deg";
       _rotationalProperties[name] = 1;
     });
   
     _propertyAliases[all[13]] = positionAndScale + "," + rotation;
   
     (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._forEachName)(aliases, function (name) {
       var split = name.split(":");
       _propertyAliases[split[1]] = all[split[0]];
     });
   })("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
   
   (0,_gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._forEachName)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function (name) {
     _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__._config.units[name] = "px";
   });
   
   _gsap_core_js__WEBPACK_IMPORTED_MODULE_0__.gsap.registerPlugin(CSSPlugin);
   
   
   /***/ }),
   /* 8 */
   /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
   
   "use strict";
   __webpack_require__.r(__webpack_exports__);
   /* harmony export */ __webpack_require__.d(__webpack_exports__, {
   /* harmony export */   ScrollTrigger: () => (/* binding */ ScrollTrigger),
   /* harmony export */   "default": () => (/* binding */ ScrollTrigger)
   /* harmony export */ });
   /* harmony import */ var _Observer_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9);
   /*!
    * ScrollTrigger 3.15.0
    * https://gsap.com
    *
    * @license Copyright 2008-2026, GreenSock. All rights reserved.
    * Subject to the terms at https://gsap.com/standard-license
    * @author: Jack Doyle, jack@greensock.com
   */
   
   /* eslint-disable */
   
   
   var gsap,
       _coreInitted,
       _win,
       _doc,
       _docEl,
       _body,
       _root,
       _resizeDelay,
       _toArray,
       _clamp,
       _time2,
       _syncInterval,
       _refreshing,
       _pointerIsDown,
       _transformProp,
       _i,
       _prevWidth,
       _prevHeight,
       _autoRefresh,
       _sort,
       _suppressOverwrites,
       _ignoreResize,
       _normalizer,
       _ignoreMobileResize,
       _baseScreenHeight,
       _baseScreenWidth,
       _fixIOSBug,
       _context,
       _scrollRestoration,
       _div100vh,
       _100vh,
       _isReverted,
       _clampingMax,
       _limitCallbacks,
       // if true, we'll only trigger callbacks if the active state toggles, so if you scroll immediately past both the start and end positions of a ScrollTrigger (thus inactive to inactive), neither its onEnter nor onLeave will be called. This is useful during startup.
   _startup = 1,
       _getTime = Date.now,
       _time1 = _getTime(),
       _lastScrollTime = 0,
       _enabled = 0,
       _parseClamp = function _parseClamp(value, type, self) {
     var clamp = _isString(value) && (value.substr(0, 6) === "clamp(" || value.indexOf("max") > -1);
     self["_" + type + "Clamp"] = clamp;
     return clamp ? value.substr(6, value.length - 7) : value;
   },
       _keepClamp = function _keepClamp(value, clamp) {
     return clamp && (!_isString(value) || value.substr(0, 6) !== "clamp(") ? "clamp(" + value + ")" : value;
   },
       _rafBugFix = function _rafBugFix() {
     return _enabled && requestAnimationFrame(_rafBugFix);
   },
       // in some browsers (like Firefox), screen repaints weren't consistent unless we had SOMETHING queued up in requestAnimationFrame()! So this just creates a super simple loop to keep it alive and smooth out repaints.
   _pointerDownHandler = function _pointerDownHandler() {
     return _pointerIsDown = 1;
   },
       _pointerUpHandler = function _pointerUpHandler() {
     return _pointerIsDown = 0;
   },
       _passThrough = function _passThrough(v) {
     return v;
   },
       _round = function _round(value) {
     return Math.round(value * 100000) / 100000 || 0;
   },
       _windowExists = function _windowExists() {
     return typeof window !== "undefined";
   },
       _getGSAP = function _getGSAP() {
     return gsap || _windowExists() && (gsap = window.gsap) && gsap.registerPlugin && gsap;
   },
       _isViewport = function _isViewport(e) {
     return !!~_root.indexOf(e);
   },
       _getViewportDimension = function _getViewportDimension(dimensionProperty) {
     return (dimensionProperty === "Height" ? _100vh : _win["inner" + dimensionProperty]) || _docEl["client" + dimensionProperty] || _body["client" + dimensionProperty];
   },
       _getBoundsFunc = function _getBoundsFunc(element) {
     return (0,_Observer_js__WEBPACK_IMPORTED_MODULE_0__._getProxyProp)(element, "getBoundingClientRect") || (_isViewport(element) ? function () {
       _winOffsets.width = _win.innerWidth;
       _winOffsets.height = _100vh;
       return _winOffsets;
     } : function () {
       return _getBounds(element);
     });
   },
       _getSizeFunc = function _getSizeFunc(scroller, isViewport, _ref) {
     var d = _ref.d,
         d2 = _ref.d2,
         a = _ref.a;
     return (a = (0,_Observer_js__WEBPACK_IMPORTED_MODULE_0__._getProxyProp)(scroller, "getBoundingClientRect")) ? function () {
       return a()[d];
     } : function () {
       return (isViewport ? _getViewportDimension(d2) : scroller["client" + d2]) || 0;
     };
   },
       _getOffsetsFunc = function _getOffsetsFunc(element, isViewport) {
     return !isViewport || ~_Observer_js__WEBPACK_IMPORTED_MODULE_0__._proxies.indexOf(element) ? _getBoundsFunc(element) : function () {
       return _winOffsets;
     };
   },
       _maxScroll = function _maxScroll(element, _ref2) {
     var s = _ref2.s,
         d2 = _ref2.d2,
         d = _ref2.d,
         a = _ref2.a;
     return Math.max(0, (s = "scroll" + d2) && (a = (0,_Observer_js__WEBPACK_IMPORTED_MODULE_0__._getProxyProp)(element, s)) ? a() - _getBoundsFunc(element)()[d] : _isViewport(element) ? (_docEl[s] || _body[s]) - _getViewportDimension(d2) : element[s] - element["offset" + d2]);
   },
       _iterateAutoRefresh = function _iterateAutoRefresh(func, events) {
     for (var i = 0; i < _autoRefresh.length; i += 3) {
       (!events || ~events.indexOf(_autoRefresh[i + 1])) && func(_autoRefresh[i], _autoRefresh[i + 1], _autoRefresh[i + 2]);
     }
   },
       _isString = function _isString(value) {
     return typeof value === "string";
   },
       _isFunction = function _isFunction(value) {
     return typeof value === "function";
   },
       _isNumber = function _isNumber(value) {
     return typeof value === "number";
   },
       _isObject = function _isObject(value) {
     return typeof value === "object";
   },
       _endAnimation = function _endAnimation(animation, reversed, pause) {
     return animation && animation.progress(reversed ? 0 : 1) && pause && animation.pause();
   },
       _callback = function _callback(self, func, extraParam) {
     if (self.enabled) {
       var result = self._ctx ? self._ctx.add(function () {
         return func(self, extraParam);
       }) : func(self, extraParam);
       result && result.totalTime && (self.callbackAnimation = result);
     }
   },
       _abs = Math.abs,
       _left = "left",
       _top = "top",
       _right = "right",
       _bottom = "bottom",
       _width = "width",
       _height = "height",
       _Right = "Right",
       _Left = "Left",
       _Top = "Top",
       _Bottom = "Bottom",
       _padding = "padding",
       _margin = "margin",
       _Width = "Width",
       _Height = "Height",
       _px = "px",
       _getComputedStyle = function _getComputedStyle(element) {
     return _win.getComputedStyle(element.nodeType === Node.DOCUMENT_NODE ? element.scrollingElement : element);
   },
       _makePositionable = function _makePositionable(element) {
     // if the element already has position: absolute or fixed, leave that, otherwise make it position: relative
     var position = _getComputedStyle(element).position;
   
     element.style.position = position === "absolute" || position === "fixed" ? position : "relative";
   },
       _setDefaults = function _setDefaults(obj, defaults) {
     for (var p in defaults) {
       p in obj || (obj[p] = defaults[p]);
     }
   
     return obj;
   },
       _getBounds = function _getBounds(element, withoutTransforms) {
     var tween = withoutTransforms && _getComputedStyle(element)[_transformProp] !== "matrix(1, 0, 0, 1, 0, 0)" && gsap.to(element, {
       x: 0,
       y: 0,
       xPercent: 0,
       yPercent: 0,
       rotation: 0,
       rotationX: 0,
       rotationY: 0,
       scale: 1,
       skewX: 0,
       skewY: 0
     }).progress(1),
         bounds = element.getBoundingClientRect ? element.getBoundingClientRect() : element.scrollingElement.getBoundingClientRect();
     tween && tween.progress(0).kill();
     return bounds;
   },
       _getSize = function _getSize(element, _ref3) {
     var d2 = _ref3.d2;
     return element["offset" + d2] || element["client" + d2] || 0;
   },
       _getLabelRatioArray = function _getLabelRatioArray(timeline) {
     var a = [],
         labels = timeline.labels,
         duration = timeline.duration(),
         p;
   
     for (p in labels) {
       a.push(labels[p] / duration);
     }
   
     return a;
   },
       _getClosestLabel = function _getClosestLabel(animation) {
     return function (value) {
       return gsap.utils.snap(_getLabelRatioArray(animation), value);
     };
   },
       _snapDirectional = function _snapDirectional(snapIncrementOrArray) {
     var snap = gsap.utils.snap(snapIncrementOrArray),
         a = Array.isArray(snapIncrementOrArray) && snapIncrementOrArray.slice(0).sort(function (a, b) {
       return a - b;
     });
     return a ? function (value, direction, threshold) {
       if (threshold === void 0) {
         threshold = 1e-3;
       }
   
       var i;
   
       if (!direction) {
         return snap(value);
       }
   
       if (direction > 0) {
         value -= threshold; // to avoid rounding errors. If we're too strict, it might snap forward, then immediately again, and again.
   
         for (i = 0; i < a.length; i++) {
           if (a[i] >= value) {
             return a[i];
           }
         }
   
         return a[i - 1];
       } else {
         i = a.length;
         value += threshold;
   
         while (i--) {
           if (a[i] <= value) {
             return a[i];
           }
         }
       }
   
       return a[0];
     } : function (value, direction, threshold) {
       if (threshold === void 0) {
         threshold = 1e-3;
       }
   
       var snapped = snap(value);
       return !direction || Math.abs(snapped - value) < threshold || snapped - value < 0 === direction < 0 ? snapped : snap(direction < 0 ? value - snapIncrementOrArray : value + snapIncrementOrArray);
     };
   },
       _getLabelAtDirection = function _getLabelAtDirection(timeline) {
     return function (value, st) {
       return _snapDirectional(_getLabelRatioArray(timeline))(value, st.direction);
     };
   },
       _multiListener = function _multiListener(func, element, types, callback) {
     return types.split(",").forEach(function (type) {
       return func(element, type, callback);
     });
   },
       _addListener = function _addListener(element, type, func, nonPassive, capture) {
     return element.addEventListener(type, func, {
       passive: !nonPassive,
       capture: !!capture
     });
   },
       _removeListener = function _removeListener(element, type, func, capture) {
     return element.removeEventListener(type, func, !!capture);
   },
       _wheelListener = function _wheelListener(func, el, scrollFunc) {
     scrollFunc = scrollFunc && scrollFunc.wheelHandler;
   
     if (scrollFunc) {
       func(el, "wheel", scrollFunc);
       func(el, "touchmove", scrollFunc);
     }
   },
       _markerDefaults = {
     startColor: "green",
     endColor: "red",
     indent: 0,
     fontSize: "16px",
     fontWeight: "normal"
   },
       _defaults = {
     toggleActions: "play",
     anticipatePin: 0
   },
       _keywords = {
     top: 0,
     left: 0,
     center: 0.5,
     bottom: 1,
     right: 1
   },
       _offsetToPx = function _offsetToPx(value, size) {
     if (_isString(value)) {
       var eqIndex = value.indexOf("="),
           relative = ~eqIndex ? +(value.charAt(eqIndex - 1) + 1) * parseFloat(value.substr(eqIndex + 1)) : 0;
   
       if (~eqIndex) {
         value.indexOf("%") > eqIndex && (relative *= size / 100);
         value = value.substr(0, eqIndex - 1);
       }
   
       value = relative + (value in _keywords ? _keywords[value] * size : ~value.indexOf("%") ? parseFloat(value) * size / 100 : parseFloat(value) || 0);
     }
   
     return value;
   },
       _createMarker = function _createMarker(type, name, container, direction, _ref4, offset, matchWidthEl, containerAnimation) {
     var startColor = _ref4.startColor,
         endColor = _ref4.endColor,
         fontSize = _ref4.fontSize,
         indent = _ref4.indent,
         fontWeight = _ref4.fontWeight;
   
     var e = _doc.createElement("div"),
         useFixedPosition = _isViewport(container) || (0,_Observer_js__WEBPACK_IMPORTED_MODULE_0__._getProxyProp)(container, "pinType") === "fixed",
         isScroller = type.indexOf("scroller") !== -1,
         parent = useFixedPosition ? _body : container.tagName === "IFRAME" ? container.contentDocument.body : container,
         isStart = type.indexOf("start") !== -1,
         color = isStart ? startColor : endColor,
         css = "border-color:" + color + ";font-size:" + fontSize + ";color:" + color + ";font-weight:" + fontWeight + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
   
     css += "position:" + ((isScroller || containerAnimation) && useFixedPosition ? "fixed;" : "absolute;");
     (isScroller || containerAnimation || !useFixedPosition) && (css += (direction === _Observer_js__WEBPACK_IMPORTED_MODULE_0__._vertical ? _right : _bottom) + ":" + (offset + parseFloat(indent)) + "px;");
     matchWidthEl && (css += "box-sizing:border-box;text-align:left;width:" + matchWidthEl.offsetWidth + "px;");
     e._isStart = isStart;
     e.setAttribute("class", "gsap-marker-" + type + (name ? " marker-" + name : ""));
     e.style.cssText = css;
     e.innerText = name || name === 0 ? type + "-" + name : type;
     parent.children[0] ? parent.insertBefore(e, parent.children[0]) : parent.appendChild(e);
     e._offset = e["offset" + direction.op.d2];
   
     _positionMarker(e, 0, direction, isStart);
   
     return e;
   },
       _positionMarker = function _positionMarker(marker, start, direction, flipped) {
     var vars = {
       display: "block"
     },
         side = direction[flipped ? "os2" : "p2"],
         oppositeSide = direction[flipped ? "p2" : "os2"];
     marker._isFlipped = flipped;
     vars[direction.a + "Percent"] = flipped ? -100 : 0;
     vars[direction.a] = flipped ? "1px" : 0;
     vars["border" + side + _Width] = 1;
     vars["border" + oppositeSide + _Width] = 0;
     vars[direction.p] = start + "px";
     gsap.set(marker, vars);
   },
       _triggers = [],
       _ids = {},
       _rafID,
       _sync = function _sync() {
     return _getTime() - _lastScrollTime > 34 && (_rafID || (_rafID = requestAnimationFrame(_updateAll)));
   },
       _onScroll = function _onScroll() {
     // previously, we tried to optimize performance by batching/deferring to the next requestAnimationFrame(), but discovered that Safari has a few bugs that make this unworkable (especially on iOS). See https://codepen.io/GreenSock/pen/16c435b12ef09c38125204818e7b45fc?editors=0010 and https://codepen.io/GreenSock/pen/JjOxYpQ/3dd65ccec5a60f1d862c355d84d14562?editors=0010 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503?editors=0010
     if (!_normalizer || !_normalizer.isPressed || _normalizer.startX > _body.clientWidth) {
       // if the user is dragging the scrollbar, allow it.
       _Observer_js__WEBPACK_IMPORTED_MODULE_0__._scrollers.cache++;
   
       if (_normalizer) {
         _rafID || (_rafID = requestAnimationFrame(_updateAll));
       } else {
         _updateAll(); // Safari in particular (on desktop) NEEDS the immediate update rather than waiting for a requestAnimationFrame() whereas iOS seems to benefit from waiting for the requestAnimationFrame() tick, at least when normalizing. See https://codepen.io/GreenSock/pen/qBYozqO?editors=0110
   
       }
   
       _lastScrollTime || _dispatch("scrollStart");
       _lastScrollTime = _getTime();
     }
   },
       _setBaseDimensions = function _setBaseDimensions() {
     _baseScreenWidth = _win.innerWidth;
     _baseScreenHeight = _win.innerHeight;
   },
       _onResize = function _onResize(force) {
     _Observer_js__WEBPACK_IMPORTED_MODULE_0__._scrollers.cache++;
     (force === true || !_refreshing && !_ignoreResize && !_doc.fullscreenElement && !_doc.webkitFullscreenElement && (!_ignoreMobileResize || _baseScreenWidth !== _win.innerWidth || Math.abs(_win.innerHeight - _baseScreenHeight) > _win.innerHeight * 0.25)) && _resizeDelay.restart(true);
   },
       // ignore resizes triggered by refresh()
   _listeners = {},
       _emptyArray = [],
       _softRefresh = function _softRefresh() {
     return _removeListener(ScrollTrigger, "scrollEnd", _softRefresh) || _refreshAll(true);
   },
       _dispatch = function _dispatch(type) {
     return _listeners[type] && _listeners[type].map(function (f) {
       return f();
     }) || _emptyArray;
   },
       _savedStyles = [],
       // when ScrollTrigger.saveStyles() is called, the inline styles are recorded in this Array in a sequential format like [element, cssText, gsCache, media]. This keeps it very memory-efficient and fast to iterate through.
   _revertRecorded = function _revertRecorded(media) {
     for (var i = 0; i < _savedStyles.length; i += 5) {
       if (!media || _savedStyles[i + 4] && _savedStyles[i + 4].query === media) {
         _savedStyles[i].style.cssText = _savedStyles[i + 1];
         _savedStyles[i].getBBox && _savedStyles[i].setAttribute("transform", _savedStyles[i + 2] || "");
         _savedStyles[i + 3].uncache = 1;
       }
     }
   },
       _recordScrollPositions = function _recordScrollPositions() {
     return _Observer_js__WEBPACK_IMPORTED_MODULE_0__._scrollers.forEach(function (obj) {
       return _isFunction(obj) && ++obj.cacheID && (obj.rec = obj());
     });
   },
       // record the current scroll position. Also force the clearing of the cache because some browsers take a little while to dispatch the "scroll" event and the user may have changed the scroll position and then called ScrollTrigger.refresh() right away
   _revertAll = function _revertAll(kill, media) {
     var trigger;
   
     for (_i = 0; _i < _triggers.length; _i++) {
       trigger = _triggers[_i];
   
       if (trigger && (!media || trigger._ctx === media)) {
         if (kill) {
           trigger.kill(1);
         } else {
           trigger.revert(true, true);
         }
       }
     }
   
     _isReverted = true;
     media && _revertRecorded(media);
     media || _dispatch("revert");
   },
       _clearScrollMemory = function _clearScrollMemory(scrollRestoration, force) {
     // zero-out all the recorded scroll positions. Don't use _triggers because if, for example, .matchMedia() is used to create some ScrollTriggers and then the user resizes and it removes ALL ScrollTriggers, and then go back to a size where there are ScrollTriggers, it would have kept the position(s) saved from the initial state.
     _Observer_js__WEBPACK_IMPORTED_MODULE_0__._scrollers.cache++;
     (force || !_refreshingAll) && _Observer_js__WEBPACK_IMPORTED_MODULE_0__._scrollers.forEach(function (obj) {
       return _isFunction(obj) && obj.cacheID++ && (obj.rec = 0);
     });
     _isString(scrollRestoration) && (_win.history.scrollRestoration = _scrollRestoration = scrollRestoration);
   },
       _refreshingAll,
       _refreshID = 0,
       _queueRefreshID,
       _queueRefreshAll = function _queueRefreshAll() {
     // we don't want to call _refreshAll() every time we create a new ScrollTrigger (for performance reasons) - it's better to batch them. Some frameworks dynamically load content and we can't rely on the window's "load" or "DOMContentLoaded" events to trigger it.
     if (_queueRefreshID !== _refreshID) {
       var id = _queueRefreshID = _refreshID;
       requestAnimationFrame(function () {
         return id === _refreshID && _refreshAll(true);
       });
     }
   },
       _refresh100vh = function _refresh100vh() {
     _body.appendChild(_div100vh);
   
     _100vh = !_normalizer && _div100vh.offsetHeight || _win.innerHeight;
   
     _body.removeChild(_div100vh);
   },
       _hideAllMarkers = function _hideAllMarkers(hide) {
     return _toArray(".gsap-marker-start, .gsap-marker-end, .gsap-marker-scroller-start, .gsap-marker-scroller-end").forEach(function (el) {
       return el.style.display = hide ? "none" : "block";
     });
   },
       _refreshAll = function _refreshAll(force, skipRevert) {
     _docEl = _doc.documentElement; // some frameworks like Astro may cache the <body> and replace it during routing, so we'll just re-record the _docEl and _body for safety (otherwise, the markers may not get added properly).
   
     _body = _doc.body;
     _root = [_win, _doc, _docEl, _body];
   
     if (_lastScrollTime && !force && !_isReverted) {
       _addListener(ScrollTrigger, "scrollEnd", _softRefresh);
   
       return;
     }
   
     _refresh100vh();
   
     _refreshingAll = ScrollTrigger.isRefreshing = true;
     _isReverted || _recordScrollPositions();
   
     var refreshInits = _dispatch("refreshInit");
   
     _sort && ScrollTrigger.sort();
     skipRevert || _revertAll();
   
     _Observer_js__WEBPACK_IMPORTED_MODULE_0__._scrollers.forEach(function (obj) {
       if (_isFunction(obj)) {
         obj.smooth && (obj.target.style.scrollBehavior = "auto"); // smooth scrolling interferes
   
         obj(0);
       }
     });
   
     _triggers.slice(0).forEach(function (t) {
       return t.refresh();
     }); // don't loop with _i because during a refresh() someone could call ScrollTrigger.update() which would iterate through _i resulting in a skip.
   
   
     _isReverted = false;
   
     _triggers.forEach(function (t) {
       // nested pins (pinnedContainer) with pinSpacing may expand the container, so we must accommodate that here.
       if (t._subPinOffset && t.pin) {
         var prop = t.vars.horizontal ? "offsetWidth" : "offsetHeight",
             original = t.pin[prop];
         t.revert(true, 1);
         t.adjustPinSpacing(t.pin[prop] - original);
         t.refresh();
       }
     });
   
     _clampingMax = 1; // pinSpacing might be propping a page open, thus when we .setPositions() to clamp a ScrollTrigger's end we should leave the pinSpacing alone. That's what this flag is for.
   
     _hideAllMarkers(true);
   
     _triggers.forEach(function (t) {
       // the scroller's max scroll position may change after all the ScrollTriggers refreshed (like pinning could push it down), so we need to loop back and correct any with end: "max". Same for anything with a clamped end
       var max = _maxScroll(t.scroller, t._dir),
           endClamp = t.vars.end === "max" || t._endClamp && t.end > max,
           startClamp = t._startClamp && t.start >= max;
   
       (endClamp || startClamp) && t.setPositions(startClamp ? max - 1 : t.start, endClamp ? Math.max(startClamp ? max : t.start + 1, max) : t.end, true);
     });
   
     _hideAllMarkers(false);
   
     _clampingMax = 0;
     refreshInits.forEach(function (result) {
       return result && result.render && result.render(-1);
     }); // if the onRefreshInit() returns an animation (typically a gsap.set()), revert it. This makes it easy to put things in a certain spot before refreshing for measurement purposes, and then put things back.
   
     _Observer_js__WEBPACK_IMPORTED_MODULE_0__._scrollers.forEach(function (obj) {
       if (_isFunction(obj)) {
         obj.smooth && requestAnimationFrame(function () {
           return obj.target.style.scrollBehavior = "smooth";
         });
         obj.rec && obj(obj.rec);
       }
     });
   
     _clearScrollMemory(_scrollRestoration, 1);
   
     _resizeDelay.pause();
   
     _refreshID++;
     _refreshingAll = 2;
   
     _updateAll(2);
   
     _triggers.forEach(function (t) {
       return _isFunction(t.vars.onRefresh) && t.vars.onRefresh(t);
     });
   
     _refreshingAll = ScrollTrigger.isRefreshing = false;
   
     _dispatch("refresh");
   },
       _lastScroll = 0,
       _direction = 1,
       _primary,
       _updateAll = function _updateAll(force) {
     if (force === 2 || !_refreshingAll && !_isReverted) {
       // _isReverted could be true if, for example, a matchMedia() is in the process of executing. We don't want to update during the time everything is reverted.
       ScrollTrigger.isUpdating = true;
       _primary && _primary.update(0); // ScrollSmoother uses refreshPriority -9999 to become the primary that gets updated before all others because it affects the scroll position.
   
       var l = _triggers.length,
           time = _getTime(),
           recordVelocity = time - _time1 >= 50,
           scroll = l && _triggers[0].scroll();
   
       _direction = _lastScroll > scroll ? -1 : 1;
       _refreshingAll || (_lastScroll = scroll);
   
       if (recordVelocity) {
         if (_lastScrollTime && !_pointerIsDown && time - _lastScrollTime > 200) {
           _lastScrollTime = 0;
   
           _dispatch("scrollEnd");
         }
   
         _time2 = _time1;
         _time1 = time;
       }
   
       if (_direction < 0) {
         _i = l;
   
         while (_i-- > 0) {
           _triggers[_i] && _triggers[_i].update(0, recordVelocity);
         }
   
         _direction = 1;
       } else {
         for (_i = 0; _i < l; _i++) {
           _triggers[_i] && _triggers[_i].update(0, recordVelocity);
         }
       }
   
       ScrollTrigger.isUpdating = false;
     }
   
     _rafID = 0;
   },
       _propNamesToCopy = [_left, _top, _bottom, _right, _margin + _Bottom, _margin + _Right, _margin + _Top, _margin + _Left, "display", "flexShrink", "float", "zIndex", "gridColumnStart", "gridColumnEnd", "gridRowStart", "gridRowEnd", "gridArea", "justifySelf", "alignSelf", "placeSelf", "order"],
       _stateProps = _propNamesToCopy.concat([_width, _height, "boxSizing", "max" + _Width, "max" + _Height, "position", _margin, _padding, _padding + _Top, _padding + _Right, _padding + _Bottom, _padding + _Left]),
       _swapPinOut = function _swapPinOut(pin, spacer, state) {
     _setState(state);
   
     var cache = pin._gsap;
   
     if (cache.spacerIsNative) {
       _setState(cache.spacerState);
     } else if (pin._gsap.swappedIn) {
       var parent = spacer.parentNode;
   
       if (parent) {
         parent.insertBefore(pin, spacer);
         parent.removeChild(spacer);
       }
     }
   
     pin._gsap.swappedIn = false;
   },
       _swapPinIn = function _swapPinIn(pin, spacer, cs, spacerState) {
     if (!pin._gsap.swappedIn) {
       var i = _propNamesToCopy.length,
           spacerStyle = spacer.style,
           pinStyle = pin.style,
           p;
   
       while (i--) {
         p = _propNamesToCopy[i];
         spacerStyle[p] = cs[p];
       }
   
       spacerStyle.position = cs.position === "absolute" ? "absolute" : "relative";
       cs.display === "inline" && (spacerStyle.display = "inline-block");
       pinStyle[_bottom] = pinStyle[_right] = "auto";
       spacerStyle.flexBasis = cs.flexBasis || "auto";
       spacerStyle.overflow = "visible";
       spacerStyle.boxSizing = "border-box";
       spacerStyle[_width] = _getSize(pin, _Observer_js__WEBPACK_IMPORTED_MODULE_0__._horizontal) + _px;
       spacerStyle[_height] = _getSize(pin, _Observer_js__WEBPACK_IMPORTED_MODULE_0__._vertical) + _px;
       spacerStyle[_padding] = pinStyle[_margin] = pinStyle[_top] = pinStyle[_left] = "0";
   
       _setState(spacerState);
   
       pinStyle[_width] = pinStyle["max" + _Width] = cs[_width];
       pinStyle[_height] = pinStyle["max" + _Height] = cs[_height];
       pinStyle[_padding] = cs[_padding];
   
       if (pin.parentNode !== spacer) {
         pin.parentNode.insertBefore(spacer, pin);
         spacer.appendChild(pin);
       }
   
       pin._gsap.swappedIn = true;
     }
   },
       _capsExp = /([A-Z])/g,
       _setState = function _setState(state) {
     if (state) {
       var style = state.t.style,
           l = state.length,
           i = 0,
           p,
           value;
       (state.t._gsap || gsap.core.getCache(state.t)).uncache = 1; // otherwise transforms may be off
   
       for (; i < l; i += 2) {
         value = state[i + 1];
         p = state[i];
   
         if (value) {
           style[p] = value;
         } else if (style[p]) {
           style.removeProperty(p.replace(_capsExp, "-$1").toLowerCase());
         }
       }
     }
   },
       _getState = function _getState(element) {
     // returns an Array with alternating values like [property, value, property, value] and a "t" property pointing to the target (element). Makes it fast and cheap.
     var l = _stateProps.length,
         style = element.style,
         state = [],
         i = 0;
   
     for (; i < l; i++) {
       state.push(_stateProps[i], style[_stateProps[i]]);
     }
   
     state.t = element;
     return state;
   },
       _copyState = function _copyState(state, override, omitOffsets) {
     var result = [],
         l = state.length,
         i = omitOffsets ? 8 : 0,
         // skip top, left, right, bottom if omitOffsets is true
     p;
   
     for (; i < l; i += 2) {
       p = state[i];
       result.push(p, p in override ? override[p] : state[i + 1]);
     }
   
     result.t = state.t;
     return result;
   },
       _winOffsets = {
     left: 0,
     top: 0
   },
       // // potential future feature (?) Allow users to calculate where a trigger hits (scroll position) like getScrollPosition("#id", "top bottom")
   // _getScrollPosition = (trigger, position, {scroller, containerAnimation, horizontal}) => {
   // 	scroller = _getTarget(scroller || _win);
   // 	let direction = horizontal ? _horizontal : _vertical,
   // 		isViewport = _isViewport(scroller);
   // 	_getSizeFunc(scroller, isViewport, direction);
   // 	return _parsePosition(position, _getTarget(trigger), _getSizeFunc(scroller, isViewport, direction)(), direction, _getScrollFunc(scroller, direction)(), 0, 0, 0, _getOffsetsFunc(scroller, isViewport)(), isViewport ? 0 : parseFloat(_getComputedStyle(scroller)["border" + direction.p2 + _Width]) || 0, 0, containerAnimation ? containerAnimation.duration() : _maxScroll(scroller), containerAnimation);
   // },
   _parsePosition = function _parsePosition(value, trigger, scrollerSize, direction, scroll, marker, markerScroller, self, scrollerBounds, borderWidth, useFixedPosition, scrollerMax, containerAnimation, clampZeroProp) {
     _isFunction(value) && (value = value(self));
   
     if (_isString(value) && value.substr(0, 3) === "max") {
       value = scrollerMax + (value.charAt(4) === "=" ? _offsetToPx("0" + value.substr(3), scrollerSize) : 0);
     }
   
     var time = containerAnimation ? containerAnimation.time() : 0,
         p1,
         p2,
         element;
     containerAnimation && containerAnimation.seek(0);
     isNaN(value) || (value = +value); // convert a string number like "45" to an actual number
   
     if (!_isNumber(value)) {
       _isFunction(trigger) && (trigger = trigger(self));
       var offsets = (value || "0").split(" "),
           bounds,
           localOffset,
           globalOffset,
           display;
       element = (0,_Observer_js__WEBPACK_IMPORTED_MODULE_0__._getTarget)(trigger, self) || _body;
       bounds = _getBounds(element) || {};
   
       if ((!bounds || !bounds.left && !bounds.top) && _getComputedStyle(element).display === "none") {
         // if display is "none", it won't report getBoundingClientRect() properly
         display = element.style.display;
         element.style.display = "block";
         bounds = _getBounds(element);
         display ? element.style.display = display : element.style.removeProperty("display");
       }
   
       localOffset = _offsetToPx(offsets[0], bounds[direction.d]);
       globalOffset = _offsetToPx(offsets[1] || "0", scrollerSize);
       value = bounds[direction.p] - scrollerBounds[direction.p] - borderWidth + localOffset + scroll - globalOffset;
       markerScroller && _positionMarker(markerScroller, globalOffset, direction, scrollerSize - globalOffset < 20 || markerScroller._isStart && globalOffset > 20);
       scrollerSize -= scrollerSize - globalOffset; // adjust for the marker
     } else {
       containerAnimation && (value = gsap.utils.mapRange(containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, 0, scrollerMax, value));
       markerScroller && _positionMarker(markerScroller, scrollerSize, direction, true);
     }
   
     if (clampZeroProp) {
       self[clampZeroProp] = value || -0.001;
       value < 0 && (value = 0);
     }
   
     if (marker) {
       var position = value + scrollerSize,
           isStart = marker._isStart;
       p1 = "scroll" + direction.d2;
   
       _positionMarker(marker, position, direction, isStart && position > 20 || !isStart && (useFixedPosition ? Math.max(_body[p1], _docEl[p1]) : marker.parentNode[p1]) <= position + 1);
   
       if (useFixedPosition) {
         scrollerBounds = _getBounds(markerScroller);
         useFixedPosition && (marker.style[direction.op.p] = scrollerBounds[direction.op.p] - direction.op.m - marker._offset + _px);
       }
     }
   
     if (containerAnimation && element) {
       p1 = _getBounds(element);
       containerAnimation.seek(scrollerMax);
       p2 = _getBounds(element);
       containerAnimation._caScrollDist = p1[direction.p] - p2[direction.p];
       value = value / containerAnimation._caScrollDist * scrollerMax;
     }
   
     containerAnimation && containerAnimation.seek(time);
     return containerAnimation ? value : Math.round(value);
   },
       _prefixExp = /(webkit|moz|length|cssText|inset)/i,
       _reparent = function _reparent(element, parent, top, left) {
     if (element.parentNode !== parent) {
       var style = element.style,
           p,
           cs;
   
       if (parent === _body) {
         element._stOrig = style.cssText; // record original inline styles so we can revert them later
   
         cs = _getComputedStyle(element);
   
         for (p in cs) {
           // must copy all relevant styles to ensure that nothing changes visually when we reparent to the <body>. Skip the vendor prefixed ones.
           if (!+p && !_prefixExp.test(p) && cs[p] && typeof style[p] === "string" && p !== "0") {
             style[p] = cs[p];
           }
         }
   
         style.top = top;
         style.left = left;
       } else {
         style.cssText = element._stOrig;
       }
   
       gsap.core.getCache(element).uncache = 1;
       parent.appendChild(element);
     }
   },
       _interruptionTracker = function _interruptionTracker(getValueFunc, initialValue, onInterrupt) {
     var last1 = initialValue,
         last2 = last1;
     return function (value) {
       var current = Math.round(getValueFunc()); // round because in some [very uncommon] Windows environments, scroll can get reported with decimals even though it was set without.
   
       if (current !== last1 && current !== last2 && Math.abs(current - last1) > 3 && Math.abs(current - last2) > 3) {
         // if the user scrolls, kill the tween. iOS Safari intermittently misreports the scroll position, it may be the most recently-set one or the one before that! When Safari is zoomed (CMD-+), it often misreports as 1 pixel off too! So if we set the scroll position to 125, for example, it'll actually report it as 124.
         value = current;
         onInterrupt && onInterrupt();
       }
   
       last2 = last1;
       last1 = Math.round(value);
       return last1;
     };
   },
       _shiftMarker = function _shiftMarker(marker, direction, value) {
     var vars = {};
     vars[direction.p] = "+=" + value;
     gsap.set(marker, vars);
   },
       // _mergeAnimations = animations => {
   // 	let tl = gsap.timeline({smoothChildTiming: true}).startTime(Math.min(...animations.map(a => a.globalTime(0))));
   // 	animations.forEach(a => {let time = a.totalTime(); tl.add(a); a.totalTime(time); });
   // 	tl.smoothChildTiming = false;
   // 	return tl;
   // },
   // returns a function that can be used to tween the scroll position in the direction provided, and when doing so it'll add a .tween property to the FUNCTION itself, and remove it when the tween completes or gets killed. This gives us a way to have multiple ScrollTriggers use a central function for any given scroller and see if there's a scroll tween running (which would affect if/how things get updated)
   _getTweenCreator = function _getTweenCreator(scroller, direction) {
     var getScroll = (0,_Observer_js__WEBPACK_IMPORTED_MODULE_0__._getScrollFunc)(scroller, direction),
         prop = "_scroll" + direction.p2,
         // add a tweenable property to the scroller that's a getter/setter function, like _scrollTop or _scrollLeft. This way, if someone does gsap.killTweensOf(scroller) it'll kill the scroll tween.
     getTween = function getTween(scrollTo, vars, initialValue, change1, change2) {
       var tween = getTween.tween,
           onComplete = vars.onComplete,
           modifiers = {};
       initialValue = initialValue || getScroll();
   
       var checkForInterruption = _interruptionTracker(getScroll, initialValue, function () {
         tween.kill();
         getTween.tween = 0;
       });
   
       change2 = change1 && change2 || 0; // if change1 is 0, we set that to the difference and ignore change2. Otherwise, there would be a compound effect.
   
       change1 = change1 || scrollTo - initialValue;
       tween && tween.kill();
       vars[prop] = scrollTo;
       vars.inherit = false;
       vars.modifiers = modifiers;
   
       modifiers[prop] = function () {
         return checkForInterruption(initialValue + change1 * tween.ratio + change2 * tween.ratio * tween.ratio);
       };
   
       vars.onUpdate = function () {
         _Observer_js__WEBPACK_IMPORTED_MODULE_0__._scrollers.cache++;
         getTween.tween && _updateAll(); // if it was interrupted/killed, like in a context.revert(), don't force an updateAll()
       };
   
       vars.onComplete = function () {
         getTween.tween = 0;
         onComplete && onComplete.call(tween);
       };
   
       tween = getTween.tween = gsap.to(scroller, vars);
       return tween;
     };
   
     scroller[prop] = getScroll;
   
     getScroll.wheelHandler = function () {
       return getTween.tween && getTween.tween.kill() && (getTween.tween = 0);
     };
   
     _addListener(scroller, "wheel", getScroll.wheelHandler); // Windows machines handle mousewheel scrolling in chunks (like "3 lines per scroll") meaning the typical strategy for cancelling the scroll isn't as sensitive. It's much more likely to match one of the previous 2 scroll event positions. So we kill any snapping as soon as there's a wheel event.
   
   
     ScrollTrigger.isTouch && _addListener(scroller, "touchmove", getScroll.wheelHandler);
     return getTween;
   };
   
   var ScrollTrigger = /*#__PURE__*/function () {
     function ScrollTrigger(vars, animation) {
       _coreInitted || ScrollTrigger.register(gsap) || console.warn("Please gsap.registerPlugin(ScrollTrigger)");
   
       _context(this);
   
       this.init(vars, animation);
     }
   
     var _proto = ScrollTrigger.prototype;
   
     _proto.init = function init(vars, animation) {
       this.progress = this.start = 0;
       this.vars && this.kill(true, true); // in case it's being initted again
   
       if (!_enabled) {
         this.update = this.refresh = this.kill = _passThrough;
         return;
       }
   
       vars = _setDefaults(_isString(vars) || _isNumber(vars) || vars.nodeType ? {
         trigger: vars
       } : vars, _defaults);
   
       var _vars = vars,
           onUpdate = _vars.onUpdate,
           toggleClass = _vars.toggleClass,
           id = _vars.id,
           onToggle = _vars.onToggle,
           onRefresh = _vars.onRefresh,
           scrub = _vars.scrub,
           trigger = _vars.trigger,
           pin = _vars.pin,
           pinSpacing = _vars.pinSpacing,
           invalidateOnRefresh = _vars.invalidateOnRefresh,
           anticipatePin = _vars.anticipatePin,
           onScrubComplete = _vars.onScrubComplete,
           onSnapComplete = _vars.onSnapComplete,
           once = _vars.once,
           snap = _vars.snap,
           pinReparent = _vars.pinReparent,
           pinSpacer = _vars.pinSpacer,
           containerAnimation = _vars.containerAnimation,
           fastScrollEnd = _vars.fastScrollEnd,
           preventOverlaps = _vars.preventOverlaps,
           direction = vars.horizontal || vars.containerAnimation && vars.horizontal !== false ? _Observer_js__WEBPACK_IMPORTED_MODULE_0__._horizontal : _Observer_js__WEBPACK_IMPORTED_MODULE_0__._vertical,
           isToggle = !scrub && scrub !== 0,
           scroller = (0,_Observer_js__WEBPACK_IMPORTED_MODULE_0__._getTarget)(vars.scroller || _win),
           scrollerCache = gsap.core.getCache(scroller),
           isViewport = _isViewport(scroller),
           useFixedPosition = ("pinType" in vars ? vars.pinType : (0,_Observer_js__WEBPACK_IMPORTED_MODULE_0__._getProxyProp)(scroller, "pinType") || isViewport && "fixed") === "fixed",
           callbacks = [vars.onEnter, vars.onLeave, vars.onEnterBack, vars.onLeaveBack],
           toggleActions = isToggle && vars.toggleActions.split(" "),
           markers = "markers" in vars ? vars.markers : _defaults.markers,
           borderWidth = isViewport ? 0 : parseFloat(_getComputedStyle(scroller)["border" + direction.p2 + _Width]) || 0,
           self = this,
           onRefreshInit = vars.onRefreshInit && function () {
         return vars.onRefreshInit(self);
       },
           getScrollerSize = _getSizeFunc(scroller, isViewport, direction),
           getScrollerOffsets = _getOffsetsFunc(scroller, isViewport),
           lastSnap = 0,
           lastRefresh = 0,
           prevProgress = 0,
           scrollFunc = (0,_Observer_js__WEBPACK_IMPORTED_MODULE_0__._getScrollFunc)(scroller, direction),
           tweenTo,
           pinCache,
           snapFunc,
           scroll1,
           scroll2,
           start,
           end,
           markerStart,
           markerEnd,
           markerStartTrigger,
           markerEndTrigger,
           markerVars,
           executingOnRefresh,
           change,
           pinOriginalState,
           pinActiveState,
           pinState,
           spacer,
           offset,
           pinGetter,
           pinSetter,
           pinStart,
           pinChange,
           spacingStart,
           spacerState,
           markerStartSetter,
           pinMoves,
           markerEndSetter,
           cs,
           snap1,
           snap2,
           scrubTween,
           scrubSmooth,
           snapDurClamp,
           snapDelayedCall,
           prevScroll,
           prevAnimProgress,
           caMarkerSetter,
           customRevertReturn; // for the sake of efficiency, _startClamp/_endClamp serve like a truthy value indicating that clamping was enabled on the start/end, and ALSO store the actual pre-clamped numeric value. We tap into that in ScrollSmoother for speed effects. So for example, if start="clamp(top bottom)" results in a start of -100 naturally, it would get clamped to 0 but -100 would be stored in _startClamp.
   
   
       self._startClamp = self._endClamp = false;
       self._dir = direction;
       anticipatePin *= 45;
       self.scroller = scroller;
       self.scroll = containerAnimation ? containerAnimation.time.bind(containerAnimation) : scrollFunc;
       scroll1 = scrollFunc();
       self.vars = vars;
       animation = animation || vars.animation;
   
       if ("refreshPriority" in vars) {
         _sort = 1;
         vars.refreshPriority === -9999 && (_primary = self); // used by ScrollSmoother
       }
   
       scrollerCache.tweenScroll = scrollerCache.tweenScroll || {
         top: _getTweenCreator(scroller, _Observer_js__WEBPACK_IMPORTED_MODULE_0__._vertical),
         left: _getTweenCreator(scroller, _Observer_js__WEBPACK_IMPORTED_MODULE_0__._horizontal)
       };
       self.tweenTo = tweenTo = scrollerCache.tweenScroll[direction.p];
   
       self.scrubDuration = function (value) {
         scrubSmooth = _isNumber(value) && value;
   
         if (!scrubSmooth) {
           scrubTween && scrubTween.progress(1).kill();
           scrubTween = 0;
         } else {
           scrubTween ? scrubTween.duration(value) : scrubTween = gsap.to(animation, {
             ease: "expo",
             totalProgress: "+=0",
             inherit: false,
             duration: scrubSmooth,
             paused: true,
             onComplete: function onComplete() {
               return onScrubComplete && onScrubComplete(self);
             }
           });
         }
       };
   
       if (animation) {
         animation.vars.lazy = false;
         animation._initted && !self.isReverted || animation.vars.immediateRender !== false && vars.immediateRender !== false && animation.duration() && animation.render(0, true, true); // special case: if this ScrollTrigger gets re-initted, a from() tween with a stagger could get initted initially and then reverted on the re-init which means it'll need to get rendered again here to properly display things. Otherwise, See https://gsap.com/forums/topic/36777-scrollsmoother-splittext-nextjs/ and https://codepen.io/GreenSock/pen/eYPyPpd?editors=0010
   
         self.animation = animation.pause();
         animation.scrollTrigger = self;
         self.scrubDuration(scrub);
         snap1 = 0;
         id || (id = animation.vars.id);
       }
   
       if (snap) {
         // TODO: potential idea: use legitimate CSS scroll snapping by pushing invisible elements into the DOM that serve as snap positions, and toggle the document.scrollingElement.style.scrollSnapType onToggle. See https://codepen.io/GreenSock/pen/JjLrgWM for a quick proof of concept.
         if (!_isObject(snap) || snap.push) {
           snap = {
             snapTo: snap
           };
         }
   
         "scrollBehavior" in _body.style && gsap.set(isViewport ? [_body, _docEl] : scroller, {
           scrollBehavior: "auto"
         }); // smooth scrolling doesn't work with snap.
   
         _Observer_js__WEBPACK_IMPORTED_MODULE_0__._scrollers.forEach(function (o) {
           return _isFunction(o) && o.target === (isViewport ? _doc.scrollingElement || _docEl : scroller) && (o.smooth = false);
         }); // note: set smooth to false on both the vertical and horizontal scroll getters/setters
   
   
         snapFunc = _isFunction(snap.snapTo) ? snap.snapTo : snap.snapTo === "labels" ? _getClosestLabel(animation) : snap.snapTo === "labelsDirectional" ? _getLabelAtDirection(animation) : snap.directional !== false ? function (value, st) {
           return _snapDirectional(snap.snapTo)(value, _getTime() - lastRefresh < 500 ? 0 : st.direction);
         } : gsap.utils.snap(snap.snapTo);
         snapDurClamp = snap.duration || {
           min: 0.1,
           max: 2
         };
         snapDurClamp = _isObject(snapDurClamp) ? _clamp(snapDurClamp.min, snapDurClamp.max) : _clamp(snapDurClamp, snapDurClamp);
         snapDelayedCall = gsap.delayedCall(snap.delay || scrubSmooth / 2 || 0.1, function () {
           var scroll = scrollFunc(),
               refreshedRecently = _getTime() - lastRefresh < 500,
               tween = tweenTo.tween;
   
           if ((refreshedRecently || Math.abs(self.getVelocity()) < 10) && !tween && !_pointerIsDown && lastSnap !== scroll) {
             var progress = (scroll - start) / change,
                 totalProgress = animation && !isToggle ? animation.totalProgress() : progress,
                 velocity = refreshedRecently ? 0 : (totalProgress - snap2) / (_getTime() - _time2) * 1000 || 0,
                 change1 = gsap.utils.clamp(-progress, 1 - progress, _abs(velocity / 2) * velocity / 0.185),
                 naturalEnd = progress + (snap.inertia === false ? 0 : change1),
                 endValue,
                 endScroll,
                 _snap = snap,
                 onStart = _snap.onStart,
                 _onInterrupt = _snap.onInterrupt,
                 _onComplete = _snap.onComplete;
             endValue = snapFunc(naturalEnd, self);
             _isNumber(endValue) || (endValue = naturalEnd); // in case the function didn't return a number, fall back to using the naturalEnd
   
             endScroll = Math.max(0, Math.round(start + endValue * change));
   
             if (scroll <= end && scroll >= start && endScroll !== scroll) {
               if (tween && !tween._initted && tween.data <= _abs(endScroll - scroll)) {
                 // there's an overlapping snap! So we must figure out which one is closer and let that tween live.
                 return;
               }
   
               if (snap.inertia === false) {
                 change1 = endValue - progress;
               }
   
               tweenTo(endScroll, {
                 duration: snapDurClamp(_abs(Math.max(_abs(naturalEnd - totalProgress), _abs(endValue - totalProgress)) * 0.185 / velocity / 0.05 || 0)),
                 ease: snap.ease || "power3",
                 data: _abs(endScroll - scroll),
                 // record the distance so that if another snap tween occurs (conflict) we can prioritize the closest snap.
                 onInterrupt: function onInterrupt() {
                   return snapDelayedCall.restart(true) && _onInterrupt && _callback(self, _onInterrupt);
                 },
                 onComplete: function onComplete() {
                   self.update();
                   lastSnap = scrollFunc();
   
                   if (animation && !isToggle) {
                     // the resolution of the scrollbar is limited, so we should correct the scrubbed animation's playhead at the end to match EXACTLY where it was supposed to snap
                     scrubTween ? scrubTween.resetTo("totalProgress", endValue, animation._tTime / animation._tDur) : animation.progress(endValue);
                   }
   
                   snap1 = snap2 = animation && !isToggle ? animation.totalProgress() : self.progress;
                   onSnapComplete && onSnapComplete(self);
                   _onComplete && _callback(self, _onComplete);
                 }
               }, scroll, change1 * change, endScroll - scroll - change1 * change);
               onStart && _callback(self, onStart, tweenTo.tween);
             }
           } else if (self.isActive && lastSnap !== scroll) {
             snapDelayedCall.restart(true);
           }
         }).pause();
       }
   
       id && (_ids[id] = self);
       trigger = self.trigger = (0,_Observer_js__WEBPACK_IMPORTED_MODULE_0__._getTarget)(trigger || pin !== true && pin); // if a trigger has some kind of scroll-related effect applied that could contaminate the "y" or "x" position (like a ScrollSmoother effect), we needed a way to temporarily revert it, so we use the stRevert property of the gsCache. It can return another function that we'll call at the end so it can return to its normal state.
   
       customRevertReturn = trigger && trigger._gsap && trigger._gsap.stRevert;
       customRevertReturn && (customRevertReturn = customRevertReturn(self));
       pin = pin === true ? trigger : (0,_Observer_js__WEBPACK_IMPORTED_MODULE_0__._getTarget)(pin);
       _isString(toggleClass) && (toggleClass = {
         targets: trigger,
         className: toggleClass
       });
   
       if (pin) {
         pinSpacing === false || pinSpacing === _margin || (pinSpacing = !pinSpacing && pin.parentNode && pin.parentNode.style && _getComputedStyle(pin.parentNode).display === "flex" ? false : _padding); // if the parent is display: flex, don't apply pinSpacing by default. We should check that pin.parentNode is an element (not shadow dom window)
   
         self.pin = pin;
         pinCache = gsap.core.getCache(pin);
   
         if (!pinCache.spacer) {
           // record the spacer and pinOriginalState on the cache in case someone tries pinning the same element with MULTIPLE ScrollTriggers - we don't want to have multiple spacers or record the "original" pin state after it has already been affected by another ScrollTrigger.
           if (pinSpacer) {
             pinSpacer = (0,_Observer_js__WEBPACK_IMPORTED_MODULE_0__._getTarget)(pinSpacer);
             pinSpacer && !pinSpacer.nodeType && (pinSpacer = pinSpacer.current || pinSpacer.nativeElement); // for React & Angular
   
             pinCache.spacerIsNative = !!pinSpacer;
             pinSpacer && (pinCache.spacerState = _getState(pinSpacer));
           }
   
           pinCache.spacer = spacer = pinSpacer || _doc.createElement("div");
           spacer.classList.add("pin-spacer");
           id && spacer.classList.add("pin-spacer-" + id);
           pinCache.pinState = pinOriginalState = _getState(pin);
         } else {
           pinOriginalState = pinCache.pinState;
         }
   
         vars.force3D !== false && gsap.set(pin, {
           force3D: true
         });
         self.spacer = spacer = pinCache.spacer;
         cs = _getComputedStyle(pin);
         spacingStart = cs[pinSpacing + direction.os2];
         pinGetter = gsap.getProperty(pin);
         pinSetter = gsap.quickSetter(pin, direction.a, _px); // pin.firstChild && !_maxScroll(pin, direction) && (pin.style.overflow = "hidden"); // protects from collapsing margins, but can have unintended consequences as demonstrated here: https://codepen.io/GreenSock/pen/1e42c7a73bfa409d2cf1e184e7a4248d so it was removed in favor of just telling people to set up their CSS to avoid the collapsing margins (overflow: hidden | auto is just one option. Another is border-top: 1px solid transparent).
   
         _swapPinIn(pin, spacer, cs);
   
         pinState = _getState(pin);
       }
   
       if (markers) {
         markerVars = _isObject(markers) ? _setDefaults(markers, _markerDefaults) : _markerDefaults;
         markerStartTrigger = _createMarker("scroller-start", id, scroller, direction, markerVars, 0);
         markerEndTrigger = _createMarker("scroller-end", id, scroller, direction, markerVars, 0, markerStartTrigger);
         offset = markerStartTrigger["offset" + direction.op.d2];
   
         var content = (0,_Observer_js__WEBPACK_IMPORTED_MODULE_0__._getTarget)((0,_Observer_js__WEBPACK_IMPORTED_MODULE_0__._getProxyProp)(scroller, "content") || scroller);
   
         markerStart = this.markerStart = _createMarker("start", id, content, direction, markerVars, offset, 0, containerAnimation);
         markerEnd = this.markerEnd = _createMarker("end", id, content, direction, markerVars, offset, 0, containerAnimation);
         containerAnimation && (caMarkerSetter = gsap.quickSetter([markerStart, markerEnd], direction.a, _px));
   
         if (!useFixedPosition && !(_Observer_js__WEBPACK_IMPORTED_MODULE_0__._proxies.length && (0,_Observer_js__WEBPACK_IMPORTED_MODULE_0__._getProxyProp)(scroller, "fixedMarkers") === true)) {
           _makePositionable(isViewport ? _body : scroller);
   
           gsap.set([markerStartTrigger, markerEndTrigger], {
             force3D: true
           });
           markerStartSetter = gsap.quickSetter(markerStartTrigger, direction.a, _px);
           markerEndSetter = gsap.quickSetter(markerEndTrigger, direction.a, _px);
         }
       }
   
       if (containerAnimation) {
         var oldOnUpdate = containerAnimation.vars.onUpdate,
             oldParams = containerAnimation.vars.onUpdateParams;
         containerAnimation.eventCallback("onUpdate", function () {
           self.update(0, 0, 1);
           oldOnUpdate && oldOnUpdate.apply(containerAnimation, oldParams || []);
         });
       }
   
       self.previous = function () {
         return _triggers[_triggers.indexOf(self) - 1];
       };
   
       self.next = function () {
         return _triggers[_triggers.indexOf(self) + 1];
       };
   
       self.revert = function (revert, temp) {
         if (!temp) {
           return self.kill(true);
         } // for compatibility with gsap.context() and gsap.matchMedia() which call revert()
   
   
         var r = revert !== false || !self.enabled,
             prevRefreshing = _refreshing;
   
         if (r !== self.isReverted) {
           if (r) {
             prevScroll = Math.max(scrollFunc(), self.scroll.rec || 0); // record the scroll so we can revert later (repositioning/pinning things can affect scroll position). In the static refresh() method, we first record all the scroll positions as a reference.
   
             prevProgress = self.progress;
             prevAnimProgress = animation && animation.progress();
           }
   
           markerStart && [markerStart, markerEnd, markerStartTrigger, markerEndTrigger].forEach(function (m) {
             return m.style.display = r ? "none" : "block";
           });
   
           if (r) {
             _refreshing = self;
             self.update(r); // make sure the pin is back in its original position so that all the measurements are correct. do this BEFORE swapping the pin out
           }
   
           if (pin && (!pinReparent || !self.isActive)) {
             if (r) {
               _swapPinOut(pin, spacer, pinOriginalState);
             } else {
               _swapPinIn(pin, spacer, _getComputedStyle(pin), spacerState);
             }
           }
   
           r || self.update(r); // when we're restoring, the update should run AFTER swapping the pin into its pin-spacer.
   
           _refreshing = prevRefreshing; // restore. We set it to true during the update() so that things fire properly in there.
   
           self.isReverted = r;
         }
       };
   
       self.refresh = function (soft, force, position, pinOffset) {
         // position is typically only defined if it's coming from setPositions() - it's a way to skip the normal parsing. pinOffset is also only from setPositions() and is mostly related to fancy stuff we need to do in ScrollSmoother with effects
         if ((_refreshing || !self.enabled) && !force) {
           return;
         }
   
         if (pin && soft && _lastScrollTime) {
           _addListener(ScrollTrigger, "scrollEnd", _softRefresh);
   
           return;
         }
   
         !_refreshingAll && onRefreshInit && onRefreshInit(self);
         _refreshing = self;
   
         if (tweenTo.tween && !position) {
           // we skip this if a position is passed in because typically that's from .setPositions() and it's best to allow in-progress snapping to continue.
           tweenTo.tween.kill();
           tweenTo.tween = 0;
         }
   
         scrubTween && scrubTween.pause();
   
         if (invalidateOnRefresh && animation) {
           animation.revert({
             kill: false
           }).invalidate();
           animation.getChildren ? animation.getChildren(true, true, false).forEach(function (t) {
             return t.vars.immediateRender && t.render(0, true, true);
           }) : animation.vars.immediateRender && animation.render(0, true, true); // any from() or fromTo() tweens should render immediately (well, unless they have immediateRender: false)
         }
   
         self.isReverted || self.revert(true, true);
         self._subPinOffset = false; // we'll set this to true in the sub-pins if we find any
   
         var size = getScrollerSize(),
             scrollerBounds = getScrollerOffsets(),
             max = containerAnimation ? containerAnimation.duration() : _maxScroll(scroller, direction),
             isFirstRefresh = change <= 0.01 || !change,
             offset = 0,
             otherPinOffset = pinOffset || 0,
             parsedEnd = _isObject(position) ? position.end : vars.end,
             parsedEndTrigger = vars.endTrigger || trigger,
             parsedStart = _isObject(position) ? position.start : vars.start || (vars.start === 0 || !trigger ? 0 : pin ? "0 0" : "0 100%"),
             pinnedContainer = self.pinnedContainer = vars.pinnedContainer && (0,_Observer_js__WEBPACK_IMPORTED_MODULE_0__._getTarget)(vars.pinnedContainer, self),
             triggerIndex = trigger && Math.max(0, _triggers.indexOf(self)) || 0,
             i = triggerIndex,
             cs,
             bounds,
             scroll,
             isVertical,
             override,
             curTrigger,
             curPin,
             oppositeScroll,
             initted,
             revertedPins,
             forcedOverflow,
             markerStartOffset,
             markerEndOffset;
   
         if (markers && _isObject(position)) {
           // if we alter the start/end positions with .setPositions(), it generally feeds in absolute NUMBERS which don't convey information about where to line up the markers, so to keep it intuitive, we record how far the trigger positions shift after applying the new numbers and then offset by that much in the opposite direction. We do the same to the associated trigger markers too of course.
           markerStartOffset = gsap.getProperty(markerStartTrigger, direction.p);
           markerEndOffset = gsap.getProperty(markerEndTrigger, direction.p);
         }
   
         while (i-- > 0) {
           // user might try to pin the same element more than once, so we must find any prior triggers with the same pin, revert them, and determine how long they're pinning so that we can offset things appropriately. Make sure we revert from last to first so that things "rewind" properly.
           curTrigger = _triggers[i];
           curTrigger.end || curTrigger.refresh(0, 1) || (_refreshing = self); // if it's a timeline-based trigger that hasn't been fully initialized yet because it's waiting for 1 tick, just force the refresh() here, otherwise if it contains a pin that's supposed to affect other ScrollTriggers further down the page, they won't be adjusted properly.
   
           curPin = curTrigger.pin;
   
           if (curPin && (curPin === trigger || curPin === pin || curPin === pinnedContainer) && !curTrigger.isReverted) {
             revertedPins || (revertedPins = []);
             revertedPins.unshift(curTrigger); // we'll revert from first to last to make sure things reach their end state properly
   
             curTrigger.revert(true, true);
           }
   
           if (curTrigger !== _triggers[i]) {
             // in case it got removed.
             triggerIndex--;
             i--;
           }
         }
   
         _isFunction(parsedStart) && (parsedStart = parsedStart(self));
         parsedStart = _parseClamp(parsedStart, "start", self);
         start = _parsePosition(parsedStart, trigger, size, direction, scrollFunc(), markerStart, markerStartTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._startClamp && "_startClamp") || (pin ? -0.001 : 0);
         _isFunction(parsedEnd) && (parsedEnd = parsedEnd(self));
   
         if (_isString(parsedEnd) && !parsedEnd.indexOf("+=")) {
           if (~parsedEnd.indexOf(" ")) {
             parsedEnd = (_isString(parsedStart) ? parsedStart.split(" ")[0] : "") + parsedEnd;
           } else {
             offset = _offsetToPx(parsedEnd.substr(2), size);
             parsedEnd = _isString(parsedStart) ? parsedStart : (containerAnimation ? gsap.utils.mapRange(0, containerAnimation.duration(), containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, start) : start) + offset; // _parsePosition won't factor in the offset if the start is a number, so do it here.
   
             parsedEndTrigger = trigger;
           }
         }
   
         parsedEnd = _parseClamp(parsedEnd, "end", self);
         end = Math.max(start, _parsePosition(parsedEnd || (parsedEndTrigger ? "100% 0" : max), parsedEndTrigger, size, direction, scrollFunc() + offset, markerEnd, markerEndTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._endClamp && "_endClamp")) || -0.001;
         offset = 0;
         i = triggerIndex;
   
         while (i--) {
           curTrigger = _triggers[i] || {};
           curPin = curTrigger.pin;
   
           if (curPin && curTrigger.start - curTrigger._pinPush <= start && !containerAnimation && curTrigger.end > 0) {
             cs = curTrigger.end - (self._startClamp ? Math.max(0, curTrigger.start) : curTrigger.start);
   
             if ((curPin === trigger && curTrigger.start - curTrigger._pinPush < start || curPin === pinnedContainer) && isNaN(parsedStart)) {
               // numeric start values shouldn't be offset at all - treat them as absolute
               offset += cs * (1 - curTrigger.progress);
             }
   
             curPin === pin && (otherPinOffset += cs);
           }
         }
   
         start += offset;
         end += offset;
         self._startClamp && (self._startClamp += offset);
   
         if (self._endClamp && !_refreshingAll) {
           self._endClamp = end || -0.001;
           end = Math.min(end, _maxScroll(scroller, direction));
         }
   
         change = end - start || (start -= 0.01) && 0.001;
   
         if (isFirstRefresh) {
           // on the very first refresh(), the prevProgress couldn't have been accurate yet because the start/end were never calculated, so we set it here. Before 3.11.5, it could lead to an inaccurate scroll position restoration with snapping.
           prevProgress = gsap.utils.clamp(0, 1, gsap.utils.normalize(start, end, prevScroll));
         }
   
         self._pinPush = otherPinOffset;
   
         if (markerStart && offset) {
           // offset the markers if necessary
           cs = {};
           cs[direction.a] = "+=" + offset;
           pinnedContainer && (cs[direction.p] = "-=" + scrollFunc());
           gsap.set([markerStart, markerEnd], cs);
         }
   
         if (pin && !(_clampingMax && self.end >= _maxScroll(scroller, direction))) {
           cs = _getComputedStyle(pin);
           isVertical = direction === _Observer_js__WEBPACK_IMPORTED_MODULE_0__._vertical;
           scroll = scrollFunc(); // recalculate because the triggers can affect the scroll
   
           pinStart = parseFloat(pinGetter(direction.a)) + otherPinOffset;
   
           if (!max && end > 1) {
             // makes sure the scroller has a scrollbar, otherwise if something has width: 100%, for example, it would be too big (exclude the scrollbar). See https://gsap.com/forums/topic/25182-scrolltrigger-width-of-page-increase-where-markers-are-set-to-false/
             forcedOverflow = (isViewport ? _doc.scrollingElement || _docEl : scroller).style;
             forcedOverflow = {
               style: forcedOverflow,
               value: forcedOverflow["overflow" + direction.a.toUpperCase()]
             };
   
             if (isViewport && _getComputedStyle(_body)["overflow" + direction.a.toUpperCase()] !== "scroll") {
               // avoid an extra scrollbar if BOTH <html> and <body> have overflow set to "scroll"
               forcedOverflow.style["overflow" + direction.a.toUpperCase()] = "scroll";
             }
           }
   
           _swapPinIn(pin, spacer, cs);
   
           pinState = _getState(pin); // transforms will interfere with the top/left/right/bottom placement, so remove them temporarily. getBoundingClientRect() factors in transforms.
   
           bounds = _getBounds(pin, true);
           oppositeScroll = useFixedPosition && (0,_Observer_js__WEBPACK_IMPORTED_MODULE_0__._getScrollFunc)(scroller, isVertical ? _Observer_js__WEBPACK_IMPORTED_MODULE_0__._horizontal : _Observer_js__WEBPACK_IMPORTED_MODULE_0__._vertical)();
   
           if (pinSpacing) {
             spacerState = [pinSpacing + direction.os2, change + otherPinOffset + _px];
             spacerState.t = spacer;
             i = pinSpacing === _padding ? _getSize(pin, direction) + change + otherPinOffset : 0;
   
             if (i) {
               spacerState.push(direction.d, i + _px); // for box-sizing: border-box (must include padding).
   
               spacer.style.flexBasis !== "auto" && (spacer.style.flexBasis = i + _px);
             }
   
             _setState(spacerState);
   
             if (pinnedContainer) {
               // in ScrollTrigger.refresh(), we need to re-evaluate the pinContainer's size because this pinSpacing may stretch it out, but we can't just add the exact distance because depending on layout, it may not push things down or it may only do so partially.
               _triggers.forEach(function (t) {
                 if (t.pin === pinnedContainer && t.vars.pinSpacing !== false) {
                   t._subPinOffset = true;
                 }
               });
             }
   
             useFixedPosition && scrollFunc(prevScroll);
           } else {
             i = _getSize(pin, direction);
             i && spacer.style.flexBasis !== "auto" && (spacer.style.flexBasis = i + _px);
           }
   
           if (useFixedPosition) {
             override = {
               top: bounds.top + (isVertical ? scroll - start : oppositeScroll) + _px,
               left: bounds.left + (isVertical ? oppositeScroll : scroll - start) + _px,
               boxSizing: "border-box",
               position: "fixed"
             };
             override[_width] = override["max" + _Width] = Math.ceil(bounds.width) + _px;
             override[_height] = override["max" + _Height] = Math.ceil(bounds.height) + _px;
             override[_margin] = override[_margin + _Top] = override[_margin + _Right] = override[_margin + _Bottom] = override[_margin + _Left] = "0";
             override[_padding] = cs[_padding];
             override[_padding + _Top] = cs[_padding + _Top];
             override[_padding + _Right] = cs[_padding + _Right];
             override[_padding + _Bottom] = cs[_padding + _Bottom];
             override[_padding + _Left] = cs[_padding + _Left];
             pinActiveState = _copyState(pinOriginalState, override, pinReparent);
             _refreshingAll && scrollFunc(0);
           }
   
           if (animation) {
             // the animation might be affecting the transform, so we must jump to the end, check the value, and compensate accordingly. Otherwise, when it becomes unpinned, the pinSetter() will get set to a value that doesn't include whatever the animation did.
             initted = animation._initted; // if not, we must invalidate() after this step, otherwise it could lock in starting values prematurely.
   
             _suppressOverwrites(1);
   
             animation.render(animation.duration(), true, true);
             pinChange = pinGetter(direction.a) - pinStart + change + otherPinOffset;
             pinMoves = Math.abs(change - pinChange) > 1;
             useFixedPosition && pinMoves && pinActiveState.splice(pinActiveState.length - 2, 2); // transform is the last property/value set in the state Array. Since the animation is controlling that, we should omit it.
   
             animation.render(0, true, true);
             initted || animation.invalidate(true);
             animation.parent || animation.totalTime(animation.totalTime()); // if, for example, a toggleAction called play() and then refresh() happens and when we render(1) above, it would cause the animation to complete and get removed from its parent, so this makes sure it gets put back in.
   
             _suppressOverwrites(0);
           } else {
             pinChange = change;
           }
   
           forcedOverflow && (forcedOverflow.value ? forcedOverflow.style["overflow" + direction.a.toUpperCase()] = forcedOverflow.value : forcedOverflow.style.removeProperty("overflow-" + direction.a));
         } else if (trigger && scrollFunc() && !containerAnimation) {
           // it may be INSIDE a pinned element, so walk up the tree and look for any elements with _pinOffset to compensate because anything with pinSpacing that's already scrolled would throw off the measurements in getBoundingClientRect()
           bounds = trigger.parentNode;
   
           while (bounds && bounds !== _body) {
             if (bounds._pinOffset) {
               start -= bounds._pinOffset;
               end -= bounds._pinOffset;
             }
   
             bounds = bounds.parentNode;
           }
         }
   
         revertedPins && revertedPins.forEach(function (t) {
           return t.revert(false, true);
         });
         self.start = start;
         self.end = end;
         scroll1 = scroll2 = _refreshingAll ? prevScroll : scrollFunc(); // reset velocity
   
         if (!containerAnimation && !_refreshingAll) {
           scroll1 < prevScroll && scrollFunc(prevScroll);
           self.scroll.rec = 0;
         }
   
         self.revert(false, true);
         lastRefresh = _getTime();
   
         if (snapDelayedCall) {
           lastSnap = -1; // just so snapping gets re-enabled, clear out any recorded last value
           // self.isActive && scrollFunc(start + change * prevProgress); // previously this line was here to ensure that when snapping kicks in, it's from the previous progress but in some cases that's not desirable, like an all-page ScrollTrigger when new content gets added to the page, that'd totally change the progress.
   
           snapDelayedCall.restart(true);
         }
   
         _refreshing = 0;
         animation && isToggle && (animation._initted || prevAnimProgress) && animation.progress() !== prevAnimProgress && animation.progress(prevAnimProgress || 0, true).render(animation.time(), true, true); // must force a re-render because if saveStyles() was used on the target(s), the styles could have been wiped out during the refresh().
   
         if (isFirstRefresh || prevProgress !== self.progress || containerAnimation || invalidateOnRefresh || animation && !animation._initted) {
           // ensures that the direction is set properly (when refreshing, progress is set back to 0 initially, then back again to wherever it needs to be) and that callbacks are triggered.
           animation && !isToggle && (animation._initted || prevProgress || animation.vars.immediateRender !== false) && animation.totalProgress(containerAnimation && start < -0.001 && !prevProgress ? gsap.utils.normalize(start, end, 0) : prevProgress, true); // to avoid issues where animation callbacks like onStart aren't triggered.
   
           self.progress = isFirstRefresh || (scroll1 - start) / change === prevProgress ? 0 : prevProgress;
         }
   
         pin && pinSpacing && (spacer._pinOffset = Math.round(self.progress * pinChange));
         scrubTween && scrubTween.invalidate();
   
         if (!isNaN(markerStartOffset)) {
           // numbers were passed in for the position which are absolute, so instead of just putting the markers at the very bottom of the viewport, we figure out how far they shifted down (it's safe to assume they were originally positioned in closer relation to the trigger element with values like "top", "center", a percentage or whatever, so we offset that much in the opposite direction to basically revert them to the relative position thy were at previously.
           markerStartOffset -= gsap.getProperty(markerStartTrigger, direction.p);
           markerEndOffset -= gsap.getProperty(markerEndTrigger, direction.p);
   
           _shiftMarker(markerStartTrigger, direction, markerStartOffset);
   
           _shiftMarker(markerStart, direction, markerStartOffset - (pinOffset || 0));
   
           _shiftMarker(markerEndTrigger, direction, markerEndOffset);
   
           _shiftMarker(markerEnd, direction, markerEndOffset - (pinOffset || 0));
         }
   
         isFirstRefresh && !_refreshingAll && self.update(); // edge case - when you reload a page when it's already scrolled down, some browsers fire a "scroll" event before DOMContentLoaded, triggering an updateAll(). If we don't update the self.progress as part of refresh(), then when it happens next, it may record prevProgress as 0 when it really shouldn't, potentially causing a callback in an animation to fire again.
   
         if (onRefresh && !_refreshingAll && !executingOnRefresh) {
           // when refreshing all, we do extra work to correct pinnedContainer sizes and ensure things don't exceed the maxScroll, so we should do all the refreshes at the end after all that work so that the start/end values are corrected.
           executingOnRefresh = true;
           onRefresh(self);
           executingOnRefresh = false;
         }
       };
   
       self.getVelocity = function () {
         return (scrollFunc() - scroll2) / (_getTime() - _time2) * 1000 || 0;
       };
   
       self.endAnimation = function () {
         _endAnimation(self.callbackAnimation);
   
         if (animation) {
           scrubTween ? scrubTween.progress(1) : !animation.paused() ? _endAnimation(animation, animation.reversed()) : isToggle || _endAnimation(animation, self.direction < 0, 1);
         }
       };
   
       self.labelToScroll = function (label) {
         return animation && animation.labels && (start || self.refresh() || start) + animation.labels[label] / animation.duration() * change || 0;
       };
   
       self.getTrailing = function (name) {
         var i = _triggers.indexOf(self),
             a = self.direction > 0 ? _triggers.slice(0, i).reverse() : _triggers.slice(i + 1);
   
         return (_isString(name) ? a.filter(function (t) {
           return t.vars.preventOverlaps === name;
         }) : a).filter(function (t) {
           return self.direction > 0 ? t.end <= start : t.start >= end;
         });
       };
   
       self.update = function (reset, recordVelocity, forceFake) {
         if (containerAnimation && !forceFake && !reset) {
           return;
         }
   
         var scroll = _refreshingAll === true ? prevScroll : self.scroll(),
             p = reset ? 0 : (scroll - start) / change,
             clipped = p < 0 ? 0 : p > 1 ? 1 : p || 0,
             prevProgress = self.progress,
             isActive,
             wasActive,
             toggleState,
             action,
             stateChanged,
             toggled,
             isAtMax,
             isTakingAction;
   
         if (recordVelocity) {
           scroll2 = scroll1;
           scroll1 = containerAnimation ? scrollFunc() : scroll;
   
           if (snap) {
             snap2 = snap1;
             snap1 = animation && !isToggle ? animation.totalProgress() : clipped;
           }
         } // anticipate the pinning a few ticks ahead of time based on velocity to avoid a visual glitch due to the fact that most browsers do scrolling on a separate thread (not synced with requestAnimationFrame).
   
   
         if (anticipatePin && pin && !_refreshing && !_startup && _lastScrollTime) {
           if (!clipped && start < scroll + (scroll - scroll2) / (_getTime() - _time2) * anticipatePin) {
             clipped = 0.0001;
           } else if (clipped === 1 && end > scroll + (scroll - scroll2) / (_getTime() - _time2) * anticipatePin) {
             clipped = 0.9999;
           }
         }
   
         if (clipped !== prevProgress && self.enabled) {
           isActive = self.isActive = !!clipped && clipped < 1;
           wasActive = !!prevProgress && prevProgress < 1;
           toggled = isActive !== wasActive;
           stateChanged = toggled || !!clipped !== !!prevProgress; // could go from start all the way to end, thus it didn't toggle but it did change state in a sense (may need to fire a callback)
   
           self.direction = clipped > prevProgress ? 1 : -1;
           self.progress = clipped;
   
           if (stateChanged && !_refreshing) {
             toggleState = clipped && !prevProgress ? 0 : clipped === 1 ? 1 : prevProgress === 1 ? 2 : 3; // 0 = enter, 1 = leave, 2 = enterBack, 3 = leaveBack (we prioritize the FIRST encounter, thus if you scroll really fast past the onEnter and onLeave in one tick, it'd prioritize onEnter.
   
             if (isToggle) {
               action = !toggled && toggleActions[toggleState + 1] !== "none" && toggleActions[toggleState + 1] || toggleActions[toggleState]; // if it didn't toggle, that means it shot right past and since we prioritize the "enter" action, we should switch to the "leave" in this case (but only if one is defined)
   
               isTakingAction = animation && (action === "complete" || action === "reset" || action in animation);
             }
           }
   
           preventOverlaps && (toggled || isTakingAction) && (isTakingAction || scrub || !animation) && (_isFunction(preventOverlaps) ? preventOverlaps(self) : self.getTrailing(preventOverlaps).forEach(function (t) {
             return t.endAnimation();
           }));
   
           if (!isToggle) {
             if (scrubTween && !_refreshing && !_startup) {
               scrubTween._dp._time - scrubTween._start !== scrubTween._time && scrubTween.render(scrubTween._dp._time - scrubTween._start); // if there's a scrub on both the container animation and this one (or a ScrollSmoother), the update order would cause this one not to have rendered yet, so it wouldn't make any progress before we .restart() it heading toward the new progress so it'd appear stuck thus we force a render here.
   
               if (scrubTween.resetTo) {
                 scrubTween.resetTo("totalProgress", clipped, animation._tTime / animation._tDur);
               } else {
                 // legacy support (courtesy), before 3.10.0
                 scrubTween.vars.totalProgress = clipped;
                 scrubTween.invalidate().restart();
               }
             } else if (animation) {
               animation.totalProgress(clipped, !!(_refreshing && (lastRefresh || reset)));
             }
           }
   
           if (pin) {
             reset && pinSpacing && (spacer.style[pinSpacing + direction.os2] = spacingStart);
   
             if (!useFixedPosition) {
               pinSetter(_round(pinStart + pinChange * clipped));
             } else if (stateChanged) {
               isAtMax = !reset && clipped > prevProgress && end + 1 > scroll && scroll + 1 >= _maxScroll(scroller, direction); // if it's at the VERY end of the page, don't switch away from position: fixed because it's pointless and it could cause a brief flash when the user scrolls back up (when it gets pinned again)
   
               if (pinReparent) {
                 if (!reset && (isActive || isAtMax)) {
                   var bounds = _getBounds(pin, true),
                       _offset = scroll - start;
   
                   _reparent(pin, _body, bounds.top + (direction === _Observer_js__WEBPACK_IMPORTED_MODULE_0__._vertical ? _offset : 0) + _px, bounds.left + (direction === _Observer_js__WEBPACK_IMPORTED_MODULE_0__._vertical ? 0 : _offset) + _px);
                 } else {
                   _reparent(pin, spacer);
                 }
               }
   
               _setState(isActive || isAtMax ? pinActiveState : pinState);
   
               pinMoves && clipped < 1 && isActive || pinSetter(pinStart + (clipped === 1 && !isAtMax ? pinChange : 0));
             }
           }
   
           snap && !tweenTo.tween && !_refreshing && !_startup && snapDelayedCall.restart(true);
           toggleClass && (toggled || once && clipped && (clipped < 1 || !_limitCallbacks)) && _toArray(toggleClass.targets).forEach(function (el) {
             return el.classList[isActive || once ? "add" : "remove"](toggleClass.className);
           }); // classes could affect positioning, so do it even if reset or refreshing is true.
   
           onUpdate && !isToggle && !reset && onUpdate(self);
   
           if (stateChanged && !_refreshing) {
             if (isToggle) {
               if (isTakingAction) {
                 if (action === "complete") {
                   animation.pause().totalProgress(1);
                 } else if (action === "reset") {
                   animation.restart(true).pause();
                 } else if (action === "restart") {
                   animation.restart(true);
                 } else {
                   animation[action]();
                 }
               }
   
               onUpdate && onUpdate(self);
             }
   
             if (toggled || !_limitCallbacks) {
               // on startup, the page could be scrolled and we don't want to fire callbacks that didn't toggle. For example onEnter shouldn't fire if the ScrollTrigger isn't actually entered.
               onToggle && toggled && _callback(self, onToggle);
               callbacks[toggleState] && _callback(self, callbacks[toggleState]);
               once && (clipped === 1 ? self.kill(false, 1) : callbacks[toggleState] = 0); // a callback shouldn't be called again if once is true.
   
               if (!toggled) {
                 // it's possible to go completely past, like from before the start to after the end (or vice-versa) in which case BOTH callbacks should be fired in that order
                 toggleState = clipped === 1 ? 1 : 3;
                 callbacks[toggleState] && _callback(self, callbacks[toggleState]);
               }
             }
   
             if (fastScrollEnd && !isActive && Math.abs(self.getVelocity()) > (_isNumber(fastScrollEnd) ? fastScrollEnd : 2500)) {
               _endAnimation(self.callbackAnimation);
   
               scrubTween ? scrubTween.progress(1) : _endAnimation(animation, action === "reverse" ? 1 : !clipped, 1);
             }
           } else if (isToggle && onUpdate && !_refreshing) {
             onUpdate(self);
           }
         } // update absolutely-positioned markers (only if the scroller isn't the viewport)
   
   
         if (markerEndSetter) {
           var n = containerAnimation ? scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0) : scroll;
           markerStartSetter(n + (markerStartTrigger._isFlipped ? 1 : 0));
           markerEndSetter(n);
         }
   
         caMarkerSetter && caMarkerSetter(-scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0));
       };
   
       self.enable = function (reset, refresh) {
         if (!self.enabled) {
           self.enabled = true;
   
           _addListener(scroller, "resize", _onResize);
   
           isViewport || _addListener(scroller, "scroll", _onScroll);
           onRefreshInit && _addListener(ScrollTrigger, "refreshInit", onRefreshInit);
   
           if (reset !== false) {
             self.progress = prevProgress = 0;
             scroll1 = scroll2 = lastSnap = scrollFunc();
           }
   
           refresh !== false && self.refresh();
         }
       };
   
       self.getTween = function (snap) {
         return snap && tweenTo ? tweenTo.tween : scrubTween;
       };
   
       self.setPositions = function (newStart, newEnd, keepClamp, pinOffset) {
         // doesn't persist after refresh()! Intended to be a way to override values that were set during refresh(), like you could set it in onRefresh()
         if (containerAnimation) {
           // convert ratios into scroll positions. Remember, start/end values on ScrollTriggers that have a containerAnimation refer to the time (in seconds), NOT scroll positions.
           var st = containerAnimation.scrollTrigger,
               duration = containerAnimation.duration(),
               _change = st.end - st.start;
   
           newStart = st.start + _change * newStart / duration;
           newEnd = st.start + _change * newEnd / duration;
         }
   
         self.refresh(false, false, {
           start: _keepClamp(newStart, keepClamp && !!self._startClamp),
           end: _keepClamp(newEnd, keepClamp && !!self._endClamp)
         }, pinOffset);
         self.update();
       };
   
       self.adjustPinSpacing = function (amount) {
         if (spacerState && amount) {
           var i = spacerState.indexOf(direction.d) + 1;
           spacerState[i] = parseFloat(spacerState[i]) + amount + _px;
           spacerState[1] = parseFloat(spacerState[1]) + amount + _px;
   
           _setState(spacerState);
         }
       };
   
       self.disable = function (reset, allowAnimation) {
         reset !== false && self.revert(true, true);
   
         if (self.enabled) {
           self.enabled = self.isActive = false;
           allowAnimation || scrubTween && scrubTween.pause();
           prevScroll = 0;
           pinCache && (pinCache.uncache = 1);
           onRefreshInit && _removeListener(ScrollTrigger, "refreshInit", onRefreshInit);
   
           if (snapDelayedCall) {
             snapDelayedCall.pause();
             tweenTo.tween && tweenTo.tween.kill() && (tweenTo.tween = 0);
           }
   
           if (!isViewport) {
             var i = _triggers.length;
   
             while (i--) {
               if (_triggers[i].scroller === scroller && _triggers[i] !== self) {
                 return; //don't remove the listeners if there are still other triggers referencing it.
               }
             }
   
             _removeListener(scroller, "resize", _onResize);
   
             isViewport || _removeListener(scroller, "scroll", _onScroll);
           }
         }
       };
   
       self.kill = function (revert, allowAnimation) {
         self.disable(revert, allowAnimation);
         scrubTween && !allowAnimation && scrubTween.kill();
         id && delete _ids[id];
   
         var i = _triggers.indexOf(self);
   
         i >= 0 && _triggers.splice(i, 1);
         i === _i && _direction > 0 && _i--; // if we're in the middle of a refresh() or update(), splicing would cause skips in the index, so adjust...
         // if no other ScrollTrigger instances of the same scroller are found, wipe out any recorded scroll position. Otherwise, in a single page application, for example, it could maintain scroll position when it really shouldn't.
   
         i = 0;
   
         _triggers.forEach(function (t) {
           return t.scroller === self.scroller && (i = 1);
         });
   
         i || _refreshingAll || (self.scroll.rec = 0);
   
         if (animation) {
           animation.scrollTrigger = null;
           revert && animation.revert({
             kill: false
           });
           allowAnimation || animation.kill();
         }
   
         markerStart && [markerStart, markerEnd, markerStartTrigger, markerEndTrigger].forEach(function (m) {
           return m.parentNode && m.parentNode.removeChild(m);
         });
         _primary === self && (_primary = 0);
   
         if (pin) {
           pinCache && (pinCache.uncache = 1);
           i = 0;
   
           _triggers.forEach(function (t) {
             return t.pin === pin && i++;
           });
   
           i || (pinCache.spacer = 0); // if there aren't any more ScrollTriggers with the same pin, remove the spacer, otherwise it could be contaminated with old/stale values if the user re-creates a ScrollTrigger for the same element.
         }
   
         vars.onKill && vars.onKill(self);
       };
   
       _triggers.push(self);
   
       self.enable(false, false);
       customRevertReturn && customRevertReturn(self);
   
       if (animation && animation.add && !change) {
         // if the animation is a timeline, it may not have been populated yet, so it wouldn't render at the proper place on the first refresh(), thus we should schedule one for the next tick. If "change" is defined, we know it must be re-enabling, thus we can refresh() right away.
         var updateFunc = self.update; // some browsers may fire a scroll event BEFORE a tick elapses and/or the DOMContentLoaded fires. So there's a chance update() will be called BEFORE a refresh() has happened on a Timeline-attached ScrollTrigger which means the start/end won't be calculated yet. We don't want to add conditional logic inside the update() method (like check to see if end is defined and if not, force a refresh()) because that's a function that gets hit a LOT (performance). So we swap out the real update() method for this one that'll re-attach it the first time it gets called and of course forces a refresh().
   
         self.update = function () {
           self.update = updateFunc;
           _Observer_js__WEBPACK_IMPORTED_MODULE_0__._scrollers.cache++; // otherwise a cached scroll position may get used in the refresh() in a very rare scenario, like if ScrollTriggers are created inside a DOMContentLoaded event and the queued requestAnimationFrame() fires beforehand. See https://gsap.com/community/forums/topic/41267-scrolltrigger-breaks-on-refresh-when-using-domcontentloaded/
   
           start || end || self.refresh();
         };
   
         gsap.delayedCall(0.01, self.update);
         change = 0.01;
         start = end = 0;
       } else {
         self.refresh();
       }
   
       pin && _queueRefreshAll(); // pinning could affect the positions of other things, so make sure we queue a full refresh()
     };
   
     ScrollTrigger.register = function register(core) {
       if (!_coreInitted) {
         gsap = core || _getGSAP();
         _windowExists() && window.document && ScrollTrigger.enable();
         _coreInitted = _enabled;
       }
   
       return _coreInitted;
     };
   
     ScrollTrigger.defaults = function defaults(config) {
       if (config) {
         for (var p in config) {
           _defaults[p] = config[p];
         }
       }
   
       return _defaults;
     };
   
     ScrollTrigger.disable = function disable(reset, kill) {
       _enabled = 0;
   
       _triggers.forEach(function (trigger) {
         return trigger[kill ? "kill" : "disable"](reset);
       });
   
       _removeListener(_win, "wheel", _onScroll);
   
       _removeListener(_doc, "scroll", _onScroll);
   
       clearInterval(_syncInterval);
   
       _removeListener(_doc, "touchcancel", _passThrough);
   
       _removeListener(_body, "touchstart", _passThrough);
   
       _multiListener(_removeListener, _doc, "pointerdown,touchstart,mousedown", _pointerDownHandler);
   
       _multiListener(_removeListener, _doc, "pointerup,touchend,mouseup", _pointerUpHandler);
   
       _resizeDelay.kill();
   
       _iterateAutoRefresh(_removeListener);
   
       for (var i = 0; i < _Observer_js__WEBPACK_IMPORTED_MODULE_0__._scrollers.length; i += 3) {
         _wheelListener(_removeListener, _Observer_js__WEBPACK_IMPORTED_MODULE_0__._scrollers[i], _Observer_js__WEBPACK_IMPORTED_MODULE_0__._scrollers[i + 1]);
   
         _wheelListener(_removeListener, _Observer_js__WEBPACK_IMPORTED_MODULE_0__._scrollers[i], _Observer_js__WEBPACK_IMPORTED_MODULE_0__._scrollers[i + 2]);
       }
     };
   
     ScrollTrigger.enable = function enable() {
       _win = window;
       _doc = document;
       _docEl = _doc.documentElement;
       _body = _doc.body;
   
       if (gsap) {
         _toArray = gsap.utils.toArray;
         _clamp = gsap.utils.clamp;
         _context = gsap.core.context || _passThrough;
         _suppressOverwrites = gsap.core.suppressOverwrites || _passThrough;
         _scrollRestoration = _win.history.scrollRestoration || "auto";
         _lastScroll = _win.pageYOffset || 0;
         gsap.core.globals("ScrollTrigger", ScrollTrigger); // must register the global manually because in Internet Explorer, functions (classes) don't have a "name" property.
   
         if (_body) {
           _enabled = 1;
           _div100vh = document.createElement("div"); // to solve mobile browser address bar show/hide resizing, we shouldn't rely on window.innerHeight. Instead, use a <div> with its height set to 100vh and measure that since that's what the scrolling is based on anyway and it's not affected by address bar showing/hiding.
   
           _div100vh.style.height = "100vh";
           _div100vh.style.position = "absolute";
   
           _refresh100vh();
   
           _rafBugFix();
   
           _Observer_js__WEBPACK_IMPORTED_MODULE_0__.Observer.register(gsap); // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
   
           ScrollTrigger.isTouch = _Observer_js__WEBPACK_IMPORTED_MODULE_0__.Observer.isTouch;
           _fixIOSBug = _Observer_js__WEBPACK_IMPORTED_MODULE_0__.Observer.isTouch && /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent); // since 2017, iOS has had a bug that causes event.clientX/Y to be inaccurate when a scroll occurs, thus we must alternate ignoring every other touchmove event to work around it. See https://bugs.webkit.org/show_bug.cgi?id=181954 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503
   
           _ignoreMobileResize = _Observer_js__WEBPACK_IMPORTED_MODULE_0__.Observer.isTouch === 1;
   
           _addListener(_win, "wheel", _onScroll); // mostly for 3rd party smooth scrolling libraries.
   
   
           _root = [_win, _doc, _docEl, _body];
   
           if (gsap.matchMedia) {
             ScrollTrigger.matchMedia = function (vars) {
               var mm = gsap.matchMedia(),
                   p;
   
               for (p in vars) {
                 mm.add(p, vars[p]);
               }
   
               return mm;
             };
   
             gsap.addEventListener("matchMediaInit", function () {
               _recordScrollPositions();
   
               _revertAll();
             });
             gsap.addEventListener("matchMediaRevert", function () {
               return _revertRecorded();
             });
             gsap.addEventListener("matchMedia", function () {
               _refreshAll(0, 1);
   
               _dispatch("matchMedia");
             });
             gsap.matchMedia().add("(orientation: portrait)", function () {
               // when orientation changes, we should take new base measurements for the ignoreMobileResize feature.
               _setBaseDimensions();
   
               return _setBaseDimensions;
             });
           } else {
             console.warn("Requires GSAP 3.11.0 or later");
           }
   
           _setBaseDimensions();
   
           _addListener(_doc, "scroll", _onScroll); // some browsers (like Chrome), the window stops dispatching scroll events on the window if you scroll really fast, but it's consistent on the document!
   
   
           var bodyHasStyle = _body.hasAttribute("style"),
               bodyStyle = _body.style,
               border = bodyStyle.borderTopStyle,
               AnimationProto = gsap.core.Animation.prototype,
               bounds,
               i;
   
           AnimationProto.revert || Object.defineProperty(AnimationProto, "revert", {
             value: function value() {
               return this.time(-0.01, true);
             }
           }); // only for backwards compatibility (Animation.revert() was added after 3.10.4)
   
           bodyStyle.borderTopStyle = "solid"; // works around an issue where a margin of a child element could throw off the bounds of the _body, making it seem like there's a margin when there actually isn't. The border ensures that the bounds are accurate.
   
           bounds = _getBounds(_body);
           _Observer_js__WEBPACK_IMPORTED_MODULE_0__._vertical.m = Math.round(bounds.top + _Observer_js__WEBPACK_IMPORTED_MODULE_0__._vertical.sc()) || 0; // accommodate the offset of the <body> caused by margins and/or padding
   
           _Observer_js__WEBPACK_IMPORTED_MODULE_0__._horizontal.m = Math.round(bounds.left + _Observer_js__WEBPACK_IMPORTED_MODULE_0__._horizontal.sc()) || 0;
           border ? bodyStyle.borderTopStyle = border : bodyStyle.removeProperty("border-top-style");
   
           if (!bodyHasStyle) {
             // SSR frameworks like Next.js complain if this attribute gets added.
             _body.setAttribute("style", ""); // it's not enough to just removeAttribute() - we must first set it to empty, otherwise Next.js complains.
   
   
             _body.removeAttribute("style");
           } // TODO: (?) maybe move to leveraging the velocity mechanism in Observer and skip intervals.
   
   
           _syncInterval = setInterval(_sync, 250);
           gsap.delayedCall(0.5, function () {
             return _startup = 0;
           });
   
           _addListener(_doc, "touchcancel", _passThrough); // some older Android devices intermittently stop dispatching "touchmove" events if we don't listen for "touchcancel" on the document.
   
   
           _addListener(_body, "touchstart", _passThrough); //works around Safari bug: https://gsap.com/forums/topic/21450-draggable-in-iframe-on-mobile-is-buggy/
   
   
           _multiListener(_addListener, _doc, "pointerdown,touchstart,mousedown", _pointerDownHandler);
   
           _multiListener(_addListener, _doc, "pointerup,touchend,mouseup", _pointerUpHandler);
   
           _transformProp = gsap.utils.checkPrefix("transform");
   
           _stateProps.push(_transformProp);
   
           _coreInitted = _getTime();
           _resizeDelay = gsap.delayedCall(0.2, _refreshAll).pause();
           _autoRefresh = [_doc, "visibilitychange", function () {
             var w = _win.innerWidth,
                 h = _win.innerHeight;
   
             if (_doc.hidden) {
               _prevWidth = w;
               _prevHeight = h;
             } else if (_prevWidth !== w || _prevHeight !== h) {
               _onResize();
             }
           }, _doc, "DOMContentLoaded", _refreshAll, _win, "load", _refreshAll, _win, "resize", _onResize];
   
           _iterateAutoRefresh(_addListener);
   
           _triggers.forEach(function (trigger) {
             return trigger.enable(0, 1);
           });
   
           for (i = 0; i < _Observer_js__WEBPACK_IMPORTED_MODULE_0__._scrollers.length; i += 3) {
             _wheelListener(_removeListener, _Observer_js__WEBPACK_IMPORTED_MODULE_0__._scrollers[i], _Observer_js__WEBPACK_IMPORTED_MODULE_0__._scrollers[i + 1]);
   
             _wheelListener(_removeListener, _Observer_js__WEBPACK_IMPORTED_MODULE_0__._scrollers[i], _Observer_js__WEBPACK_IMPORTED_MODULE_0__._scrollers[i + 2]);
           }
         } else if (_doc) {
           var onLoad = function onLoad() {
             ScrollTrigger.enable();
   
             _doc.removeEventListener("DOMContentLoaded", onLoad);
           };
   
           _doc.addEventListener("DOMContentLoaded", onLoad);
         }
       }
     };
   
     ScrollTrigger.config = function config(vars) {
       "limitCallbacks" in vars && (_limitCallbacks = !!vars.limitCallbacks);
       var ms = vars.syncInterval;
       ms && clearInterval(_syncInterval) || (_syncInterval = ms) && setInterval(_sync, ms);
       "ignoreMobileResize" in vars && (_ignoreMobileResize = ScrollTrigger.isTouch === 1 && vars.ignoreMobileResize);
   
       if ("autoRefreshEvents" in vars) {
         _iterateAutoRefresh(_removeListener) || _iterateAutoRefresh(_addListener, vars.autoRefreshEvents || "none");
         _ignoreResize = (vars.autoRefreshEvents + "").indexOf("resize") === -1;
       }
     };
   
     ScrollTrigger.scrollerProxy = function scrollerProxy(target, vars) {
       var t = (0,_Observer_js__WEBPACK_IMPORTED_MODULE_0__._getTarget)(target),
           i = _Observer_js__WEBPACK_IMPORTED_MODULE_0__._scrollers.indexOf(t),
           isViewport = _isViewport(t);
   
       if (~i) {
         _Observer_js__WEBPACK_IMPORTED_MODULE_0__._scrollers.splice(i, isViewport ? 6 : 2);
       }
   
       if (vars) {
         isViewport ? _Observer_js__WEBPACK_IMPORTED_MODULE_0__._proxies.unshift(_win, vars, _body, vars, _docEl, vars) : _Observer_js__WEBPACK_IMPORTED_MODULE_0__._proxies.unshift(t, vars);
       }
     };
   
     ScrollTrigger.clearMatchMedia = function clearMatchMedia(query) {
       _triggers.forEach(function (t) {
         return t._ctx && t._ctx.query === query && t._ctx.kill(true, true);
       });
     };
   
     ScrollTrigger.isInViewport = function isInViewport(element, ratio, horizontal) {
       var bounds = (_isString(element) ? (0,_Observer_js__WEBPACK_IMPORTED_MODULE_0__._getTarget)(element) : element).getBoundingClientRect(),
           offset = bounds[horizontal ? _width : _height] * ratio || 0;
       return horizontal ? bounds.right - offset > 0 && bounds.left + offset < _win.innerWidth : bounds.bottom - offset > 0 && bounds.top + offset < _win.innerHeight;
     };
   
     ScrollTrigger.positionInViewport = function positionInViewport(element, referencePoint, horizontal) {
       _isString(element) && (element = (0,_Observer_js__WEBPACK_IMPORTED_MODULE_0__._getTarget)(element));
       var bounds = element.getBoundingClientRect(),
           size = bounds[horizontal ? _width : _height],
           offset = referencePoint == null ? size / 2 : referencePoint in _keywords ? _keywords[referencePoint] * size : ~referencePoint.indexOf("%") ? parseFloat(referencePoint) * size / 100 : parseFloat(referencePoint) || 0;
       return horizontal ? (bounds.left + offset) / _win.innerWidth : (bounds.top + offset) / _win.innerHeight;
     };
   
     ScrollTrigger.killAll = function killAll(allowListeners) {
       _triggers.slice(0).forEach(function (t) {
         return t.vars.id !== "ScrollSmoother" && t.kill();
       });
   
       if (allowListeners !== true) {
         var listeners = _listeners.killAll || [];
         _listeners = {};
         listeners.forEach(function (f) {
           return f();
         });
       }
     };
   
     return ScrollTrigger;
   }();
   ScrollTrigger.version = "3.15.0";
   
   ScrollTrigger.saveStyles = function (targets) {
     return targets ? _toArray(targets).forEach(function (target) {
       // saved styles are recorded in a consecutive alternating Array, like [element, cssText, transform attribute, cache, matchMedia, ...]
       if (target && target.style) {
         var i = _savedStyles.indexOf(target);
   
         i >= 0 && _savedStyles.splice(i, 5);
   
         _savedStyles.push(target, target.style.cssText, target.getBBox && target.getAttribute("transform"), gsap.core.getCache(target), _context());
       }
     }) : _savedStyles;
   };
   
   ScrollTrigger.revert = function (soft, media) {
     return _revertAll(!soft, media);
   };
   
   ScrollTrigger.create = function (vars, animation) {
     return new ScrollTrigger(vars, animation);
   };
   
   ScrollTrigger.refresh = function (safe) {
     return safe ? _onResize(true) : (_coreInitted || ScrollTrigger.register()) && _refreshAll(true);
   };
   
   ScrollTrigger.update = function (force) {
     return ++_Observer_js__WEBPACK_IMPORTED_MODULE_0__._scrollers.cache && _updateAll(force === true ? 2 : 0);
   };
   
   ScrollTrigger.clearScrollMemory = _clearScrollMemory;
   
   ScrollTrigger.maxScroll = function (element, horizontal) {
     return _maxScroll(element, horizontal ? _Observer_js__WEBPACK_IMPORTED_MODULE_0__._horizontal : _Observer_js__WEBPACK_IMPORTED_MODULE_0__._vertical);
   };
   
   ScrollTrigger.getScrollFunc = function (element, horizontal) {
     return (0,_Observer_js__WEBPACK_IMPORTED_MODULE_0__._getScrollFunc)((0,_Observer_js__WEBPACK_IMPORTED_MODULE_0__._getTarget)(element), horizontal ? _Observer_js__WEBPACK_IMPORTED_MODULE_0__._horizontal : _Observer_js__WEBPACK_IMPORTED_MODULE_0__._vertical);
   };
   
   ScrollTrigger.getById = function (id) {
     return _ids[id];
   };
   
   ScrollTrigger.getAll = function () {
     return _triggers.filter(function (t) {
       return t.vars.id !== "ScrollSmoother";
     });
   }; // it's common for people to ScrollTrigger.getAll(t => t.kill()) on page routes, for example, and we don't want it to ruin smooth scrolling by killing the main ScrollSmoother one.
   
   
   ScrollTrigger.isScrolling = function () {
     return !!_lastScrollTime;
   };
   
   ScrollTrigger.snapDirectional = _snapDirectional;
   
   ScrollTrigger.addEventListener = function (type, callback) {
     var a = _listeners[type] || (_listeners[type] = []);
     ~a.indexOf(callback) || a.push(callback);
   };
   
   ScrollTrigger.removeEventListener = function (type, callback) {
     var a = _listeners[type],
         i = a && a.indexOf(callback);
     i >= 0 && a.splice(i, 1);
   };
   
   ScrollTrigger.batch = function (targets, vars) {
     var result = [],
         varsCopy = {},
         interval = vars.interval || 0.016,
         batchMax = vars.batchMax || 1e9,
         proxyCallback = function proxyCallback(type, callback) {
       var elements = [],
           triggers = [],
           delay = gsap.delayedCall(interval, function () {
         callback(elements, triggers);
         elements = [];
         triggers = [];
       }).pause();
       return function (self) {
         elements.length || delay.restart(true);
         elements.push(self.trigger);
         triggers.push(self);
         batchMax <= elements.length && delay.progress(1);
       };
     },
         p;
   
     for (p in vars) {
       varsCopy[p] = p.substr(0, 2) === "on" && _isFunction(vars[p]) && p !== "onRefreshInit" ? proxyCallback(p, vars[p]) : vars[p];
     }
   
     if (_isFunction(batchMax)) {
       batchMax = batchMax();
   
       _addListener(ScrollTrigger, "refresh", function () {
         return batchMax = vars.batchMax();
       });
     }
   
     _toArray(targets).forEach(function (target) {
       var config = {};
   
       for (p in varsCopy) {
         config[p] = varsCopy[p];
       }
   
       config.trigger = target;
       result.push(ScrollTrigger.create(config));
     });
   
     return result;
   }; // to reduce file size. clamps the scroll and also returns a duration multiplier so that if the scroll gets chopped shorter, the duration gets curtailed as well (otherwise if you're very close to the top of the page, for example, and swipe up really fast, it'll suddenly slow down and take a long time to reach the top).
   
   
   var _clampScrollAndGetDurationMultiplier = function _clampScrollAndGetDurationMultiplier(scrollFunc, current, end, max) {
     current > max ? scrollFunc(max) : current < 0 && scrollFunc(0);
     return end > max ? (max - current) / (end - current) : end < 0 ? current / (current - end) : 1;
   },
       _allowNativePanning = function _allowNativePanning(target, direction) {
     if (direction === true) {
       target.style.removeProperty("touch-action");
     } else {
       target.style.touchAction = direction === true ? "auto" : direction ? "pan-" + direction + (_Observer_js__WEBPACK_IMPORTED_MODULE_0__.Observer.isTouch ? " pinch-zoom" : "") : "none"; // note: Firefox doesn't support it pinch-zoom properly, at least in addition to a pan-x or pan-y.
     }
   
     target === _docEl && _allowNativePanning(_body, direction);
   },
       _overflow = {
     auto: 1,
     scroll: 1
   },
       _nestedScroll = function _nestedScroll(_ref5) {
     var event = _ref5.event,
         target = _ref5.target,
         axis = _ref5.axis;
   
     var node = (event.changedTouches ? event.changedTouches[0] : event).target,
         cache = node._gsap || gsap.core.getCache(node),
         time = _getTime(),
         cs;
   
     if (!cache._isScrollT || time - cache._isScrollT > 2000) {
       // cache for 2 seconds to improve performance.
       while (node && node !== _body && (node.scrollHeight <= node.clientHeight && node.scrollWidth <= node.clientWidth || !(_overflow[(cs = _getComputedStyle(node)).overflowY] || _overflow[cs.overflowX]))) {
         node = node.parentNode;
       }
   
       cache._isScroll = node && node !== target && !_isViewport(node) && (_overflow[(cs = _getComputedStyle(node)).overflowY] || _overflow[cs.overflowX]);
       cache._isScrollT = time;
     }
   
     if (cache._isScroll || axis === "x") {
       event.stopPropagation();
       event._gsapAllow = true;
     }
   },
       // capture events on scrollable elements INSIDE the <body> and allow those by calling stopPropagation() when we find a scrollable ancestor
   _inputObserver = function _inputObserver(target, type, inputs, nested) {
     return _Observer_js__WEBPACK_IMPORTED_MODULE_0__.Observer.create({
       target: target,
       capture: true,
       debounce: false,
       lockAxis: true,
       type: type,
       onWheel: nested = nested && _nestedScroll,
       onPress: nested,
       onDrag: nested,
       onScroll: nested,
       onEnable: function onEnable() {
         return inputs && _addListener(_doc, _Observer_js__WEBPACK_IMPORTED_MODULE_0__.Observer.eventTypes[0], _captureInputs, false, true);
       },
       onDisable: function onDisable() {
         return _removeListener(_doc, _Observer_js__WEBPACK_IMPORTED_MODULE_0__.Observer.eventTypes[0], _captureInputs, true);
       }
     });
   },
       _inputExp = /(input|label|select|textarea)/i,
       _inputIsFocused,
       _captureInputs = function _captureInputs(e) {
     var isInput = _inputExp.test(e.target.tagName);
   
     if (isInput || _inputIsFocused) {
       e._gsapAllow = true;
       _inputIsFocused = isInput;
     }
   },
       _getScrollNormalizer = function _getScrollNormalizer(vars) {
     _isObject(vars) || (vars = {});
     vars.preventDefault = vars.isNormalizer = vars.allowClicks = true;
     vars.type || (vars.type = "wheel,touch");
     vars.debounce = !!vars.debounce;
     vars.id = vars.id || "normalizer";
   
     var _vars2 = vars,
         normalizeScrollX = _vars2.normalizeScrollX,
         momentum = _vars2.momentum,
         allowNestedScroll = _vars2.allowNestedScroll,
         onRelease = _vars2.onRelease,
         self,
         maxY,
         target = (0,_Observer_js__WEBPACK_IMPORTED_MODULE_0__._getTarget)(vars.target) || _docEl,
         smoother = gsap.core.globals().ScrollSmoother,
         smootherInstance = smoother && smoother.get(),
         content = _fixIOSBug && (vars.content && (0,_Observer_js__WEBPACK_IMPORTED_MODULE_0__._getTarget)(vars.content) || smootherInstance && vars.content !== false && !smootherInstance.smooth() && smootherInstance.content()),
         scrollFuncY = (0,_Observer_js__WEBPACK_IMPORTED_MODULE_0__._getScrollFunc)(target, _Observer_js__WEBPACK_IMPORTED_MODULE_0__._vertical),
         scrollFuncX = (0,_Observer_js__WEBPACK_IMPORTED_MODULE_0__._getScrollFunc)(target, _Observer_js__WEBPACK_IMPORTED_MODULE_0__._horizontal),
         scale = 1,
         initialScale = (_Observer_js__WEBPACK_IMPORTED_MODULE_0__.Observer.isTouch && _win.visualViewport ? _win.visualViewport.scale * _win.visualViewport.width : _win.outerWidth) / _win.innerWidth,
         wheelRefresh = 0,
         resolveMomentumDuration = _isFunction(momentum) ? function () {
       return momentum(self);
     } : function () {
       return momentum || 2.8;
     },
         lastRefreshID,
         skipTouchMove,
         inputObserver = _inputObserver(target, vars.type, true, allowNestedScroll),
         resumeTouchMove = function resumeTouchMove() {
       return skipTouchMove = false;
     },
         scrollClampX = _passThrough,
         scrollClampY = _passThrough,
         updateClamps = function updateClamps() {
       maxY = _maxScroll(target, _Observer_js__WEBPACK_IMPORTED_MODULE_0__._vertical);
       scrollClampY = _clamp(_fixIOSBug ? 1 : 0, maxY);
       normalizeScrollX && (scrollClampX = _clamp(0, _maxScroll(target, _Observer_js__WEBPACK_IMPORTED_MODULE_0__._horizontal)));
       lastRefreshID = _refreshID;
     },
         removeContentOffset = function removeContentOffset() {
       content._gsap.y = _round(parseFloat(content._gsap.y) + scrollFuncY.offset) + "px";
       content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + parseFloat(content._gsap.y) + ", 0, 1)";
       scrollFuncY.offset = scrollFuncY.cacheID = 0;
     },
         ignoreDrag = function ignoreDrag() {
       if (skipTouchMove) {
         requestAnimationFrame(resumeTouchMove);
   
         var offset = _round(self.deltaY / 2),
             scroll = scrollClampY(scrollFuncY.v - offset);
   
         if (content && scroll !== scrollFuncY.v + scrollFuncY.offset) {
           scrollFuncY.offset = scroll - scrollFuncY.v;
   
           var y = _round((parseFloat(content && content._gsap.y) || 0) - scrollFuncY.offset);
   
           content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + y + ", 0, 1)";
           content._gsap.y = y + "px";
           scrollFuncY.cacheID = _Observer_js__WEBPACK_IMPORTED_MODULE_0__._scrollers.cache;
   
           _updateAll();
         }
   
         return true;
       }
   
       scrollFuncY.offset && removeContentOffset();
       skipTouchMove = true;
     },
         tween,
         startScrollX,
         startScrollY,
         onStopDelayedCall,
         onResize = function onResize() {
       // if the window resizes, like on an iPhone which Apple FORCES the address bar to show/hide even if we event.preventDefault(), it may be scrolling too far now that the address bar is showing, so we must dynamically adjust the momentum tween.
       updateClamps();
   
       if (tween.isActive() && tween.vars.scrollY > maxY) {
         scrollFuncY() > maxY ? tween.progress(1) && scrollFuncY(maxY) : tween.resetTo("scrollY", maxY);
       }
     };
   
     content && gsap.set(content, {
       y: "+=0"
     }); // to ensure there's a cache (element._gsap)
   
     vars.ignoreCheck = function (e) {
       return _fixIOSBug && e.type === "touchmove" && ignoreDrag(e) || scale > 1.05 && e.type !== "touchstart" || self.isGesturing || e.touches && e.touches.length > 1;
     };
   
     vars.onPress = function () {
       skipTouchMove = false;
       var prevScale = scale;
       scale = _round((_win.visualViewport && _win.visualViewport.scale || 1) / initialScale);
       tween.pause();
       prevScale !== scale && _allowNativePanning(target, scale > 1.01 ? true : normalizeScrollX ? false : "x");
       startScrollX = scrollFuncX();
       startScrollY = scrollFuncY();
       updateClamps();
       lastRefreshID = _refreshID;
     };
   
     vars.onRelease = vars.onGestureStart = function (self, wasDragging) {
       scrollFuncY.offset && removeContentOffset();
   
       if (!wasDragging) {
         onStopDelayedCall.restart(true);
       } else {
         _Observer_js__WEBPACK_IMPORTED_MODULE_0__._scrollers.cache++; // make sure we're pulling the non-cached value
         // alternate algorithm: durX = Math.min(6, Math.abs(self.velocityX / 800)),	dur = Math.max(durX, Math.min(6, Math.abs(self.velocityY / 800))); dur = dur * (0.4 + (1 - _power4In(dur / 6)) * 0.6)) * (momentumSpeed || 1)
   
         var dur = resolveMomentumDuration(),
             currentScroll,
             endScroll;
   
         if (normalizeScrollX) {
           currentScroll = scrollFuncX();
           endScroll = currentScroll + dur * 0.05 * -self.velocityX / 0.227; // the constant .227 is from power4(0.05). velocity is inverted because scrolling goes in the opposite direction.
   
           dur *= _clampScrollAndGetDurationMultiplier(scrollFuncX, currentScroll, endScroll, _maxScroll(target, _Observer_js__WEBPACK_IMPORTED_MODULE_0__._horizontal));
           tween.vars.scrollX = scrollClampX(endScroll);
         }
   
         currentScroll = scrollFuncY();
         endScroll = currentScroll + dur * 0.05 * -self.velocityY / 0.227; // the constant .227 is from power4(0.05)
   
         dur *= _clampScrollAndGetDurationMultiplier(scrollFuncY, currentScroll, endScroll, _maxScroll(target, _Observer_js__WEBPACK_IMPORTED_MODULE_0__._vertical));
         tween.vars.scrollY = scrollClampY(endScroll);
         tween.invalidate().duration(dur).play(0.01);
   
         if (_fixIOSBug && tween.vars.scrollY >= maxY || currentScroll >= maxY - 1) {
           // iOS bug: it'll show the address bar but NOT fire the window "resize" event until the animation is done but we must protect against overshoot so we leverage an onUpdate to do so.
           gsap.to({}, {
             onUpdate: onResize,
             duration: dur
           });
         }
       }
   
       onRelease && onRelease(self);
     };
   
     vars.onWheel = function () {
       tween._ts && tween.pause();
   
       if (_getTime() - wheelRefresh > 1000) {
         // after 1 second, refresh the clamps otherwise that'll only happen when ScrollTrigger.refresh() is called or for touch-scrolling.
         lastRefreshID = 0;
         wheelRefresh = _getTime();
       }
     };
   
     vars.onChange = function (self, dx, dy, xArray, yArray) {
       _refreshID !== lastRefreshID && updateClamps();
       dx && normalizeScrollX && scrollFuncX(scrollClampX(xArray[2] === dx ? startScrollX + (self.startX - self.x) : scrollFuncX() + dx - xArray[1])); // for more precision, we track pointer/touch movement from the start, otherwise it'll drift.
   
       if (dy) {
         scrollFuncY.offset && removeContentOffset();
         var isTouch = yArray[2] === dy,
             y = isTouch ? startScrollY + self.startY - self.y : scrollFuncY() + dy - yArray[1],
             yClamped = scrollClampY(y);
         isTouch && y !== yClamped && (startScrollY += yClamped - y);
         scrollFuncY(yClamped);
       }
   
       (dy || dx) && _updateAll();
     };
   
     vars.onEnable = function () {
       _allowNativePanning(target, normalizeScrollX ? false : "x");
   
       ScrollTrigger.addEventListener("refresh", onResize);
   
       _addListener(_win, "resize", onResize);
   
       if (scrollFuncY.smooth) {
         scrollFuncY.target.style.scrollBehavior = "auto";
         scrollFuncY.smooth = scrollFuncX.smooth = false;
       }
   
       inputObserver.enable();
     };
   
     vars.onDisable = function () {
       _allowNativePanning(target, true);
   
       _removeListener(_win, "resize", onResize);
   
       ScrollTrigger.removeEventListener("refresh", onResize);
       inputObserver.kill();
     };
   
     vars.lockAxis = vars.lockAxis !== false;
     self = new _Observer_js__WEBPACK_IMPORTED_MODULE_0__.Observer(vars);
     self.iOS = _fixIOSBug; // used in the Observer getCachedScroll() function to work around an iOS bug that wreaks havoc with TouchEvent.clientY if we allow scroll to go all the way back to 0.
   
     _fixIOSBug && !scrollFuncY() && scrollFuncY(1); // iOS bug causes event.clientY values to freak out (wildly inaccurate) if the scroll position is exactly 0.
   
     _fixIOSBug && gsap.ticker.add(_passThrough); // prevent the ticker from sleeping
   
     onStopDelayedCall = self._dc;
     tween = gsap.to(self, {
       ease: "power4",
       paused: true,
       inherit: false,
       scrollX: normalizeScrollX ? "+=0.1" : "+=0",
       scrollY: "+=0.1",
       modifiers: {
         scrollY: _interruptionTracker(scrollFuncY, scrollFuncY(), function () {
           return tween.pause();
         })
       },
       onUpdate: _updateAll,
       onComplete: onStopDelayedCall.vars.onComplete
     }); // we need the modifier to sense if the scroll position is altered outside of the momentum tween (like with a scrollTo tween) so we can pause() it to prevent conflicts.
   
     return self;
   };
   
   ScrollTrigger.sort = function (func) {
     if (_isFunction(func)) {
       return _triggers.sort(func);
     }
   
     var scroll = _win.pageYOffset || 0;
     ScrollTrigger.getAll().forEach(function (t) {
       return t._sortY = t.trigger ? scroll + t.trigger.getBoundingClientRect().top : t.start + _win.innerHeight;
     });
     return _triggers.sort(func || function (a, b) {
       return (a.vars.refreshPriority || 0) * -1e6 + (a.vars.containerAnimation ? 1e6 : a._sortY) - ((b.vars.containerAnimation ? 1e6 : b._sortY) + (b.vars.refreshPriority || 0) * -1e6);
     }); // anything with a containerAnimation should refresh last.
   };
   
   ScrollTrigger.observe = function (vars) {
     return new _Observer_js__WEBPACK_IMPORTED_MODULE_0__.Observer(vars);
   };
   
   ScrollTrigger.normalizeScroll = function (vars) {
     if (typeof vars === "undefined") {
       return _normalizer;
     }
   
     if (vars === true && _normalizer) {
       return _normalizer.enable();
     }
   
     if (vars === false) {
       _normalizer && _normalizer.kill();
       _normalizer = vars;
       return;
     }
   
     var normalizer = vars instanceof _Observer_js__WEBPACK_IMPORTED_MODULE_0__.Observer ? vars : _getScrollNormalizer(vars);
     _normalizer && _normalizer.target === normalizer.target && _normalizer.kill();
     _isViewport(normalizer.target) && (_normalizer = normalizer);
     return normalizer;
   };
   
   ScrollTrigger.core = {
     // smaller file size way to leverage in ScrollSmoother and Observer
     _getVelocityProp: _Observer_js__WEBPACK_IMPORTED_MODULE_0__._getVelocityProp,
     _inputObserver: _inputObserver,
     _scrollers: _Observer_js__WEBPACK_IMPORTED_MODULE_0__._scrollers,
     _proxies: _Observer_js__WEBPACK_IMPORTED_MODULE_0__._proxies,
     bridge: {
       // when normalizeScroll sets the scroll position (ss = setScroll)
       ss: function ss() {
         _lastScrollTime || _dispatch("scrollStart");
         _lastScrollTime = _getTime();
       },
       // a way to get the _refreshing value in Observer
       ref: function ref() {
         return _refreshing;
       }
     }
   };
   _getGSAP() && gsap.registerPlugin(ScrollTrigger);
   
   
   /***/ }),
   /* 9 */
   /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
   
   "use strict";
   __webpack_require__.r(__webpack_exports__);
   /* harmony export */ __webpack_require__.d(__webpack_exports__, {
   /* harmony export */   Observer: () => (/* binding */ Observer),
   /* harmony export */   _getProxyProp: () => (/* binding */ _getProxyProp),
   /* harmony export */   _getScrollFunc: () => (/* binding */ _getScrollFunc),
   /* harmony export */   _getTarget: () => (/* binding */ _getTarget),
   /* harmony export */   _getVelocityProp: () => (/* binding */ _getVelocityProp),
   /* harmony export */   _horizontal: () => (/* binding */ _horizontal),
   /* harmony export */   _isViewport: () => (/* binding */ _isViewport),
   /* harmony export */   _proxies: () => (/* binding */ _proxies),
   /* harmony export */   _scrollers: () => (/* binding */ _scrollers),
   /* harmony export */   _vertical: () => (/* binding */ _vertical),
   /* harmony export */   "default": () => (/* binding */ Observer)
   /* harmony export */ });
   function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
   
   /*!
    * Observer 3.15.0
    * https://gsap.com
    *
    * @license Copyright 2008-2026, GreenSock. All rights reserved.
    * Subject to the terms at https://gsap.com/standard-license
    * @author: Jack Doyle, jack@greensock.com
   */
   
   /* eslint-disable */
   var gsap,
       _coreInitted,
       _clamp,
       _win,
       _doc,
       _docEl,
       _body,
       _isTouch,
       _pointerType,
       ScrollTrigger,
       _root,
       _normalizer,
       _eventTypes,
       _context,
       _getGSAP = function _getGSAP() {
     return gsap || typeof window !== "undefined" && (gsap = window.gsap) && gsap.registerPlugin && gsap;
   },
       _startup = 1,
       _observers = [],
       _scrollers = [],
       _proxies = [],
       _getTime = Date.now,
       _bridge = function _bridge(name, value) {
     return value;
   },
       _integrate = function _integrate() {
     var core = ScrollTrigger.core,
         data = core.bridge || {},
         scrollers = core._scrollers,
         proxies = core._proxies;
     scrollers.push.apply(scrollers, _scrollers);
     proxies.push.apply(proxies, _proxies);
     _scrollers = scrollers;
     _proxies = proxies;
   
     _bridge = function _bridge(name, value) {
       return data[name](value);
     };
   },
       _getProxyProp = function _getProxyProp(element, property) {
     return ~_proxies.indexOf(element) && _proxies[_proxies.indexOf(element) + 1][property];
   },
       _isViewport = function _isViewport(el) {
     return !!~_root.indexOf(el);
   },
       _addListener = function _addListener(element, type, func, passive, capture) {
     return element.addEventListener(type, func, {
       passive: passive !== false,
       capture: !!capture
     });
   },
       _removeListener = function _removeListener(element, type, func, capture) {
     return element.removeEventListener(type, func, !!capture);
   },
       _scrollLeft = "scrollLeft",
       _scrollTop = "scrollTop",
       _onScroll = function _onScroll() {
     return _normalizer && _normalizer.isPressed || _scrollers.cache++;
   },
       _scrollCacheFunc = function _scrollCacheFunc(f, doNotCache) {
     var cachingFunc = function cachingFunc(value) {
       // since reading the scrollTop/scrollLeft/pageOffsetY/pageOffsetX can trigger a layout, this function allows us to cache the value so it only gets read fresh after a "scroll" event fires (or while we're refreshing because that can lengthen the page and alter the scroll position). when "soft" is true, that means don't actually set the scroll, but cache the new value instead (useful in ScrollSmoother)
       if (value || value === 0) {
         _startup && (_win.history.scrollRestoration = "manual"); // otherwise the new position will get overwritten by the browser onload.
   
         var isNormalizing = _normalizer && _normalizer.isPressed;
         value = cachingFunc.v = Math.round(value) || (_normalizer && _normalizer.iOS ? 1 : 0); //TODO: iOS Bug: if you allow it to go to 0, Safari can start to report super strange (wildly inaccurate) touch positions!
   
         f(value);
         cachingFunc.cacheID = _scrollers.cache;
         isNormalizing && _bridge("ss", value); // set scroll (notify ScrollTrigger so it can dispatch a "scrollStart" event if necessary
       } else if (doNotCache || _scrollers.cache !== cachingFunc.cacheID || _bridge("ref")) {
         cachingFunc.cacheID = _scrollers.cache;
         cachingFunc.v = f();
       }
   
       return cachingFunc.v + cachingFunc.offset;
     };
   
     cachingFunc.offset = 0;
     return f && cachingFunc;
   },
       _horizontal = {
     s: _scrollLeft,
     p: "left",
     p2: "Left",
     os: "right",
     os2: "Right",
     d: "width",
     d2: "Width",
     a: "x",
     sc: _scrollCacheFunc(function (value) {
       return arguments.length ? _win.scrollTo(value, _vertical.sc()) : _win.pageXOffset || _doc[_scrollLeft] || _docEl[_scrollLeft] || _body[_scrollLeft] || 0;
     })
   },
       _vertical = {
     s: _scrollTop,
     p: "top",
     p2: "Top",
     os: "bottom",
     os2: "Bottom",
     d: "height",
     d2: "Height",
     a: "y",
     op: _horizontal,
     sc: _scrollCacheFunc(function (value) {
       return arguments.length ? _win.scrollTo(_horizontal.sc(), value) : _win.pageYOffset || _doc[_scrollTop] || _docEl[_scrollTop] || _body[_scrollTop] || 0;
     })
   },
       _getTarget = function _getTarget(t, self) {
     return (self && self._ctx && self._ctx.selector || gsap.utils.toArray)(t)[0] || (typeof t === "string" && gsap.config().nullTargetWarn !== false ? console.warn("Element not found:", t) : null);
   },
       _isWithin = function _isWithin(element, list) {
     // check if the element is in the list or is a descendant of an element in the list.
     var i = list.length;
   
     while (i--) {
       if (list[i] === element || list[i].contains(element)) {
         return true;
       }
     }
   
     return false;
   },
       _getScrollFunc = function _getScrollFunc(element, _ref) {
     var s = _ref.s,
         sc = _ref.sc;
     // we store the scroller functions in an alternating sequenced Array like [element, verticalScrollFunc, horizontalScrollFunc, ...] so that we can minimize memory, maximize performance, and we also record the last position as a ".rec" property in order to revert to that after refreshing to ensure things don't shift around.
     _isViewport(element) && (element = _doc.scrollingElement || _docEl);
   
     var i = _scrollers.indexOf(element),
         offset = sc === _vertical.sc ? 1 : 2;
   
     !~i && (i = _scrollers.push(element) - 1);
     _scrollers[i + offset] || _addListener(element, "scroll", _onScroll); // clear the cache when a scroll occurs
   
     var prev = _scrollers[i + offset],
         func = prev || (_scrollers[i + offset] = _scrollCacheFunc(_getProxyProp(element, s), true) || (_isViewport(element) ? sc : _scrollCacheFunc(function (value) {
       return arguments.length ? element[s] = value : element[s];
     })));
     func.target = element;
     prev || (func.smooth = gsap.getProperty(element, "scrollBehavior") === "smooth"); // only set it the first time (don't reset every time a scrollFunc is requested because perhaps it happens during a refresh() when it's disabled in ScrollTrigger.
   
     return func;
   },
       _getVelocityProp = function _getVelocityProp(value, minTimeRefresh, useDelta) {
     var v1 = value,
         v2 = value,
         t1 = _getTime(),
         t2 = t1,
         min = minTimeRefresh || 50,
         dropToZeroTime = Math.max(500, min * 3),
         update = function update(value, force) {
       var t = _getTime();
   
       if (force || t - t1 > min) {
         v2 = v1;
         v1 = value;
         t2 = t1;
         t1 = t;
       } else if (useDelta) {
         v1 += value;
       } else {
         // not totally necessary, but makes it a bit more accurate by adjusting the v1 value according to the new slope. This way we're not just ignoring the incoming data. Removing for now because it doesn't seem to make much practical difference and it's probably not worth the kb.
         v1 = v2 + (value - v2) / (t - t2) * (t1 - t2);
       }
     },
         reset = function reset() {
       v2 = v1 = useDelta ? 0 : v1;
       t2 = t1 = 0;
     },
         getVelocity = function getVelocity(latestValue) {
       var tOld = t2,
           vOld = v2,
           t = _getTime();
   
       (latestValue || latestValue === 0) && latestValue !== v1 && update(latestValue);
       return t1 === t2 || t - t2 > dropToZeroTime ? 0 : (v1 + (useDelta ? vOld : -vOld)) / ((useDelta ? t : t1) - tOld) * 1000;
     };
   
     return {
       update: update,
       reset: reset,
       getVelocity: getVelocity
     };
   },
       _getEvent = function _getEvent(e, preventDefault) {
     preventDefault && !e._gsapAllow && e.cancelable !== false && e.preventDefault();
     return e.changedTouches ? e.changedTouches[0] : e;
   },
       _getAbsoluteMax = function _getAbsoluteMax(a) {
     var max = Math.max.apply(Math, a),
         min = Math.min.apply(Math, a);
     return Math.abs(max) >= Math.abs(min) ? max : min;
   },
       _setScrollTrigger = function _setScrollTrigger() {
     ScrollTrigger = gsap.core.globals().ScrollTrigger;
     ScrollTrigger && ScrollTrigger.core && _integrate();
   },
       _initCore = function _initCore(core) {
     gsap = core || _getGSAP();
   
     if (!_coreInitted && gsap && typeof document !== "undefined" && document.body) {
       _win = window;
       _doc = document;
       _docEl = _doc.documentElement;
       _body = _doc.body;
       _root = [_win, _doc, _docEl, _body];
       _clamp = gsap.utils.clamp;
   
       _context = gsap.core.context || function () {};
   
       _pointerType = "onpointerenter" in _body ? "pointer" : "mouse"; // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
   
       _isTouch = Observer.isTouch = _win.matchMedia && _win.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in _win || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? 2 : 0;
       _eventTypes = Observer.eventTypes = ("ontouchstart" in _docEl ? "touchstart,touchmove,touchcancel,touchend" : !("onpointerdown" in _docEl) ? "mousedown,mousemove,mouseup,mouseup" : "pointerdown,pointermove,pointercancel,pointerup").split(",");
       setTimeout(function () {
         return _startup = 0;
       }, 500);
       _coreInitted = 1;
     }
   
     ScrollTrigger || _setScrollTrigger(); // Observer might be initted BEFORE ScrollTrigger, so don't put this with the initting code. ScrollTrigger will call Observer.register() when it inits.
   
     return _coreInitted;
   };
   
   _horizontal.op = _vertical;
   _scrollers.cache = 0;
   var Observer = /*#__PURE__*/function () {
     function Observer(vars) {
       this.init(vars);
     }
   
     var _proto = Observer.prototype;
   
     _proto.init = function init(vars) {
       _coreInitted || _initCore(gsap) || console.warn("Please gsap.registerPlugin(Observer)");
       ScrollTrigger || _setScrollTrigger();
       var tolerance = vars.tolerance,
           dragMinimum = vars.dragMinimum,
           type = vars.type,
           target = vars.target,
           lineHeight = vars.lineHeight,
           debounce = vars.debounce,
           preventDefault = vars.preventDefault,
           onStop = vars.onStop,
           onStopDelay = vars.onStopDelay,
           ignore = vars.ignore,
           wheelSpeed = vars.wheelSpeed,
           event = vars.event,
           onDragStart = vars.onDragStart,
           onDragEnd = vars.onDragEnd,
           onDrag = vars.onDrag,
           onPress = vars.onPress,
           onRelease = vars.onRelease,
           onRight = vars.onRight,
           onLeft = vars.onLeft,
           onUp = vars.onUp,
           onDown = vars.onDown,
           onChangeX = vars.onChangeX,
           onChangeY = vars.onChangeY,
           onChange = vars.onChange,
           onToggleX = vars.onToggleX,
           onToggleY = vars.onToggleY,
           onHover = vars.onHover,
           onHoverEnd = vars.onHoverEnd,
           onMove = vars.onMove,
           ignoreCheck = vars.ignoreCheck,
           isNormalizer = vars.isNormalizer,
           onGestureStart = vars.onGestureStart,
           onGestureEnd = vars.onGestureEnd,
           onWheel = vars.onWheel,
           onEnable = vars.onEnable,
           onDisable = vars.onDisable,
           onClick = vars.onClick,
           scrollSpeed = vars.scrollSpeed,
           capture = vars.capture,
           allowClicks = vars.allowClicks,
           lockAxis = vars.lockAxis,
           onLockAxis = vars.onLockAxis;
       this.target = target = _getTarget(target) || _docEl;
       this.vars = vars;
       ignore && (ignore = gsap.utils.toArray(ignore));
       tolerance = tolerance || 1e-9;
       dragMinimum = dragMinimum || 0;
       wheelSpeed = wheelSpeed || 1;
       scrollSpeed = scrollSpeed || 1;
       type = type || "wheel,touch,pointer";
       debounce = debounce !== false;
       lineHeight || (lineHeight = parseFloat(_win.getComputedStyle(_body).lineHeight) || 22); // note: browser may report "normal", so default to 22.
   
       var id,
           onStopDelayedCall,
           dragged,
           moved,
           wheeled,
           locked,
           axis,
           self = this,
           prevDeltaX = 0,
           prevDeltaY = 0,
           passive = vars.passive || !preventDefault && vars.passive !== false,
           scrollFuncX = _getScrollFunc(target, _horizontal),
           scrollFuncY = _getScrollFunc(target, _vertical),
           scrollX = scrollFuncX(),
           scrollY = scrollFuncY(),
           limitToTouch = ~type.indexOf("touch") && !~type.indexOf("pointer") && _eventTypes[0] === "pointerdown",
           // for devices that accommodate mouse events and touch events, we need to distinguish.
       isViewport = _isViewport(target),
           ownerDoc = target.ownerDocument || _doc,
           deltaX = [0, 0, 0],
           // wheel, scroll, pointer/touch
       deltaY = [0, 0, 0],
           onClickTime = 0,
           clickCapture = function clickCapture() {
         return onClickTime = _getTime();
       },
           _ignoreCheck = function _ignoreCheck(e, isPointerOrTouch) {
         return (self.event = e) && ignore && _isWithin(e.target, ignore) || isPointerOrTouch && limitToTouch && e.pointerType !== "touch" || ignoreCheck && ignoreCheck(e, isPointerOrTouch);
       },
           onStopFunc = function onStopFunc() {
         self._vx.reset();
   
         self._vy.reset();
   
         onStopDelayedCall.pause();
         onStop && onStop(self);
       },
           update = function update() {
         var dx = self.deltaX = _getAbsoluteMax(deltaX),
             dy = self.deltaY = _getAbsoluteMax(deltaY),
             changedX = Math.abs(dx) >= tolerance,
             changedY = Math.abs(dy) >= tolerance;
   
         onChange && (changedX || changedY) && onChange(self, dx, dy, deltaX, deltaY); // in ScrollTrigger.normalizeScroll(), we need to know if it was touch/pointer so we need access to the deltaX/deltaY Arrays before we clear them out.
   
         if (changedX) {
           onRight && self.deltaX > 0 && onRight(self);
           onLeft && self.deltaX < 0 && onLeft(self);
           onChangeX && onChangeX(self);
           onToggleX && self.deltaX < 0 !== prevDeltaX < 0 && onToggleX(self);
           prevDeltaX = self.deltaX;
           deltaX[0] = deltaX[1] = deltaX[2] = 0;
         }
   
         if (changedY) {
           onDown && self.deltaY > 0 && onDown(self);
           onUp && self.deltaY < 0 && onUp(self);
           onChangeY && onChangeY(self);
           onToggleY && self.deltaY < 0 !== prevDeltaY < 0 && onToggleY(self);
           prevDeltaY = self.deltaY;
           deltaY[0] = deltaY[1] = deltaY[2] = 0;
         }
   
         if (moved || dragged) {
           onMove && onMove(self);
   
           if (dragged) {
             onDragStart && dragged === 1 && onDragStart(self);
             onDrag && onDrag(self);
             dragged = 0;
           }
   
           moved = false;
         }
   
         locked && !(locked = false) && onLockAxis && onLockAxis(self);
   
         if (wheeled) {
           onWheel(self);
           wheeled = false;
         }
   
         id = 0;
       },
           onDelta = function onDelta(x, y, index) {
         deltaX[index] += x;
         deltaY[index] += y;
   
         self._vx.update(x);
   
         self._vy.update(y);
   
         debounce ? id || (id = requestAnimationFrame(update)) : update();
       },
           onTouchOrPointerDelta = function onTouchOrPointerDelta(x, y) {
         if (lockAxis && !axis) {
           self.axis = axis = Math.abs(x) > Math.abs(y) ? "x" : "y";
           locked = true;
         }
   
         if (axis !== "y") {
           deltaX[2] += x;
   
           self._vx.update(x, true); // update the velocity as frequently as possible instead of in the debounced function so that very quick touch-scrolls (flicks) feel natural. If it's the mouse/touch/pointer, force it so that we get snappy/accurate momentum scroll.
   
         }
   
         if (axis !== "x") {
           deltaY[2] += y;
   
           self._vy.update(y, true);
         }
   
         debounce ? id || (id = requestAnimationFrame(update)) : update();
       },
           _onDrag = function _onDrag(e) {
         if (_ignoreCheck(e, 1)) {
           return;
         }
   
         e = _getEvent(e, preventDefault);
         var x = e.clientX,
             y = e.clientY,
             dx = x - self.x,
             dy = y - self.y,
             isDragging = self.isDragging;
         self.x = x;
         self.y = y;
   
         if (isDragging || (dx || dy) && (Math.abs(self.startX - x) >= dragMinimum || Math.abs(self.startY - y) >= dragMinimum)) {
           dragged || (dragged = isDragging ? 2 : 1); // dragged: 0 = not dragging, 1 = first drag, 2 = normal drag
   
           isDragging || (self.isDragging = true);
           onTouchOrPointerDelta(dx, dy);
         }
       },
           _onPress = self.onPress = function (e) {
         if (_ignoreCheck(e, 1) || e && e.button) {
           return;
         }
   
         self.axis = axis = null;
         onStopDelayedCall.pause();
         self.isPressed = true;
         e = _getEvent(e); // note: may need to preventDefault(?) Won't side-scroll on iOS Safari if we do, though.
   
         prevDeltaX = prevDeltaY = 0;
         self.startX = self.x = e.clientX;
         self.startY = self.y = e.clientY;
   
         self._vx.reset(); // otherwise the t2 may be stale if the user touches and flicks super fast and releases in less than 2 requestAnimationFrame ticks, causing velocity to be 0.
   
   
         self._vy.reset();
   
         _addListener(isNormalizer ? target : ownerDoc, _eventTypes[1], _onDrag, passive, true);
   
         self.deltaX = self.deltaY = 0;
         onPress && onPress(self);
       },
           _onRelease = self.onRelease = function (e) {
         if (_ignoreCheck(e, 1)) {
           return;
         }
   
         _removeListener(isNormalizer ? target : ownerDoc, _eventTypes[1], _onDrag, true);
   
         var isTrackingDrag = !isNaN(self.y - self.startY),
             wasDragging = self.isDragging,
             isDragNotClick = wasDragging && (Math.abs(self.x - self.startX) > 3 || Math.abs(self.y - self.startY) > 3),
             // some touch devices need some wiggle room in terms of sensing clicks - the finger may move a few pixels.
         eventData = _getEvent(e);
   
         if (!isDragNotClick && isTrackingDrag) {
           self._vx.reset();
   
           self._vy.reset(); //if (preventDefault && allowClicks && self.isPressed) { // check isPressed because in a rare edge case, the inputObserver in ScrollTrigger may stopPropagation() on the press/drag, so the onRelease may get fired without the onPress/onDrag ever getting called, thus it could trigger a click to occur on a link after scroll-dragging it.
   
   
           if (preventDefault && allowClicks) {
             gsap.delayedCall(0.08, function () {
               // some browsers (like Firefox) won't trust script-generated clicks, so if the user tries to click on a video to play it, for example, it simply won't work. Since a regular "click" event will most likely be generated anyway (one that has its isTrusted flag set to true), we must slightly delay our script-generated click so that the "real"/trusted one is prioritized. Remember, when there are duplicate events in quick succession, we suppress all but the first one. Some browsers don't even trigger the "real" one at all, so our synthetic one is a safety valve that ensures that no matter what, a click event does get dispatched.
               if (_getTime() - onClickTime > 300 && !e.defaultPrevented) {
                 if (e.target.click) {
                   //some browsers (like mobile Safari) don't properly trigger the click event
                   e.target.click();
                 } else if (ownerDoc.createEvent) {
                   var syntheticEvent = ownerDoc.createEvent("MouseEvents");
                   syntheticEvent.initMouseEvent("click", true, true, _win, 1, eventData.screenX, eventData.screenY, eventData.clientX, eventData.clientY, false, false, false, false, 0, null);
                   e.target.dispatchEvent(syntheticEvent);
                 }
               }
             });
           }
         }
   
         self.isDragging = self.isGesturing = self.isPressed = false;
         onStop && wasDragging && !isNormalizer && onStopDelayedCall.restart(true);
         dragged && update(); // in case debouncing, we don't want onDrag to fire AFTER onDragEnd().
   
         onDragEnd && wasDragging && onDragEnd(self);
         onRelease && onRelease(self, isDragNotClick);
       },
           _onGestureStart = function _onGestureStart(e) {
         return e.touches && e.touches.length > 1 && (self.isGesturing = true) && onGestureStart(e, self.isDragging);
       },
           _onGestureEnd = function _onGestureEnd() {
         return (self.isGesturing = false) || onGestureEnd(self);
       },
           onScroll = function onScroll(e) {
         if (_ignoreCheck(e)) {
           return;
         }
   
         var x = scrollFuncX(),
             y = scrollFuncY();
         onDelta((x - scrollX) * scrollSpeed, (y - scrollY) * scrollSpeed, 1);
         scrollX = x;
         scrollY = y;
         onStop && onStopDelayedCall.restart(true);
       },
           _onWheel = function _onWheel(e) {
         if (_ignoreCheck(e)) {
           return;
         }
   
         e = _getEvent(e, preventDefault);
         onWheel && (wheeled = true);
         var multiplier = (e.deltaMode === 1 ? lineHeight : e.deltaMode === 2 ? _win.innerHeight : 1) * wheelSpeed;
         onDelta(e.deltaX * multiplier, e.deltaY * multiplier, 0);
         onStop && !isNormalizer && onStopDelayedCall.restart(true);
       },
           _onMove = function _onMove(e) {
         if (_ignoreCheck(e)) {
           return;
         }
   
         var x = e.clientX,
             y = e.clientY,
             dx = x - self.x,
             dy = y - self.y;
         self.x = x;
         self.y = y;
         moved = true;
         onStop && onStopDelayedCall.restart(true);
         (dx || dy) && onTouchOrPointerDelta(dx, dy);
       },
           _onHover = function _onHover(e) {
         self.event = e;
         onHover(self);
       },
           _onHoverEnd = function _onHoverEnd(e) {
         self.event = e;
         onHoverEnd(self);
       },
           _onClick = function _onClick(e) {
         return _ignoreCheck(e) || _getEvent(e, preventDefault) && onClick(self);
       };
   
       onStopDelayedCall = self._dc = gsap.delayedCall(onStopDelay || 0.25, onStopFunc).pause();
       self.deltaX = self.deltaY = 0;
       self._vx = _getVelocityProp(0, 50, true);
       self._vy = _getVelocityProp(0, 50, true);
       self.scrollX = scrollFuncX;
       self.scrollY = scrollFuncY;
       self.isDragging = self.isGesturing = self.isPressed = false;
   
       _context(this);
   
       self.enable = function (e) {
         if (!self.isEnabled) {
           _addListener(isViewport ? ownerDoc : target, "scroll", _onScroll);
   
           type.indexOf("scroll") >= 0 && _addListener(isViewport ? ownerDoc : target, "scroll", onScroll, passive, capture);
           type.indexOf("wheel") >= 0 && _addListener(target, "wheel", _onWheel, passive, capture);
   
           if (type.indexOf("touch") >= 0 && _isTouch || type.indexOf("pointer") >= 0) {
             _addListener(target, _eventTypes[0], _onPress, passive, capture);
   
             _addListener(ownerDoc, _eventTypes[2], _onRelease);
   
             _addListener(ownerDoc, _eventTypes[3], _onRelease);
   
             allowClicks && _addListener(target, "click", clickCapture, true, true);
             onClick && _addListener(target, "click", _onClick);
             onGestureStart && _addListener(ownerDoc, "gesturestart", _onGestureStart);
             onGestureEnd && _addListener(ownerDoc, "gestureend", _onGestureEnd);
             onHover && _addListener(target, _pointerType + "enter", _onHover);
             onHoverEnd && _addListener(target, _pointerType + "leave", _onHoverEnd);
             onMove && _addListener(target, _pointerType + "move", _onMove);
           }
   
           self.isEnabled = true;
           self.isDragging = self.isGesturing = self.isPressed = moved = dragged = false;
   
           self._vx.reset();
   
           self._vy.reset();
   
           scrollX = scrollFuncX();
           scrollY = scrollFuncY();
           e && e.type && _onPress(e);
           onEnable && onEnable(self);
         }
   
         return self;
       };
   
       self.disable = function () {
         if (self.isEnabled) {
           // only remove the _onScroll listener if there aren't any others that rely on the functionality.
           _observers.filter(function (o) {
             return o !== self && _isViewport(o.target);
           }).length || _removeListener(isViewport ? ownerDoc : target, "scroll", _onScroll);
   
           if (self.isPressed) {
             self._vx.reset();
   
             self._vy.reset();
   
             _removeListener(isNormalizer ? target : ownerDoc, _eventTypes[1], _onDrag, true);
           }
   
           _removeListener(isViewport ? ownerDoc : target, "scroll", onScroll, capture);
   
           _removeListener(target, "wheel", _onWheel, capture);
   
           _removeListener(target, _eventTypes[0], _onPress, capture);
   
           _removeListener(ownerDoc, _eventTypes[2], _onRelease);
   
           _removeListener(ownerDoc, _eventTypes[3], _onRelease);
   
           _removeListener(target, "click", clickCapture, true);
   
           _removeListener(target, "click", _onClick);
   
           _removeListener(ownerDoc, "gesturestart", _onGestureStart);
   
           _removeListener(ownerDoc, "gestureend", _onGestureEnd);
   
           _removeListener(target, _pointerType + "enter", _onHover);
   
           _removeListener(target, _pointerType + "leave", _onHoverEnd);
   
           _removeListener(target, _pointerType + "move", _onMove);
   
           self.isEnabled = self.isPressed = self.isDragging = false;
           onDisable && onDisable(self);
         }
       };
   
       self.kill = self.revert = function () {
         self.disable();
   
         var i = _observers.indexOf(self);
   
         i >= 0 && _observers.splice(i, 1);
         _normalizer === self && (_normalizer = 0);
       };
   
       _observers.push(self);
   
       isNormalizer && _isViewport(target) && (_normalizer = self);
       self.enable(event);
     };
   
     _createClass(Observer, [{
       key: "velocityX",
       get: function get() {
         return this._vx.getVelocity();
       }
     }, {
       key: "velocityY",
       get: function get() {
         return this._vy.getVelocity();
       }
     }]);
   
     return Observer;
   }();
   Observer.version = "3.15.0";
   
   Observer.create = function (vars) {
     return new Observer(vars);
   };
   
   Observer.register = _initCore;
   
   Observer.getAll = function () {
     return _observers.slice();
   };
   
   Observer.getById = function (id) {
     return _observers.filter(function (o) {
       return o.vars.id === id;
     })[0];
   };
   
   _getGSAP() && gsap.registerPlugin(Observer);
   
   
   /***/ }),
   /* 10 */
   /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
   
   "use strict";
   __webpack_require__.r(__webpack_exports__);
   /* harmony export */ __webpack_require__.d(__webpack_exports__, {
   /* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
   /* harmony export */ });
   /* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
   /* harmony import */ var gsap_ScrollTrigger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
   /* harmony import */ var _device_controller__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11);
   function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
   function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
   function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
   function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
   function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
   function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
   function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
   function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
   function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
   function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
   function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
   function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
   
   
   
   gsap__WEBPACK_IMPORTED_MODULE_0__["default"].registerPlugin(gsap_ScrollTrigger__WEBPACK_IMPORTED_MODULE_1__["default"]);
   var ScrollController = /*#__PURE__*/function () {
     function ScrollController() {
       var _this = this;
       _classCallCheck(this, ScrollController);
       var addactive = document.getElementsByClassName('add-active');
       var top = document.getElementById('top');
       var back = document.getElementById('back');
       var scrollbar = document.getElementById('scrollbar');
       var fadeIn = document.getElementsByClassName('fade-in');
       var slideInLeft = document.getElementsByClassName('slide-in-from-left');
       var slideInRight = document.getElementsByClassName('slide-in-from-right');
       var scaleIn = document.getElementsByClassName('scale-in');
       var alphaIn = document.getElementsByClassName('alpha-in');
       var textIn = document.getElementsByClassName('text-in');
       var parallax = document.getElementsByClassName('parallax');
       var pastW = window.innerWidth;
       this.deviceController = new _device_controller__WEBPACK_IMPORTED_MODULE_2__["default"]();
       window.addEventListener("resize", function () {
         if (window.innerWidth < _this.deviceController.getDevice('sm') && pastW > _this.deviceController.getDevice('sm') || window.innerWidth > _this.deviceController.getDevice('sm')) {}
         if (window.innerWidth > _this.deviceController.getDevice('sm')) {
           gsap_ScrollTrigger__WEBPACK_IMPORTED_MODULE_1__["default"].refresh(); // Refresh ScrollTrigger on resize
         }
         pastW = window.innerWidth;
       });
       gsap__WEBPACK_IMPORTED_MODULE_0__["default"].fromTo(back, {
         alpha: 0
       }, {
         alpha: 1,
         scrollTrigger: {
           // markers: true,
           trigger: top,
           start: "top top",
           end: "bottom top",
           scrub: 1,
           invalidateOnRefresh: true
         }
       });
       var _loop = function _loop() {
         var elm = addactive[i];
         var start = "top bottom-=".concat(window.innerHeight / 4);
         if (elm.classList.contains('first')) {
           start = "top bottom";
         }
         gsap__WEBPACK_IMPORTED_MODULE_0__["default"].fromTo(elm, {}, {
           scrollTrigger: {
             trigger: elm,
             start: start,
             onEnter: function onEnter() {
               if (elm.getAttribute('data-delay')) {
                 var _delay5 = parseInt(elm.getAttribute('data-delay')) * 100;
                 setTimeout(function () {
                   elm.classList.add('active');
                 }, _delay5);
               } else {
                 elm.classList.add('active');
               }
             },
             onEnterBack: function onEnterBack() {}
           }
         });
       };
       for (var i = 0; i < addactive.length; i++) {
         _loop();
       }
       for (var _i = 0; _i < fadeIn.length; _i++) {
         var elm = fadeIn[_i];
         var start = "top bottom-=".concat(window.innerHeight / 4);
         var delay = elm.getAttribute('data-delay') ? parseInt(elm.getAttribute('data-delay')) * .1 : 0;
         if (window.innerWidth < this.deviceController.getDevice('sm')) {
           delay = 0;
         }
         gsap__WEBPACK_IMPORTED_MODULE_0__["default"].fromTo(elm, {
           alpha: 0,
           y: "10px"
         }, {
           alpha: 1,
           y: "0px",
           duration: 1,
           delay: delay,
           ease: "power1.inOut",
           scrollTrigger: {
             trigger: elm,
             start: start
           }
         });
       }
       for (var _i2 = 0; _i2 < slideInLeft.length; _i2++) {
         var _elm = slideInLeft[_i2];
         var _start = "top bottom-=".concat(window.innerHeight / 4);
         var _delay = _elm.getAttribute('data-delay') ? parseInt(_elm.getAttribute('data-delay')) * .1 : 0;
         if (window.innerWidth < this.deviceController.getDevice('sm')) {
           _delay = 0;
         }
         gsap__WEBPACK_IMPORTED_MODULE_0__["default"].fromTo(_elm, {
           alpha: 0,
           x: "-40px"
         }, {
           alpha: 1,
           x: "0px",
           duration: 1,
           delay: _delay,
           ease: "power1.inOut",
           scrollTrigger: {
             trigger: _elm,
             start: _start
           }
         });
       }
       for (var _i3 = 0; _i3 < slideInRight.length; _i3++) {
         var _elm2 = slideInRight[_i3];
         var _start2 = "top bottom-=".concat(window.innerHeight / 4);
         var _delay2 = _elm2.getAttribute('data-delay') ? parseInt(_elm2.getAttribute('data-delay')) * .1 : 0;
         if (window.innerWidth < this.deviceController.getDevice('sm')) {
           _delay2 = 0;
         }
         gsap__WEBPACK_IMPORTED_MODULE_0__["default"].fromTo(_elm2, {
           alpha: 0,
           x: "40px"
         }, {
           alpha: 1,
           x: "0px",
           duration: 1,
           delay: _delay2,
           ease: "power1.inOut",
           scrollTrigger: {
             trigger: _elm2,
             start: _start2
           }
         });
       }
       for (var _i4 = 0; _i4 < scaleIn.length; _i4++) {
         var _elm3 = scaleIn[_i4];
         var _start3 = "top bottom-=".concat(window.innerHeight / 4);
         var _delay3 = _elm3.getAttribute('data-delay') ? parseInt(_elm3.getAttribute('data-delay')) * .1 : 0;
         if (window.innerWidth < this.deviceController.getDevice('sm')) {
           _delay3 = 0;
         }
         gsap__WEBPACK_IMPORTED_MODULE_0__["default"].fromTo(_elm3, {
           alpha: 0,
           scale: "1.025"
         }, {
           alpha: 1,
           scale: "1",
           duration: 1,
           delay: _delay3,
           ease: "power1.inOut",
           scrollTrigger: {
             trigger: _elm3,
             start: _start3
           }
         });
       }
       for (var _i5 = 0; _i5 < alphaIn.length; _i5++) {
         var _elm4 = alphaIn[_i5];
         var _start4 = "top bottom-=".concat(window.innerHeight / 4);
         var _delay4 = _elm4.getAttribute('data-delay') ? parseInt(_elm4.getAttribute('data-delay')) * .1 : 0;
         if (window.innerWidth < this.deviceController.getDevice('sm')) {
           _delay4 = 0;
         }
         gsap__WEBPACK_IMPORTED_MODULE_0__["default"].fromTo(_elm4, {
           alpha: 0
         }, {
           alpha: 1,
           duration: 3,
           delay: _delay4,
           ease: "power1.inOut",
           scrollTrigger: {
             trigger: _elm4,
             start: _start4
           }
         });
       }
       var _loop2 = function _loop2() {
         var elm = textIn[_i6];
         var start = "top bottom-=".concat(window.innerHeight / 4);
         var delay = elm.getAttribute('data-delay') ? parseInt(elm.getAttribute('data-delay')) * .1 : 0;
         if (window.innerWidth < _this.deviceController.getDevice('sm')) {
           delay = 0;
         }
         gsap__WEBPACK_IMPORTED_MODULE_0__["default"].fromTo(elm, {
           alpha: 0,
           y: "20px"
         }, {
           alpha: 1,
           y: "0px",
           duration: 1,
           delay: delay,
           ease: "power1.inOut",
           scrollTrigger: {
             trigger: elm,
             start: start,
             onEnter: function onEnter() {
               return elm.classList.add('active');
             }
           }
         });
       };
       for (var _i6 = 0; _i6 < textIn.length; _i6++) {
         _loop2();
       }
       var _loop3 = function _loop3() {
         var elm = parallax[_i7];
         var amountPc = elm.getAttribute('data-amountPc');
         var amountSp = elm.getAttribute('data-amountSp');
         var amount = '';
         if (window.innerWidth < _this.deviceController.getDevice('sm')) {
           amount = amountSp;
         } else {
           amount = amountPc;
         }
         gsap__WEBPACK_IMPORTED_MODULE_0__["default"].fromTo(elm, {
           y: function y() {
             return "".concat(amount, "%");
           }
         }, {
           y: function y() {
             return "-".concat(amount / 2, "%");
           },
           scrollTrigger: {
             trigger: elm,
             start: "top bottom",
             end: "bottom top",
             scrub: 1,
             invalidateOnRefresh: true
           }
         });
       };
       for (var _i7 = 0; _i7 < parallax.length; _i7++) {
         _loop3();
       }
       gsap__WEBPACK_IMPORTED_MODULE_0__["default"].fromTo(scrollbar, {
         alpha: 1
       }, {
         alpha: 0,
         scrollTrigger: {
           trigger: top,
           start: "top top",
           end: "top top-=100",
           scrub: true,
           onEnter: function onEnter() {},
           onLeave: function onLeave() {}
         }
       });
   
       // ▼ .change-bg が画面中央（縦幅の半分）に達したら .bg の背景色を切り替える
       this._initChangeBg();
     }
     return _createClass(ScrollController, [{
       key: "_initChangeBg",
       value: function _initChangeBg() {
         var sections = document.querySelectorAll('.change-bg');
         if (!sections.length) return;
   
         // ---------------------------------------------------------------
         // カラーマップ
         // key名（'bg' / 'accent'）でHTMLのクラス名と対応させる
         // data-color（背景色） → { bg: 背景色, accent: アクセントカラー }
         // ---------------------------------------------------------------
         var colorMap = {
           '#f3f9f8': {
             bg: '#f3f9f8',
             accent: '#7eb5b3',
             star: '#b0d8dc'
           },
           '#f6f3f9': {
             bg: '#f6f3f9',
             accent: '#a191b3',
             star: '#d1c4e0'
           },
           '#fffaf6': {
             bg: '#fffaf6',
             accent: '#dcbb85',
             star: '#eacea7'
           }
         };
   
         // ---------------------------------------------------------------
         // 汎用カラー適用
         //
         // HTMLに以下のクラスを付けるだけで自動的に色が変わります。
         // クラス名のルール: js-color-{type}-{key}
         //
         //   js-color-bg-{key}      → backgroundColor を変更
         //   js-color-color-{key}   → color（テキスト色）を変更
         //   js-color-fill-{key}    → 子孫SVG要素のfillをまとめて変更
         //   js-color-stroke-{key}  → 子孫SVG要素のstrokeをまとめて変更
         //   js-color-var-{key}     → data-color-var で指定したCSS変数を変更
         //                            例: <div class="js-color-var-accent" data-color-var="--button-before-bg">
         //
         // {key} は colorMap のキー名（'bg' / 'accent' など）
         // ---------------------------------------------------------------
         var DURATION = 0.6;
         var EASE = 'power1.inOut';
         var applyColor = function applyColor(palette) {
           var instant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
           var duration = instant ? 0 : DURATION;
           Object.entries(palette).forEach(function (_ref) {
             var _ref2 = _slicedToArray(_ref, 2),
               key = _ref2[0],
               color = _ref2[1];
             // backgroundColor
             document.querySelectorAll(".js-color-bg-".concat(key)).forEach(function (el) {
               gsap__WEBPACK_IMPORTED_MODULE_0__["default"].to(el, {
                 backgroundColor: color,
                 duration: duration,
                 ease: EASE
               });
             });
   
             // color（テキスト色）
             document.querySelectorAll(".js-color-color-".concat(key)).forEach(function (el) {
               gsap__WEBPACK_IMPORTED_MODULE_0__["default"].to(el, {
                 color: color,
                 duration: duration,
                 ease: EASE
               });
             });
   
             // fill（子孫SVG要素をまとめて）
             document.querySelectorAll(".js-color-fill-".concat(key)).forEach(function (el) {
               var fillRoot = el;
               if (el.tagName === "OBJECT") {
                 if (!el.contentDocument) return;
                 fillRoot = el.contentDocument.documentElement;
               }
               var targets = fillRoot.querySelectorAll('path, circle, rect, ellipse, polygon, polyline, use');
               var fillTargets = targets.length ? targets : el.tagName === "OBJECT" ? [] : [el];
               fillTargets.forEach(function (t) {
                 if (instant) {
                   t.style.fill = color;
                 } else {
                   gsap__WEBPACK_IMPORTED_MODULE_0__["default"].to(t, {
                     fill: color,
                     duration: duration,
                     ease: EASE
                   });
                 }
               });
             });
   
             // stroke（子孫SVG要素をまとめて）
             document.querySelectorAll(".js-color-stroke-".concat(key)).forEach(function (el) {
               var targets = el.querySelectorAll('path, line, polyline, circle, rect, ellipse, polygon');
               var strokeTargets = targets.length ? targets : [el];
               strokeTargets.forEach(function (t) {
                 gsap__WEBPACK_IMPORTED_MODULE_0__["default"].to(t, {
                   stroke: color,
                   duration: duration,
                   ease: EASE
                 });
               });
             });
   
             // CSS変数経由（::before などの疑似要素対応）
             // 使い方: <div class="js-color-var-accent" data-color-var="--button-before-bg">
             document.querySelectorAll(".js-color-var-".concat(key)).forEach(function (el) {
               var varName = el.getAttribute('data-color-var');
               if (!varName) return;
               if (instant) {
                 el.style.setProperty(varName, color);
               } else {
                 gsap__WEBPACK_IMPORTED_MODULE_0__["default"].to({
                   value: 0
                 }, {
                   duration: duration,
                   ease: EASE,
                   onUpdate: function onUpdate() {
                     el.style.setProperty(varName, color);
                   },
                   onComplete: function onComplete() {
                     el.style.setProperty(varName, color);
                   }
                 });
               }
             });
           });
         };
   
         // ページロード時に最初のセクションの色を即時適用
         var firstDataColor = sections[0].getAttribute('data-color');
         var firstPalette = colorMap[firstDataColor];
         if (firstPalette) applyColor(firstPalette, true);
         sections.forEach(function (section) {
           var dataColor = section.getAttribute('data-color');
           if (!dataColor) return;
           var palette = colorMap[dataColor];
           if (!palette) return;
           gsap_ScrollTrigger__WEBPACK_IMPORTED_MODULE_1__["default"].create({
             trigger: section,
             // セクションの上端が画面の中央（50%）に達したタイミング
             start: 'top 50%',
             // セクションの下端が画面の中央（50%）を抜けたタイミング
             end: 'bottom 50%',
             onEnter: function onEnter() {
               return applyColor(palette);
             },
             onEnterBack: function onEnterBack() {
               return applyColor(palette);
             }
           });
         });
       }
     }]);
   }();
   /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ScrollController);
   
   /***/ }),
   /* 11 */
   /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
   
   "use strict";
   __webpack_require__.r(__webpack_exports__);
   /* harmony export */ __webpack_require__.d(__webpack_exports__, {
   /* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
   /* harmony export */ });
   function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
   function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
   function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
   function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
   function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
   function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
   var DeviceController = /*#__PURE__*/function () {
     function DeviceController() {
       _classCallCheck(this, DeviceController);
     }
     return _createClass(DeviceController, [{
       key: "getDevice",
       value: function getDevice(device) {
         var width = 0;
         switch (device) {
           case 'sm':
             width = 750;
             break;
           default:
             break;
         }
         return width;
       }
     }]);
   }();
   /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (DeviceController);
   
   /***/ }),
   /* 12 */
   /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
   
   "use strict";
   __webpack_require__.r(__webpack_exports__);
   /* harmony export */ __webpack_require__.d(__webpack_exports__, {
   /* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
   /* harmony export */ });
   /* harmony import */ var _libs_swiper_bundle_min_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13);
   /* harmony import */ var _libs_swiper_bundle_min_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_libs_swiper_bundle_min_js__WEBPACK_IMPORTED_MODULE_0__);
   /* harmony import */ var _device_controller__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11);
   function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
   function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
   function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
   function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
   function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
   function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
   
   
   var SwiperController = /*#__PURE__*/function () {
     function SwiperController() {
       _classCallCheck(this, SwiperController);
       this.deviceController = new _device_controller__WEBPACK_IMPORTED_MODULE_1__["default"]();
       this.swiperArray = [];
   
       // sm の幅（= 750 想定）
       this.smWidth = this.deviceController.getDevice('sm') || 750;
   
       // 現在のモード（'sp' | 'pc'）
       this.currentMode = this._getMode();
   
       // resize イベント用
       this._onResize = this._onResize.bind(this);
       window.addEventListener('resize', this._onResize);
     }
   
     /** 今のウィンドウ幅から SP / PC を判定 */
     return _createClass(SwiperController, [{
       key: "_getMode",
       value: function _getMode() {
         return window.innerWidth < this.smWidth ? 'sp' : 'pc';
       }
   
       /** 750px をまたいだら Swiper をリフレッシュ */
     }, {
       key: "_onResize",
       value: function _onResize() {
         var newMode = this._getMode();
         if (newMode === this.currentMode) return; // SP→SP / PC→PC のときは何もしない
   
         this.currentMode = newMode;
         this.refresh();
       }
   
       /** 既存の Swiper を全部破棄して再初期化 */
     }, {
       key: "refresh",
       value: function refresh() {
         this.destroyAll();
         this.init();
       }
   
       /** 全 Swiper destroy */
     }, {
       key: "destroyAll",
       value: function destroyAll() {
         this.swiperArray.forEach(function (_ref) {
           var swiper = _ref.swiper;
           if (swiper && swiper.destroy) {
             swiper.destroy(true, true);
           }
         });
         this.swiperArray = [];
       }
     }, {
       key: "init",
       value: function init() {
         var _this = this;
         // いったん配列をリセット
         this.swiperArray = [];
         var containers = document.querySelectorAll('.swiper-container');
   
         // ここでも一応 smWidth を参照
         var smWidth = this.smWidth;
         containers.forEach(function (container) {
           var _ref2, _getNumber;
           var isSp = window.innerWidth < smWidth;
           var isPc = !isSp;
           var useSpSwiper = isSp && container.getAttribute('data-swiper') === 'true';
           var usePcSwiper = isPc && container.getAttribute('data-swiperPc') === 'true';
           if (!useSpSwiper && !usePcSwiper) return;
           var getBool = function getBool(name) {
             return container.getAttribute(name) === 'true';
           };
           var getAttr = function getAttr(name) {
             return container.getAttribute(name);
           };
           var getNumber = function getNumber(name) {
             var val = getAttr(name);
             return val ? parseFloat(val) : undefined;
           };
           var effect = getAttr('data-effect') || undefined;
           var slides = getAttr('data-slides') === 'auto' ? 'auto' : getNumber('data-slides') || 1;
           var slidesPc = getAttr('data-slidesPc') === 'auto' ? 'auto' : getNumber('data-slidesPc') || slides;
   
           // container 直下から探すように修正（parentElement → container）
           var scrollbar = getBool('data-scrollbar') ? {
             el: container.querySelector('.swiper-scrollbar')
           } : false;
           var scrollbarPc = getBool('data-scrollbarPc') ? {
             el: container.querySelector('.swiper-scrollbar')
           } : false;
           var pagination = getBool('data-pagination') ? {
             el: container.querySelector('.swiper-pagination'),
             clickable: true,
             renderBullet: function renderBullet(index, className) {
               return "\n                <span class=\"".concat(className, "\">\n                  <svg id=\"_\u30EC\u30A4\u30E4\u30FC_2\" data-name=\"\u30EC\u30A4\u30E4\u30FC 2\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30.53 31.68\">\n    <g id=\"lp\">\n      <path d=\"M.02,11.1c.69-.16,1.39-.47,2.08-.46,2.11.04,4.21.16,6.31.32,1.55.13,2.52-.58,3.15-1.91,1.27-2.71,2.5-5.43,3.82-8.1.19-.4.79-.59,1.32-.96.46,2.54.94,4.84,1.25,7.16.17,1.28.64,2.17,1.93,2.53,3.19.89,6.39,1.79,9.57,2.72.4.11.73.46,1.09.7-.35.28-.67.63-1.06.83-2.18,1.15-4.42,2.2-6.57,3.39-1.45.8-2.09,2.08-1.53,3.78.95,2.91,1.9,5.82,2.76,8.75.16.54-.1,1.21-.16,1.81-.44-.28-.94-.49-1.31-.84-2.39-2.27-4.68-4.65-7.18-6.8-.5-.43-1.97-.28-2.66.14-2.26,1.38-4.35,3.04-6.56,4.51-.4.26-1.05.14-1.58.19.02-.55-.13-1.18.08-1.63,1.04-2.25,2.26-4.42,3.22-6.7.28-.65.2-1.81-.21-2.33-1.18-1.48-2.31-2.99-4.31-3.72-1.31-.48-2.32-1.82-3.46-2.76,0-.22.01-.43.02-.65\"/>\n    </g>\n  </svg>\n                </span>\n              ");
             }
           } : false;
           var paginationPc = getBool('data-paginationPc') ? {
             el: container.querySelector('.swiper-pagination')
           } : false;
           var navigation = getBool('data-navigation') ? {
             nextEl: container.querySelector('.swiper-button-next'),
             prevEl: container.querySelector('.swiper-button-prev'),
             clickable: true
           } : false;
           var navigationPc = getBool('data-navigationPc') ? {
             nextEl: container.querySelector('.swiper-button-next'),
             prevEl: container.querySelector('.swiper-button-prev'),
             clickable: true
           } : false;
           var baseSpeed = parseInt(getAttr('data-speed'), 10) || 400;
           var speedSp = baseSpeed;
           var speedPc = baseSpeed;
   
           /** autoplay 設定 */
           var autoplayAttr = getAttr('data-autoplay');
           var autoplay = false;
           if (autoplayAttr === 'marquee') {
             autoplay = {
               delay: 0,
               disableOnInteraction: false,
               preventInteractionOnTransition: true
             };
   
             /** ★ marquee の場合のみ timing-function を linear に */
             var wrapper = container.querySelector('.swiper-wrapper');
             if (wrapper) {
               wrapper.style.transitionTimingFunction = 'linear';
             }
           } else if (autoplayAttr && autoplayAttr !== 'false') {
             autoplay = {
               delay: parseInt(autoplayAttr, 10),
               pauseOnMouseEnter: true,
               preventInteractionOnTransition: true
             };
           }
           var initialSlide = parseInt(getAttr('data-initialslide'), 10) || 0;
           var swiper = new (_libs_swiper_bundle_min_js__WEBPACK_IMPORTED_MODULE_0___default())(container, {
             speed: speedSp,
             initialSlide: initialSlide,
             autoplay: autoplay,
             loop: getBool('data-loop'),
             centeredSlides: getBool('data-center'),
             slidesPerView: slides,
             spaceBetween: getNumber('data-space') || 0,
             slidesPerGroup: 1,
             scrollbar: scrollbar,
             pagination: pagination,
             navigation: navigation,
             effect: effect,
             fadeEffect: {
               crossFade: true
             },
             breakpoints: {
               750: {
                 speed: speedPc,
                 slidesPerView: slidesPc,
                 centeredSlides: getBool('data-centerPc'),
                 scrollbar: scrollbarPc,
                 pagination: paginationPc,
                 navigation: navigationPc,
                 spaceBetween: (_ref2 = (_getNumber = getNumber('data-spacePc')) !== null && _getNumber !== void 0 ? _getNumber : getNumber('data-space')) !== null && _ref2 !== void 0 ? _ref2 : 0
               }
             },
             on: {
               slideChange: function slideChange(swiperInstance) {
                 var _swiperInstance$realI;
                 // この swiper に対応する title-wrap を探す
                 var container = swiperInstance.el;
                 var block = container.closest('.swiper-block');
                 if (!block) return;
                 var index = swiperInstance.realIndex; // loop 対応
   
                 var titles_ = block.querySelectorAll('.title-wrap');
                 for (var i = 0; i < titles_.length; i++) {
                   var thisTitleWrap = titles_[i];
                   var title_ = thisTitleWrap.getElementsByClassName('title');
                   for (var j = 0; j < title_.length; j++) {
                     var thisTitle = title_[j];
                     if (j === index) {
                       thisTitle.classList.add('active');
                     } else {
                       thisTitle.classList.remove('active');
                     }
                   }
                 }
                 titles_.forEach(function (el, i) {
                   el.classList.toggle('active', i === index);
                 });
                 var currentIndex = (_swiperInstance$realI = swiperInstance.realIndex) !== null && _swiperInstance$realI !== void 0 ? _swiperInstance$realI : swiperInstance.activeIndex;
                 var titleWrap = block.querySelector('#title-wrap');
                 if (!titleWrap) return;
                 var titles = titleWrap.querySelectorAll('h2');
                 titles.forEach(function (h2, i) {
                   h2.classList.toggle('active', i === currentIndex);
                 });
                 block.classList.remove('sm:bg-unityGray');
                 block.classList.remove('sm:bg-white');
                 block.classList.remove('sm:bg-black');
                 if (currentIndex === 0) {
                   block.classList.add('sm:bg-unityGray');
                 }
                 if (currentIndex === 1) {
                   block.classList.add('sm:bg-white');
                 }
                 if (currentIndex === 2) {
                   block.classList.add('sm:bg-black');
                 }
               }
             }
           });
           _this.swiperArray.push({
             swiper: swiper,
             elm: container
           });
         });
       }
     }]);
   }();
   /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SwiperController);
   
   /***/ }),
   /* 13 */
   /***/ (function(module, exports, __webpack_require__) {
   
   var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
   function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
   function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
   function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
   function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
   function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
   function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
   function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
   function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
   function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
   function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
   function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
   function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
   function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
   function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
   function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
   function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
   function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
   function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
   function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
   function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
   function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
   function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
   function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
   function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
   function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
   function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
   /**
    * Swiper 8.2.4
    * Most modern mobile touch slider and framework with hardware accelerated transitions
    * https://swiperjs.com
    *
    * Copyright 2014-2022 Vladimir Kharlampidi
    *
    * Released under the MIT License
    *
    * Released on: June 13, 2022
    */
   
   !function (e, t) {
     "object" == ( false ? 0 : _typeof(exports)) && "undefined" != "object" ? module.exports = t() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (t),
           __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
           (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
           __WEBPACK_AMD_DEFINE_FACTORY__),
           __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : 0;
   }(this, function () {
     "use strict";
   
     function e(e) {
       return null !== e && "object" == _typeof(e) && "constructor" in e && e.constructor === Object;
     }
     function t(s, a) {
       void 0 === s && (s = {}), void 0 === a && (a = {}), Object.keys(a).forEach(function (i) {
         void 0 === s[i] ? s[i] = a[i] : e(a[i]) && e(s[i]) && Object.keys(a[i]).length > 0 && t(s[i], a[i]);
       });
     }
     var s = {
       body: {},
       addEventListener: function addEventListener() {},
       removeEventListener: function removeEventListener() {},
       activeElement: {
         blur: function blur() {},
         nodeName: ""
       },
       querySelector: function querySelector() {
         return null;
       },
       querySelectorAll: function querySelectorAll() {
         return [];
       },
       getElementById: function getElementById() {
         return null;
       },
       createEvent: function createEvent() {
         return {
           initEvent: function initEvent() {}
         };
       },
       createElement: function createElement() {
         return {
           children: [],
           childNodes: [],
           style: {},
           setAttribute: function setAttribute() {},
           getElementsByTagName: function getElementsByTagName() {
             return [];
           }
         };
       },
       createElementNS: function createElementNS() {
         return {};
       },
       importNode: function importNode() {
         return null;
       },
       location: {
         hash: "",
         host: "",
         hostname: "",
         href: "",
         origin: "",
         pathname: "",
         protocol: "",
         search: ""
       }
     };
     function a() {
       var e = "undefined" != typeof document ? document : {};
       return t(e, s), e;
     }
     var i = {
       document: s,
       navigator: {
         userAgent: ""
       },
       location: {
         hash: "",
         host: "",
         hostname: "",
         href: "",
         origin: "",
         pathname: "",
         protocol: "",
         search: ""
       },
       history: {
         replaceState: function replaceState() {},
         pushState: function pushState() {},
         go: function go() {},
         back: function back() {}
       },
       CustomEvent: function CustomEvent() {
         return this;
       },
       addEventListener: function addEventListener() {},
       removeEventListener: function removeEventListener() {},
       getComputedStyle: function getComputedStyle() {
         return {
           getPropertyValue: function getPropertyValue() {
             return "";
           }
         };
       },
       Image: function Image() {},
       Date: function Date() {},
       screen: {},
       setTimeout: function setTimeout() {},
       clearTimeout: function clearTimeout() {},
       matchMedia: function matchMedia() {
         return {};
       },
       requestAnimationFrame: function requestAnimationFrame(e) {
         return "undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0);
       },
       cancelAnimationFrame: function cancelAnimationFrame(e) {
         "undefined" != typeof setTimeout && clearTimeout(e);
       }
     };
     function r() {
       var e = "undefined" != typeof window ? window : {};
       return t(e, i), e;
     }
     var n = /*#__PURE__*/function (_Array) {
       function n(e) {
         var _this;
         _classCallCheck(this, n);
         "number" == typeof e ? _this = _callSuper(this, n, [e]) : (_this = _callSuper(this, n, _toConsumableArray(e || [])), function (e) {
           var t = e.__proto__;
           Object.defineProperty(e, "__proto__", {
             get: function get() {
               return t;
             },
             set: function set(e) {
               t.__proto__ = e;
             }
           });
         }(_assertThisInitialized(_this)));
         return _assertThisInitialized(_this);
       }
       _inherits(n, _Array);
       return _createClass(n);
     }(/*#__PURE__*/_wrapNativeSuper(Array));
     function l(e) {
       void 0 === e && (e = []);
       var t = [];
       return e.forEach(function (e) {
         Array.isArray(e) ? t.push.apply(t, _toConsumableArray(l(e))) : t.push(e);
       }), t;
     }
     function o(e, t) {
       return Array.prototype.filter.call(e, t);
     }
     function d(e, t) {
       var s = r(),
         i = a();
       var l = [];
       if (!t && e instanceof n) return e;
       if (!e) return new n(l);
       if ("string" == typeof e) {
         var _s = e.trim();
         if (_s.indexOf("<") >= 0 && _s.indexOf(">") >= 0) {
           var _e = "div";
           0 === _s.indexOf("<li") && (_e = "ul"), 0 === _s.indexOf("<tr") && (_e = "tbody"), 0 !== _s.indexOf("<td") && 0 !== _s.indexOf("<th") || (_e = "tr"), 0 === _s.indexOf("<tbody") && (_e = "table"), 0 === _s.indexOf("<option") && (_e = "select");
           var _t = i.createElement(_e);
           _t.innerHTML = _s;
           for (var _e2 = 0; _e2 < _t.childNodes.length; _e2 += 1) l.push(_t.childNodes[_e2]);
         } else l = function (e, t) {
           if ("string" != typeof e) return [e];
           var s = [],
             a = t.querySelectorAll(e);
           for (var _e3 = 0; _e3 < a.length; _e3 += 1) s.push(a[_e3]);
           return s;
         }(e.trim(), t || i);
       } else if (e.nodeType || e === s || e === i) l.push(e);else if (Array.isArray(e)) {
         if (e instanceof n) return e;
         l = e;
       }
       return new n(function (e) {
         var t = [];
         for (var _s2 = 0; _s2 < e.length; _s2 += 1) -1 === t.indexOf(e[_s2]) && t.push(e[_s2]);
         return t;
       }(l));
     }
     d.fn = n.prototype;
     var c = {
       addClass: function addClass() {
         for (var e = arguments.length, t = new Array(e), s = 0; s < e; s++) t[s] = arguments[s];
         var a = l(t.map(function (e) {
           return e.split(" ");
         }));
         return this.forEach(function (e) {
           var _e$classList;
           (_e$classList = e.classList).add.apply(_e$classList, _toConsumableArray(a));
         }), this;
       },
       removeClass: function removeClass() {
         for (var e = arguments.length, t = new Array(e), s = 0; s < e; s++) t[s] = arguments[s];
         var a = l(t.map(function (e) {
           return e.split(" ");
         }));
         return this.forEach(function (e) {
           var _e$classList2;
           (_e$classList2 = e.classList).remove.apply(_e$classList2, _toConsumableArray(a));
         }), this;
       },
       hasClass: function hasClass() {
         for (var e = arguments.length, t = new Array(e), s = 0; s < e; s++) t[s] = arguments[s];
         var a = l(t.map(function (e) {
           return e.split(" ");
         }));
         return o(this, function (e) {
           return a.filter(function (t) {
             return e.classList.contains(t);
           }).length > 0;
         }).length > 0;
       },
       toggleClass: function toggleClass() {
         for (var e = arguments.length, t = new Array(e), s = 0; s < e; s++) t[s] = arguments[s];
         var a = l(t.map(function (e) {
           return e.split(" ");
         }));
         this.forEach(function (e) {
           a.forEach(function (t) {
             e.classList.toggle(t);
           });
         });
       },
       attr: function attr(e, t) {
         if (1 === arguments.length && "string" == typeof e) return this[0] ? this[0].getAttribute(e) : void 0;
         for (var _s3 = 0; _s3 < this.length; _s3 += 1) if (2 === arguments.length) this[_s3].setAttribute(e, t);else for (var _t2 in e) this[_s3][_t2] = e[_t2], this[_s3].setAttribute(_t2, e[_t2]);
         return this;
       },
       removeAttr: function removeAttr(e) {
         for (var _t3 = 0; _t3 < this.length; _t3 += 1) this[_t3].removeAttribute(e);
         return this;
       },
       transform: function transform(e) {
         for (var _t4 = 0; _t4 < this.length; _t4 += 1) this[_t4].style.transform = e;
         return this;
       },
       transition: function transition(e) {
         for (var _t5 = 0; _t5 < this.length; _t5 += 1) this[_t5].style.transitionDuration = "string" != typeof e ? "".concat(e, "ms") : e;
         return this;
       },
       on: function on() {
         for (var e = arguments.length, t = new Array(e), s = 0; s < e; s++) t[s] = arguments[s];
         var a = t[0],
           i = t[1],
           r = t[2],
           n = t[3];
         function l(e) {
           var t = e.target;
           if (!t) return;
           var s = e.target.dom7EventData || [];
           if (s.indexOf(e) < 0 && s.unshift(e), d(t).is(i)) r.apply(t, s);else {
             var _e4 = d(t).parents();
             for (var _t6 = 0; _t6 < _e4.length; _t6 += 1) d(_e4[_t6]).is(i) && r.apply(_e4[_t6], s);
           }
         }
         function o(e) {
           var t = e && e.target && e.target.dom7EventData || [];
           t.indexOf(e) < 0 && t.unshift(e), r.apply(this, t);
         }
         "function" == typeof t[1] && (a = t[0], r = t[1], n = t[2], i = void 0), n || (n = !1);
         var c = a.split(" ");
         var p;
         for (var _e5 = 0; _e5 < this.length; _e5 += 1) {
           var _t7 = this[_e5];
           if (i) for (p = 0; p < c.length; p += 1) {
             var _e6 = c[p];
             _t7.dom7LiveListeners || (_t7.dom7LiveListeners = {}), _t7.dom7LiveListeners[_e6] || (_t7.dom7LiveListeners[_e6] = []), _t7.dom7LiveListeners[_e6].push({
               listener: r,
               proxyListener: l
             }), _t7.addEventListener(_e6, l, n);
           } else for (p = 0; p < c.length; p += 1) {
             var _e7 = c[p];
             _t7.dom7Listeners || (_t7.dom7Listeners = {}), _t7.dom7Listeners[_e7] || (_t7.dom7Listeners[_e7] = []), _t7.dom7Listeners[_e7].push({
               listener: r,
               proxyListener: o
             }), _t7.addEventListener(_e7, o, n);
           }
         }
         return this;
       },
       off: function off() {
         for (var e = arguments.length, t = new Array(e), s = 0; s < e; s++) t[s] = arguments[s];
         var a = t[0],
           i = t[1],
           r = t[2],
           n = t[3];
         "function" == typeof t[1] && (a = t[0], r = t[1], n = t[2], i = void 0), n || (n = !1);
         var l = a.split(" ");
         for (var _e8 = 0; _e8 < l.length; _e8 += 1) {
           var _t8 = l[_e8];
           for (var _e9 = 0; _e9 < this.length; _e9 += 1) {
             var _s4 = this[_e9];
             var _a = void 0;
             if (!i && _s4.dom7Listeners ? _a = _s4.dom7Listeners[_t8] : i && _s4.dom7LiveListeners && (_a = _s4.dom7LiveListeners[_t8]), _a && _a.length) for (var _e0 = _a.length - 1; _e0 >= 0; _e0 -= 1) {
               var _i = _a[_e0];
               r && _i.listener === r || r && _i.listener && _i.listener.dom7proxy && _i.listener.dom7proxy === r ? (_s4.removeEventListener(_t8, _i.proxyListener, n), _a.splice(_e0, 1)) : r || (_s4.removeEventListener(_t8, _i.proxyListener, n), _a.splice(_e0, 1));
             }
           }
         }
         return this;
       },
       trigger: function trigger() {
         var e = r();
         for (var t = arguments.length, s = new Array(t), a = 0; a < t; a++) s[a] = arguments[a];
         var i = s[0].split(" "),
           n = s[1];
         for (var _t9 = 0; _t9 < i.length; _t9 += 1) {
           var _a2 = i[_t9];
           for (var _t0 = 0; _t0 < this.length; _t0 += 1) {
             var _i2 = this[_t0];
             if (e.CustomEvent) {
               var _t1 = new e.CustomEvent(_a2, {
                 detail: n,
                 bubbles: !0,
                 cancelable: !0
               });
               _i2.dom7EventData = s.filter(function (e, t) {
                 return t > 0;
               }), _i2.dispatchEvent(_t1), _i2.dom7EventData = [], delete _i2.dom7EventData;
             }
           }
         }
         return this;
       },
       transitionEnd: function transitionEnd(e) {
         var t = this;
         return e && t.on("transitionend", function s(a) {
           a.target === this && (e.call(this, a), t.off("transitionend", s));
         }), this;
       },
       outerWidth: function outerWidth(e) {
         if (this.length > 0) {
           if (e) {
             var _e1 = this.styles();
             return this[0].offsetWidth + parseFloat(_e1.getPropertyValue("margin-right")) + parseFloat(_e1.getPropertyValue("margin-left"));
           }
           return this[0].offsetWidth;
         }
         return null;
       },
       outerHeight: function outerHeight(e) {
         if (this.length > 0) {
           if (e) {
             var _e10 = this.styles();
             return this[0].offsetHeight + parseFloat(_e10.getPropertyValue("margin-top")) + parseFloat(_e10.getPropertyValue("margin-bottom"));
           }
           return this[0].offsetHeight;
         }
         return null;
       },
       styles: function styles() {
         var e = r();
         return this[0] ? e.getComputedStyle(this[0], null) : {};
       },
       offset: function offset() {
         if (this.length > 0) {
           var _e11 = r(),
             _t10 = a(),
             _s5 = this[0],
             _i3 = _s5.getBoundingClientRect(),
             _n = _t10.body,
             _l = _s5.clientTop || _n.clientTop || 0,
             _o = _s5.clientLeft || _n.clientLeft || 0,
             _d = _s5 === _e11 ? _e11.scrollY : _s5.scrollTop,
             _c = _s5 === _e11 ? _e11.scrollX : _s5.scrollLeft;
           return {
             top: _i3.top + _d - _l,
             left: _i3.left + _c - _o
           };
         }
         return null;
       },
       css: function css(e, t) {
         var s = r();
         var a;
         if (1 === arguments.length) {
           if ("string" != typeof e) {
             for (a = 0; a < this.length; a += 1) for (var _t11 in e) this[a].style[_t11] = e[_t11];
             return this;
           }
           if (this[0]) return s.getComputedStyle(this[0], null).getPropertyValue(e);
         }
         if (2 === arguments.length && "string" == typeof e) {
           for (a = 0; a < this.length; a += 1) this[a].style[e] = t;
           return this;
         }
         return this;
       },
       each: function each(e) {
         return e ? (this.forEach(function (t, s) {
           e.apply(t, [t, s]);
         }), this) : this;
       },
       html: function html(e) {
         if (void 0 === e) return this[0] ? this[0].innerHTML : null;
         for (var _t12 = 0; _t12 < this.length; _t12 += 1) this[_t12].innerHTML = e;
         return this;
       },
       text: function text(e) {
         if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;
         for (var _t13 = 0; _t13 < this.length; _t13 += 1) this[_t13].textContent = e;
         return this;
       },
       is: function is(e) {
         var t = r(),
           s = a(),
           i = this[0];
         var l, o;
         if (!i || void 0 === e) return !1;
         if ("string" == typeof e) {
           if (i.matches) return i.matches(e);
           if (i.webkitMatchesSelector) return i.webkitMatchesSelector(e);
           if (i.msMatchesSelector) return i.msMatchesSelector(e);
           for (l = d(e), o = 0; o < l.length; o += 1) if (l[o] === i) return !0;
           return !1;
         }
         if (e === s) return i === s;
         if (e === t) return i === t;
         if (e.nodeType || e instanceof n) {
           for (l = e.nodeType ? [e] : e, o = 0; o < l.length; o += 1) if (l[o] === i) return !0;
           return !1;
         }
         return !1;
       },
       index: function index() {
         var e,
           t = this[0];
         if (t) {
           for (e = 0; null !== (t = t.previousSibling);) 1 === t.nodeType && (e += 1);
           return e;
         }
       },
       eq: function eq(e) {
         if (void 0 === e) return this;
         var t = this.length;
         if (e > t - 1) return d([]);
         if (e < 0) {
           var _s6 = t + e;
           return d(_s6 < 0 ? [] : [this[_s6]]);
         }
         return d([this[e]]);
       },
       append: function append() {
         var e;
         var t = a();
         for (var _s7 = 0; _s7 < arguments.length; _s7 += 1) {
           e = _s7 < 0 || arguments.length <= _s7 ? void 0 : arguments[_s7];
           for (var _s8 = 0; _s8 < this.length; _s8 += 1) if ("string" == typeof e) {
             var _a3 = t.createElement("div");
             for (_a3.innerHTML = e; _a3.firstChild;) this[_s8].appendChild(_a3.firstChild);
           } else if (e instanceof n) for (var _t14 = 0; _t14 < e.length; _t14 += 1) this[_s8].appendChild(e[_t14]);else this[_s8].appendChild(e);
         }
         return this;
       },
       prepend: function prepend(e) {
         var t = a();
         var s, i;
         for (s = 0; s < this.length; s += 1) if ("string" == typeof e) {
           var _a4 = t.createElement("div");
           for (_a4.innerHTML = e, i = _a4.childNodes.length - 1; i >= 0; i -= 1) this[s].insertBefore(_a4.childNodes[i], this[s].childNodes[0]);
         } else if (e instanceof n) for (i = 0; i < e.length; i += 1) this[s].insertBefore(e[i], this[s].childNodes[0]);else this[s].insertBefore(e, this[s].childNodes[0]);
         return this;
       },
       next: function next(e) {
         return this.length > 0 ? e ? this[0].nextElementSibling && d(this[0].nextElementSibling).is(e) ? d([this[0].nextElementSibling]) : d([]) : this[0].nextElementSibling ? d([this[0].nextElementSibling]) : d([]) : d([]);
       },
       nextAll: function nextAll(e) {
         var t = [];
         var s = this[0];
         if (!s) return d([]);
         for (; s.nextElementSibling;) {
           var _a5 = s.nextElementSibling;
           e ? d(_a5).is(e) && t.push(_a5) : t.push(_a5), s = _a5;
         }
         return d(t);
       },
       prev: function prev(e) {
         if (this.length > 0) {
           var _t15 = this[0];
           return e ? _t15.previousElementSibling && d(_t15.previousElementSibling).is(e) ? d([_t15.previousElementSibling]) : d([]) : _t15.previousElementSibling ? d([_t15.previousElementSibling]) : d([]);
         }
         return d([]);
       },
       prevAll: function prevAll(e) {
         var t = [];
         var s = this[0];
         if (!s) return d([]);
         for (; s.previousElementSibling;) {
           var _a6 = s.previousElementSibling;
           e ? d(_a6).is(e) && t.push(_a6) : t.push(_a6), s = _a6;
         }
         return d(t);
       },
       parent: function parent(e) {
         var t = [];
         for (var _s9 = 0; _s9 < this.length; _s9 += 1) null !== this[_s9].parentNode && (e ? d(this[_s9].parentNode).is(e) && t.push(this[_s9].parentNode) : t.push(this[_s9].parentNode));
         return d(t);
       },
       parents: function parents(e) {
         var t = [];
         for (var _s0 = 0; _s0 < this.length; _s0 += 1) {
           var _a7 = this[_s0].parentNode;
           for (; _a7;) e ? d(_a7).is(e) && t.push(_a7) : t.push(_a7), _a7 = _a7.parentNode;
         }
         return d(t);
       },
       closest: function closest(e) {
         var t = this;
         return void 0 === e ? d([]) : (t.is(e) || (t = t.parents(e).eq(0)), t);
       },
       find: function find(e) {
         var t = [];
         for (var _s1 = 0; _s1 < this.length; _s1 += 1) {
           var _a8 = this[_s1].querySelectorAll(e);
           for (var _e12 = 0; _e12 < _a8.length; _e12 += 1) t.push(_a8[_e12]);
         }
         return d(t);
       },
       children: function children(e) {
         var t = [];
         for (var _s10 = 0; _s10 < this.length; _s10 += 1) {
           var _a9 = this[_s10].children;
           for (var _s11 = 0; _s11 < _a9.length; _s11 += 1) e && !d(_a9[_s11]).is(e) || t.push(_a9[_s11]);
         }
         return d(t);
       },
       filter: function filter(e) {
         return d(o(this, e));
       },
       remove: function remove() {
         for (var _e13 = 0; _e13 < this.length; _e13 += 1) this[_e13].parentNode && this[_e13].parentNode.removeChild(this[_e13]);
         return this;
       }
     };
     function p(e, t) {
       return void 0 === t && (t = 0), setTimeout(e, t);
     }
     function u() {
       return Date.now();
     }
     function h(e, t) {
       void 0 === t && (t = "x");
       var s = r();
       var a, i, n;
       var l = function (e) {
         var t = r();
         var s;
         return t.getComputedStyle && (s = t.getComputedStyle(e, null)), !s && e.currentStyle && (s = e.currentStyle), s || (s = e.style), s;
       }(e);
       return s.WebKitCSSMatrix ? (i = l.transform || l.webkitTransform, i.split(",").length > 6 && (i = i.split(", ").map(function (e) {
         return e.replace(",", ".");
       }).join(", ")), n = new s.WebKitCSSMatrix("none" === i ? "" : i)) : (n = l.MozTransform || l.OTransform || l.MsTransform || l.msTransform || l.transform || l.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), a = n.toString().split(",")), "x" === t && (i = s.WebKitCSSMatrix ? n.m41 : 16 === a.length ? parseFloat(a[12]) : parseFloat(a[4])), "y" === t && (i = s.WebKitCSSMatrix ? n.m42 : 16 === a.length ? parseFloat(a[13]) : parseFloat(a[5])), i || 0;
     }
     function m(e) {
       return "object" == _typeof(e) && null !== e && e.constructor && "Object" === Object.prototype.toString.call(e).slice(8, -1);
     }
     function f(e) {
       return "undefined" != typeof window && void 0 !== window.HTMLElement ? e instanceof HTMLElement : e && (1 === e.nodeType || 11 === e.nodeType);
     }
     function g() {
       var e = Object(arguments.length <= 0 ? void 0 : arguments[0]),
         t = ["__proto__", "constructor", "prototype"];
       for (var _s12 = 1; _s12 < arguments.length; _s12 += 1) {
         var _a0 = _s12 < 0 || arguments.length <= _s12 ? void 0 : arguments[_s12];
         if (null != _a0 && !f(_a0)) {
           var _s13 = Object.keys(Object(_a0)).filter(function (e) {
             return t.indexOf(e) < 0;
           });
           for (var _t16 = 0, _i4 = _s13.length; _t16 < _i4; _t16 += 1) {
             var _i5 = _s13[_t16],
               _r = Object.getOwnPropertyDescriptor(_a0, _i5);
             void 0 !== _r && _r.enumerable && (m(e[_i5]) && m(_a0[_i5]) ? _a0[_i5].__swiper__ ? e[_i5] = _a0[_i5] : g(e[_i5], _a0[_i5]) : !m(e[_i5]) && m(_a0[_i5]) ? (e[_i5] = {}, _a0[_i5].__swiper__ ? e[_i5] = _a0[_i5] : g(e[_i5], _a0[_i5])) : e[_i5] = _a0[_i5]);
           }
         }
       }
       return e;
     }
     function v(e, t, s) {
       e.style.setProperty(t, s);
     }
     function w(e) {
       var t = e.swiper,
         s = e.targetPosition,
         a = e.side;
       var i = r(),
         n = -t.translate;
       var l,
         o = null;
       var d = t.params.speed;
       t.wrapperEl.style.scrollSnapType = "none", i.cancelAnimationFrame(t.cssModeFrameID);
       var c = s > n ? "next" : "prev",
         p = function p(e, t) {
           return "next" === c && e >= t || "prev" === c && e <= t;
         },
         _u = function u() {
           l = new Date().getTime(), null === o && (o = l);
           var e = Math.max(Math.min((l - o) / d, 1), 0),
             r = .5 - Math.cos(e * Math.PI) / 2;
           var c = n + r * (s - n);
           if (p(c, s) && (c = s), t.wrapperEl.scrollTo(_defineProperty({}, a, c)), p(c, s)) return t.wrapperEl.style.overflow = "hidden", t.wrapperEl.style.scrollSnapType = "", setTimeout(function () {
             t.wrapperEl.style.overflow = "", t.wrapperEl.scrollTo(_defineProperty({}, a, c));
           }), void i.cancelAnimationFrame(t.cssModeFrameID);
           t.cssModeFrameID = i.requestAnimationFrame(_u);
         };
       _u();
     }
     var b, x, y;
     function E() {
       return b || (b = function () {
         var e = r(),
           t = a();
         return {
           smoothScroll: t.documentElement && "scrollBehavior" in t.documentElement.style,
           touch: !!("ontouchstart" in e || e.DocumentTouch && t instanceof e.DocumentTouch),
           passiveListener: function () {
             var t = !1;
             try {
               var _s14 = Object.defineProperty({}, "passive", {
                 get: function get() {
                   t = !0;
                 }
               });
               e.addEventListener("testPassiveListener", null, _s14);
             } catch (e) {}
             return t;
           }(),
           gestures: "ongesturestart" in e
         };
       }()), b;
     }
     function C(e) {
       return void 0 === e && (e = {}), x || (x = function (e) {
         var _ref = void 0 === e ? {} : e,
           t = _ref.userAgent;
         var s = E(),
           a = r(),
           i = a.navigator.platform,
           n = t || a.navigator.userAgent,
           l = {
             ios: !1,
             android: !1
           },
           o = a.screen.width,
           d = a.screen.height,
           c = n.match(/(Android);?[\s\/]+([\d.]+)?/);
         var p = n.match(/(iPad).*OS\s([\d_]+)/);
         var u = n.match(/(iPod)(.*OS\s([\d_]+))?/),
           h = !p && n.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
           m = "Win32" === i;
         var f = "MacIntel" === i;
         return !p && f && s.touch && ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"].indexOf("".concat(o, "x").concat(d)) >= 0 && (p = n.match(/(Version)\/([\d.]+)/), p || (p = [0, 1, "13_0_0"]), f = !1), c && !m && (l.os = "android", l.android = !0), (p || h || u) && (l.os = "ios", l.ios = !0), l;
       }(e)), x;
     }
     function T() {
       return y || (y = function () {
         var e = r();
         return {
           isSafari: function () {
             var t = e.navigator.userAgent.toLowerCase();
             return t.indexOf("safari") >= 0 && t.indexOf("chrome") < 0 && t.indexOf("android") < 0;
           }(),
           isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent)
         };
       }()), y;
     }
     Object.keys(c).forEach(function (e) {
       Object.defineProperty(d.fn, e, {
         value: c[e],
         writable: !0
       });
     });
     var $ = {
       on: function on(e, t, s) {
         var a = this;
         if (!a.eventsListeners || a.destroyed) return a;
         if ("function" != typeof t) return a;
         var i = s ? "unshift" : "push";
         return e.split(" ").forEach(function (e) {
           a.eventsListeners[e] || (a.eventsListeners[e] = []), a.eventsListeners[e][i](t);
         }), a;
       },
       once: function once(e, t, s) {
         var a = this;
         if (!a.eventsListeners || a.destroyed) return a;
         if ("function" != typeof t) return a;
         function i() {
           a.off(e, i), i.__emitterProxy && delete i.__emitterProxy;
           for (var s = arguments.length, r = new Array(s), n = 0; n < s; n++) r[n] = arguments[n];
           t.apply(a, r);
         }
         return i.__emitterProxy = t, a.on(e, i, s);
       },
       onAny: function onAny(e, t) {
         var s = this;
         if (!s.eventsListeners || s.destroyed) return s;
         if ("function" != typeof e) return s;
         var a = t ? "unshift" : "push";
         return s.eventsAnyListeners.indexOf(e) < 0 && s.eventsAnyListeners[a](e), s;
       },
       offAny: function offAny(e) {
         var t = this;
         if (!t.eventsListeners || t.destroyed) return t;
         if (!t.eventsAnyListeners) return t;
         var s = t.eventsAnyListeners.indexOf(e);
         return s >= 0 && t.eventsAnyListeners.splice(s, 1), t;
       },
       off: function off(e, t) {
         var s = this;
         return !s.eventsListeners || s.destroyed ? s : s.eventsListeners ? (e.split(" ").forEach(function (e) {
           void 0 === t ? s.eventsListeners[e] = [] : s.eventsListeners[e] && s.eventsListeners[e].forEach(function (a, i) {
             (a === t || a.__emitterProxy && a.__emitterProxy === t) && s.eventsListeners[e].splice(i, 1);
           });
         }), s) : s;
       },
       emit: function emit() {
         var e = this;
         if (!e.eventsListeners || e.destroyed) return e;
         if (!e.eventsListeners) return e;
         var t, s, a;
         for (var i = arguments.length, r = new Array(i), n = 0; n < i; n++) r[n] = arguments[n];
         "string" == typeof r[0] || Array.isArray(r[0]) ? (t = r[0], s = r.slice(1, r.length), a = e) : (t = r[0].events, s = r[0].data, a = r[0].context || e), s.unshift(a);
         return (Array.isArray(t) ? t : t.split(" ")).forEach(function (t) {
           e.eventsAnyListeners && e.eventsAnyListeners.length && e.eventsAnyListeners.forEach(function (e) {
             e.apply(a, [t].concat(_toConsumableArray(s)));
           }), e.eventsListeners && e.eventsListeners[t] && e.eventsListeners[t].forEach(function (e) {
             e.apply(a, s);
           });
         }), e;
       }
     };
     var S = {
       updateSize: function updateSize() {
         var e = this;
         var t, s;
         var a = e.$el;
         t = void 0 !== e.params.width && null !== e.params.width ? e.params.width : a[0].clientWidth, s = void 0 !== e.params.height && null !== e.params.height ? e.params.height : a[0].clientHeight, 0 === t && e.isHorizontal() || 0 === s && e.isVertical() || (t = t - parseInt(a.css("padding-left") || 0, 10) - parseInt(a.css("padding-right") || 0, 10), s = s - parseInt(a.css("padding-top") || 0, 10) - parseInt(a.css("padding-bottom") || 0, 10), Number.isNaN(t) && (t = 0), Number.isNaN(s) && (s = 0), Object.assign(e, {
           width: t,
           height: s,
           size: e.isHorizontal() ? t : s
         }));
       },
       updateSlides: function updateSlides() {
         var e = this;
         function t(t) {
           return e.isHorizontal() ? t : {
             width: "height",
             "margin-top": "margin-left",
             "margin-bottom ": "margin-right",
             "margin-left": "margin-top",
             "margin-right": "margin-bottom",
             "padding-left": "padding-top",
             "padding-right": "padding-bottom",
             marginRight: "marginBottom"
           }[t];
         }
         function s(e, s) {
           return parseFloat(e.getPropertyValue(t(s)) || 0);
         }
         var a = e.params,
           i = e.$wrapperEl,
           r = e.size,
           n = e.rtlTranslate,
           l = e.wrongRTL,
           o = e.virtual && a.virtual.enabled,
           d = o ? e.virtual.slides.length : e.slides.length,
           c = i.children(".".concat(e.params.slideClass)),
           p = o ? e.virtual.slides.length : c.length;
         var u = [];
         var h = [],
           m = [];
         var f = a.slidesOffsetBefore;
         "function" == typeof f && (f = a.slidesOffsetBefore.call(e));
         var g = a.slidesOffsetAfter;
         "function" == typeof g && (g = a.slidesOffsetAfter.call(e));
         var w = e.snapGrid.length,
           b = e.slidesGrid.length;
         var x = a.spaceBetween,
           y = -f,
           E = 0,
           C = 0;
         if (void 0 === r) return;
         "string" == typeof x && x.indexOf("%") >= 0 && (x = parseFloat(x.replace("%", "")) / 100 * r), e.virtualSize = -x, n ? c.css({
           marginLeft: "",
           marginBottom: "",
           marginTop: ""
         }) : c.css({
           marginRight: "",
           marginBottom: "",
           marginTop: ""
         }), a.centeredSlides && a.cssMode && (v(e.wrapperEl, "--swiper-centered-offset-before", ""), v(e.wrapperEl, "--swiper-centered-offset-after", ""));
         var T = a.grid && a.grid.rows > 1 && e.grid;
         var $;
         T && e.grid.initSlides(p);
         var S = "auto" === a.slidesPerView && a.breakpoints && Object.keys(a.breakpoints).filter(function (e) {
           return void 0 !== a.breakpoints[e].slidesPerView;
         }).length > 0;
         for (var _i6 = 0; _i6 < p; _i6 += 1) {
           $ = 0;
           var _n2 = c.eq(_i6);
           if (T && e.grid.updateSlide(_i6, _n2, p, t), "none" !== _n2.css("display")) {
             if ("auto" === a.slidesPerView) {
               S && (c[_i6].style[t("width")] = "");
               var _r2 = getComputedStyle(_n2[0]),
                 _l2 = _n2[0].style.transform,
                 _o2 = _n2[0].style.webkitTransform;
               if (_l2 && (_n2[0].style.transform = "none"), _o2 && (_n2[0].style.webkitTransform = "none"), a.roundLengths) $ = e.isHorizontal() ? _n2.outerWidth(!0) : _n2.outerHeight(!0);else {
                 var _e14 = s(_r2, "width"),
                   _t17 = s(_r2, "padding-left"),
                   _a1 = s(_r2, "padding-right"),
                   _i7 = s(_r2, "margin-left"),
                   _l3 = s(_r2, "margin-right"),
                   _o3 = _r2.getPropertyValue("box-sizing");
                 if (_o3 && "border-box" === _o3) $ = _e14 + _i7 + _l3;else {
                   var _n2$ = _n2[0],
                     _s15 = _n2$.clientWidth,
                     _r3 = _n2$.offsetWidth;
                   $ = _e14 + _t17 + _a1 + _i7 + _l3 + (_r3 - _s15);
                 }
               }
               _l2 && (_n2[0].style.transform = _l2), _o2 && (_n2[0].style.webkitTransform = _o2), a.roundLengths && ($ = Math.floor($));
             } else $ = (r - (a.slidesPerView - 1) * x) / a.slidesPerView, a.roundLengths && ($ = Math.floor($)), c[_i6] && (c[_i6].style[t("width")] = "".concat($, "px"));
             c[_i6] && (c[_i6].swiperSlideSize = $), m.push($), a.centeredSlides ? (y = y + $ / 2 + E / 2 + x, 0 === E && 0 !== _i6 && (y = y - r / 2 - x), 0 === _i6 && (y = y - r / 2 - x), Math.abs(y) < .001 && (y = 0), a.roundLengths && (y = Math.floor(y)), C % a.slidesPerGroup == 0 && u.push(y), h.push(y)) : (a.roundLengths && (y = Math.floor(y)), (C - Math.min(e.params.slidesPerGroupSkip, C)) % e.params.slidesPerGroup == 0 && u.push(y), h.push(y), y = y + $ + x), e.virtualSize += $ + x, E = $, C += 1;
           }
         }
         if (e.virtualSize = Math.max(e.virtualSize, r) + g, n && l && ("slide" === a.effect || "coverflow" === a.effect) && i.css({
           width: "".concat(e.virtualSize + a.spaceBetween, "px")
         }), a.setWrapperSize && i.css(_defineProperty({}, t("width"), "".concat(e.virtualSize + a.spaceBetween, "px"))), T && e.grid.updateWrapperSize($, u, t), !a.centeredSlides) {
           var _t18 = [];
           for (var _s16 = 0; _s16 < u.length; _s16 += 1) {
             var _i8 = u[_s16];
             a.roundLengths && (_i8 = Math.floor(_i8)), u[_s16] <= e.virtualSize - r && _t18.push(_i8);
           }
           u = _t18, Math.floor(e.virtualSize - r) - Math.floor(u[u.length - 1]) > 1 && u.push(e.virtualSize - r);
         }
         if (0 === u.length && (u = [0]), 0 !== a.spaceBetween) {
           var _s17 = e.isHorizontal() && n ? "marginLeft" : t("marginRight");
           c.filter(function (e, t) {
             return !a.cssMode || t !== c.length - 1;
           }).css(_defineProperty({}, _s17, "".concat(x, "px")));
         }
         if (a.centeredSlides && a.centeredSlidesBounds) {
           var _e15 = 0;
           m.forEach(function (t) {
             _e15 += t + (a.spaceBetween ? a.spaceBetween : 0);
           }), _e15 -= a.spaceBetween;
           var _t19 = _e15 - r;
           u = u.map(function (e) {
             return e < 0 ? -f : e > _t19 ? _t19 + g : e;
           });
         }
         if (a.centerInsufficientSlides) {
           var _e16 = 0;
           if (m.forEach(function (t) {
             _e16 += t + (a.spaceBetween ? a.spaceBetween : 0);
           }), _e16 -= a.spaceBetween, _e16 < r) {
             var _t20 = (r - _e16) / 2;
             u.forEach(function (e, s) {
               u[s] = e - _t20;
             }), h.forEach(function (e, s) {
               h[s] = e + _t20;
             });
           }
         }
         if (Object.assign(e, {
           slides: c,
           snapGrid: u,
           slidesGrid: h,
           slidesSizesGrid: m
         }), a.centeredSlides && a.cssMode && !a.centeredSlidesBounds) {
           v(e.wrapperEl, "--swiper-centered-offset-before", -u[0] + "px"), v(e.wrapperEl, "--swiper-centered-offset-after", e.size / 2 - m[m.length - 1] / 2 + "px");
           var _t21 = -e.snapGrid[0],
             _s18 = -e.slidesGrid[0];
           e.snapGrid = e.snapGrid.map(function (e) {
             return e + _t21;
           }), e.slidesGrid = e.slidesGrid.map(function (e) {
             return e + _s18;
           });
         }
         if (p !== d && e.emit("slidesLengthChange"), u.length !== w && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), h.length !== b && e.emit("slidesGridLengthChange"), a.watchSlidesProgress && e.updateSlidesOffset(), !(o || a.cssMode || "slide" !== a.effect && "fade" !== a.effect)) {
           var _t22 = "".concat(a.containerModifierClass, "backface-hidden"),
             _s19 = e.$el.hasClass(_t22);
           p <= a.maxBackfaceHiddenSlides ? _s19 || e.$el.addClass(_t22) : _s19 && e.$el.removeClass(_t22);
         }
       },
       updateAutoHeight: function updateAutoHeight(e) {
         var t = this,
           s = [],
           a = t.virtual && t.params.virtual.enabled;
         var i,
           r = 0;
         "number" == typeof e ? t.setTransition(e) : !0 === e && t.setTransition(t.params.speed);
         var n = function n(e) {
           return a ? t.slides.filter(function (t) {
             return parseInt(t.getAttribute("data-swiper-slide-index"), 10) === e;
           })[0] : t.slides.eq(e)[0];
         };
         if ("auto" !== t.params.slidesPerView && t.params.slidesPerView > 1) {
           if (t.params.centeredSlides) (t.visibleSlides || d([])).each(function (e) {
             s.push(e);
           });else for (i = 0; i < Math.ceil(t.params.slidesPerView); i += 1) {
             var _e17 = t.activeIndex + i;
             if (_e17 > t.slides.length && !a) break;
             s.push(n(_e17));
           }
         } else s.push(n(t.activeIndex));
         for (i = 0; i < s.length; i += 1) if (void 0 !== s[i]) {
           var _e18 = s[i].offsetHeight;
           r = _e18 > r ? _e18 : r;
         }
         (r || 0 === r) && t.$wrapperEl.css("height", "".concat(r, "px"));
       },
       updateSlidesOffset: function updateSlidesOffset() {
         var e = this,
           t = e.slides;
         for (var _s20 = 0; _s20 < t.length; _s20 += 1) t[_s20].swiperSlideOffset = e.isHorizontal() ? t[_s20].offsetLeft : t[_s20].offsetTop;
       },
       updateSlidesProgress: function updateSlidesProgress(e) {
         void 0 === e && (e = this && this.translate || 0);
         var t = this,
           s = t.params,
           a = t.slides,
           i = t.rtlTranslate,
           r = t.snapGrid;
         if (0 === a.length) return;
         void 0 === a[0].swiperSlideOffset && t.updateSlidesOffset();
         var n = -e;
         i && (n = e), a.removeClass(s.slideVisibleClass), t.visibleSlidesIndexes = [], t.visibleSlides = [];
         for (var _e19 = 0; _e19 < a.length; _e19 += 1) {
           var _l4 = a[_e19];
           var _o4 = _l4.swiperSlideOffset;
           s.cssMode && s.centeredSlides && (_o4 -= a[0].swiperSlideOffset);
           var _d2 = (n + (s.centeredSlides ? t.minTranslate() : 0) - _o4) / (_l4.swiperSlideSize + s.spaceBetween),
             _c2 = (n - r[0] + (s.centeredSlides ? t.minTranslate() : 0) - _o4) / (_l4.swiperSlideSize + s.spaceBetween),
             _p = -(n - _o4),
             _u2 = _p + t.slidesSizesGrid[_e19];
           (_p >= 0 && _p < t.size - 1 || _u2 > 1 && _u2 <= t.size || _p <= 0 && _u2 >= t.size) && (t.visibleSlides.push(_l4), t.visibleSlidesIndexes.push(_e19), a.eq(_e19).addClass(s.slideVisibleClass)), _l4.progress = i ? -_d2 : _d2, _l4.originalProgress = i ? -_c2 : _c2;
         }
         t.visibleSlides = d(t.visibleSlides);
       },
       updateProgress: function updateProgress(e) {
         var t = this;
         if (void 0 === e) {
           var _s21 = t.rtlTranslate ? -1 : 1;
           e = t && t.translate && t.translate * _s21 || 0;
         }
         var s = t.params,
           a = t.maxTranslate() - t.minTranslate();
         var i = t.progress,
           r = t.isBeginning,
           n = t.isEnd;
         var l = r,
           o = n;
         0 === a ? (i = 0, r = !0, n = !0) : (i = (e - t.minTranslate()) / a, r = i <= 0, n = i >= 1), Object.assign(t, {
           progress: i,
           isBeginning: r,
           isEnd: n
         }), (s.watchSlidesProgress || s.centeredSlides && s.autoHeight) && t.updateSlidesProgress(e), r && !l && t.emit("reachBeginning toEdge"), n && !o && t.emit("reachEnd toEdge"), (l && !r || o && !n) && t.emit("fromEdge"), t.emit("progress", i);
       },
       updateSlidesClasses: function updateSlidesClasses() {
         var e = this,
           t = e.slides,
           s = e.params,
           a = e.$wrapperEl,
           i = e.activeIndex,
           r = e.realIndex,
           n = e.virtual && s.virtual.enabled;
         var l;
         t.removeClass("".concat(s.slideActiveClass, " ").concat(s.slideNextClass, " ").concat(s.slidePrevClass, " ").concat(s.slideDuplicateActiveClass, " ").concat(s.slideDuplicateNextClass, " ").concat(s.slideDuplicatePrevClass)), l = n ? e.$wrapperEl.find(".".concat(s.slideClass, "[data-swiper-slide-index=\"").concat(i, "\"]")) : t.eq(i), l.addClass(s.slideActiveClass), s.loop && (l.hasClass(s.slideDuplicateClass) ? a.children(".".concat(s.slideClass, ":not(.").concat(s.slideDuplicateClass, ")[data-swiper-slide-index=\"").concat(r, "\"]")).addClass(s.slideDuplicateActiveClass) : a.children(".".concat(s.slideClass, ".").concat(s.slideDuplicateClass, "[data-swiper-slide-index=\"").concat(r, "\"]")).addClass(s.slideDuplicateActiveClass));
         var o = l.nextAll(".".concat(s.slideClass)).eq(0).addClass(s.slideNextClass);
         s.loop && 0 === o.length && (o = t.eq(0), o.addClass(s.slideNextClass));
         var d = l.prevAll(".".concat(s.slideClass)).eq(0).addClass(s.slidePrevClass);
         s.loop && 0 === d.length && (d = t.eq(-1), d.addClass(s.slidePrevClass)), s.loop && (o.hasClass(s.slideDuplicateClass) ? a.children(".".concat(s.slideClass, ":not(.").concat(s.slideDuplicateClass, ")[data-swiper-slide-index=\"").concat(o.attr("data-swiper-slide-index"), "\"]")).addClass(s.slideDuplicateNextClass) : a.children(".".concat(s.slideClass, ".").concat(s.slideDuplicateClass, "[data-swiper-slide-index=\"").concat(o.attr("data-swiper-slide-index"), "\"]")).addClass(s.slideDuplicateNextClass), d.hasClass(s.slideDuplicateClass) ? a.children(".".concat(s.slideClass, ":not(.").concat(s.slideDuplicateClass, ")[data-swiper-slide-index=\"").concat(d.attr("data-swiper-slide-index"), "\"]")).addClass(s.slideDuplicatePrevClass) : a.children(".".concat(s.slideClass, ".").concat(s.slideDuplicateClass, "[data-swiper-slide-index=\"").concat(d.attr("data-swiper-slide-index"), "\"]")).addClass(s.slideDuplicatePrevClass)), e.emitSlidesClasses();
       },
       updateActiveIndex: function updateActiveIndex(e) {
         var t = this,
           s = t.rtlTranslate ? t.translate : -t.translate,
           a = t.slidesGrid,
           i = t.snapGrid,
           r = t.params,
           n = t.activeIndex,
           l = t.realIndex,
           o = t.snapIndex;
         var d,
           c = e;
         if (void 0 === c) {
           for (var _e20 = 0; _e20 < a.length; _e20 += 1) void 0 !== a[_e20 + 1] ? s >= a[_e20] && s < a[_e20 + 1] - (a[_e20 + 1] - a[_e20]) / 2 ? c = _e20 : s >= a[_e20] && s < a[_e20 + 1] && (c = _e20 + 1) : s >= a[_e20] && (c = _e20);
           r.normalizeSlideIndex && (c < 0 || void 0 === c) && (c = 0);
         }
         if (i.indexOf(s) >= 0) d = i.indexOf(s);else {
           var _e21 = Math.min(r.slidesPerGroupSkip, c);
           d = _e21 + Math.floor((c - _e21) / r.slidesPerGroup);
         }
         if (d >= i.length && (d = i.length - 1), c === n) return void (d !== o && (t.snapIndex = d, t.emit("snapIndexChange")));
         var p = parseInt(t.slides.eq(c).attr("data-swiper-slide-index") || c, 10);
         Object.assign(t, {
           snapIndex: d,
           realIndex: p,
           previousIndex: n,
           activeIndex: c
         }), t.emit("activeIndexChange"), t.emit("snapIndexChange"), l !== p && t.emit("realIndexChange"), (t.initialized || t.params.runCallbacksOnInit) && t.emit("slideChange");
       },
       updateClickedSlide: function updateClickedSlide(e) {
         var t = this,
           s = t.params,
           a = d(e).closest(".".concat(s.slideClass))[0];
         var i,
           r = !1;
         if (a) for (var _e22 = 0; _e22 < t.slides.length; _e22 += 1) if (t.slides[_e22] === a) {
           r = !0, i = _e22;
           break;
         }
         if (!a || !r) return t.clickedSlide = void 0, void (t.clickedIndex = void 0);
         t.clickedSlide = a, t.virtual && t.params.virtual.enabled ? t.clickedIndex = parseInt(d(a).attr("data-swiper-slide-index"), 10) : t.clickedIndex = i, s.slideToClickedSlide && void 0 !== t.clickedIndex && t.clickedIndex !== t.activeIndex && t.slideToClickedSlide();
       }
     };
     var M = {
       getTranslate: function getTranslate(e) {
         void 0 === e && (e = this.isHorizontal() ? "x" : "y");
         var t = this.params,
           s = this.rtlTranslate,
           a = this.translate,
           i = this.$wrapperEl;
         if (t.virtualTranslate) return s ? -a : a;
         if (t.cssMode) return a;
         var r = h(i[0], e);
         return s && (r = -r), r || 0;
       },
       setTranslate: function setTranslate(e, t) {
         var s = this,
           a = s.rtlTranslate,
           i = s.params,
           r = s.$wrapperEl,
           n = s.wrapperEl,
           l = s.progress;
         var o,
           d = 0,
           c = 0;
         s.isHorizontal() ? d = a ? -e : e : c = e, i.roundLengths && (d = Math.floor(d), c = Math.floor(c)), i.cssMode ? n[s.isHorizontal() ? "scrollLeft" : "scrollTop"] = s.isHorizontal() ? -d : -c : i.virtualTranslate || r.transform("translate3d(".concat(d, "px, ").concat(c, "px, 0px)")), s.previousTranslate = s.translate, s.translate = s.isHorizontal() ? d : c;
         var p = s.maxTranslate() - s.minTranslate();
         o = 0 === p ? 0 : (e - s.minTranslate()) / p, o !== l && s.updateProgress(e), s.emit("setTranslate", s.translate, t);
       },
       minTranslate: function minTranslate() {
         return -this.snapGrid[0];
       },
       maxTranslate: function maxTranslate() {
         return -this.snapGrid[this.snapGrid.length - 1];
       },
       translateTo: function translateTo(e, t, s, a, i) {
         void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === s && (s = !0), void 0 === a && (a = !0);
         var r = this,
           n = r.params,
           l = r.wrapperEl;
         if (r.animating && n.preventInteractionOnTransition) return !1;
         var o = r.minTranslate(),
           d = r.maxTranslate();
         var c;
         if (c = a && e > o ? o : a && e < d ? d : e, r.updateProgress(c), n.cssMode) {
           var _e23 = r.isHorizontal();
           if (0 === t) l[_e23 ? "scrollLeft" : "scrollTop"] = -c;else {
             if (!r.support.smoothScroll) return w({
               swiper: r,
               targetPosition: -c,
               side: _e23 ? "left" : "top"
             }), !0;
             l.scrollTo(_defineProperty(_defineProperty({}, _e23 ? "left" : "top", -c), "behavior", "smooth"));
           }
           return !0;
         }
         return 0 === t ? (r.setTransition(0), r.setTranslate(c), s && (r.emit("beforeTransitionStart", t, i), r.emit("transitionEnd"))) : (r.setTransition(t), r.setTranslate(c), s && (r.emit("beforeTransitionStart", t, i), r.emit("transitionStart")), r.animating || (r.animating = !0, r.onTranslateToWrapperTransitionEnd || (r.onTranslateToWrapperTransitionEnd = function (e) {
           r && !r.destroyed && e.target === this && (r.$wrapperEl[0].removeEventListener("transitionend", r.onTranslateToWrapperTransitionEnd), r.$wrapperEl[0].removeEventListener("webkitTransitionEnd", r.onTranslateToWrapperTransitionEnd), r.onTranslateToWrapperTransitionEnd = null, delete r.onTranslateToWrapperTransitionEnd, s && r.emit("transitionEnd"));
         }), r.$wrapperEl[0].addEventListener("transitionend", r.onTranslateToWrapperTransitionEnd), r.$wrapperEl[0].addEventListener("webkitTransitionEnd", r.onTranslateToWrapperTransitionEnd))), !0;
       }
     };
     function P(e) {
       var t = e.swiper,
         s = e.runCallbacks,
         a = e.direction,
         i = e.step;
       var r = t.activeIndex,
         n = t.previousIndex;
       var l = a;
       if (l || (l = r > n ? "next" : r < n ? "prev" : "reset"), t.emit("transition".concat(i)), s && r !== n) {
         if ("reset" === l) return void t.emit("slideResetTransition".concat(i));
         t.emit("slideChangeTransition".concat(i)), "next" === l ? t.emit("slideNextTransition".concat(i)) : t.emit("slidePrevTransition".concat(i));
       }
     }
     var k = {
       slideTo: function slideTo(e, t, s, a, i) {
         if (void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === s && (s = !0), "number" != typeof e && "string" != typeof e) throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. [".concat(_typeof(e), "] given."));
         if ("string" == typeof e) {
           var _t23 = parseInt(e, 10);
           if (!isFinite(_t23)) throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [".concat(e, "] given."));
           e = _t23;
         }
         var r = this;
         var n = e;
         n < 0 && (n = 0);
         var l = r.params,
           o = r.snapGrid,
           d = r.slidesGrid,
           c = r.previousIndex,
           p = r.activeIndex,
           u = r.rtlTranslate,
           h = r.wrapperEl,
           m = r.enabled;
         if (r.animating && l.preventInteractionOnTransition || !m && !a && !i) return !1;
         var f = Math.min(r.params.slidesPerGroupSkip, n);
         var g = f + Math.floor((n - f) / r.params.slidesPerGroup);
         g >= o.length && (g = o.length - 1), (p || l.initialSlide || 0) === (c || 0) && s && r.emit("beforeSlideChangeStart");
         var v = -o[g];
         if (r.updateProgress(v), l.normalizeSlideIndex) for (var _e24 = 0; _e24 < d.length; _e24 += 1) {
           var _t24 = -Math.floor(100 * v),
             _s22 = Math.floor(100 * d[_e24]),
             _a10 = Math.floor(100 * d[_e24 + 1]);
           void 0 !== d[_e24 + 1] ? _t24 >= _s22 && _t24 < _a10 - (_a10 - _s22) / 2 ? n = _e24 : _t24 >= _s22 && _t24 < _a10 && (n = _e24 + 1) : _t24 >= _s22 && (n = _e24);
         }
         if (r.initialized && n !== p) {
           if (!r.allowSlideNext && v < r.translate && v < r.minTranslate()) return !1;
           if (!r.allowSlidePrev && v > r.translate && v > r.maxTranslate() && (p || 0) !== n) return !1;
         }
         var b;
         if (b = n > p ? "next" : n < p ? "prev" : "reset", u && -v === r.translate || !u && v === r.translate) return r.updateActiveIndex(n), l.autoHeight && r.updateAutoHeight(), r.updateSlidesClasses(), "slide" !== l.effect && r.setTranslate(v), "reset" !== b && (r.transitionStart(s, b), r.transitionEnd(s, b)), !1;
         if (l.cssMode) {
           var _e25 = r.isHorizontal(),
             _s23 = u ? v : -v;
           if (0 === t) {
             var _t25 = r.virtual && r.params.virtual.enabled;
             _t25 && (r.wrapperEl.style.scrollSnapType = "none", r._immediateVirtual = !0), h[_e25 ? "scrollLeft" : "scrollTop"] = _s23, _t25 && requestAnimationFrame(function () {
               r.wrapperEl.style.scrollSnapType = "", r._swiperImmediateVirtual = !1;
             });
           } else {
             if (!r.support.smoothScroll) return w({
               swiper: r,
               targetPosition: _s23,
               side: _e25 ? "left" : "top"
             }), !0;
             h.scrollTo(_defineProperty(_defineProperty({}, _e25 ? "left" : "top", _s23), "behavior", "smooth"));
           }
           return !0;
         }
         return r.setTransition(t), r.setTranslate(v), r.updateActiveIndex(n), r.updateSlidesClasses(), r.emit("beforeTransitionStart", t, a), r.transitionStart(s, b), 0 === t ? r.transitionEnd(s, b) : r.animating || (r.animating = !0, r.onSlideToWrapperTransitionEnd || (r.onSlideToWrapperTransitionEnd = function (e) {
           r && !r.destroyed && e.target === this && (r.$wrapperEl[0].removeEventListener("transitionend", r.onSlideToWrapperTransitionEnd), r.$wrapperEl[0].removeEventListener("webkitTransitionEnd", r.onSlideToWrapperTransitionEnd), r.onSlideToWrapperTransitionEnd = null, delete r.onSlideToWrapperTransitionEnd, r.transitionEnd(s, b));
         }), r.$wrapperEl[0].addEventListener("transitionend", r.onSlideToWrapperTransitionEnd), r.$wrapperEl[0].addEventListener("webkitTransitionEnd", r.onSlideToWrapperTransitionEnd)), !0;
       },
       slideToLoop: function slideToLoop(e, t, s, a) {
         if (void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === s && (s = !0), "string" == typeof e) {
           var _t26 = parseInt(e, 10);
           if (!isFinite(_t26)) throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [".concat(e, "] given."));
           e = _t26;
         }
         var i = this;
         var r = e;
         return i.params.loop && (r += i.loopedSlides), i.slideTo(r, t, s, a);
       },
       slideNext: function slideNext(e, t, s) {
         void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
         var a = this,
           i = a.animating,
           r = a.enabled,
           n = a.params;
         if (!r) return a;
         var l = n.slidesPerGroup;
         "auto" === n.slidesPerView && 1 === n.slidesPerGroup && n.slidesPerGroupAuto && (l = Math.max(a.slidesPerViewDynamic("current", !0), 1));
         var o = a.activeIndex < n.slidesPerGroupSkip ? 1 : l;
         if (n.loop) {
           if (i && n.loopPreventsSlide) return !1;
           a.loopFix(), a._clientLeft = a.$wrapperEl[0].clientLeft;
         }
         return n.rewind && a.isEnd ? a.slideTo(0, e, t, s) : a.slideTo(a.activeIndex + o, e, t, s);
       },
       slidePrev: function slidePrev(e, t, s) {
         void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
         var a = this,
           i = a.params,
           r = a.animating,
           n = a.snapGrid,
           l = a.slidesGrid,
           o = a.rtlTranslate,
           d = a.enabled;
         if (!d) return a;
         if (i.loop) {
           if (r && i.loopPreventsSlide) return !1;
           a.loopFix(), a._clientLeft = a.$wrapperEl[0].clientLeft;
         }
         function c(e) {
           return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
         }
         var p = c(o ? a.translate : -a.translate),
           u = n.map(function (e) {
             return c(e);
           });
         var h = n[u.indexOf(p) - 1];
         if (void 0 === h && i.cssMode) {
           var _e26;
           n.forEach(function (t, s) {
             p >= t && (_e26 = s);
           }), void 0 !== _e26 && (h = n[_e26 > 0 ? _e26 - 1 : _e26]);
         }
         var m = 0;
         if (void 0 !== h && (m = l.indexOf(h), m < 0 && (m = a.activeIndex - 1), "auto" === i.slidesPerView && 1 === i.slidesPerGroup && i.slidesPerGroupAuto && (m = m - a.slidesPerViewDynamic("previous", !0) + 1, m = Math.max(m, 0))), i.rewind && a.isBeginning) {
           var _i9 = a.params.virtual && a.params.virtual.enabled && a.virtual ? a.virtual.slides.length - 1 : a.slides.length - 1;
           return a.slideTo(_i9, e, t, s);
         }
         return a.slideTo(m, e, t, s);
       },
       slideReset: function slideReset(e, t, s) {
         return void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), this.slideTo(this.activeIndex, e, t, s);
       },
       slideToClosest: function slideToClosest(e, t, s, a) {
         void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), void 0 === a && (a = .5);
         var i = this;
         var r = i.activeIndex;
         var n = Math.min(i.params.slidesPerGroupSkip, r),
           l = n + Math.floor((r - n) / i.params.slidesPerGroup),
           o = i.rtlTranslate ? i.translate : -i.translate;
         if (o >= i.snapGrid[l]) {
           var _e27 = i.snapGrid[l];
           o - _e27 > (i.snapGrid[l + 1] - _e27) * a && (r += i.params.slidesPerGroup);
         } else {
           var _e28 = i.snapGrid[l - 1];
           o - _e28 <= (i.snapGrid[l] - _e28) * a && (r -= i.params.slidesPerGroup);
         }
         return r = Math.max(r, 0), r = Math.min(r, i.slidesGrid.length - 1), i.slideTo(r, e, t, s);
       },
       slideToClickedSlide: function slideToClickedSlide() {
         var e = this,
           t = e.params,
           s = e.$wrapperEl,
           a = "auto" === t.slidesPerView ? e.slidesPerViewDynamic() : t.slidesPerView;
         var i,
           r = e.clickedIndex;
         if (t.loop) {
           if (e.animating) return;
           i = parseInt(d(e.clickedSlide).attr("data-swiper-slide-index"), 10), t.centeredSlides ? r < e.loopedSlides - a / 2 || r > e.slides.length - e.loopedSlides + a / 2 ? (e.loopFix(), r = s.children(".".concat(t.slideClass, "[data-swiper-slide-index=\"").concat(i, "\"]:not(.").concat(t.slideDuplicateClass, ")")).eq(0).index(), p(function () {
             e.slideTo(r);
           })) : e.slideTo(r) : r > e.slides.length - a ? (e.loopFix(), r = s.children(".".concat(t.slideClass, "[data-swiper-slide-index=\"").concat(i, "\"]:not(.").concat(t.slideDuplicateClass, ")")).eq(0).index(), p(function () {
             e.slideTo(r);
           })) : e.slideTo(r);
         } else e.slideTo(r);
       }
     };
     var z = {
       loopCreate: function loopCreate() {
         var e = this,
           t = a(),
           s = e.params,
           i = e.$wrapperEl,
           r = i.children().length > 0 ? d(i.children()[0].parentNode) : i;
         r.children(".".concat(s.slideClass, ".").concat(s.slideDuplicateClass)).remove();
         var n = r.children(".".concat(s.slideClass));
         if (s.loopFillGroupWithBlank) {
           var _e29 = s.slidesPerGroup - n.length % s.slidesPerGroup;
           if (_e29 !== s.slidesPerGroup) {
             for (var _a11 = 0; _a11 < _e29; _a11 += 1) {
               var _e30 = d(t.createElement("div")).addClass("".concat(s.slideClass, " ").concat(s.slideBlankClass));
               r.append(_e30);
             }
             n = r.children(".".concat(s.slideClass));
           }
         }
         "auto" !== s.slidesPerView || s.loopedSlides || (s.loopedSlides = n.length), e.loopedSlides = Math.ceil(parseFloat(s.loopedSlides || s.slidesPerView, 10)), e.loopedSlides += s.loopAdditionalSlides, e.loopedSlides > n.length && (e.loopedSlides = n.length);
         var l = [],
           o = [];
         n.each(function (t, s) {
           var a = d(t);
           s < e.loopedSlides && o.push(t), s < n.length && s >= n.length - e.loopedSlides && l.push(t), a.attr("data-swiper-slide-index", s);
         });
         for (var _e31 = 0; _e31 < o.length; _e31 += 1) r.append(d(o[_e31].cloneNode(!0)).addClass(s.slideDuplicateClass));
         for (var _e32 = l.length - 1; _e32 >= 0; _e32 -= 1) r.prepend(d(l[_e32].cloneNode(!0)).addClass(s.slideDuplicateClass));
       },
       loopFix: function loopFix() {
         var e = this;
         e.emit("beforeLoopFix");
         var t = e.activeIndex,
           s = e.slides,
           a = e.loopedSlides,
           i = e.allowSlidePrev,
           r = e.allowSlideNext,
           n = e.snapGrid,
           l = e.rtlTranslate;
         var o;
         e.allowSlidePrev = !0, e.allowSlideNext = !0;
         var d = -n[t] - e.getTranslate();
         if (t < a) {
           o = s.length - 3 * a + t, o += a;
           e.slideTo(o, 0, !1, !0) && 0 !== d && e.setTranslate((l ? -e.translate : e.translate) - d);
         } else if (t >= s.length - a) {
           o = -s.length + t + a, o += a;
           e.slideTo(o, 0, !1, !0) && 0 !== d && e.setTranslate((l ? -e.translate : e.translate) - d);
         }
         e.allowSlidePrev = i, e.allowSlideNext = r, e.emit("loopFix");
       },
       loopDestroy: function loopDestroy() {
         var e = this.$wrapperEl,
           t = this.params,
           s = this.slides;
         e.children(".".concat(t.slideClass, ".").concat(t.slideDuplicateClass, ",.").concat(t.slideClass, ".").concat(t.slideBlankClass)).remove(), s.removeAttr("data-swiper-slide-index");
       }
     };
     function L(e) {
       var t = this,
         s = a(),
         i = r(),
         n = t.touchEventsData,
         l = t.params,
         o = t.touches,
         c = t.enabled;
       if (!c) return;
       if (t.animating && l.preventInteractionOnTransition) return;
       !t.animating && l.cssMode && l.loop && t.loopFix();
       var p = e;
       p.originalEvent && (p = p.originalEvent);
       var h = d(p.target);
       if ("wrapper" === l.touchEventsTarget && !h.closest(t.wrapperEl).length) return;
       if (n.isTouchEvent = "touchstart" === p.type, !n.isTouchEvent && "which" in p && 3 === p.which) return;
       if (!n.isTouchEvent && "button" in p && p.button > 0) return;
       if (n.isTouched && n.isMoved) return;
       !!l.noSwipingClass && "" !== l.noSwipingClass && p.target && p.target.shadowRoot && e.path && e.path[0] && (h = d(e.path[0]));
       var m = l.noSwipingSelector ? l.noSwipingSelector : ".".concat(l.noSwipingClass),
         f = !(!p.target || !p.target.shadowRoot);
       if (l.noSwiping && (f ? function (e, t) {
         return void 0 === t && (t = this), function t(s) {
           if (!s || s === a() || s === r()) return null;
           s.assignedSlot && (s = s.assignedSlot);
           var i = s.closest(e);
           return i || s.getRootNode ? i || t(s.getRootNode().host) : null;
         }(t);
       }(m, h[0]) : h.closest(m)[0])) return void (t.allowClick = !0);
       if (l.swipeHandler && !h.closest(l.swipeHandler)[0]) return;
       o.currentX = "touchstart" === p.type ? p.targetTouches[0].pageX : p.pageX, o.currentY = "touchstart" === p.type ? p.targetTouches[0].pageY : p.pageY;
       var g = o.currentX,
         v = o.currentY,
         w = l.edgeSwipeDetection || l.iOSEdgeSwipeDetection,
         b = l.edgeSwipeThreshold || l.iOSEdgeSwipeThreshold;
       if (w && (g <= b || g >= i.innerWidth - b)) {
         if ("prevent" !== w) return;
         e.preventDefault();
       }
       if (Object.assign(n, {
         isTouched: !0,
         isMoved: !1,
         allowTouchCallbacks: !0,
         isScrolling: void 0,
         startMoving: void 0
       }), o.startX = g, o.startY = v, n.touchStartTime = u(), t.allowClick = !0, t.updateSize(), t.swipeDirection = void 0, l.threshold > 0 && (n.allowThresholdMove = !1), "touchstart" !== p.type) {
         var _e33 = !0;
         h.is(n.focusableElements) && (_e33 = !1, "SELECT" === h[0].nodeName && (n.isTouched = !1)), s.activeElement && d(s.activeElement).is(n.focusableElements) && s.activeElement !== h[0] && s.activeElement.blur();
         var _a12 = _e33 && t.allowTouchMove && l.touchStartPreventDefault;
         !l.touchStartForcePreventDefault && !_a12 || h[0].isContentEditable || p.preventDefault();
       }
       t.params.freeMode && t.params.freeMode.enabled && t.freeMode && t.animating && !l.cssMode && t.freeMode.onTouchStart(), t.emit("touchStart", p);
     }
     function O(e) {
       var t = a(),
         s = this,
         i = s.touchEventsData,
         r = s.params,
         n = s.touches,
         l = s.rtlTranslate,
         o = s.enabled;
       if (!o) return;
       var c = e;
       if (c.originalEvent && (c = c.originalEvent), !i.isTouched) return void (i.startMoving && i.isScrolling && s.emit("touchMoveOpposite", c));
       if (i.isTouchEvent && "touchmove" !== c.type) return;
       var p = "touchmove" === c.type && c.targetTouches && (c.targetTouches[0] || c.changedTouches[0]),
         h = "touchmove" === c.type ? p.pageX : c.pageX,
         m = "touchmove" === c.type ? p.pageY : c.pageY;
       if (c.preventedByNestedSwiper) return n.startX = h, void (n.startY = m);
       if (!s.allowTouchMove) return d(c.target).is(i.focusableElements) || (s.allowClick = !1), void (i.isTouched && (Object.assign(n, {
         startX: h,
         startY: m,
         currentX: h,
         currentY: m
       }), i.touchStartTime = u()));
       if (i.isTouchEvent && r.touchReleaseOnEdges && !r.loop) if (s.isVertical()) {
         if (m < n.startY && s.translate <= s.maxTranslate() || m > n.startY && s.translate >= s.minTranslate()) return i.isTouched = !1, void (i.isMoved = !1);
       } else if (h < n.startX && s.translate <= s.maxTranslate() || h > n.startX && s.translate >= s.minTranslate()) return;
       if (i.isTouchEvent && t.activeElement && c.target === t.activeElement && d(c.target).is(i.focusableElements)) return i.isMoved = !0, void (s.allowClick = !1);
       if (i.allowTouchCallbacks && s.emit("touchMove", c), c.targetTouches && c.targetTouches.length > 1) return;
       n.currentX = h, n.currentY = m;
       var f = n.currentX - n.startX,
         g = n.currentY - n.startY;
       if (s.params.threshold && Math.sqrt(Math.pow(f, 2) + Math.pow(g, 2)) < s.params.threshold) return;
       if (void 0 === i.isScrolling) {
         var _e34;
         s.isHorizontal() && n.currentY === n.startY || s.isVertical() && n.currentX === n.startX ? i.isScrolling = !1 : f * f + g * g >= 25 && (_e34 = 180 * Math.atan2(Math.abs(g), Math.abs(f)) / Math.PI, i.isScrolling = s.isHorizontal() ? _e34 > r.touchAngle : 90 - _e34 > r.touchAngle);
       }
       if (i.isScrolling && s.emit("touchMoveOpposite", c), void 0 === i.startMoving && (n.currentX === n.startX && n.currentY === n.startY || (i.startMoving = !0)), i.isScrolling) return void (i.isTouched = !1);
       if (!i.startMoving) return;
       s.allowClick = !1, !r.cssMode && c.cancelable && c.preventDefault(), r.touchMoveStopPropagation && !r.nested && c.stopPropagation(), i.isMoved || (r.loop && !r.cssMode && s.loopFix(), i.startTranslate = s.getTranslate(), s.setTransition(0), s.animating && s.$wrapperEl.trigger("webkitTransitionEnd transitionend"), i.allowMomentumBounce = !1, !r.grabCursor || !0 !== s.allowSlideNext && !0 !== s.allowSlidePrev || s.setGrabCursor(!0), s.emit("sliderFirstMove", c)), s.emit("sliderMove", c), i.isMoved = !0;
       var v = s.isHorizontal() ? f : g;
       n.diff = v, v *= r.touchRatio, l && (v = -v), s.swipeDirection = v > 0 ? "prev" : "next", i.currentTranslate = v + i.startTranslate;
       var w = !0,
         b = r.resistanceRatio;
       if (r.touchReleaseOnEdges && (b = 0), v > 0 && i.currentTranslate > s.minTranslate() ? (w = !1, r.resistance && (i.currentTranslate = s.minTranslate() - 1 + Math.pow(-s.minTranslate() + i.startTranslate + v, b))) : v < 0 && i.currentTranslate < s.maxTranslate() && (w = !1, r.resistance && (i.currentTranslate = s.maxTranslate() + 1 - Math.pow(s.maxTranslate() - i.startTranslate - v, b))), w && (c.preventedByNestedSwiper = !0), !s.allowSlideNext && "next" === s.swipeDirection && i.currentTranslate < i.startTranslate && (i.currentTranslate = i.startTranslate), !s.allowSlidePrev && "prev" === s.swipeDirection && i.currentTranslate > i.startTranslate && (i.currentTranslate = i.startTranslate), s.allowSlidePrev || s.allowSlideNext || (i.currentTranslate = i.startTranslate), r.threshold > 0) {
         if (!(Math.abs(v) > r.threshold || i.allowThresholdMove)) return void (i.currentTranslate = i.startTranslate);
         if (!i.allowThresholdMove) return i.allowThresholdMove = !0, n.startX = n.currentX, n.startY = n.currentY, i.currentTranslate = i.startTranslate, void (n.diff = s.isHorizontal() ? n.currentX - n.startX : n.currentY - n.startY);
       }
       r.followFinger && !r.cssMode && ((r.freeMode && r.freeMode.enabled && s.freeMode || r.watchSlidesProgress) && (s.updateActiveIndex(), s.updateSlidesClasses()), s.params.freeMode && r.freeMode.enabled && s.freeMode && s.freeMode.onTouchMove(), s.updateProgress(i.currentTranslate), s.setTranslate(i.currentTranslate));
     }
     function I(e) {
       var t = this,
         s = t.touchEventsData,
         a = t.params,
         i = t.touches,
         r = t.rtlTranslate,
         n = t.slidesGrid,
         l = t.enabled;
       if (!l) return;
       var o = e;
       if (o.originalEvent && (o = o.originalEvent), s.allowTouchCallbacks && t.emit("touchEnd", o), s.allowTouchCallbacks = !1, !s.isTouched) return s.isMoved && a.grabCursor && t.setGrabCursor(!1), s.isMoved = !1, void (s.startMoving = !1);
       a.grabCursor && s.isMoved && s.isTouched && (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) && t.setGrabCursor(!1);
       var d = u(),
         c = d - s.touchStartTime;
       if (t.allowClick) {
         var _e35 = o.path || o.composedPath && o.composedPath();
         t.updateClickedSlide(_e35 && _e35[0] || o.target), t.emit("tap click", o), c < 300 && d - s.lastClickTime < 300 && t.emit("doubleTap doubleClick", o);
       }
       if (s.lastClickTime = u(), p(function () {
         t.destroyed || (t.allowClick = !0);
       }), !s.isTouched || !s.isMoved || !t.swipeDirection || 0 === i.diff || s.currentTranslate === s.startTranslate) return s.isTouched = !1, s.isMoved = !1, void (s.startMoving = !1);
       var h;
       if (s.isTouched = !1, s.isMoved = !1, s.startMoving = !1, h = a.followFinger ? r ? t.translate : -t.translate : -s.currentTranslate, a.cssMode) return;
       if (t.params.freeMode && a.freeMode.enabled) return void t.freeMode.onTouchEnd({
         currentPos: h
       });
       var m = 0,
         f = t.slidesSizesGrid[0];
       for (var _e36 = 0; _e36 < n.length; _e36 += _e36 < a.slidesPerGroupSkip ? 1 : a.slidesPerGroup) {
         var _t27 = _e36 < a.slidesPerGroupSkip - 1 ? 1 : a.slidesPerGroup;
         void 0 !== n[_e36 + _t27] ? h >= n[_e36] && h < n[_e36 + _t27] && (m = _e36, f = n[_e36 + _t27] - n[_e36]) : h >= n[_e36] && (m = _e36, f = n[n.length - 1] - n[n.length - 2]);
       }
       var g = null,
         v = null;
       a.rewind && (t.isBeginning ? v = t.params.virtual && t.params.virtual.enabled && t.virtual ? t.virtual.slides.length - 1 : t.slides.length - 1 : t.isEnd && (g = 0));
       var w = (h - n[m]) / f,
         b = m < a.slidesPerGroupSkip - 1 ? 1 : a.slidesPerGroup;
       if (c > a.longSwipesMs) {
         if (!a.longSwipes) return void t.slideTo(t.activeIndex);
         "next" === t.swipeDirection && (w >= a.longSwipesRatio ? t.slideTo(a.rewind && t.isEnd ? g : m + b) : t.slideTo(m)), "prev" === t.swipeDirection && (w > 1 - a.longSwipesRatio ? t.slideTo(m + b) : null !== v && w < 0 && Math.abs(w) > a.longSwipesRatio ? t.slideTo(v) : t.slideTo(m));
       } else {
         if (!a.shortSwipes) return void t.slideTo(t.activeIndex);
         t.navigation && (o.target === t.navigation.nextEl || o.target === t.navigation.prevEl) ? o.target === t.navigation.nextEl ? t.slideTo(m + b) : t.slideTo(m) : ("next" === t.swipeDirection && t.slideTo(null !== g ? g : m + b), "prev" === t.swipeDirection && t.slideTo(null !== v ? v : m));
       }
     }
     function A() {
       var e = this,
         t = e.params,
         s = e.el;
       if (s && 0 === s.offsetWidth) return;
       t.breakpoints && e.setBreakpoint();
       var a = e.allowSlideNext,
         i = e.allowSlidePrev,
         r = e.snapGrid;
       e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), e.updateSlidesClasses(), ("auto" === t.slidesPerView || t.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0), e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.run(), e.allowSlidePrev = i, e.allowSlideNext = a, e.params.watchOverflow && r !== e.snapGrid && e.checkOverflow();
     }
     function D(e) {
       var t = this;
       t.enabled && (t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
     }
     function G() {
       var e = this,
         t = e.wrapperEl,
         s = e.rtlTranslate,
         a = e.enabled;
       if (!a) return;
       var i;
       e.previousTranslate = e.translate, e.isHorizontal() ? e.translate = -t.scrollLeft : e.translate = -t.scrollTop, 0 === e.translate && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
       var r = e.maxTranslate() - e.minTranslate();
       i = 0 === r ? 0 : (e.translate - e.minTranslate()) / r, i !== e.progress && e.updateProgress(s ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1);
     }
     var N = !1;
     function B() {}
     var H = function H(e, t) {
       var s = a(),
         i = e.params,
         r = e.touchEvents,
         n = e.el,
         l = e.wrapperEl,
         o = e.device,
         d = e.support,
         c = !!i.nested,
         p = "on" === t ? "addEventListener" : "removeEventListener",
         u = t;
       if (d.touch) {
         var _t28 = !("touchstart" !== r.start || !d.passiveListener || !i.passiveListeners) && {
           passive: !0,
           capture: !1
         };
         n[p](r.start, e.onTouchStart, _t28), n[p](r.move, e.onTouchMove, d.passiveListener ? {
           passive: !1,
           capture: c
         } : c), n[p](r.end, e.onTouchEnd, _t28), r.cancel && n[p](r.cancel, e.onTouchEnd, _t28);
       } else n[p](r.start, e.onTouchStart, !1), s[p](r.move, e.onTouchMove, c), s[p](r.end, e.onTouchEnd, !1);
       (i.preventClicks || i.preventClicksPropagation) && n[p]("click", e.onClick, !0), i.cssMode && l[p]("scroll", e.onScroll), i.updateOnWindowResize ? e[u](o.ios || o.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", A, !0) : e[u]("observerUpdate", A, !0);
     };
     var X = {
       attachEvents: function attachEvents() {
         var e = this,
           t = a(),
           s = e.params,
           i = e.support;
         e.onTouchStart = L.bind(e), e.onTouchMove = O.bind(e), e.onTouchEnd = I.bind(e), s.cssMode && (e.onScroll = G.bind(e)), e.onClick = D.bind(e), i.touch && !N && (t.addEventListener("touchstart", B), N = !0), H(e, "on");
       },
       detachEvents: function detachEvents() {
         H(this, "off");
       }
     };
     var Y = function Y(e, t) {
       return e.grid && t.grid && t.grid.rows > 1;
     };
     var R = {
       addClasses: function addClasses() {
         var e = this,
           t = e.classNames,
           s = e.params,
           a = e.rtl,
           i = e.$el,
           r = e.device,
           n = e.support,
           l = function (e, t) {
             var s = [];
             return e.forEach(function (e) {
               "object" == _typeof(e) ? Object.keys(e).forEach(function (a) {
                 e[a] && s.push(t + a);
               }) : "string" == typeof e && s.push(t + e);
             }), s;
           }(["initialized", s.direction, {
             "pointer-events": !n.touch
           }, {
             "free-mode": e.params.freeMode && s.freeMode.enabled
           }, {
             autoheight: s.autoHeight
           }, {
             rtl: a
           }, {
             grid: s.grid && s.grid.rows > 1
           }, {
             "grid-column": s.grid && s.grid.rows > 1 && "column" === s.grid.fill
           }, {
             android: r.android
           }, {
             ios: r.ios
           }, {
             "css-mode": s.cssMode
           }, {
             centered: s.cssMode && s.centeredSlides
           }, {
             "watch-progress": s.watchSlidesProgress
           }], s.containerModifierClass);
         t.push.apply(t, _toConsumableArray(l)), i.addClass(_toConsumableArray(t).join(" ")), e.emitContainerClasses();
       },
       removeClasses: function removeClasses() {
         var e = this.$el,
           t = this.classNames;
         e.removeClass(t.join(" ")), this.emitContainerClasses();
       }
     };
     var W = {
       init: !0,
       direction: "horizontal",
       touchEventsTarget: "wrapper",
       initialSlide: 0,
       speed: 300,
       cssMode: !1,
       updateOnWindowResize: !0,
       resizeObserver: !0,
       nested: !1,
       createElements: !1,
       enabled: !0,
       focusableElements: "input, select, option, textarea, button, video, label",
       width: null,
       height: null,
       preventInteractionOnTransition: !1,
       userAgent: null,
       url: null,
       edgeSwipeDetection: !1,
       edgeSwipeThreshold: 20,
       autoHeight: !1,
       setWrapperSize: !1,
       virtualTranslate: !1,
       effect: "slide",
       breakpoints: void 0,
       breakpointsBase: "window",
       spaceBetween: 0,
       slidesPerView: 1,
       slidesPerGroup: 1,
       slidesPerGroupSkip: 0,
       slidesPerGroupAuto: !1,
       centeredSlides: !1,
       centeredSlidesBounds: !1,
       slidesOffsetBefore: 0,
       slidesOffsetAfter: 0,
       normalizeSlideIndex: !0,
       centerInsufficientSlides: !1,
       watchOverflow: !0,
       roundLengths: !1,
       touchRatio: 1,
       touchAngle: 45,
       simulateTouch: !0,
       shortSwipes: !0,
       longSwipes: !0,
       longSwipesRatio: .5,
       longSwipesMs: 300,
       followFinger: !0,
       allowTouchMove: !0,
       threshold: 0,
       touchMoveStopPropagation: !1,
       touchStartPreventDefault: !0,
       touchStartForcePreventDefault: !1,
       touchReleaseOnEdges: !1,
       uniqueNavElements: !0,
       resistance: !0,
       resistanceRatio: .85,
       watchSlidesProgress: !1,
       grabCursor: !1,
       preventClicks: !0,
       preventClicksPropagation: !0,
       slideToClickedSlide: !1,
       preloadImages: !0,
       updateOnImagesReady: !0,
       loop: !1,
       loopAdditionalSlides: 0,
       loopedSlides: null,
       loopFillGroupWithBlank: !1,
       loopPreventsSlide: !0,
       rewind: !1,
       allowSlidePrev: !0,
       allowSlideNext: !0,
       swipeHandler: null,
       noSwiping: !0,
       noSwipingClass: "swiper-no-swiping",
       noSwipingSelector: null,
       passiveListeners: !0,
       maxBackfaceHiddenSlides: 10,
       containerModifierClass: "swiper-",
       slideClass: "swiper-slide",
       slideBlankClass: "swiper-slide-invisible-blank",
       slideActiveClass: "swiper-slide-active",
       slideDuplicateActiveClass: "swiper-slide-duplicate-active",
       slideVisibleClass: "swiper-slide-visible",
       slideDuplicateClass: "swiper-slide-duplicate",
       slideNextClass: "swiper-slide-next",
       slideDuplicateNextClass: "swiper-slide-duplicate-next",
       slidePrevClass: "swiper-slide-prev",
       slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
       wrapperClass: "swiper-wrapper",
       runCallbacksOnInit: !0,
       _emitClasses: !1
     };
     function j(e, t) {
       return function (s) {
         void 0 === s && (s = {});
         var a = Object.keys(s)[0],
           i = s[a];
         "object" == _typeof(i) && null !== i ? (["navigation", "pagination", "scrollbar"].indexOf(a) >= 0 && !0 === e[a] && (e[a] = {
           auto: !0
         }), a in e && "enabled" in i ? (!0 === e[a] && (e[a] = {
           enabled: !0
         }), "object" != _typeof(e[a]) || "enabled" in e[a] || (e[a].enabled = !0), e[a] || (e[a] = {
           enabled: !1
         }), g(t, s)) : g(t, s)) : g(t, s);
       };
     }
     var _ = {
         eventsEmitter: $,
         update: S,
         translate: M,
         transition: {
           setTransition: function setTransition(e, t) {
             var s = this;
             s.params.cssMode || s.$wrapperEl.transition(e), s.emit("setTransition", e, t);
           },
           transitionStart: function transitionStart(e, t) {
             void 0 === e && (e = !0);
             var s = this,
               a = s.params;
             a.cssMode || (a.autoHeight && s.updateAutoHeight(), P({
               swiper: s,
               runCallbacks: e,
               direction: t,
               step: "Start"
             }));
           },
           transitionEnd: function transitionEnd(e, t) {
             void 0 === e && (e = !0);
             var s = this,
               a = s.params;
             s.animating = !1, a.cssMode || (s.setTransition(0), P({
               swiper: s,
               runCallbacks: e,
               direction: t,
               step: "End"
             }));
           }
         },
         slide: k,
         loop: z,
         grabCursor: {
           setGrabCursor: function setGrabCursor(e) {
             var t = this;
             if (t.support.touch || !t.params.simulateTouch || t.params.watchOverflow && t.isLocked || t.params.cssMode) return;
             var s = "container" === t.params.touchEventsTarget ? t.el : t.wrapperEl;
             s.style.cursor = "move", s.style.cursor = e ? "grabbing" : "grab";
           },
           unsetGrabCursor: function unsetGrabCursor() {
             var e = this;
             e.support.touch || e.params.watchOverflow && e.isLocked || e.params.cssMode || (e["container" === e.params.touchEventsTarget ? "el" : "wrapperEl"].style.cursor = "");
           }
         },
         events: X,
         breakpoints: {
           setBreakpoint: function setBreakpoint() {
             var e = this,
               t = e.activeIndex,
               s = e.initialized,
               _e$loopedSlides = e.loopedSlides,
               a = _e$loopedSlides === void 0 ? 0 : _e$loopedSlides,
               i = e.params,
               r = e.$el,
               n = i.breakpoints;
             if (!n || n && 0 === Object.keys(n).length) return;
             var l = e.getBreakpoint(n, e.params.breakpointsBase, e.el);
             if (!l || e.currentBreakpoint === l) return;
             var o = (l in n ? n[l] : void 0) || e.originalParams,
               d = Y(e, i),
               c = Y(e, o),
               p = i.enabled;
             d && !c ? (r.removeClass("".concat(i.containerModifierClass, "grid ").concat(i.containerModifierClass, "grid-column")), e.emitContainerClasses()) : !d && c && (r.addClass("".concat(i.containerModifierClass, "grid")), (o.grid.fill && "column" === o.grid.fill || !o.grid.fill && "column" === i.grid.fill) && r.addClass("".concat(i.containerModifierClass, "grid-column")), e.emitContainerClasses()), ["navigation", "pagination", "scrollbar"].forEach(function (t) {
               var s = i[t] && i[t].enabled,
                 a = o[t] && o[t].enabled;
               s && !a && e[t].disable(), !s && a && e[t].enable();
             });
             var u = o.direction && o.direction !== i.direction,
               h = i.loop && (o.slidesPerView !== i.slidesPerView || u);
             u && s && e.changeDirection(), g(e.params, o);
             var m = e.params.enabled;
             Object.assign(e, {
               allowTouchMove: e.params.allowTouchMove,
               allowSlideNext: e.params.allowSlideNext,
               allowSlidePrev: e.params.allowSlidePrev
             }), p && !m ? e.disable() : !p && m && e.enable(), e.currentBreakpoint = l, e.emit("_beforeBreakpoint", o), h && s && (e.loopDestroy(), e.loopCreate(), e.updateSlides(), e.slideTo(t - a + e.loopedSlides, 0, !1)), e.emit("breakpoint", o);
           },
           getBreakpoint: function getBreakpoint(e, t, s) {
             if (void 0 === t && (t = "window"), !e || "container" === t && !s) return;
             var a = !1;
             var i = r(),
               n = "window" === t ? i.innerHeight : s.clientHeight,
               l = Object.keys(e).map(function (e) {
                 if ("string" == typeof e && 0 === e.indexOf("@")) {
                   var _t29 = parseFloat(e.substr(1));
                   return {
                     value: n * _t29,
                     point: e
                   };
                 }
                 return {
                   value: e,
                   point: e
                 };
               });
             l.sort(function (e, t) {
               return parseInt(e.value, 10) - parseInt(t.value, 10);
             });
             for (var _e37 = 0; _e37 < l.length; _e37 += 1) {
               var _l$_e = l[_e37],
                 _r4 = _l$_e.point,
                 _n3 = _l$_e.value;
               "window" === t ? i.matchMedia("(min-width: ".concat(_n3, "px)")).matches && (a = _r4) : _n3 <= s.clientWidth && (a = _r4);
             }
             return a || "max";
           }
         },
         checkOverflow: {
           checkOverflow: function checkOverflow() {
             var e = this,
               t = e.isLocked,
               s = e.params,
               a = s.slidesOffsetBefore;
             if (a) {
               var _t30 = e.slides.length - 1,
                 _s24 = e.slidesGrid[_t30] + e.slidesSizesGrid[_t30] + 2 * a;
               e.isLocked = e.size > _s24;
             } else e.isLocked = 1 === e.snapGrid.length;
             !0 === s.allowSlideNext && (e.allowSlideNext = !e.isLocked), !0 === s.allowSlidePrev && (e.allowSlidePrev = !e.isLocked), t && t !== e.isLocked && (e.isEnd = !1), t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
           }
         },
         classes: R,
         images: {
           loadImage: function loadImage(e, t, s, a, i, n) {
             var l = r();
             var o;
             function c() {
               n && n();
             }
             d(e).parent("picture")[0] || e.complete && i ? c() : t ? (o = new l.Image(), o.onload = c, o.onerror = c, a && (o.sizes = a), s && (o.srcset = s), t && (o.src = t)) : c();
           },
           preloadImages: function preloadImages() {
             var e = this;
             function t() {
               null != e && e && !e.destroyed && (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1), e.imagesLoaded === e.imagesToLoad.length && (e.params.updateOnImagesReady && e.update(), e.emit("imagesReady")));
             }
             e.imagesToLoad = e.$el.find("img");
             for (var _s25 = 0; _s25 < e.imagesToLoad.length; _s25 += 1) {
               var _a13 = e.imagesToLoad[_s25];
               e.loadImage(_a13, _a13.currentSrc || _a13.getAttribute("src"), _a13.srcset || _a13.getAttribute("srcset"), _a13.sizes || _a13.getAttribute("sizes"), !0, t);
             }
           }
         }
       },
       q = {};
     var V = /*#__PURE__*/function () {
       function V() {
         var _a14, _a15, _r$modules;
         _classCallCheck(this, V);
         var e, t;
         for (var s = arguments.length, a = new Array(s), i = 0; i < s; i++) a[i] = arguments[i];
         if (1 === a.length && a[0].constructor && "Object" === Object.prototype.toString.call(a[0]).slice(8, -1) ? t = a[0] : (_a14 = a, _a15 = _slicedToArray(_a14, 2), e = _a15[0], t = _a15[1], _a14), t || (t = {}), t = g({}, t), e && !t.el && (t.el = e), t.el && d(t.el).length > 1) {
           var _e38 = [];
           return d(t.el).each(function (s) {
             var a = g({}, t, {
               el: s
             });
             _e38.push(new V(a));
           }), _e38;
         }
         var r = this;
         r.__swiper__ = !0, r.support = E(), r.device = C({
           userAgent: t.userAgent
         }), r.browser = T(), r.eventsListeners = {}, r.eventsAnyListeners = [], r.modules = _toConsumableArray(r.__modules__), t.modules && Array.isArray(t.modules) && (_r$modules = r.modules).push.apply(_r$modules, _toConsumableArray(t.modules));
         var n = {};
         r.modules.forEach(function (e) {
           e({
             swiper: r,
             extendParams: j(t, n),
             on: r.on.bind(r),
             once: r.once.bind(r),
             off: r.off.bind(r),
             emit: r.emit.bind(r)
           });
         });
         var l = g({}, W, n);
         return r.params = g({}, l, q, t), r.originalParams = g({}, r.params), r.passedParams = g({}, t), r.params && r.params.on && Object.keys(r.params.on).forEach(function (e) {
           r.on(e, r.params.on[e]);
         }), r.params && r.params.onAny && r.onAny(r.params.onAny), r.$ = d, Object.assign(r, {
           enabled: r.params.enabled,
           el: e,
           classNames: [],
           slides: d(),
           slidesGrid: [],
           snapGrid: [],
           slidesSizesGrid: [],
           isHorizontal: function isHorizontal() {
             return "horizontal" === r.params.direction;
           },
           isVertical: function isVertical() {
             return "vertical" === r.params.direction;
           },
           activeIndex: 0,
           realIndex: 0,
           isBeginning: !0,
           isEnd: !1,
           translate: 0,
           previousTranslate: 0,
           progress: 0,
           velocity: 0,
           animating: !1,
           allowSlideNext: r.params.allowSlideNext,
           allowSlidePrev: r.params.allowSlidePrev,
           touchEvents: function () {
             var e = ["touchstart", "touchmove", "touchend", "touchcancel"],
               t = ["pointerdown", "pointermove", "pointerup"];
             return r.touchEventsTouch = {
               start: e[0],
               move: e[1],
               end: e[2],
               cancel: e[3]
             }, r.touchEventsDesktop = {
               start: t[0],
               move: t[1],
               end: t[2]
             }, r.support.touch || !r.params.simulateTouch ? r.touchEventsTouch : r.touchEventsDesktop;
           }(),
           touchEventsData: {
             isTouched: void 0,
             isMoved: void 0,
             allowTouchCallbacks: void 0,
             touchStartTime: void 0,
             isScrolling: void 0,
             currentTranslate: void 0,
             startTranslate: void 0,
             allowThresholdMove: void 0,
             focusableElements: r.params.focusableElements,
             lastClickTime: u(),
             clickTimeout: void 0,
             velocities: [],
             allowMomentumBounce: void 0,
             isTouchEvent: void 0,
             startMoving: void 0
           },
           allowClick: !0,
           allowTouchMove: r.params.allowTouchMove,
           touches: {
             startX: 0,
             startY: 0,
             currentX: 0,
             currentY: 0,
             diff: 0
           },
           imagesToLoad: [],
           imagesLoaded: 0
         }), r.emit("_swiper"), r.params.init && r.init(), r;
       }
       return _createClass(V, [{
         key: "enable",
         value: function enable() {
           var e = this;
           e.enabled || (e.enabled = !0, e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
         }
       }, {
         key: "disable",
         value: function disable() {
           var e = this;
           e.enabled && (e.enabled = !1, e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
         }
       }, {
         key: "setProgress",
         value: function setProgress(e, t) {
           var s = this;
           e = Math.min(Math.max(e, 0), 1);
           var a = s.minTranslate(),
             i = (s.maxTranslate() - a) * e + a;
           s.translateTo(i, void 0 === t ? 0 : t), s.updateActiveIndex(), s.updateSlidesClasses();
         }
       }, {
         key: "emitContainerClasses",
         value: function emitContainerClasses() {
           var e = this;
           if (!e.params._emitClasses || !e.el) return;
           var t = e.el.className.split(" ").filter(function (t) {
             return 0 === t.indexOf("swiper") || 0 === t.indexOf(e.params.containerModifierClass);
           });
           e.emit("_containerClasses", t.join(" "));
         }
       }, {
         key: "getSlideClasses",
         value: function getSlideClasses(e) {
           var t = this;
           return t.destroyed ? "" : e.className.split(" ").filter(function (e) {
             return 0 === e.indexOf("swiper-slide") || 0 === e.indexOf(t.params.slideClass);
           }).join(" ");
         }
       }, {
         key: "emitSlidesClasses",
         value: function emitSlidesClasses() {
           var e = this;
           if (!e.params._emitClasses || !e.el) return;
           var t = [];
           e.slides.each(function (s) {
             var a = e.getSlideClasses(s);
             t.push({
               slideEl: s,
               classNames: a
             }), e.emit("_slideClass", s, a);
           }), e.emit("_slideClasses", t);
         }
       }, {
         key: "slidesPerViewDynamic",
         value: function slidesPerViewDynamic(e, t) {
           void 0 === e && (e = "current"), void 0 === t && (t = !1);
           var s = this.params,
             a = this.slides,
             i = this.slidesGrid,
             r = this.slidesSizesGrid,
             n = this.size,
             l = this.activeIndex;
           var o = 1;
           if (s.centeredSlides) {
             var _e39,
               _t31 = a[l].swiperSlideSize;
             for (var _s26 = l + 1; _s26 < a.length; _s26 += 1) a[_s26] && !_e39 && (_t31 += a[_s26].swiperSlideSize, o += 1, _t31 > n && (_e39 = !0));
             for (var _s27 = l - 1; _s27 >= 0; _s27 -= 1) a[_s27] && !_e39 && (_t31 += a[_s27].swiperSlideSize, o += 1, _t31 > n && (_e39 = !0));
           } else if ("current" === e) for (var _e40 = l + 1; _e40 < a.length; _e40 += 1) {
             (t ? i[_e40] + r[_e40] - i[l] < n : i[_e40] - i[l] < n) && (o += 1);
           } else for (var _e41 = l - 1; _e41 >= 0; _e41 -= 1) {
             i[l] - i[_e41] < n && (o += 1);
           }
           return o;
         }
       }, {
         key: "update",
         value: function update() {
           var e = this;
           if (!e || e.destroyed) return;
           var t = e.snapGrid,
             s = e.params;
           function a() {
             var t = e.rtlTranslate ? -1 * e.translate : e.translate,
               s = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
             e.setTranslate(s), e.updateActiveIndex(), e.updateSlidesClasses();
           }
           var i;
           s.breakpoints && e.setBreakpoint(), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), e.params.freeMode && e.params.freeMode.enabled ? (a(), e.params.autoHeight && e.updateAutoHeight()) : (i = ("auto" === e.params.slidesPerView || e.params.slidesPerView > 1) && e.isEnd && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0), i || a()), s.watchOverflow && t !== e.snapGrid && e.checkOverflow(), e.emit("update");
         }
       }, {
         key: "changeDirection",
         value: function changeDirection(e, t) {
           void 0 === t && (t = !0);
           var s = this,
             a = s.params.direction;
           return e || (e = "horizontal" === a ? "vertical" : "horizontal"), e === a || "horizontal" !== e && "vertical" !== e || (s.$el.removeClass("".concat(s.params.containerModifierClass).concat(a)).addClass("".concat(s.params.containerModifierClass).concat(e)), s.emitContainerClasses(), s.params.direction = e, s.slides.each(function (t) {
             "vertical" === e ? t.style.width = "" : t.style.height = "";
           }), s.emit("changeDirection"), t && s.update()), s;
         }
       }, {
         key: "mount",
         value: function mount(e) {
           var t = this;
           if (t.mounted) return !0;
           var s = d(e || t.params.el);
           if (!(e = s[0])) return !1;
           e.swiper = t;
           var i = function i() {
             return ".".concat((t.params.wrapperClass || "").trim().split(" ").join("."));
           };
           var r = function () {
             if (e && e.shadowRoot && e.shadowRoot.querySelector) {
               var _t32 = d(e.shadowRoot.querySelector(i()));
               return _t32.children = function (e) {
                 return s.children(e);
               }, _t32;
             }
             return s.children ? s.children(i()) : d(s).children(i());
           }();
           if (0 === r.length && t.params.createElements) {
             var _e42 = a().createElement("div");
             r = d(_e42), _e42.className = t.params.wrapperClass, s.append(_e42), s.children(".".concat(t.params.slideClass)).each(function (e) {
               r.append(e);
             });
           }
           return Object.assign(t, {
             $el: s,
             el: e,
             $wrapperEl: r,
             wrapperEl: r[0],
             mounted: !0,
             rtl: "rtl" === e.dir.toLowerCase() || "rtl" === s.css("direction"),
             rtlTranslate: "horizontal" === t.params.direction && ("rtl" === e.dir.toLowerCase() || "rtl" === s.css("direction")),
             wrongRTL: "-webkit-box" === r.css("display")
           }), !0;
         }
       }, {
         key: "init",
         value: function init(e) {
           var t = this;
           if (t.initialized) return t;
           return !1 === t.mount(e) || (t.emit("beforeInit"), t.params.breakpoints && t.setBreakpoint(), t.addClasses(), t.params.loop && t.loopCreate(), t.updateSize(), t.updateSlides(), t.params.watchOverflow && t.checkOverflow(), t.params.grabCursor && t.enabled && t.setGrabCursor(), t.params.preloadImages && t.preloadImages(), t.params.loop ? t.slideTo(t.params.initialSlide + t.loopedSlides, 0, t.params.runCallbacksOnInit, !1, !0) : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0), t.attachEvents(), t.initialized = !0, t.emit("init"), t.emit("afterInit")), t;
         }
       }, {
         key: "destroy",
         value: function destroy(e, t) {
           void 0 === e && (e = !0), void 0 === t && (t = !0);
           var s = this,
             a = s.params,
             i = s.$el,
             r = s.$wrapperEl,
             n = s.slides;
           return void 0 === s.params || s.destroyed || (s.emit("beforeDestroy"), s.initialized = !1, s.detachEvents(), a.loop && s.loopDestroy(), t && (s.removeClasses(), i.removeAttr("style"), r.removeAttr("style"), n && n.length && n.removeClass([a.slideVisibleClass, a.slideActiveClass, a.slideNextClass, a.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index")), s.emit("destroy"), Object.keys(s.eventsListeners).forEach(function (e) {
             s.off(e);
           }), !1 !== e && (s.$el[0].swiper = null, function (e) {
             var t = e;
             Object.keys(t).forEach(function (e) {
               try {
                 t[e] = null;
               } catch (e) {}
               try {
                 delete t[e];
               } catch (e) {}
             });
           }(s)), s.destroyed = !0), null;
         }
       }], [{
         key: "extendDefaults",
         value: function extendDefaults(e) {
           g(q, e);
         }
       }, {
         key: "extendedDefaults",
         get: function get() {
           return q;
         }
       }, {
         key: "defaults",
         get: function get() {
           return W;
         }
       }, {
         key: "installModule",
         value: function installModule(e) {
           V.prototype.__modules__ || (V.prototype.__modules__ = []);
           var t = V.prototype.__modules__;
           "function" == typeof e && t.indexOf(e) < 0 && t.push(e);
         }
       }, {
         key: "use",
         value: function use(e) {
           return Array.isArray(e) ? (e.forEach(function (e) {
             return V.installModule(e);
           }), V) : (V.installModule(e), V);
         }
       }]);
     }();
     function F(e, t, s, i) {
       var r = a();
       return e.params.createElements && Object.keys(i).forEach(function (a) {
         if (!s[a] && !0 === s.auto) {
           var _n4 = e.$el.children(".".concat(i[a]))[0];
           _n4 || (_n4 = r.createElement("div"), _n4.className = i[a], e.$el.append(_n4)), s[a] = _n4, t[a] = _n4;
         }
       }), s;
     }
     function U(e) {
       return void 0 === e && (e = ""), ".".concat(e.trim().replace(/([\.:!\/])/g, "\\$1").replace(/ /g, "."));
     }
     function K(e) {
       var t = this,
         s = t.$wrapperEl,
         a = t.params;
       if (a.loop && t.loopDestroy(), "object" == _typeof(e) && "length" in e) for (var _t33 = 0; _t33 < e.length; _t33 += 1) e[_t33] && s.append(e[_t33]);else s.append(e);
       a.loop && t.loopCreate(), a.observer || t.update();
     }
     function Z(e) {
       var t = this,
         s = t.params,
         a = t.$wrapperEl,
         i = t.activeIndex;
       s.loop && t.loopDestroy();
       var r = i + 1;
       if ("object" == _typeof(e) && "length" in e) {
         for (var _t34 = 0; _t34 < e.length; _t34 += 1) e[_t34] && a.prepend(e[_t34]);
         r = i + e.length;
       } else a.prepend(e);
       s.loop && t.loopCreate(), s.observer || t.update(), t.slideTo(r, 0, !1);
     }
     function Q(e, t) {
       var s = this,
         a = s.$wrapperEl,
         i = s.params,
         r = s.activeIndex;
       var n = r;
       i.loop && (n -= s.loopedSlides, s.loopDestroy(), s.slides = a.children(".".concat(i.slideClass)));
       var l = s.slides.length;
       if (e <= 0) return void s.prependSlide(t);
       if (e >= l) return void s.appendSlide(t);
       var o = n > e ? n + 1 : n;
       var d = [];
       for (var _t35 = l - 1; _t35 >= e; _t35 -= 1) {
         var _e43 = s.slides.eq(_t35);
         _e43.remove(), d.unshift(_e43);
       }
       if ("object" == _typeof(t) && "length" in t) {
         for (var _e44 = 0; _e44 < t.length; _e44 += 1) t[_e44] && a.append(t[_e44]);
         o = n > e ? n + t.length : n;
       } else a.append(t);
       for (var _e45 = 0; _e45 < d.length; _e45 += 1) a.append(d[_e45]);
       i.loop && s.loopCreate(), i.observer || s.update(), i.loop ? s.slideTo(o + s.loopedSlides, 0, !1) : s.slideTo(o, 0, !1);
     }
     function J(e) {
       var t = this,
         s = t.params,
         a = t.$wrapperEl,
         i = t.activeIndex;
       var r = i;
       s.loop && (r -= t.loopedSlides, t.loopDestroy(), t.slides = a.children(".".concat(s.slideClass)));
       var n,
         l = r;
       if ("object" == _typeof(e) && "length" in e) {
         for (var _s28 = 0; _s28 < e.length; _s28 += 1) n = e[_s28], t.slides[n] && t.slides.eq(n).remove(), n < l && (l -= 1);
         l = Math.max(l, 0);
       } else n = e, t.slides[n] && t.slides.eq(n).remove(), n < l && (l -= 1), l = Math.max(l, 0);
       s.loop && t.loopCreate(), s.observer || t.update(), s.loop ? t.slideTo(l + t.loopedSlides, 0, !1) : t.slideTo(l, 0, !1);
     }
     function ee() {
       var e = this,
         t = [];
       for (var _s29 = 0; _s29 < e.slides.length; _s29 += 1) t.push(_s29);
       e.removeSlide(t);
     }
     function te(e) {
       var t = e.effect,
         s = e.swiper,
         a = e.on,
         i = e.setTranslate,
         r = e.setTransition,
         n = e.overwriteParams,
         l = e.perspective,
         o = e.recreateShadows,
         d = e.getEffectParams;
       var c;
       a("beforeInit", function () {
         if (s.params.effect !== t) return;
         s.classNames.push("".concat(s.params.containerModifierClass).concat(t)), l && l() && s.classNames.push("".concat(s.params.containerModifierClass, "3d"));
         var e = n ? n() : {};
         Object.assign(s.params, e), Object.assign(s.originalParams, e);
       }), a("setTranslate", function () {
         s.params.effect === t && i();
       }), a("setTransition", function (e, a) {
         s.params.effect === t && r(a);
       }), a("transitionEnd", function () {
         if (s.params.effect === t && o) {
           if (!d || !d().slideShadows) return;
           s.slides.each(function (e) {
             s.$(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").remove();
           }), o();
         }
       }), a("virtualUpdate", function () {
         s.params.effect === t && (s.slides.length || (c = !0), requestAnimationFrame(function () {
           c && s.slides && s.slides.length && (i(), c = !1);
         }));
       });
     }
     function se(e, t) {
       return e.transformEl ? t.find(e.transformEl).css({
         "backface-visibility": "hidden",
         "-webkit-backface-visibility": "hidden"
       }) : t;
     }
     function ae(e) {
       var t = e.swiper,
         s = e.duration,
         a = e.transformEl,
         i = e.allSlides;
       var r = t.slides,
         n = t.activeIndex,
         l = t.$wrapperEl;
       if (t.params.virtualTranslate && 0 !== s) {
         var _e46,
           _s30 = !1;
         _e46 = i ? a ? r.find(a) : r : a ? r.eq(n).find(a) : r.eq(n), _e46.transitionEnd(function () {
           if (_s30) return;
           if (!t || t.destroyed) return;
           _s30 = !0, t.animating = !1;
           var e = ["webkitTransitionEnd", "transitionend"];
           for (var _t36 = 0; _t36 < e.length; _t36 += 1) l.trigger(e[_t36]);
         });
       }
     }
     function ie(e, t, s) {
       var a = "swiper-slide-shadow" + (s ? "-".concat(s) : ""),
         i = e.transformEl ? t.find(e.transformEl) : t;
       var r = i.children(".".concat(a));
       return r.length || (r = d("<div class=\"swiper-slide-shadow".concat(s ? "-".concat(s) : "", "\"></div>")), i.append(r)), r;
     }
     Object.keys(_).forEach(function (e) {
       Object.keys(_[e]).forEach(function (t) {
         V.prototype[t] = _[e][t];
       });
     }), V.use([function (e) {
       var t = e.swiper,
         s = e.on,
         a = e.emit;
       var i = r();
       var n = null,
         l = null;
       var o = function o() {
           t && !t.destroyed && t.initialized && (a("beforeResize"), a("resize"));
         },
         d = function d() {
           t && !t.destroyed && t.initialized && a("orientationchange");
         };
       s("init", function () {
         t.params.resizeObserver && void 0 !== i.ResizeObserver ? t && !t.destroyed && t.initialized && (n = new ResizeObserver(function (e) {
           l = i.requestAnimationFrame(function () {
             var s = t.width,
               a = t.height;
             var i = s,
               r = a;
             e.forEach(function (e) {
               var s = e.contentBoxSize,
                 a = e.contentRect,
                 n = e.target;
               n && n !== t.el || (i = a ? a.width : (s[0] || s).inlineSize, r = a ? a.height : (s[0] || s).blockSize);
             }), i === s && r === a || o();
           });
         }), n.observe(t.el)) : (i.addEventListener("resize", o), i.addEventListener("orientationchange", d));
       }), s("destroy", function () {
         l && i.cancelAnimationFrame(l), n && n.unobserve && t.el && (n.unobserve(t.el), n = null), i.removeEventListener("resize", o), i.removeEventListener("orientationchange", d);
       });
     }, function (e) {
       var t = e.swiper,
         s = e.extendParams,
         a = e.on,
         i = e.emit;
       var n = [],
         l = r(),
         o = function o(e, t) {
           void 0 === t && (t = {});
           var s = new (l.MutationObserver || l.WebkitMutationObserver)(function (e) {
             if (1 === e.length) return void i("observerUpdate", e[0]);
             var t = function t() {
               i("observerUpdate", e[0]);
             };
             l.requestAnimationFrame ? l.requestAnimationFrame(t) : l.setTimeout(t, 0);
           });
           s.observe(e, {
             attributes: void 0 === t.attributes || t.attributes,
             childList: void 0 === t.childList || t.childList,
             characterData: void 0 === t.characterData || t.characterData
           }), n.push(s);
         };
       s({
         observer: !1,
         observeParents: !1,
         observeSlideChildren: !1
       }), a("init", function () {
         if (t.params.observer) {
           if (t.params.observeParents) {
             var _e47 = t.$el.parents();
             for (var _t37 = 0; _t37 < _e47.length; _t37 += 1) o(_e47[_t37]);
           }
           o(t.$el[0], {
             childList: t.params.observeSlideChildren
           }), o(t.$wrapperEl[0], {
             attributes: !1
           });
         }
       }), a("destroy", function () {
         n.forEach(function (e) {
           e.disconnect();
         }), n.splice(0, n.length);
       });
     }]);
     var re = [function (e) {
       var t,
         s = e.swiper,
         a = e.extendParams,
         i = e.on,
         r = e.emit;
       function n(e, t) {
         var a = s.params.virtual;
         if (a.cache && s.virtual.cache[t]) return s.virtual.cache[t];
         var i = a.renderSlide ? d(a.renderSlide.call(s, e, t)) : d("<div class=\"".concat(s.params.slideClass, "\" data-swiper-slide-index=\"").concat(t, "\">").concat(e, "</div>"));
         return i.attr("data-swiper-slide-index") || i.attr("data-swiper-slide-index", t), a.cache && (s.virtual.cache[t] = i), i;
       }
       function l(e) {
         var _s$params = s.params,
           t = _s$params.slidesPerView,
           a = _s$params.slidesPerGroup,
           i = _s$params.centeredSlides,
           _s$params$virtual = s.params.virtual,
           l = _s$params$virtual.addSlidesBefore,
           o = _s$params$virtual.addSlidesAfter,
           _s$virtual = s.virtual,
           d = _s$virtual.from,
           c = _s$virtual.to,
           p = _s$virtual.slides,
           u = _s$virtual.slidesGrid,
           h = _s$virtual.offset;
         s.params.cssMode || s.updateActiveIndex();
         var m = s.activeIndex || 0;
         var f, g, v;
         f = s.rtlTranslate ? "right" : s.isHorizontal() ? "left" : "top", i ? (g = Math.floor(t / 2) + a + o, v = Math.floor(t / 2) + a + l) : (g = t + (a - 1) + o, v = a + l);
         var w = Math.max((m || 0) - v, 0),
           b = Math.min((m || 0) + g, p.length - 1),
           x = (s.slidesGrid[w] || 0) - (s.slidesGrid[0] || 0);
         function y() {
           s.updateSlides(), s.updateProgress(), s.updateSlidesClasses(), s.lazy && s.params.lazy.enabled && s.lazy.load(), r("virtualUpdate");
         }
         if (Object.assign(s.virtual, {
           from: w,
           to: b,
           offset: x,
           slidesGrid: s.slidesGrid
         }), d === w && c === b && !e) return s.slidesGrid !== u && x !== h && s.slides.css(f, "".concat(x, "px")), s.updateProgress(), void r("virtualUpdate");
         if (s.params.virtual.renderExternal) return s.params.virtual.renderExternal.call(s, {
           offset: x,
           from: w,
           to: b,
           slides: function () {
             var e = [];
             for (var _t38 = w; _t38 <= b; _t38 += 1) e.push(p[_t38]);
             return e;
           }()
         }), void (s.params.virtual.renderExternalUpdate ? y() : r("virtualUpdate"));
         var E = [],
           C = [];
         if (e) s.$wrapperEl.find(".".concat(s.params.slideClass)).remove();else for (var _e48 = d; _e48 <= c; _e48 += 1) (_e48 < w || _e48 > b) && s.$wrapperEl.find(".".concat(s.params.slideClass, "[data-swiper-slide-index=\"").concat(_e48, "\"]")).remove();
         for (var _t39 = 0; _t39 < p.length; _t39 += 1) _t39 >= w && _t39 <= b && (void 0 === c || e ? C.push(_t39) : (_t39 > c && C.push(_t39), _t39 < d && E.push(_t39)));
         C.forEach(function (e) {
           s.$wrapperEl.append(n(p[e], e));
         }), E.sort(function (e, t) {
           return t - e;
         }).forEach(function (e) {
           s.$wrapperEl.prepend(n(p[e], e));
         }), s.$wrapperEl.children(".swiper-slide").css(f, "".concat(x, "px")), y();
       }
       a({
         virtual: {
           enabled: !1,
           slides: [],
           cache: !0,
           renderSlide: null,
           renderExternal: null,
           renderExternalUpdate: !0,
           addSlidesBefore: 0,
           addSlidesAfter: 0
         }
       }), s.virtual = {
         cache: {},
         from: void 0,
         to: void 0,
         slides: [],
         offset: 0,
         slidesGrid: []
       }, i("beforeInit", function () {
         s.params.virtual.enabled && (s.virtual.slides = s.params.virtual.slides, s.classNames.push("".concat(s.params.containerModifierClass, "virtual")), s.params.watchSlidesProgress = !0, s.originalParams.watchSlidesProgress = !0, s.params.initialSlide || l());
       }), i("setTranslate", function () {
         s.params.virtual.enabled && (s.params.cssMode && !s._immediateVirtual ? (clearTimeout(t), t = setTimeout(function () {
           l();
         }, 100)) : l());
       }), i("init update resize", function () {
         s.params.virtual.enabled && s.params.cssMode && v(s.wrapperEl, "--swiper-virtual-size", "".concat(s.virtualSize, "px"));
       }), Object.assign(s.virtual, {
         appendSlide: function appendSlide(e) {
           if ("object" == _typeof(e) && "length" in e) for (var _t40 = 0; _t40 < e.length; _t40 += 1) e[_t40] && s.virtual.slides.push(e[_t40]);else s.virtual.slides.push(e);
           l(!0);
         },
         prependSlide: function prependSlide(e) {
           var t = s.activeIndex;
           var a = t + 1,
             i = 1;
           if (Array.isArray(e)) {
             for (var _t41 = 0; _t41 < e.length; _t41 += 1) e[_t41] && s.virtual.slides.unshift(e[_t41]);
             a = t + e.length, i = e.length;
           } else s.virtual.slides.unshift(e);
           if (s.params.virtual.cache) {
             var _e49 = s.virtual.cache,
               _t42 = {};
             Object.keys(_e49).forEach(function (s) {
               var a = _e49[s],
                 r = a.attr("data-swiper-slide-index");
               r && a.attr("data-swiper-slide-index", parseInt(r, 10) + i), _t42[parseInt(s, 10) + i] = a;
             }), s.virtual.cache = _t42;
           }
           l(!0), s.slideTo(a, 0);
         },
         removeSlide: function removeSlide(e) {
           if (null == e) return;
           var t = s.activeIndex;
           if (Array.isArray(e)) for (var _a16 = e.length - 1; _a16 >= 0; _a16 -= 1) s.virtual.slides.splice(e[_a16], 1), s.params.virtual.cache && delete s.virtual.cache[e[_a16]], e[_a16] < t && (t -= 1), t = Math.max(t, 0);else s.virtual.slides.splice(e, 1), s.params.virtual.cache && delete s.virtual.cache[e], e < t && (t -= 1), t = Math.max(t, 0);
           l(!0), s.slideTo(t, 0);
         },
         removeAllSlides: function removeAllSlides() {
           s.virtual.slides = [], s.params.virtual.cache && (s.virtual.cache = {}), l(!0), s.slideTo(0, 0);
         },
         update: l
       });
     }, function (e) {
       var t = e.swiper,
         s = e.extendParams,
         i = e.on,
         n = e.emit;
       var l = a(),
         o = r();
       function c(e) {
         if (!t.enabled) return;
         var s = t.rtlTranslate;
         var a = e;
         a.originalEvent && (a = a.originalEvent);
         var i = a.keyCode || a.charCode,
           r = t.params.keyboard.pageUpDown,
           d = r && 33 === i,
           c = r && 34 === i,
           p = 37 === i,
           u = 39 === i,
           h = 38 === i,
           m = 40 === i;
         if (!t.allowSlideNext && (t.isHorizontal() && u || t.isVertical() && m || c)) return !1;
         if (!t.allowSlidePrev && (t.isHorizontal() && p || t.isVertical() && h || d)) return !1;
         if (!(a.shiftKey || a.altKey || a.ctrlKey || a.metaKey || l.activeElement && l.activeElement.nodeName && ("input" === l.activeElement.nodeName.toLowerCase() || "textarea" === l.activeElement.nodeName.toLowerCase()))) {
           if (t.params.keyboard.onlyInViewport && (d || c || p || u || h || m)) {
             var _e50 = !1;
             if (t.$el.parents(".".concat(t.params.slideClass)).length > 0 && 0 === t.$el.parents(".".concat(t.params.slideActiveClass)).length) return;
             var _a17 = t.$el,
               _i0 = _a17[0].clientWidth,
               _r5 = _a17[0].clientHeight,
               _n5 = o.innerWidth,
               _l5 = o.innerHeight,
               _d3 = t.$el.offset();
             s && (_d3.left -= t.$el[0].scrollLeft);
             var _c3 = [[_d3.left, _d3.top], [_d3.left + _i0, _d3.top], [_d3.left, _d3.top + _r5], [_d3.left + _i0, _d3.top + _r5]];
             for (var _t43 = 0; _t43 < _c3.length; _t43 += 1) {
               var _s31 = _c3[_t43];
               if (_s31[0] >= 0 && _s31[0] <= _n5 && _s31[1] >= 0 && _s31[1] <= _l5) {
                 if (0 === _s31[0] && 0 === _s31[1]) continue;
                 _e50 = !0;
               }
             }
             if (!_e50) return;
           }
           t.isHorizontal() ? ((d || c || p || u) && (a.preventDefault ? a.preventDefault() : a.returnValue = !1), ((c || u) && !s || (d || p) && s) && t.slideNext(), ((d || p) && !s || (c || u) && s) && t.slidePrev()) : ((d || c || h || m) && (a.preventDefault ? a.preventDefault() : a.returnValue = !1), (c || m) && t.slideNext(), (d || h) && t.slidePrev()), n("keyPress", i);
         }
       }
       function p() {
         t.keyboard.enabled || (d(l).on("keydown", c), t.keyboard.enabled = !0);
       }
       function u() {
         t.keyboard.enabled && (d(l).off("keydown", c), t.keyboard.enabled = !1);
       }
       t.keyboard = {
         enabled: !1
       }, s({
         keyboard: {
           enabled: !1,
           onlyInViewport: !0,
           pageUpDown: !0
         }
       }), i("init", function () {
         t.params.keyboard.enabled && p();
       }), i("destroy", function () {
         t.keyboard.enabled && u();
       }), Object.assign(t.keyboard, {
         enable: p,
         disable: u
       });
     }, function (e) {
       var t = e.swiper,
         s = e.extendParams,
         a = e.on,
         i = e.emit;
       var n = r();
       var l;
       s({
         mousewheel: {
           enabled: !1,
           releaseOnEdges: !1,
           invert: !1,
           forceToAxis: !1,
           sensitivity: 1,
           eventsTarget: "container",
           thresholdDelta: null,
           thresholdTime: null
         }
       }), t.mousewheel = {
         enabled: !1
       };
       var o,
         c = u();
       var h = [];
       function m() {
         t.enabled && (t.mouseEntered = !0);
       }
       function f() {
         t.enabled && (t.mouseEntered = !1);
       }
       function g(e) {
         return !(t.params.mousewheel.thresholdDelta && e.delta < t.params.mousewheel.thresholdDelta) && !(t.params.mousewheel.thresholdTime && u() - c < t.params.mousewheel.thresholdTime) && (e.delta >= 6 && u() - c < 60 || (e.direction < 0 ? t.isEnd && !t.params.loop || t.animating || (t.slideNext(), i("scroll", e.raw)) : t.isBeginning && !t.params.loop || t.animating || (t.slidePrev(), i("scroll", e.raw)), c = new n.Date().getTime(), !1));
       }
       function v(e) {
         var s = e,
           a = !0;
         if (!t.enabled) return;
         var r = t.params.mousewheel;
         t.params.cssMode && s.preventDefault();
         var n = t.$el;
         if ("container" !== t.params.mousewheel.eventsTarget && (n = d(t.params.mousewheel.eventsTarget)), !t.mouseEntered && !n[0].contains(s.target) && !r.releaseOnEdges) return !0;
         s.originalEvent && (s = s.originalEvent);
         var c = 0;
         var m = t.rtlTranslate ? -1 : 1,
           f = function (e) {
             var t = 0,
               s = 0,
               a = 0,
               i = 0;
             return "detail" in e && (s = e.detail), "wheelDelta" in e && (s = -e.wheelDelta / 120), "wheelDeltaY" in e && (s = -e.wheelDeltaY / 120), "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120), "axis" in e && e.axis === e.HORIZONTAL_AXIS && (t = s, s = 0), a = 10 * t, i = 10 * s, "deltaY" in e && (i = e.deltaY), "deltaX" in e && (a = e.deltaX), e.shiftKey && !a && (a = i, i = 0), (a || i) && e.deltaMode && (1 === e.deltaMode ? (a *= 40, i *= 40) : (a *= 800, i *= 800)), a && !t && (t = a < 1 ? -1 : 1), i && !s && (s = i < 1 ? -1 : 1), {
               spinX: t,
               spinY: s,
               pixelX: a,
               pixelY: i
             };
           }(s);
         if (r.forceToAxis) {
           if (t.isHorizontal()) {
             if (!(Math.abs(f.pixelX) > Math.abs(f.pixelY))) return !0;
             c = -f.pixelX * m;
           } else {
             if (!(Math.abs(f.pixelY) > Math.abs(f.pixelX))) return !0;
             c = -f.pixelY;
           }
         } else c = Math.abs(f.pixelX) > Math.abs(f.pixelY) ? -f.pixelX * m : -f.pixelY;
         if (0 === c) return !0;
         r.invert && (c = -c);
         var v = t.getTranslate() + c * r.sensitivity;
         if (v >= t.minTranslate() && (v = t.minTranslate()), v <= t.maxTranslate() && (v = t.maxTranslate()), a = !!t.params.loop || !(v === t.minTranslate() || v === t.maxTranslate()), a && t.params.nested && s.stopPropagation(), t.params.freeMode && t.params.freeMode.enabled) {
           var _e51 = {
               time: u(),
               delta: Math.abs(c),
               direction: Math.sign(c)
             },
             _a18 = o && _e51.time < o.time + 500 && _e51.delta <= o.delta && _e51.direction === o.direction;
           if (!_a18) {
             o = void 0, t.params.loop && t.loopFix();
             var _n6 = t.getTranslate() + c * r.sensitivity;
             var _d4 = t.isBeginning,
               _u3 = t.isEnd;
             if (_n6 >= t.minTranslate() && (_n6 = t.minTranslate()), _n6 <= t.maxTranslate() && (_n6 = t.maxTranslate()), t.setTransition(0), t.setTranslate(_n6), t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses(), (!_d4 && t.isBeginning || !_u3 && t.isEnd) && t.updateSlidesClasses(), t.params.freeMode.sticky) {
               clearTimeout(l), l = void 0, h.length >= 15 && h.shift();
               var _s32 = h.length ? h[h.length - 1] : void 0,
                 _a19 = h[0];
               if (h.push(_e51), _s32 && (_e51.delta > _s32.delta || _e51.direction !== _s32.direction)) h.splice(0);else if (h.length >= 15 && _e51.time - _a19.time < 500 && _a19.delta - _e51.delta >= 1 && _e51.delta <= 6) {
                 var _s33 = c > 0 ? .8 : .2;
                 o = _e51, h.splice(0), l = p(function () {
                   t.slideToClosest(t.params.speed, !0, void 0, _s33);
                 }, 0);
               }
               l || (l = p(function () {
                 o = _e51, h.splice(0), t.slideToClosest(t.params.speed, !0, void 0, .5);
               }, 500));
             }
             if (_a18 || i("scroll", s), t.params.autoplay && t.params.autoplayDisableOnInteraction && t.autoplay.stop(), _n6 === t.minTranslate() || _n6 === t.maxTranslate()) return !0;
           }
         } else {
           var _s34 = {
             time: u(),
             delta: Math.abs(c),
             direction: Math.sign(c),
             raw: e
           };
           h.length >= 2 && h.shift();
           var _a20 = h.length ? h[h.length - 1] : void 0;
           if (h.push(_s34), _a20 ? (_s34.direction !== _a20.direction || _s34.delta > _a20.delta || _s34.time > _a20.time + 150) && g(_s34) : g(_s34), function (e) {
             var s = t.params.mousewheel;
             if (e.direction < 0) {
               if (t.isEnd && !t.params.loop && s.releaseOnEdges) return !0;
             } else if (t.isBeginning && !t.params.loop && s.releaseOnEdges) return !0;
             return !1;
           }(_s34)) return !0;
         }
         return s.preventDefault ? s.preventDefault() : s.returnValue = !1, !1;
       }
       function w(e) {
         var s = t.$el;
         "container" !== t.params.mousewheel.eventsTarget && (s = d(t.params.mousewheel.eventsTarget)), s[e]("mouseenter", m), s[e]("mouseleave", f), s[e]("wheel", v);
       }
       function b() {
         return t.params.cssMode ? (t.wrapperEl.removeEventListener("wheel", v), !0) : !t.mousewheel.enabled && (w("on"), t.mousewheel.enabled = !0, !0);
       }
       function x() {
         return t.params.cssMode ? (t.wrapperEl.addEventListener(event, v), !0) : !!t.mousewheel.enabled && (w("off"), t.mousewheel.enabled = !1, !0);
       }
       a("init", function () {
         !t.params.mousewheel.enabled && t.params.cssMode && x(), t.params.mousewheel.enabled && b();
       }), a("destroy", function () {
         t.params.cssMode && b(), t.mousewheel.enabled && x();
       }), Object.assign(t.mousewheel, {
         enable: b,
         disable: x
       });
     }, function (e) {
       var t = e.swiper,
         s = e.extendParams,
         a = e.on,
         i = e.emit;
       function r(e) {
         var s;
         return e && (s = d(e), t.params.uniqueNavElements && "string" == typeof e && s.length > 1 && 1 === t.$el.find(e).length && (s = t.$el.find(e))), s;
       }
       function n(e, s) {
         var a = t.params.navigation;
         e && e.length > 0 && (e[s ? "addClass" : "removeClass"](a.disabledClass), e[0] && "BUTTON" === e[0].tagName && (e[0].disabled = s), t.params.watchOverflow && t.enabled && e[t.isLocked ? "addClass" : "removeClass"](a.lockClass));
       }
       function l() {
         if (t.params.loop) return;
         var _t$navigation = t.navigation,
           e = _t$navigation.$nextEl,
           s = _t$navigation.$prevEl;
         n(s, t.isBeginning && !t.params.rewind), n(e, t.isEnd && !t.params.rewind);
       }
       function o(e) {
         e.preventDefault(), (!t.isBeginning || t.params.loop || t.params.rewind) && t.slidePrev();
       }
       function c(e) {
         e.preventDefault(), (!t.isEnd || t.params.loop || t.params.rewind) && t.slideNext();
       }
       function p() {
         var e = t.params.navigation;
         if (t.params.navigation = F(t, t.originalParams.navigation, t.params.navigation, {
           nextEl: "swiper-button-next",
           prevEl: "swiper-button-prev"
         }), !e.nextEl && !e.prevEl) return;
         var s = r(e.nextEl),
           a = r(e.prevEl);
         s && s.length > 0 && s.on("click", c), a && a.length > 0 && a.on("click", o), Object.assign(t.navigation, {
           $nextEl: s,
           nextEl: s && s[0],
           $prevEl: a,
           prevEl: a && a[0]
         }), t.enabled || (s && s.addClass(e.lockClass), a && a.addClass(e.lockClass));
       }
       function u() {
         var _t$navigation2 = t.navigation,
           e = _t$navigation2.$nextEl,
           s = _t$navigation2.$prevEl;
         e && e.length && (e.off("click", c), e.removeClass(t.params.navigation.disabledClass)), s && s.length && (s.off("click", o), s.removeClass(t.params.navigation.disabledClass));
       }
       s({
         navigation: {
           nextEl: null,
           prevEl: null,
           hideOnClick: !1,
           disabledClass: "swiper-button-disabled",
           hiddenClass: "swiper-button-hidden",
           lockClass: "swiper-button-lock",
           navigationDisabledClass: "swiper-navigation-disabled"
         }
       }), t.navigation = {
         nextEl: null,
         $nextEl: null,
         prevEl: null,
         $prevEl: null
       }, a("init", function () {
         !1 === t.params.navigation.enabled ? h() : (p(), l());
       }), a("toEdge fromEdge lock unlock", function () {
         l();
       }), a("destroy", function () {
         u();
       }), a("enable disable", function () {
         var _t$navigation3 = t.navigation,
           e = _t$navigation3.$nextEl,
           s = _t$navigation3.$prevEl;
         e && e[t.enabled ? "removeClass" : "addClass"](t.params.navigation.lockClass), s && s[t.enabled ? "removeClass" : "addClass"](t.params.navigation.lockClass);
       }), a("click", function (e, s) {
         var _t$navigation4 = t.navigation,
           a = _t$navigation4.$nextEl,
           r = _t$navigation4.$prevEl,
           n = s.target;
         if (t.params.navigation.hideOnClick && !d(n).is(r) && !d(n).is(a)) {
           if (t.pagination && t.params.pagination && t.params.pagination.clickable && (t.pagination.el === n || t.pagination.el.contains(n))) return;
           var _e52;
           a ? _e52 = a.hasClass(t.params.navigation.hiddenClass) : r && (_e52 = r.hasClass(t.params.navigation.hiddenClass)), i(!0 === _e52 ? "navigationShow" : "navigationHide"), a && a.toggleClass(t.params.navigation.hiddenClass), r && r.toggleClass(t.params.navigation.hiddenClass);
         }
       });
       var h = function h() {
         t.$el.addClass(t.params.navigation.navigationDisabledClass), u();
       };
       Object.assign(t.navigation, {
         enable: function enable() {
           t.$el.removeClass(t.params.navigation.navigationDisabledClass), p(), l();
         },
         disable: h,
         update: l,
         init: p,
         destroy: u
       });
     }, function (e) {
       var t = e.swiper,
         s = e.extendParams,
         a = e.on,
         i = e.emit;
       var r = "swiper-pagination";
       var n;
       s({
         pagination: {
           el: null,
           bulletElement: "span",
           clickable: !1,
           hideOnClick: !1,
           renderBullet: null,
           renderProgressbar: null,
           renderFraction: null,
           renderCustom: null,
           progressbarOpposite: !1,
           type: "bullets",
           dynamicBullets: !1,
           dynamicMainBullets: 1,
           formatFractionCurrent: function formatFractionCurrent(e) {
             return e;
           },
           formatFractionTotal: function formatFractionTotal(e) {
             return e;
           },
           bulletClass: "".concat(r, "-bullet"),
           bulletActiveClass: "".concat(r, "-bullet-active"),
           modifierClass: "".concat(r, "-"),
           currentClass: "".concat(r, "-current"),
           totalClass: "".concat(r, "-total"),
           hiddenClass: "".concat(r, "-hidden"),
           progressbarFillClass: "".concat(r, "-progressbar-fill"),
           progressbarOppositeClass: "".concat(r, "-progressbar-opposite"),
           clickableClass: "".concat(r, "-clickable"),
           lockClass: "".concat(r, "-lock"),
           horizontalClass: "".concat(r, "-horizontal"),
           verticalClass: "".concat(r, "-vertical"),
           paginationDisabledClass: "".concat(r, "-disabled")
         }
       }), t.pagination = {
         el: null,
         $el: null,
         bullets: []
       };
       var l = 0;
       function o() {
         return !t.params.pagination.el || !t.pagination.el || !t.pagination.$el || 0 === t.pagination.$el.length;
       }
       function c(e, s) {
         var a = t.params.pagination.bulletActiveClass;
         e[s]().addClass("".concat(a, "-").concat(s))[s]().addClass("".concat(a, "-").concat(s, "-").concat(s));
       }
       function p() {
         var e = t.rtl,
           s = t.params.pagination;
         if (o()) return;
         var a = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.slides.length,
           r = t.pagination.$el;
         var p;
         var u = t.params.loop ? Math.ceil((a - 2 * t.loopedSlides) / t.params.slidesPerGroup) : t.snapGrid.length;
         if (t.params.loop ? (p = Math.ceil((t.activeIndex - t.loopedSlides) / t.params.slidesPerGroup), p > a - 1 - 2 * t.loopedSlides && (p -= a - 2 * t.loopedSlides), p > u - 1 && (p -= u), p < 0 && "bullets" !== t.params.paginationType && (p = u + p)) : p = void 0 !== t.snapIndex ? t.snapIndex : t.activeIndex || 0, "bullets" === s.type && t.pagination.bullets && t.pagination.bullets.length > 0) {
           var _a21 = t.pagination.bullets;
           var _i1, _o5, _u4;
           if (s.dynamicBullets && (n = _a21.eq(0)[t.isHorizontal() ? "outerWidth" : "outerHeight"](!0), r.css(t.isHorizontal() ? "width" : "height", n * (s.dynamicMainBullets + 4) + "px"), s.dynamicMainBullets > 1 && void 0 !== t.previousIndex && (l += p - (t.previousIndex - t.loopedSlides || 0), l > s.dynamicMainBullets - 1 ? l = s.dynamicMainBullets - 1 : l < 0 && (l = 0)), _i1 = Math.max(p - l, 0), _o5 = _i1 + (Math.min(_a21.length, s.dynamicMainBullets) - 1), _u4 = (_o5 + _i1) / 2), _a21.removeClass(["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map(function (e) {
             return "".concat(s.bulletActiveClass).concat(e);
           }).join(" ")), r.length > 1) _a21.each(function (e) {
             var t = d(e),
               a = t.index();
             a === p && t.addClass(s.bulletActiveClass), s.dynamicBullets && (a >= _i1 && a <= _o5 && t.addClass("".concat(s.bulletActiveClass, "-main")), a === _i1 && c(t, "prev"), a === _o5 && c(t, "next"));
           });else {
             var _e53 = _a21.eq(p),
               _r6 = _e53.index();
             if (_e53.addClass(s.bulletActiveClass), s.dynamicBullets) {
               var _e54 = _a21.eq(_i1),
                 _n7 = _a21.eq(_o5);
               for (var _e55 = _i1; _e55 <= _o5; _e55 += 1) _a21.eq(_e55).addClass("".concat(s.bulletActiveClass, "-main"));
               if (t.params.loop) {
                 if (_r6 >= _a21.length) {
                   for (var _e56 = s.dynamicMainBullets; _e56 >= 0; _e56 -= 1) _a21.eq(_a21.length - _e56).addClass("".concat(s.bulletActiveClass, "-main"));
                   _a21.eq(_a21.length - s.dynamicMainBullets - 1).addClass("".concat(s.bulletActiveClass, "-prev"));
                 } else c(_e54, "prev"), c(_n7, "next");
               } else c(_e54, "prev"), c(_n7, "next");
             }
           }
           if (s.dynamicBullets) {
             var _i10 = Math.min(_a21.length, s.dynamicMainBullets + 4),
               _r7 = (n * _i10 - n) / 2 - _u4 * n,
               _l6 = e ? "right" : "left";
             _a21.css(t.isHorizontal() ? _l6 : "top", "".concat(_r7, "px"));
           }
         }
         if ("fraction" === s.type && (r.find(U(s.currentClass)).text(s.formatFractionCurrent(p + 1)), r.find(U(s.totalClass)).text(s.formatFractionTotal(u))), "progressbar" === s.type) {
           var _e57;
           _e57 = s.progressbarOpposite ? t.isHorizontal() ? "vertical" : "horizontal" : t.isHorizontal() ? "horizontal" : "vertical";
           var _a22 = (p + 1) / u;
           var _i11 = 1,
             _n8 = 1;
           "horizontal" === _e57 ? _i11 = _a22 : _n8 = _a22, r.find(U(s.progressbarFillClass)).transform("translate3d(0,0,0) scaleX(".concat(_i11, ") scaleY(").concat(_n8, ")")).transition(t.params.speed);
         }
         "custom" === s.type && s.renderCustom ? (r.html(s.renderCustom(t, p + 1, u)), i("paginationRender", r[0])) : i("paginationUpdate", r[0]), t.params.watchOverflow && t.enabled && r[t.isLocked ? "addClass" : "removeClass"](s.lockClass);
       }
       function u() {
         var e = t.params.pagination;
         if (o()) return;
         var s = t.virtual && t.params.virtual.enabled ? t.virtual.slides.length : t.slides.length,
           a = t.pagination.$el;
         var r = "";
         if ("bullets" === e.type) {
           var _i12 = t.params.loop ? Math.ceil((s - 2 * t.loopedSlides) / t.params.slidesPerGroup) : t.snapGrid.length;
           t.params.freeMode && t.params.freeMode.enabled && !t.params.loop && _i12 > s && (_i12 = s);
           for (var _s35 = 0; _s35 < _i12; _s35 += 1) e.renderBullet ? r += e.renderBullet.call(t, _s35, e.bulletClass) : r += "<".concat(e.bulletElement, " class=\"").concat(e.bulletClass, "\"></").concat(e.bulletElement, ">");
           a.html(r), t.pagination.bullets = a.find(U(e.bulletClass));
         }
         "fraction" === e.type && (r = e.renderFraction ? e.renderFraction.call(t, e.currentClass, e.totalClass) : "<span class=\"".concat(e.currentClass, "\"></span> / <span class=\"").concat(e.totalClass, "\"></span>"), a.html(r)), "progressbar" === e.type && (r = e.renderProgressbar ? e.renderProgressbar.call(t, e.progressbarFillClass) : "<span class=\"".concat(e.progressbarFillClass, "\"></span>"), a.html(r)), "custom" !== e.type && i("paginationRender", t.pagination.$el[0]);
       }
       function h() {
         t.params.pagination = F(t, t.originalParams.pagination, t.params.pagination, {
           el: "swiper-pagination"
         });
         var e = t.params.pagination;
         if (!e.el) return;
         var s = d(e.el);
         0 !== s.length && (t.params.uniqueNavElements && "string" == typeof e.el && s.length > 1 && (s = t.$el.find(e.el), s.length > 1 && (s = s.filter(function (e) {
           return d(e).parents(".swiper")[0] === t.el;
         }))), "bullets" === e.type && e.clickable && s.addClass(e.clickableClass), s.addClass(e.modifierClass + e.type), s.addClass(t.isHorizontal() ? e.horizontalClass : e.verticalClass), "bullets" === e.type && e.dynamicBullets && (s.addClass("".concat(e.modifierClass).concat(e.type, "-dynamic")), l = 0, e.dynamicMainBullets < 1 && (e.dynamicMainBullets = 1)), "progressbar" === e.type && e.progressbarOpposite && s.addClass(e.progressbarOppositeClass), e.clickable && s.on("click", U(e.bulletClass), function (e) {
           e.preventDefault();
           var s = d(this).index() * t.params.slidesPerGroup;
           t.params.loop && (s += t.loopedSlides), t.slideTo(s);
         }), Object.assign(t.pagination, {
           $el: s,
           el: s[0]
         }), t.enabled || s.addClass(e.lockClass));
       }
       function m() {
         var e = t.params.pagination;
         if (o()) return;
         var s = t.pagination.$el;
         s.removeClass(e.hiddenClass), s.removeClass(e.modifierClass + e.type), s.removeClass(t.isHorizontal() ? e.horizontalClass : e.verticalClass), t.pagination.bullets && t.pagination.bullets.removeClass && t.pagination.bullets.removeClass(e.bulletActiveClass), e.clickable && s.off("click", U(e.bulletClass));
       }
       a("init", function () {
         !1 === t.params.pagination.enabled ? f() : (h(), u(), p());
       }), a("activeIndexChange", function () {
         (t.params.loop || void 0 === t.snapIndex) && p();
       }), a("snapIndexChange", function () {
         t.params.loop || p();
       }), a("slidesLengthChange", function () {
         t.params.loop && (u(), p());
       }), a("snapGridLengthChange", function () {
         t.params.loop || (u(), p());
       }), a("destroy", function () {
         m();
       }), a("enable disable", function () {
         var e = t.pagination.$el;
         e && e[t.enabled ? "removeClass" : "addClass"](t.params.pagination.lockClass);
       }), a("lock unlock", function () {
         p();
       }), a("click", function (e, s) {
         var a = s.target,
           r = t.pagination.$el;
         if (t.params.pagination.el && t.params.pagination.hideOnClick && r.length > 0 && !d(a).hasClass(t.params.pagination.bulletClass)) {
           if (t.navigation && (t.navigation.nextEl && a === t.navigation.nextEl || t.navigation.prevEl && a === t.navigation.prevEl)) return;
           var _e58 = r.hasClass(t.params.pagination.hiddenClass);
           i(!0 === _e58 ? "paginationShow" : "paginationHide"), r.toggleClass(t.params.pagination.hiddenClass);
         }
       });
       var f = function f() {
         t.$el.addClass(t.params.pagination.paginationDisabledClass), t.pagination.$el && t.pagination.$el.addClass(t.params.pagination.paginationDisabledClass), m();
       };
       Object.assign(t.pagination, {
         enable: function enable() {
           t.$el.removeClass(t.params.pagination.paginationDisabledClass), t.pagination.$el && t.pagination.$el.removeClass(t.params.pagination.paginationDisabledClass), h(), u(), p();
         },
         disable: f,
         render: u,
         update: p,
         init: h,
         destroy: m
       });
     }, function (e) {
       var t = e.swiper,
         s = e.extendParams,
         i = e.on,
         r = e.emit;
       var n = a();
       var l,
         o,
         c,
         u,
         h = !1,
         m = null,
         f = null;
       function g() {
         if (!t.params.scrollbar.el || !t.scrollbar.el) return;
         var e = t.scrollbar,
           s = t.rtlTranslate,
           a = t.progress,
           i = e.$dragEl,
           r = e.$el,
           n = t.params.scrollbar;
         var l = o,
           d = (c - o) * a;
         s ? (d = -d, d > 0 ? (l = o - d, d = 0) : -d + o > c && (l = c + d)) : d < 0 ? (l = o + d, d = 0) : d + o > c && (l = c - d), t.isHorizontal() ? (i.transform("translate3d(".concat(d, "px, 0, 0)")), i[0].style.width = "".concat(l, "px")) : (i.transform("translate3d(0px, ".concat(d, "px, 0)")), i[0].style.height = "".concat(l, "px")), n.hide && (clearTimeout(m), r[0].style.opacity = 1, m = setTimeout(function () {
           r[0].style.opacity = 0, r.transition(400);
         }, 1e3));
       }
       function v() {
         if (!t.params.scrollbar.el || !t.scrollbar.el) return;
         var e = t.scrollbar,
           s = e.$dragEl,
           a = e.$el;
         s[0].style.width = "", s[0].style.height = "", c = t.isHorizontal() ? a[0].offsetWidth : a[0].offsetHeight, u = t.size / (t.virtualSize + t.params.slidesOffsetBefore - (t.params.centeredSlides ? t.snapGrid[0] : 0)), o = "auto" === t.params.scrollbar.dragSize ? c * u : parseInt(t.params.scrollbar.dragSize, 10), t.isHorizontal() ? s[0].style.width = "".concat(o, "px") : s[0].style.height = "".concat(o, "px"), a[0].style.display = u >= 1 ? "none" : "", t.params.scrollbar.hide && (a[0].style.opacity = 0), t.params.watchOverflow && t.enabled && e.$el[t.isLocked ? "addClass" : "removeClass"](t.params.scrollbar.lockClass);
       }
       function w(e) {
         return t.isHorizontal() ? "touchstart" === e.type || "touchmove" === e.type ? e.targetTouches[0].clientX : e.clientX : "touchstart" === e.type || "touchmove" === e.type ? e.targetTouches[0].clientY : e.clientY;
       }
       function b(e) {
         var s = t.scrollbar,
           a = t.rtlTranslate,
           i = s.$el;
         var r;
         r = (w(e) - i.offset()[t.isHorizontal() ? "left" : "top"] - (null !== l ? l : o / 2)) / (c - o), r = Math.max(Math.min(r, 1), 0), a && (r = 1 - r);
         var n = t.minTranslate() + (t.maxTranslate() - t.minTranslate()) * r;
         t.updateProgress(n), t.setTranslate(n), t.updateActiveIndex(), t.updateSlidesClasses();
       }
       function x(e) {
         var s = t.params.scrollbar,
           a = t.scrollbar,
           i = t.$wrapperEl,
           n = a.$el,
           o = a.$dragEl;
         h = !0, l = e.target === o[0] || e.target === o ? w(e) - e.target.getBoundingClientRect()[t.isHorizontal() ? "left" : "top"] : null, e.preventDefault(), e.stopPropagation(), i.transition(100), o.transition(100), b(e), clearTimeout(f), n.transition(0), s.hide && n.css("opacity", 1), t.params.cssMode && t.$wrapperEl.css("scroll-snap-type", "none"), r("scrollbarDragStart", e);
       }
       function y(e) {
         var s = t.scrollbar,
           a = t.$wrapperEl,
           i = s.$el,
           n = s.$dragEl;
         h && (e.preventDefault ? e.preventDefault() : e.returnValue = !1, b(e), a.transition(0), i.transition(0), n.transition(0), r("scrollbarDragMove", e));
       }
       function E(e) {
         var s = t.params.scrollbar,
           a = t.scrollbar,
           i = t.$wrapperEl,
           n = a.$el;
         h && (h = !1, t.params.cssMode && (t.$wrapperEl.css("scroll-snap-type", ""), i.transition("")), s.hide && (clearTimeout(f), f = p(function () {
           n.css("opacity", 0), n.transition(400);
         }, 1e3)), r("scrollbarDragEnd", e), s.snapOnRelease && t.slideToClosest());
       }
       function C(e) {
         var s = t.scrollbar,
           a = t.touchEventsTouch,
           i = t.touchEventsDesktop,
           r = t.params,
           l = t.support,
           o = s.$el;
         if (!o) return;
         var d = o[0],
           c = !(!l.passiveListener || !r.passiveListeners) && {
             passive: !1,
             capture: !1
           },
           p = !(!l.passiveListener || !r.passiveListeners) && {
             passive: !0,
             capture: !1
           };
         if (!d) return;
         var u = "on" === e ? "addEventListener" : "removeEventListener";
         l.touch ? (d[u](a.start, x, c), d[u](a.move, y, c), d[u](a.end, E, p)) : (d[u](i.start, x, c), n[u](i.move, y, c), n[u](i.end, E, p));
       }
       function T() {
         var e = t.scrollbar,
           s = t.$el;
         t.params.scrollbar = F(t, t.originalParams.scrollbar, t.params.scrollbar, {
           el: "swiper-scrollbar"
         });
         var a = t.params.scrollbar;
         if (!a.el) return;
         var i = d(a.el);
         t.params.uniqueNavElements && "string" == typeof a.el && i.length > 1 && 1 === s.find(a.el).length && (i = s.find(a.el)), i.addClass(t.isHorizontal() ? a.horizontalClass : a.verticalClass);
         var r = i.find(".".concat(t.params.scrollbar.dragClass));
         0 === r.length && (r = d("<div class=\"".concat(t.params.scrollbar.dragClass, "\"></div>")), i.append(r)), Object.assign(e, {
           $el: i,
           el: i[0],
           $dragEl: r,
           dragEl: r[0]
         }), a.draggable && t.params.scrollbar.el && t.scrollbar.el && C("on"), i && i[t.enabled ? "removeClass" : "addClass"](t.params.scrollbar.lockClass);
       }
       function $() {
         var e = t.params.scrollbar,
           s = t.scrollbar.$el;
         s && s.removeClass(t.isHorizontal() ? e.horizontalClass : e.verticalClass), t.params.scrollbar.el && t.scrollbar.el && C("off");
       }
       s({
         scrollbar: {
           el: null,
           dragSize: "auto",
           hide: !1,
           draggable: !1,
           snapOnRelease: !0,
           lockClass: "swiper-scrollbar-lock",
           dragClass: "swiper-scrollbar-drag",
           scrollbarDisabledClass: "swiper-scrollbar-disabled",
           horizontalClass: "swiper-scrollbar-horizontal",
           verticalClass: "swiper-scrollbar-vertical"
         }
       }), t.scrollbar = {
         el: null,
         dragEl: null,
         $el: null,
         $dragEl: null
       }, i("init", function () {
         !1 === t.params.scrollbar.enabled ? S() : (T(), v(), g());
       }), i("update resize observerUpdate lock unlock", function () {
         v();
       }), i("setTranslate", function () {
         g();
       }), i("setTransition", function (e, s) {
         !function (e) {
           t.params.scrollbar.el && t.scrollbar.el && t.scrollbar.$dragEl.transition(e);
         }(s);
       }), i("enable disable", function () {
         var e = t.scrollbar.$el;
         e && e[t.enabled ? "removeClass" : "addClass"](t.params.scrollbar.lockClass);
       }), i("destroy", function () {
         $();
       });
       var S = function S() {
         t.$el.addClass(t.params.scrollbar.scrollbarDisabledClass), t.scrollbar.$el && t.scrollbar.$el.addClass(t.params.scrollbar.scrollbarDisabledClass), $();
       };
       Object.assign(t.scrollbar, {
         enable: function enable() {
           t.$el.removeClass(t.params.scrollbar.scrollbarDisabledClass), t.scrollbar.$el && t.scrollbar.$el.removeClass(t.params.scrollbar.scrollbarDisabledClass), T(), v(), g();
         },
         disable: S,
         updateSize: v,
         setTranslate: g,
         init: T,
         destroy: $
       });
     }, function (e) {
       var t = e.swiper,
         s = e.extendParams,
         a = e.on;
       s({
         parallax: {
           enabled: !1
         }
       });
       var i = function i(e, s) {
           var a = t.rtl,
             i = d(e),
             r = a ? -1 : 1,
             n = i.attr("data-swiper-parallax") || "0";
           var l = i.attr("data-swiper-parallax-x"),
             o = i.attr("data-swiper-parallax-y");
           var c = i.attr("data-swiper-parallax-scale"),
             p = i.attr("data-swiper-parallax-opacity");
           if (l || o ? (l = l || "0", o = o || "0") : t.isHorizontal() ? (l = n, o = "0") : (o = n, l = "0"), l = l.indexOf("%") >= 0 ? parseInt(l, 10) * s * r + "%" : l * s * r + "px", o = o.indexOf("%") >= 0 ? parseInt(o, 10) * s + "%" : o * s + "px", null != p) {
             var _e59 = p - (p - 1) * (1 - Math.abs(s));
             i[0].style.opacity = _e59;
           }
           if (null == c) i.transform("translate3d(".concat(l, ", ").concat(o, ", 0px)"));else {
             var _e60 = c - (c - 1) * (1 - Math.abs(s));
             i.transform("translate3d(".concat(l, ", ").concat(o, ", 0px) scale(").concat(_e60, ")"));
           }
         },
         r = function r() {
           var e = t.$el,
             s = t.slides,
             a = t.progress,
             r = t.snapGrid;
           e.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each(function (e) {
             i(e, a);
           }), s.each(function (e, s) {
             var n = e.progress;
             t.params.slidesPerGroup > 1 && "auto" !== t.params.slidesPerView && (n += Math.ceil(s / 2) - a * (r.length - 1)), n = Math.min(Math.max(n, -1), 1), d(e).find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each(function (e) {
               i(e, n);
             });
           });
         };
       a("beforeInit", function () {
         t.params.parallax.enabled && (t.params.watchSlidesProgress = !0, t.originalParams.watchSlidesProgress = !0);
       }), a("init", function () {
         t.params.parallax.enabled && r();
       }), a("setTranslate", function () {
         t.params.parallax.enabled && r();
       }), a("setTransition", function (e, s) {
         t.params.parallax.enabled && function (e) {
           void 0 === e && (e = t.params.speed);
           var s = t.$el;
           s.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each(function (t) {
             var s = d(t);
             var a = parseInt(s.attr("data-swiper-parallax-duration"), 10) || e;
             0 === e && (a = 0), s.transition(a);
           });
         }(s);
       });
     }, function (e) {
       var t = e.swiper,
         s = e.extendParams,
         a = e.on,
         i = e.emit;
       var n = r();
       s({
         zoom: {
           enabled: !1,
           maxRatio: 3,
           minRatio: 1,
           toggle: !0,
           containerClass: "swiper-zoom-container",
           zoomedSlideClass: "swiper-slide-zoomed"
         }
       }), t.zoom = {
         enabled: !1
       };
       var l,
         o,
         c,
         p = 1,
         u = !1;
       var m = {
           $slideEl: void 0,
           slideWidth: void 0,
           slideHeight: void 0,
           $imageEl: void 0,
           $imageWrapEl: void 0,
           maxRatio: 3
         },
         f = {
           isTouched: void 0,
           isMoved: void 0,
           currentX: void 0,
           currentY: void 0,
           minX: void 0,
           minY: void 0,
           maxX: void 0,
           maxY: void 0,
           width: void 0,
           height: void 0,
           startX: void 0,
           startY: void 0,
           touchesStart: {},
           touchesCurrent: {}
         },
         g = {
           x: void 0,
           y: void 0,
           prevPositionX: void 0,
           prevPositionY: void 0,
           prevTime: void 0
         };
       var v = 1;
       function w(e) {
         if (e.targetTouches.length < 2) return 1;
         var t = e.targetTouches[0].pageX,
           s = e.targetTouches[0].pageY,
           a = e.targetTouches[1].pageX,
           i = e.targetTouches[1].pageY;
         return Math.sqrt(Math.pow(a - t, 2) + Math.pow(i - s, 2));
       }
       function b(e) {
         var s = t.support,
           a = t.params.zoom;
         if (o = !1, c = !1, !s.gestures) {
           if ("touchstart" !== e.type || "touchstart" === e.type && e.targetTouches.length < 2) return;
           o = !0, m.scaleStart = w(e);
         }
         m.$slideEl && m.$slideEl.length || (m.$slideEl = d(e.target).closest(".".concat(t.params.slideClass)), 0 === m.$slideEl.length && (m.$slideEl = t.slides.eq(t.activeIndex)), m.$imageEl = m.$slideEl.find(".".concat(a.containerClass)).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0), m.$imageWrapEl = m.$imageEl.parent(".".concat(a.containerClass)), m.maxRatio = m.$imageWrapEl.attr("data-swiper-zoom") || a.maxRatio, 0 !== m.$imageWrapEl.length) ? (m.$imageEl && m.$imageEl.transition(0), u = !0) : m.$imageEl = void 0;
       }
       function x(e) {
         var s = t.support,
           a = t.params.zoom,
           i = t.zoom;
         if (!s.gestures) {
           if ("touchmove" !== e.type || "touchmove" === e.type && e.targetTouches.length < 2) return;
           c = !0, m.scaleMove = w(e);
         }
         m.$imageEl && 0 !== m.$imageEl.length ? (s.gestures ? i.scale = e.scale * p : i.scale = m.scaleMove / m.scaleStart * p, i.scale > m.maxRatio && (i.scale = m.maxRatio - 1 + Math.pow(i.scale - m.maxRatio + 1, .5)), i.scale < a.minRatio && (i.scale = a.minRatio + 1 - Math.pow(a.minRatio - i.scale + 1, .5)), m.$imageEl.transform("translate3d(0,0,0) scale(".concat(i.scale, ")"))) : "gesturechange" === e.type && b(e);
       }
       function y(e) {
         var s = t.device,
           a = t.support,
           i = t.params.zoom,
           r = t.zoom;
         if (!a.gestures) {
           if (!o || !c) return;
           if ("touchend" !== e.type || "touchend" === e.type && e.changedTouches.length < 2 && !s.android) return;
           o = !1, c = !1;
         }
         m.$imageEl && 0 !== m.$imageEl.length && (r.scale = Math.max(Math.min(r.scale, m.maxRatio), i.minRatio), m.$imageEl.transition(t.params.speed).transform("translate3d(0,0,0) scale(".concat(r.scale, ")")), p = r.scale, u = !1, 1 === r.scale && (m.$slideEl = void 0));
       }
       function E(e) {
         var s = t.zoom;
         if (!m.$imageEl || 0 === m.$imageEl.length) return;
         if (t.allowClick = !1, !f.isTouched || !m.$slideEl) return;
         f.isMoved || (f.width = m.$imageEl[0].offsetWidth, f.height = m.$imageEl[0].offsetHeight, f.startX = h(m.$imageWrapEl[0], "x") || 0, f.startY = h(m.$imageWrapEl[0], "y") || 0, m.slideWidth = m.$slideEl[0].offsetWidth, m.slideHeight = m.$slideEl[0].offsetHeight, m.$imageWrapEl.transition(0));
         var a = f.width * s.scale,
           i = f.height * s.scale;
         if (!(a < m.slideWidth && i < m.slideHeight)) {
           if (f.minX = Math.min(m.slideWidth / 2 - a / 2, 0), f.maxX = -f.minX, f.minY = Math.min(m.slideHeight / 2 - i / 2, 0), f.maxY = -f.minY, f.touchesCurrent.x = "touchmove" === e.type ? e.targetTouches[0].pageX : e.pageX, f.touchesCurrent.y = "touchmove" === e.type ? e.targetTouches[0].pageY : e.pageY, !f.isMoved && !u) {
             if (t.isHorizontal() && (Math.floor(f.minX) === Math.floor(f.startX) && f.touchesCurrent.x < f.touchesStart.x || Math.floor(f.maxX) === Math.floor(f.startX) && f.touchesCurrent.x > f.touchesStart.x)) return void (f.isTouched = !1);
             if (!t.isHorizontal() && (Math.floor(f.minY) === Math.floor(f.startY) && f.touchesCurrent.y < f.touchesStart.y || Math.floor(f.maxY) === Math.floor(f.startY) && f.touchesCurrent.y > f.touchesStart.y)) return void (f.isTouched = !1);
           }
           e.cancelable && e.preventDefault(), e.stopPropagation(), f.isMoved = !0, f.currentX = f.touchesCurrent.x - f.touchesStart.x + f.startX, f.currentY = f.touchesCurrent.y - f.touchesStart.y + f.startY, f.currentX < f.minX && (f.currentX = f.minX + 1 - Math.pow(f.minX - f.currentX + 1, .8)), f.currentX > f.maxX && (f.currentX = f.maxX - 1 + Math.pow(f.currentX - f.maxX + 1, .8)), f.currentY < f.minY && (f.currentY = f.minY + 1 - Math.pow(f.minY - f.currentY + 1, .8)), f.currentY > f.maxY && (f.currentY = f.maxY - 1 + Math.pow(f.currentY - f.maxY + 1, .8)), g.prevPositionX || (g.prevPositionX = f.touchesCurrent.x), g.prevPositionY || (g.prevPositionY = f.touchesCurrent.y), g.prevTime || (g.prevTime = Date.now()), g.x = (f.touchesCurrent.x - g.prevPositionX) / (Date.now() - g.prevTime) / 2, g.y = (f.touchesCurrent.y - g.prevPositionY) / (Date.now() - g.prevTime) / 2, Math.abs(f.touchesCurrent.x - g.prevPositionX) < 2 && (g.x = 0), Math.abs(f.touchesCurrent.y - g.prevPositionY) < 2 && (g.y = 0), g.prevPositionX = f.touchesCurrent.x, g.prevPositionY = f.touchesCurrent.y, g.prevTime = Date.now(), m.$imageWrapEl.transform("translate3d(".concat(f.currentX, "px, ").concat(f.currentY, "px,0)"));
         }
       }
       function C() {
         var e = t.zoom;
         m.$slideEl && t.previousIndex !== t.activeIndex && (m.$imageEl && m.$imageEl.transform("translate3d(0,0,0) scale(1)"), m.$imageWrapEl && m.$imageWrapEl.transform("translate3d(0,0,0)"), e.scale = 1, p = 1, m.$slideEl = void 0, m.$imageEl = void 0, m.$imageWrapEl = void 0);
       }
       function T(e) {
         var s = t.zoom,
           a = t.params.zoom;
         if (m.$slideEl || (e && e.target && (m.$slideEl = d(e.target).closest(".".concat(t.params.slideClass))), m.$slideEl || (t.params.virtual && t.params.virtual.enabled && t.virtual ? m.$slideEl = t.$wrapperEl.children(".".concat(t.params.slideActiveClass)) : m.$slideEl = t.slides.eq(t.activeIndex)), m.$imageEl = m.$slideEl.find(".".concat(a.containerClass)).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0), m.$imageWrapEl = m.$imageEl.parent(".".concat(a.containerClass))), !m.$imageEl || 0 === m.$imageEl.length || !m.$imageWrapEl || 0 === m.$imageWrapEl.length) return;
         var i, r, l, o, c, u, h, g, v, w, b, x, y, E, C, T, $, S;
         t.params.cssMode && (t.wrapperEl.style.overflow = "hidden", t.wrapperEl.style.touchAction = "none"), m.$slideEl.addClass("".concat(a.zoomedSlideClass)), void 0 === f.touchesStart.x && e ? (i = "touchend" === e.type ? e.changedTouches[0].pageX : e.pageX, r = "touchend" === e.type ? e.changedTouches[0].pageY : e.pageY) : (i = f.touchesStart.x, r = f.touchesStart.y), s.scale = m.$imageWrapEl.attr("data-swiper-zoom") || a.maxRatio, p = m.$imageWrapEl.attr("data-swiper-zoom") || a.maxRatio, e ? ($ = m.$slideEl[0].offsetWidth, S = m.$slideEl[0].offsetHeight, l = m.$slideEl.offset().left + n.scrollX, o = m.$slideEl.offset().top + n.scrollY, c = l + $ / 2 - i, u = o + S / 2 - r, v = m.$imageEl[0].offsetWidth, w = m.$imageEl[0].offsetHeight, b = v * s.scale, x = w * s.scale, y = Math.min($ / 2 - b / 2, 0), E = Math.min(S / 2 - x / 2, 0), C = -y, T = -E, h = c * s.scale, g = u * s.scale, h < y && (h = y), h > C && (h = C), g < E && (g = E), g > T && (g = T)) : (h = 0, g = 0), m.$imageWrapEl.transition(300).transform("translate3d(".concat(h, "px, ").concat(g, "px,0)")), m.$imageEl.transition(300).transform("translate3d(0,0,0) scale(".concat(s.scale, ")"));
       }
       function $() {
         var e = t.zoom,
           s = t.params.zoom;
         m.$slideEl || (t.params.virtual && t.params.virtual.enabled && t.virtual ? m.$slideEl = t.$wrapperEl.children(".".concat(t.params.slideActiveClass)) : m.$slideEl = t.slides.eq(t.activeIndex), m.$imageEl = m.$slideEl.find(".".concat(s.containerClass)).eq(0).find("picture, img, svg, canvas, .swiper-zoom-target").eq(0), m.$imageWrapEl = m.$imageEl.parent(".".concat(s.containerClass))), m.$imageEl && 0 !== m.$imageEl.length && m.$imageWrapEl && 0 !== m.$imageWrapEl.length && (t.params.cssMode && (t.wrapperEl.style.overflow = "", t.wrapperEl.style.touchAction = ""), e.scale = 1, p = 1, m.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"), m.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)"), m.$slideEl.removeClass("".concat(s.zoomedSlideClass)), m.$slideEl = void 0);
       }
       function S(e) {
         var s = t.zoom;
         s.scale && 1 !== s.scale ? $() : T(e);
       }
       function M() {
         var e = t.support;
         return {
           passiveListener: !("touchstart" !== t.touchEvents.start || !e.passiveListener || !t.params.passiveListeners) && {
             passive: !0,
             capture: !1
           },
           activeListenerWithCapture: !e.passiveListener || {
             passive: !1,
             capture: !0
           }
         };
       }
       function P() {
         return ".".concat(t.params.slideClass);
       }
       function k(e) {
         var _M = M(),
           s = _M.passiveListener,
           a = P();
         t.$wrapperEl[e]("gesturestart", a, b, s), t.$wrapperEl[e]("gesturechange", a, x, s), t.$wrapperEl[e]("gestureend", a, y, s);
       }
       function z() {
         l || (l = !0, k("on"));
       }
       function L() {
         l && (l = !1, k("off"));
       }
       function O() {
         var e = t.zoom;
         if (e.enabled) return;
         e.enabled = !0;
         var s = t.support,
           _M2 = M(),
           a = _M2.passiveListener,
           i = _M2.activeListenerWithCapture,
           r = P();
         s.gestures ? (t.$wrapperEl.on(t.touchEvents.start, z, a), t.$wrapperEl.on(t.touchEvents.end, L, a)) : "touchstart" === t.touchEvents.start && (t.$wrapperEl.on(t.touchEvents.start, r, b, a), t.$wrapperEl.on(t.touchEvents.move, r, x, i), t.$wrapperEl.on(t.touchEvents.end, r, y, a), t.touchEvents.cancel && t.$wrapperEl.on(t.touchEvents.cancel, r, y, a)), t.$wrapperEl.on(t.touchEvents.move, ".".concat(t.params.zoom.containerClass), E, i);
       }
       function I() {
         var e = t.zoom;
         if (!e.enabled) return;
         var s = t.support;
         e.enabled = !1;
         var _M3 = M(),
           a = _M3.passiveListener,
           i = _M3.activeListenerWithCapture,
           r = P();
         s.gestures ? (t.$wrapperEl.off(t.touchEvents.start, z, a), t.$wrapperEl.off(t.touchEvents.end, L, a)) : "touchstart" === t.touchEvents.start && (t.$wrapperEl.off(t.touchEvents.start, r, b, a), t.$wrapperEl.off(t.touchEvents.move, r, x, i), t.$wrapperEl.off(t.touchEvents.end, r, y, a), t.touchEvents.cancel && t.$wrapperEl.off(t.touchEvents.cancel, r, y, a)), t.$wrapperEl.off(t.touchEvents.move, ".".concat(t.params.zoom.containerClass), E, i);
       }
       Object.defineProperty(t.zoom, "scale", {
         get: function get() {
           return v;
         },
         set: function set(e) {
           if (v !== e) {
             var _t44 = m.$imageEl ? m.$imageEl[0] : void 0,
               _s36 = m.$slideEl ? m.$slideEl[0] : void 0;
             i("zoomChange", e, _t44, _s36);
           }
           v = e;
         }
       }), a("init", function () {
         t.params.zoom.enabled && O();
       }), a("destroy", function () {
         I();
       }), a("touchStart", function (e, s) {
         t.zoom.enabled && function (e) {
           var s = t.device;
           m.$imageEl && 0 !== m.$imageEl.length && (f.isTouched || (s.android && e.cancelable && e.preventDefault(), f.isTouched = !0, f.touchesStart.x = "touchstart" === e.type ? e.targetTouches[0].pageX : e.pageX, f.touchesStart.y = "touchstart" === e.type ? e.targetTouches[0].pageY : e.pageY));
         }(s);
       }), a("touchEnd", function (e, s) {
         t.zoom.enabled && function () {
           var e = t.zoom;
           if (!m.$imageEl || 0 === m.$imageEl.length) return;
           if (!f.isTouched || !f.isMoved) return f.isTouched = !1, void (f.isMoved = !1);
           f.isTouched = !1, f.isMoved = !1;
           var s = 300,
             a = 300;
           var i = g.x * s,
             r = f.currentX + i,
             n = g.y * a,
             l = f.currentY + n;
           0 !== g.x && (s = Math.abs((r - f.currentX) / g.x)), 0 !== g.y && (a = Math.abs((l - f.currentY) / g.y));
           var o = Math.max(s, a);
           f.currentX = r, f.currentY = l;
           var d = f.width * e.scale,
             c = f.height * e.scale;
           f.minX = Math.min(m.slideWidth / 2 - d / 2, 0), f.maxX = -f.minX, f.minY = Math.min(m.slideHeight / 2 - c / 2, 0), f.maxY = -f.minY, f.currentX = Math.max(Math.min(f.currentX, f.maxX), f.minX), f.currentY = Math.max(Math.min(f.currentY, f.maxY), f.minY), m.$imageWrapEl.transition(o).transform("translate3d(".concat(f.currentX, "px, ").concat(f.currentY, "px,0)"));
         }();
       }), a("doubleTap", function (e, s) {
         !t.animating && t.params.zoom.enabled && t.zoom.enabled && t.params.zoom.toggle && S(s);
       }), a("transitionEnd", function () {
         t.zoom.enabled && t.params.zoom.enabled && C();
       }), a("slideChange", function () {
         t.zoom.enabled && t.params.zoom.enabled && t.params.cssMode && C();
       }), Object.assign(t.zoom, {
         enable: O,
         disable: I,
         "in": T,
         out: $,
         toggle: S
       });
     }, function (e) {
       var t = e.swiper,
         s = e.extendParams,
         a = e.on,
         i = e.emit;
       s({
         lazy: {
           checkInView: !1,
           enabled: !1,
           loadPrevNext: !1,
           loadPrevNextAmount: 1,
           loadOnTransitionStart: !1,
           scrollingElement: "",
           elementClass: "swiper-lazy",
           loadingClass: "swiper-lazy-loading",
           loadedClass: "swiper-lazy-loaded",
           preloaderClass: "swiper-lazy-preloader"
         }
       }), t.lazy = {};
       var n = !1,
         l = !1;
       function o(e, s) {
         void 0 === s && (s = !0);
         var a = t.params.lazy;
         if (void 0 === e) return;
         if (0 === t.slides.length) return;
         var r = t.virtual && t.params.virtual.enabled ? t.$wrapperEl.children(".".concat(t.params.slideClass, "[data-swiper-slide-index=\"").concat(e, "\"]")) : t.slides.eq(e),
           n = r.find(".".concat(a.elementClass, ":not(.").concat(a.loadedClass, "):not(.").concat(a.loadingClass, ")"));
         !r.hasClass(a.elementClass) || r.hasClass(a.loadedClass) || r.hasClass(a.loadingClass) || n.push(r[0]), 0 !== n.length && n.each(function (e) {
           var n = d(e);
           n.addClass(a.loadingClass);
           var l = n.attr("data-background"),
             c = n.attr("data-src"),
             p = n.attr("data-srcset"),
             u = n.attr("data-sizes"),
             h = n.parent("picture");
           t.loadImage(n[0], c || l, p, u, !1, function () {
             if (null != t && t && (!t || t.params) && !t.destroyed) {
               if (l ? (n.css("background-image", "url(\"".concat(l, "\")")), n.removeAttr("data-background")) : (p && (n.attr("srcset", p), n.removeAttr("data-srcset")), u && (n.attr("sizes", u), n.removeAttr("data-sizes")), h.length && h.children("source").each(function (e) {
                 var t = d(e);
                 t.attr("data-srcset") && (t.attr("srcset", t.attr("data-srcset")), t.removeAttr("data-srcset"));
               }), c && (n.attr("src", c), n.removeAttr("data-src"))), n.addClass(a.loadedClass).removeClass(a.loadingClass), r.find(".".concat(a.preloaderClass)).remove(), t.params.loop && s) {
                 var _e61 = r.attr("data-swiper-slide-index");
                 if (r.hasClass(t.params.slideDuplicateClass)) {
                   o(t.$wrapperEl.children("[data-swiper-slide-index=\"".concat(_e61, "\"]:not(.").concat(t.params.slideDuplicateClass, ")")).index(), !1);
                 } else {
                   o(t.$wrapperEl.children(".".concat(t.params.slideDuplicateClass, "[data-swiper-slide-index=\"").concat(_e61, "\"]")).index(), !1);
                 }
               }
               i("lazyImageReady", r[0], n[0]), t.params.autoHeight && t.updateAutoHeight();
             }
           }), i("lazyImageLoad", r[0], n[0]);
         });
       }
       function c() {
         var e = t.$wrapperEl,
           s = t.params,
           a = t.slides,
           i = t.activeIndex,
           r = t.virtual && s.virtual.enabled,
           n = s.lazy;
         var c = s.slidesPerView;
         function p(t) {
           if (r) {
             if (e.children(".".concat(s.slideClass, "[data-swiper-slide-index=\"").concat(t, "\"]")).length) return !0;
           } else if (a[t]) return !0;
           return !1;
         }
         function u(e) {
           return r ? d(e).attr("data-swiper-slide-index") : d(e).index();
         }
         if ("auto" === c && (c = 0), l || (l = !0), t.params.watchSlidesProgress) e.children(".".concat(s.slideVisibleClass)).each(function (e) {
           o(r ? d(e).attr("data-swiper-slide-index") : d(e).index());
         });else if (c > 1) for (var _e62 = i; _e62 < i + c; _e62 += 1) p(_e62) && o(_e62);else o(i);
         if (n.loadPrevNext) if (c > 1 || n.loadPrevNextAmount && n.loadPrevNextAmount > 1) {
           var _e63 = n.loadPrevNextAmount,
             _t45 = Math.ceil(c),
             _s37 = Math.min(i + _t45 + Math.max(_e63, _t45), a.length),
             _r8 = Math.max(i - Math.max(_t45, _e63), 0);
           for (var _e64 = i + _t45; _e64 < _s37; _e64 += 1) p(_e64) && o(_e64);
           for (var _e65 = _r8; _e65 < i; _e65 += 1) p(_e65) && o(_e65);
         } else {
           var _t46 = e.children(".".concat(s.slideNextClass));
           _t46.length > 0 && o(u(_t46));
           var _a23 = e.children(".".concat(s.slidePrevClass));
           _a23.length > 0 && o(u(_a23));
         }
       }
       function p() {
         var e = r();
         if (!t || t.destroyed) return;
         var s = t.params.lazy.scrollingElement ? d(t.params.lazy.scrollingElement) : d(e),
           a = s[0] === e,
           i = a ? e.innerWidth : s[0].offsetWidth,
           l = a ? e.innerHeight : s[0].offsetHeight,
           o = t.$el.offset(),
           u = t.rtlTranslate;
         var h = !1;
         u && (o.left -= t.$el[0].scrollLeft);
         var m = [[o.left, o.top], [o.left + t.width, o.top], [o.left, o.top + t.height], [o.left + t.width, o.top + t.height]];
         for (var _e66 = 0; _e66 < m.length; _e66 += 1) {
           var _t47 = m[_e66];
           if (_t47[0] >= 0 && _t47[0] <= i && _t47[1] >= 0 && _t47[1] <= l) {
             if (0 === _t47[0] && 0 === _t47[1]) continue;
             h = !0;
           }
         }
         var f = !("touchstart" !== t.touchEvents.start || !t.support.passiveListener || !t.params.passiveListeners) && {
           passive: !0,
           capture: !1
         };
         h ? (c(), s.off("scroll", p, f)) : n || (n = !0, s.on("scroll", p, f));
       }
       a("beforeInit", function () {
         t.params.lazy.enabled && t.params.preloadImages && (t.params.preloadImages = !1);
       }), a("init", function () {
         t.params.lazy.enabled && (t.params.lazy.checkInView ? p() : c());
       }), a("scroll", function () {
         t.params.freeMode && t.params.freeMode.enabled && !t.params.freeMode.sticky && c();
       }), a("scrollbarDragMove resize _freeModeNoMomentumRelease", function () {
         t.params.lazy.enabled && (t.params.lazy.checkInView ? p() : c());
       }), a("transitionStart", function () {
         t.params.lazy.enabled && (t.params.lazy.loadOnTransitionStart || !t.params.lazy.loadOnTransitionStart && !l) && (t.params.lazy.checkInView ? p() : c());
       }), a("transitionEnd", function () {
         t.params.lazy.enabled && !t.params.lazy.loadOnTransitionStart && (t.params.lazy.checkInView ? p() : c());
       }), a("slideChange", function () {
         var _t$params = t.params,
           e = _t$params.lazy,
           s = _t$params.cssMode,
           a = _t$params.watchSlidesProgress,
           i = _t$params.touchReleaseOnEdges,
           r = _t$params.resistanceRatio;
         e.enabled && (s || a && (i || 0 === r)) && c();
       }), a("destroy", function () {
         t.$el && t.$el.find(".".concat(t.params.lazy.loadingClass)).removeClass(t.params.lazy.loadingClass);
       }), Object.assign(t.lazy, {
         load: c,
         loadInSlide: o
       });
     }, function (e) {
       var t = e.swiper,
         s = e.extendParams,
         a = e.on;
       function i(e, t) {
         var s = function () {
           var e, t, s;
           return function (a, i) {
             for (t = -1, e = a.length; e - t > 1;) s = e + t >> 1, a[s] <= i ? t = s : e = s;
             return e;
           };
         }();
         var a, i;
         return this.x = e, this.y = t, this.lastIndex = e.length - 1, this.interpolate = function (e) {
           return e ? (i = s(this.x, e), a = i - 1, (e - this.x[a]) * (this.y[i] - this.y[a]) / (this.x[i] - this.x[a]) + this.y[a]) : 0;
         }, this;
       }
       function r() {
         t.controller.control && t.controller.spline && (t.controller.spline = void 0, delete t.controller.spline);
       }
       s({
         controller: {
           control: void 0,
           inverse: !1,
           by: "slide"
         }
       }), t.controller = {
         control: void 0
       }, a("beforeInit", function () {
         t.controller.control = t.params.controller.control;
       }), a("update", function () {
         r();
       }), a("resize", function () {
         r();
       }), a("observerUpdate", function () {
         r();
       }), a("setTranslate", function (e, s, a) {
         t.controller.control && t.controller.setTranslate(s, a);
       }), a("setTransition", function (e, s, a) {
         t.controller.control && t.controller.setTransition(s, a);
       }), Object.assign(t.controller, {
         setTranslate: function setTranslate(e, s) {
           var a = t.controller.control;
           var r, n;
           var l = t.constructor;
           function o(e) {
             var s = t.rtlTranslate ? -t.translate : t.translate;
             "slide" === t.params.controller.by && (!function (e) {
               t.controller.spline || (t.controller.spline = t.params.loop ? new i(t.slidesGrid, e.slidesGrid) : new i(t.snapGrid, e.snapGrid));
             }(e), n = -t.controller.spline.interpolate(-s)), n && "container" !== t.params.controller.by || (r = (e.maxTranslate() - e.minTranslate()) / (t.maxTranslate() - t.minTranslate()), n = (s - t.minTranslate()) * r + e.minTranslate()), t.params.controller.inverse && (n = e.maxTranslate() - n), e.updateProgress(n), e.setTranslate(n, t), e.updateActiveIndex(), e.updateSlidesClasses();
           }
           if (Array.isArray(a)) for (var _e67 = 0; _e67 < a.length; _e67 += 1) a[_e67] !== s && a[_e67] instanceof l && o(a[_e67]);else a instanceof l && s !== a && o(a);
         },
         setTransition: function setTransition(e, s) {
           var a = t.constructor,
             i = t.controller.control;
           var r;
           function n(s) {
             s.setTransition(e, t), 0 !== e && (s.transitionStart(), s.params.autoHeight && p(function () {
               s.updateAutoHeight();
             }), s.$wrapperEl.transitionEnd(function () {
               i && (s.params.loop && "slide" === t.params.controller.by && s.loopFix(), s.transitionEnd());
             }));
           }
           if (Array.isArray(i)) for (r = 0; r < i.length; r += 1) i[r] !== s && i[r] instanceof a && n(i[r]);else i instanceof a && s !== i && n(i);
         }
       });
     }, function (e) {
       var t = e.swiper,
         s = e.extendParams,
         a = e.on;
       s({
         a11y: {
           enabled: !0,
           notificationClass: "swiper-notification",
           prevSlideMessage: "Previous slide",
           nextSlideMessage: "Next slide",
           firstSlideMessage: "This is the first slide",
           lastSlideMessage: "This is the last slide",
           paginationBulletMessage: "Go to slide {{index}}",
           slideLabelMessage: "{{index}} / {{slidesLength}}",
           containerMessage: null,
           containerRoleDescriptionMessage: null,
           itemRoleDescriptionMessage: null,
           slideRole: "group",
           id: null
         }
       });
       var i = null;
       function r(e) {
         var t = i;
         0 !== t.length && (t.html(""), t.html(e));
       }
       function n(e) {
         e.attr("tabIndex", "0");
       }
       function l(e) {
         e.attr("tabIndex", "-1");
       }
       function o(e, t) {
         e.attr("role", t);
       }
       function c(e, t) {
         e.attr("aria-roledescription", t);
       }
       function p(e, t) {
         e.attr("aria-label", t);
       }
       function u(e) {
         e.attr("aria-disabled", !0);
       }
       function h(e) {
         e.attr("aria-disabled", !1);
       }
       function m(e) {
         if (13 !== e.keyCode && 32 !== e.keyCode) return;
         var s = t.params.a11y,
           a = d(e.target);
         t.navigation && t.navigation.$nextEl && a.is(t.navigation.$nextEl) && (t.isEnd && !t.params.loop || t.slideNext(), t.isEnd ? r(s.lastSlideMessage) : r(s.nextSlideMessage)), t.navigation && t.navigation.$prevEl && a.is(t.navigation.$prevEl) && (t.isBeginning && !t.params.loop || t.slidePrev(), t.isBeginning ? r(s.firstSlideMessage) : r(s.prevSlideMessage)), t.pagination && a.is(U(t.params.pagination.bulletClass)) && a[0].click();
       }
       function f() {
         return t.pagination && t.pagination.bullets && t.pagination.bullets.length;
       }
       function g() {
         return f() && t.params.pagination.clickable;
       }
       var v = function v(e, t, s) {
           n(e), "BUTTON" !== e[0].tagName && (o(e, "button"), e.on("keydown", m)), p(e, s), function (e, t) {
             e.attr("aria-controls", t);
           }(e, t);
         },
         w = function w(e) {
           var s = e.target.closest(".".concat(t.params.slideClass));
           if (!s || !t.slides.includes(s)) return;
           var a = t.slides.indexOf(s) === t.activeIndex,
             i = t.params.watchSlidesProgress && t.visibleSlides && t.visibleSlides.includes(s);
           a || i || t.slideTo(t.slides.indexOf(s), 0);
         },
         b = function b() {
           var e = t.params.a11y;
           e.itemRoleDescriptionMessage && c(d(t.slides), e.itemRoleDescriptionMessage), o(d(t.slides), e.slideRole);
           var s = t.params.loop ? t.slides.filter(function (e) {
             return !e.classList.contains(t.params.slideDuplicateClass);
           }).length : t.slides.length;
           e.slideLabelMessage && t.slides.each(function (a, i) {
             var r = d(a),
               n = t.params.loop ? parseInt(r.attr("data-swiper-slide-index"), 10) : i;
             p(r, e.slideLabelMessage.replace(/\{\{index\}\}/, n + 1).replace(/\{\{slidesLength\}\}/, s));
           });
         },
         x = function x() {
           var e = t.params.a11y;
           t.$el.append(i);
           var s = t.$el;
           e.containerRoleDescriptionMessage && c(s, e.containerRoleDescriptionMessage), e.containerMessage && p(s, e.containerMessage);
           var a = t.$wrapperEl,
             r = e.id || a.attr("id") || "swiper-wrapper-".concat((n = 16, void 0 === n && (n = 16), "x".repeat(n).replace(/x/g, function () {
               return Math.round(16 * Math.random()).toString(16);
             })));
           var n;
           var l = t.params.autoplay && t.params.autoplay.enabled ? "off" : "polite";
           var o;
           var d, u;
           o = r, a.attr("id", o), function (e, t) {
             e.attr("aria-live", t);
           }(a, l), b(), t.navigation && t.navigation.$nextEl && (d = t.navigation.$nextEl), t.navigation && t.navigation.$prevEl && (u = t.navigation.$prevEl), d && d.length && v(d, r, e.nextSlideMessage), u && u.length && v(u, r, e.prevSlideMessage), g() && t.pagination.$el.on("keydown", U(t.params.pagination.bulletClass), m), t.$el.on("focus", w, !0);
         };
       a("beforeInit", function () {
         i = d("<span class=\"".concat(t.params.a11y.notificationClass, "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>"));
       }), a("afterInit", function () {
         t.params.a11y.enabled && x();
       }), a("slidesLengthChange snapGridLengthChange slidesGridLengthChange", function () {
         t.params.a11y.enabled && b();
       }), a("fromEdge toEdge afterInit lock unlock", function () {
         t.params.a11y.enabled && function () {
           if (t.params.loop || t.params.rewind || !t.navigation) return;
           var _t$navigation5 = t.navigation,
             e = _t$navigation5.$nextEl,
             s = _t$navigation5.$prevEl;
           s && s.length > 0 && (t.isBeginning ? (u(s), l(s)) : (h(s), n(s))), e && e.length > 0 && (t.isEnd ? (u(e), l(e)) : (h(e), n(e)));
         }();
       }), a("paginationUpdate", function () {
         t.params.a11y.enabled && function () {
           var e = t.params.a11y;
           f() && t.pagination.bullets.each(function (s) {
             var a = d(s);
             t.params.pagination.clickable && (n(a), t.params.pagination.renderBullet || (o(a, "button"), p(a, e.paginationBulletMessage.replace(/\{\{index\}\}/, a.index() + 1)))), a.is(".".concat(t.params.pagination.bulletActiveClass)) ? a.attr("aria-current", "true") : a.removeAttr("aria-current");
           });
         }();
       }), a("destroy", function () {
         t.params.a11y.enabled && function () {
           var e, s;
           i && i.length > 0 && i.remove(), t.navigation && t.navigation.$nextEl && (e = t.navigation.$nextEl), t.navigation && t.navigation.$prevEl && (s = t.navigation.$prevEl), e && e.off("keydown", m), s && s.off("keydown", m), g() && t.pagination.$el.off("keydown", U(t.params.pagination.bulletClass), m), t.$el.off("focus", w, !0);
         }();
       });
     }, function (e) {
       var t = e.swiper,
         s = e.extendParams,
         a = e.on;
       s({
         history: {
           enabled: !1,
           root: "",
           replaceState: !1,
           key: "slides",
           keepQuery: !1
         }
       });
       var i = !1,
         n = {};
       var l = function l(e) {
           return e.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
         },
         o = function o(e) {
           var t = r();
           var s;
           s = e ? new URL(e) : t.location;
           var a = s.pathname.slice(1).split("/").filter(function (e) {
               return "" !== e;
             }),
             i = a.length;
           return {
             key: a[i - 2],
             value: a[i - 1]
           };
         },
         d = function d(e, s) {
           var a = r();
           if (!i || !t.params.history.enabled) return;
           var n;
           n = t.params.url ? new URL(t.params.url) : a.location;
           var o = t.slides.eq(s);
           var d = l(o.attr("data-history"));
           if (t.params.history.root.length > 0) {
             var _s38 = t.params.history.root;
             "/" === _s38[_s38.length - 1] && (_s38 = _s38.slice(0, _s38.length - 1)), d = "".concat(_s38, "/").concat(e, "/").concat(d);
           } else n.pathname.includes(e) || (d = "".concat(e, "/").concat(d));
           t.params.history.keepQuery && (d += n.search);
           var c = a.history.state;
           c && c.value === d || (t.params.history.replaceState ? a.history.replaceState({
             value: d
           }, null, d) : a.history.pushState({
             value: d
           }, null, d));
         },
         c = function c(e, s, a) {
           if (s) for (var _i13 = 0, _r9 = t.slides.length; _i13 < _r9; _i13 += 1) {
             var _r0 = t.slides.eq(_i13);
             if (l(_r0.attr("data-history")) === s && !_r0.hasClass(t.params.slideDuplicateClass)) {
               var _s39 = _r0.index();
               t.slideTo(_s39, e, a);
             }
           } else t.slideTo(0, e, a);
         },
         p = function p() {
           n = o(t.params.url), c(t.params.speed, n.value, !1);
         };
       a("init", function () {
         t.params.history.enabled && function () {
           var e = r();
           if (t.params.history) {
             if (!e.history || !e.history.pushState) return t.params.history.enabled = !1, void (t.params.hashNavigation.enabled = !0);
             i = !0, n = o(t.params.url), (n.key || n.value) && (c(0, n.value, t.params.runCallbacksOnInit), t.params.history.replaceState || e.addEventListener("popstate", p));
           }
         }();
       }), a("destroy", function () {
         t.params.history.enabled && function () {
           var e = r();
           t.params.history.replaceState || e.removeEventListener("popstate", p);
         }();
       }), a("transitionEnd _freeModeNoMomentumRelease", function () {
         i && d(t.params.history.key, t.activeIndex);
       }), a("slideChange", function () {
         i && t.params.cssMode && d(t.params.history.key, t.activeIndex);
       });
     }, function (e) {
       var t = e.swiper,
         s = e.extendParams,
         i = e.emit,
         n = e.on,
         l = !1;
       var o = a(),
         c = r();
       s({
         hashNavigation: {
           enabled: !1,
           replaceState: !1,
           watchState: !1
         }
       });
       var p = function p() {
           i("hashChange");
           var e = o.location.hash.replace("#", "");
           if (e !== t.slides.eq(t.activeIndex).attr("data-hash")) {
             var _s40 = t.$wrapperEl.children(".".concat(t.params.slideClass, "[data-hash=\"").concat(e, "\"]")).index();
             if (void 0 === _s40) return;
             t.slideTo(_s40);
           }
         },
         u = function u() {
           if (l && t.params.hashNavigation.enabled) if (t.params.hashNavigation.replaceState && c.history && c.history.replaceState) c.history.replaceState(null, null, "#".concat(t.slides.eq(t.activeIndex).attr("data-hash")) || 0), i("hashSet");else {
             var _e68 = t.slides.eq(t.activeIndex),
               _s41 = _e68.attr("data-hash") || _e68.attr("data-history");
             o.location.hash = _s41 || "", i("hashSet");
           }
         };
       n("init", function () {
         t.params.hashNavigation.enabled && function () {
           if (!t.params.hashNavigation.enabled || t.params.history && t.params.history.enabled) return;
           l = !0;
           var e = o.location.hash.replace("#", "");
           if (e) {
             var _s42 = 0;
             for (var _a24 = 0, _i14 = t.slides.length; _a24 < _i14; _a24 += 1) {
               var _i15 = t.slides.eq(_a24);
               if ((_i15.attr("data-hash") || _i15.attr("data-history")) === e && !_i15.hasClass(t.params.slideDuplicateClass)) {
                 var _e69 = _i15.index();
                 t.slideTo(_e69, _s42, t.params.runCallbacksOnInit, !0);
               }
             }
           }
           t.params.hashNavigation.watchState && d(c).on("hashchange", p);
         }();
       }), n("destroy", function () {
         t.params.hashNavigation.enabled && t.params.hashNavigation.watchState && d(c).off("hashchange", p);
       }), n("transitionEnd _freeModeNoMomentumRelease", function () {
         l && u();
       }), n("slideChange", function () {
         l && t.params.cssMode && u();
       });
     }, function (e) {
       var t,
         s = e.swiper,
         i = e.extendParams,
         r = e.on,
         n = e.emit;
       function l() {
         var e = s.slides.eq(s.activeIndex);
         var a = s.params.autoplay.delay;
         e.attr("data-swiper-autoplay") && (a = e.attr("data-swiper-autoplay") || s.params.autoplay.delay), clearTimeout(t), t = p(function () {
           var e;
           s.params.autoplay.reverseDirection ? s.params.loop ? (s.loopFix(), e = s.slidePrev(s.params.speed, !0, !0), n("autoplay")) : s.isBeginning ? s.params.autoplay.stopOnLastSlide ? d() : (e = s.slideTo(s.slides.length - 1, s.params.speed, !0, !0), n("autoplay")) : (e = s.slidePrev(s.params.speed, !0, !0), n("autoplay")) : s.params.loop ? (s.loopFix(), e = s.slideNext(s.params.speed, !0, !0), n("autoplay")) : s.isEnd ? s.params.autoplay.stopOnLastSlide ? d() : (e = s.slideTo(0, s.params.speed, !0, !0), n("autoplay")) : (e = s.slideNext(s.params.speed, !0, !0), n("autoplay")), (s.params.cssMode && s.autoplay.running || !1 === e) && l();
         }, a);
       }
       function o() {
         return void 0 === t && !s.autoplay.running && (s.autoplay.running = !0, n("autoplayStart"), l(), !0);
       }
       function d() {
         return !!s.autoplay.running && void 0 !== t && (t && (clearTimeout(t), t = void 0), s.autoplay.running = !1, n("autoplayStop"), !0);
       }
       function c(e) {
         s.autoplay.running && (s.autoplay.paused || (t && clearTimeout(t), s.autoplay.paused = !0, 0 !== e && s.params.autoplay.waitForTransition ? ["transitionend", "webkitTransitionEnd"].forEach(function (e) {
           s.$wrapperEl[0].addEventListener(e, h);
         }) : (s.autoplay.paused = !1, l())));
       }
       function u() {
         var e = a();
         "hidden" === e.visibilityState && s.autoplay.running && c(), "visible" === e.visibilityState && s.autoplay.paused && (l(), s.autoplay.paused = !1);
       }
       function h(e) {
         s && !s.destroyed && s.$wrapperEl && e.target === s.$wrapperEl[0] && (["transitionend", "webkitTransitionEnd"].forEach(function (e) {
           s.$wrapperEl[0].removeEventListener(e, h);
         }), s.autoplay.paused = !1, s.autoplay.running ? l() : d());
       }
       function m() {
         s.params.autoplay.disableOnInteraction ? d() : (n("autoplayPause"), c()), ["transitionend", "webkitTransitionEnd"].forEach(function (e) {
           s.$wrapperEl[0].removeEventListener(e, h);
         });
       }
       function f() {
         s.params.autoplay.disableOnInteraction || (s.autoplay.paused = !1, n("autoplayResume"), l());
       }
       s.autoplay = {
         running: !1,
         paused: !1
       }, i({
         autoplay: {
           enabled: !1,
           delay: 3e3,
           waitForTransition: !0,
           disableOnInteraction: !0,
           stopOnLastSlide: !1,
           reverseDirection: !1,
           pauseOnMouseEnter: !1
         }
       }), r("init", function () {
         if (s.params.autoplay.enabled) {
           o();
           a().addEventListener("visibilitychange", u), s.params.autoplay.pauseOnMouseEnter && (s.$el.on("mouseenter", m), s.$el.on("mouseleave", f));
         }
       }), r("beforeTransitionStart", function (e, t, a) {
         s.autoplay.running && (a || !s.params.autoplay.disableOnInteraction ? s.autoplay.pause(t) : d());
       }), r("sliderFirstMove", function () {
         s.autoplay.running && (s.params.autoplay.disableOnInteraction ? d() : c());
       }), r("touchEnd", function () {
         s.params.cssMode && s.autoplay.paused && !s.params.autoplay.disableOnInteraction && l();
       }), r("destroy", function () {
         s.$el.off("mouseenter", m), s.$el.off("mouseleave", f), s.autoplay.running && d();
         a().removeEventListener("visibilitychange", u);
       }), Object.assign(s.autoplay, {
         pause: c,
         run: l,
         start: o,
         stop: d
       });
     }, function (e) {
       var t = e.swiper,
         s = e.extendParams,
         a = e.on;
       s({
         thumbs: {
           swiper: null,
           multipleActiveThumbs: !0,
           autoScrollOffset: 0,
           slideThumbActiveClass: "swiper-slide-thumb-active",
           thumbsContainerClass: "swiper-thumbs"
         }
       });
       var i = !1,
         r = !1;
       function n() {
         var e = t.thumbs.swiper;
         if (!e || e.destroyed) return;
         var s = e.clickedIndex,
           a = e.clickedSlide;
         if (a && d(a).hasClass(t.params.thumbs.slideThumbActiveClass)) return;
         if (null == s) return;
         var i;
         if (i = e.params.loop ? parseInt(d(e.clickedSlide).attr("data-swiper-slide-index"), 10) : s, t.params.loop) {
           var _e70 = t.activeIndex;
           t.slides.eq(_e70).hasClass(t.params.slideDuplicateClass) && (t.loopFix(), t._clientLeft = t.$wrapperEl[0].clientLeft, _e70 = t.activeIndex);
           var _s43 = t.slides.eq(_e70).prevAll("[data-swiper-slide-index=\"".concat(i, "\"]")).eq(0).index(),
             _a25 = t.slides.eq(_e70).nextAll("[data-swiper-slide-index=\"".concat(i, "\"]")).eq(0).index();
           i = void 0 === _s43 ? _a25 : void 0 === _a25 ? _s43 : _a25 - _e70 < _e70 - _s43 ? _a25 : _s43;
         }
         t.slideTo(i);
       }
       function l() {
         var e = t.params.thumbs;
         if (i) return !1;
         i = !0;
         var s = t.constructor;
         if (e.swiper instanceof s) t.thumbs.swiper = e.swiper, Object.assign(t.thumbs.swiper.originalParams, {
           watchSlidesProgress: !0,
           slideToClickedSlide: !1
         }), Object.assign(t.thumbs.swiper.params, {
           watchSlidesProgress: !0,
           slideToClickedSlide: !1
         });else if (m(e.swiper)) {
           var _a26 = Object.assign({}, e.swiper);
           Object.assign(_a26, {
             watchSlidesProgress: !0,
             slideToClickedSlide: !1
           }), t.thumbs.swiper = new s(_a26), r = !0;
         }
         return t.thumbs.swiper.$el.addClass(t.params.thumbs.thumbsContainerClass), t.thumbs.swiper.on("tap", n), !0;
       }
       function o(e) {
         var s = t.thumbs.swiper;
         if (!s || s.destroyed) return;
         var a = "auto" === s.params.slidesPerView ? s.slidesPerViewDynamic() : s.params.slidesPerView,
           i = t.params.thumbs.autoScrollOffset,
           r = i && !s.params.loop;
         if (t.realIndex !== s.realIndex || r) {
           var _n9,
             _l7,
             _o6 = s.activeIndex;
           if (s.params.loop) {
             s.slides.eq(_o6).hasClass(s.params.slideDuplicateClass) && (s.loopFix(), s._clientLeft = s.$wrapperEl[0].clientLeft, _o6 = s.activeIndex);
             var _e71 = s.slides.eq(_o6).prevAll("[data-swiper-slide-index=\"".concat(t.realIndex, "\"]")).eq(0).index(),
               _a27 = s.slides.eq(_o6).nextAll("[data-swiper-slide-index=\"".concat(t.realIndex, "\"]")).eq(0).index();
             _n9 = void 0 === _e71 ? _a27 : void 0 === _a27 ? _e71 : _a27 - _o6 == _o6 - _e71 ? s.params.slidesPerGroup > 1 ? _a27 : _o6 : _a27 - _o6 < _o6 - _e71 ? _a27 : _e71, _l7 = t.activeIndex > t.previousIndex ? "next" : "prev";
           } else _n9 = t.realIndex, _l7 = _n9 > t.previousIndex ? "next" : "prev";
           r && (_n9 += "next" === _l7 ? i : -1 * i), s.visibleSlidesIndexes && s.visibleSlidesIndexes.indexOf(_n9) < 0 && (s.params.centeredSlides ? _n9 = _n9 > _o6 ? _n9 - Math.floor(a / 2) + 1 : _n9 + Math.floor(a / 2) - 1 : _n9 > _o6 && s.params.slidesPerGroup, s.slideTo(_n9, e ? 0 : void 0));
         }
         var n = 1;
         var l = t.params.thumbs.slideThumbActiveClass;
         if (t.params.slidesPerView > 1 && !t.params.centeredSlides && (n = t.params.slidesPerView), t.params.thumbs.multipleActiveThumbs || (n = 1), n = Math.floor(n), s.slides.removeClass(l), s.params.loop || s.params.virtual && s.params.virtual.enabled) for (var _e72 = 0; _e72 < n; _e72 += 1) s.$wrapperEl.children("[data-swiper-slide-index=\"".concat(t.realIndex + _e72, "\"]")).addClass(l);else for (var _e73 = 0; _e73 < n; _e73 += 1) s.slides.eq(t.realIndex + _e73).addClass(l);
       }
       t.thumbs = {
         swiper: null
       }, a("beforeInit", function () {
         var e = t.params.thumbs;
         e && e.swiper && (l(), o(!0));
       }), a("slideChange update resize observerUpdate", function () {
         o();
       }), a("setTransition", function (e, s) {
         var a = t.thumbs.swiper;
         a && !a.destroyed && a.setTransition(s);
       }), a("beforeDestroy", function () {
         var e = t.thumbs.swiper;
         e && !e.destroyed && r && e.destroy();
       }), Object.assign(t.thumbs, {
         init: l,
         update: o
       });
     }, function (e) {
       var t = e.swiper,
         s = e.extendParams,
         a = e.emit,
         i = e.once;
       s({
         freeMode: {
           enabled: !1,
           momentum: !0,
           momentumRatio: 1,
           momentumBounce: !0,
           momentumBounceRatio: 1,
           momentumVelocityRatio: 1,
           sticky: !1,
           minimumVelocity: .02
         }
       }), Object.assign(t, {
         freeMode: {
           onTouchStart: function onTouchStart() {
             var e = t.getTranslate();
             t.setTranslate(e), t.setTransition(0), t.touchEventsData.velocities.length = 0, t.freeMode.onTouchEnd({
               currentPos: t.rtl ? t.translate : -t.translate
             });
           },
           onTouchMove: function onTouchMove() {
             var e = t.touchEventsData,
               s = t.touches;
             0 === e.velocities.length && e.velocities.push({
               position: s[t.isHorizontal() ? "startX" : "startY"],
               time: e.touchStartTime
             }), e.velocities.push({
               position: s[t.isHorizontal() ? "currentX" : "currentY"],
               time: u()
             });
           },
           onTouchEnd: function onTouchEnd(e) {
             var s = e.currentPos;
             var r = t.params,
               n = t.$wrapperEl,
               l = t.rtlTranslate,
               o = t.snapGrid,
               d = t.touchEventsData,
               c = u() - d.touchStartTime;
             if (s < -t.minTranslate()) t.slideTo(t.activeIndex);else if (s > -t.maxTranslate()) t.slides.length < o.length ? t.slideTo(o.length - 1) : t.slideTo(t.slides.length - 1);else {
               if (r.freeMode.momentum) {
                 if (d.velocities.length > 1) {
                   var _e74 = d.velocities.pop(),
                     _s44 = d.velocities.pop(),
                     _a28 = _e74.position - _s44.position,
                     _i16 = _e74.time - _s44.time;
                   t.velocity = _a28 / _i16, t.velocity /= 2, Math.abs(t.velocity) < r.freeMode.minimumVelocity && (t.velocity = 0), (_i16 > 150 || u() - _e74.time > 300) && (t.velocity = 0);
                 } else t.velocity = 0;
                 t.velocity *= r.freeMode.momentumVelocityRatio, d.velocities.length = 0;
                 var _e75 = 1e3 * r.freeMode.momentumRatio;
                 var _s45 = t.velocity * _e75;
                 var _c4 = t.translate + _s45;
                 l && (_c4 = -_c4);
                 var _p2,
                   _h = !1;
                 var _m = 20 * Math.abs(t.velocity) * r.freeMode.momentumBounceRatio;
                 var _f;
                 if (_c4 < t.maxTranslate()) r.freeMode.momentumBounce ? (_c4 + t.maxTranslate() < -_m && (_c4 = t.maxTranslate() - _m), _p2 = t.maxTranslate(), _h = !0, d.allowMomentumBounce = !0) : _c4 = t.maxTranslate(), r.loop && r.centeredSlides && (_f = !0);else if (_c4 > t.minTranslate()) r.freeMode.momentumBounce ? (_c4 - t.minTranslate() > _m && (_c4 = t.minTranslate() + _m), _p2 = t.minTranslate(), _h = !0, d.allowMomentumBounce = !0) : _c4 = t.minTranslate(), r.loop && r.centeredSlides && (_f = !0);else if (r.freeMode.sticky) {
                   var _e76;
                   for (var _t48 = 0; _t48 < o.length; _t48 += 1) if (o[_t48] > -_c4) {
                     _e76 = _t48;
                     break;
                   }
                   _c4 = Math.abs(o[_e76] - _c4) < Math.abs(o[_e76 - 1] - _c4) || "next" === t.swipeDirection ? o[_e76] : o[_e76 - 1], _c4 = -_c4;
                 }
                 if (_f && i("transitionEnd", function () {
                   t.loopFix();
                 }), 0 !== t.velocity) {
                   if (_e75 = l ? Math.abs((-_c4 - t.translate) / t.velocity) : Math.abs((_c4 - t.translate) / t.velocity), r.freeMode.sticky) {
                     var _s46 = Math.abs((l ? -_c4 : _c4) - t.translate),
                       _a29 = t.slidesSizesGrid[t.activeIndex];
                     _e75 = _s46 < _a29 ? r.speed : _s46 < 2 * _a29 ? 1.5 * r.speed : 2.5 * r.speed;
                   }
                 } else if (r.freeMode.sticky) return void t.slideToClosest();
                 r.freeMode.momentumBounce && _h ? (t.updateProgress(_p2), t.setTransition(_e75), t.setTranslate(_c4), t.transitionStart(!0, t.swipeDirection), t.animating = !0, n.transitionEnd(function () {
                   t && !t.destroyed && d.allowMomentumBounce && (a("momentumBounce"), t.setTransition(r.speed), setTimeout(function () {
                     t.setTranslate(_p2), n.transitionEnd(function () {
                       t && !t.destroyed && t.transitionEnd();
                     });
                   }, 0));
                 })) : t.velocity ? (a("_freeModeNoMomentumRelease"), t.updateProgress(_c4), t.setTransition(_e75), t.setTranslate(_c4), t.transitionStart(!0, t.swipeDirection), t.animating || (t.animating = !0, n.transitionEnd(function () {
                   t && !t.destroyed && t.transitionEnd();
                 }))) : t.updateProgress(_c4), t.updateActiveIndex(), t.updateSlidesClasses();
               } else {
                 if (r.freeMode.sticky) return void t.slideToClosest();
                 r.freeMode && a("_freeModeNoMomentumRelease");
               }
               (!r.freeMode.momentum || c >= r.longSwipesMs) && (t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses());
             }
           }
         }
       });
     }, function (e) {
       var t,
         s,
         a,
         i = e.swiper,
         r = e.extendParams;
       r({
         grid: {
           rows: 1,
           fill: "column"
         }
       }), i.grid = {
         initSlides: function initSlides(e) {
           var r = i.params.slidesPerView,
             _i$params$grid = i.params.grid,
             n = _i$params$grid.rows,
             l = _i$params$grid.fill;
           s = t / n, a = Math.floor(e / n), t = Math.floor(e / n) === e / n ? e : Math.ceil(e / n) * n, "auto" !== r && "row" === l && (t = Math.max(t, r * n));
         },
         updateSlide: function updateSlide(e, r, n, l) {
           var _i$params = i.params,
             o = _i$params.slidesPerGroup,
             d = _i$params.spaceBetween,
             _i$params$grid2 = i.params.grid,
             c = _i$params$grid2.rows,
             p = _i$params$grid2.fill;
           var u, h, m;
           if ("row" === p && o > 1) {
             var _s47 = Math.floor(e / (o * c)),
               _a30 = e - c * o * _s47,
               _i17 = 0 === _s47 ? o : Math.min(Math.ceil((n - _s47 * c * o) / c), o);
             m = Math.floor(_a30 / _i17), h = _a30 - m * _i17 + _s47 * o, u = h + m * t / c, r.css({
               "-webkit-order": u,
               order: u
             });
           } else "column" === p ? (h = Math.floor(e / c), m = e - h * c, (h > a || h === a && m === c - 1) && (m += 1, m >= c && (m = 0, h += 1))) : (m = Math.floor(e / s), h = e - m * s);
           r.css(l("margin-top"), 0 !== m ? d && "".concat(d, "px") : "");
         },
         updateWrapperSize: function updateWrapperSize(e, s, a) {
           var _i$params2 = i.params,
             r = _i$params2.spaceBetween,
             n = _i$params2.centeredSlides,
             l = _i$params2.roundLengths,
             o = i.params.grid.rows;
           if (i.virtualSize = (e + r) * t, i.virtualSize = Math.ceil(i.virtualSize / o) - r, i.$wrapperEl.css(_defineProperty({}, a("width"), "".concat(i.virtualSize + r, "px"))), n) {
             s.splice(0, s.length);
             var _e77 = [];
             for (var _t49 = 0; _t49 < s.length; _t49 += 1) {
               var _a31 = s[_t49];
               l && (_a31 = Math.floor(_a31)), s[_t49] < i.virtualSize + s[0] && _e77.push(_a31);
             }
             s.push.apply(s, _e77);
           }
         }
       };
     }, function (e) {
       var t = e.swiper;
       Object.assign(t, {
         appendSlide: K.bind(t),
         prependSlide: Z.bind(t),
         addSlide: Q.bind(t),
         removeSlide: J.bind(t),
         removeAllSlides: ee.bind(t)
       });
     }, function (e) {
       var t = e.swiper,
         s = e.extendParams,
         a = e.on;
       s({
         fadeEffect: {
           crossFade: !1,
           transformEl: null
         }
       }), te({
         effect: "fade",
         swiper: t,
         on: a,
         setTranslate: function setTranslate() {
           var e = t.slides,
             s = t.params.fadeEffect;
           for (var _a32 = 0; _a32 < e.length; _a32 += 1) {
             var _e78 = t.slides.eq(_a32);
             var _i18 = -_e78[0].swiperSlideOffset;
             t.params.virtualTranslate || (_i18 -= t.translate);
             var _r1 = 0;
             t.isHorizontal() || (_r1 = _i18, _i18 = 0);
             var _n0 = t.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(_e78[0].progress), 0) : 1 + Math.min(Math.max(_e78[0].progress, -1), 0);
             se(s, _e78).css({
               opacity: _n0
             }).transform("translate3d(".concat(_i18, "px, ").concat(_r1, "px, 0px)"));
           }
         },
         setTransition: function setTransition(e) {
           var s = t.params.fadeEffect.transformEl;
           (s ? t.slides.find(s) : t.slides).transition(e), ae({
             swiper: t,
             duration: e,
             transformEl: s,
             allSlides: !0
           });
         },
         overwriteParams: function overwriteParams() {
           return {
             slidesPerView: 1,
             slidesPerGroup: 1,
             watchSlidesProgress: !0,
             spaceBetween: 0,
             virtualTranslate: !t.params.cssMode
           };
         }
       });
     }, function (e) {
       var t = e.swiper,
         s = e.extendParams,
         a = e.on;
       s({
         cubeEffect: {
           slideShadows: !0,
           shadow: !0,
           shadowOffset: 20,
           shadowScale: .94
         }
       });
       var i = function i(e, t, s) {
         var a = s ? e.find(".swiper-slide-shadow-left") : e.find(".swiper-slide-shadow-top"),
           i = s ? e.find(".swiper-slide-shadow-right") : e.find(".swiper-slide-shadow-bottom");
         0 === a.length && (a = d("<div class=\"swiper-slide-shadow-".concat(s ? "left" : "top", "\"></div>")), e.append(a)), 0 === i.length && (i = d("<div class=\"swiper-slide-shadow-".concat(s ? "right" : "bottom", "\"></div>")), e.append(i)), a.length && (a[0].style.opacity = Math.max(-t, 0)), i.length && (i[0].style.opacity = Math.max(t, 0));
       };
       te({
         effect: "cube",
         swiper: t,
         on: a,
         setTranslate: function setTranslate() {
           var e = t.$el,
             s = t.$wrapperEl,
             a = t.slides,
             r = t.width,
             n = t.height,
             l = t.rtlTranslate,
             o = t.size,
             c = t.browser,
             p = t.params.cubeEffect,
             u = t.isHorizontal(),
             h = t.virtual && t.params.virtual.enabled;
           var m,
             f = 0;
           p.shadow && (u ? (m = s.find(".swiper-cube-shadow"), 0 === m.length && (m = d('<div class="swiper-cube-shadow"></div>'), s.append(m)), m.css({
             height: "".concat(r, "px")
           })) : (m = e.find(".swiper-cube-shadow"), 0 === m.length && (m = d('<div class="swiper-cube-shadow"></div>'), e.append(m))));
           for (var _e79 = 0; _e79 < a.length; _e79 += 1) {
             var _t50 = a.eq(_e79);
             var _s48 = _e79;
             h && (_s48 = parseInt(_t50.attr("data-swiper-slide-index"), 10));
             var _r10 = 90 * _s48,
               _n1 = Math.floor(_r10 / 360);
             l && (_r10 = -_r10, _n1 = Math.floor(-_r10 / 360));
             var _d5 = Math.max(Math.min(_t50[0].progress, 1), -1);
             var _c5 = 0,
               _m2 = 0,
               _g = 0;
             _s48 % 4 == 0 ? (_c5 = 4 * -_n1 * o, _g = 0) : (_s48 - 1) % 4 == 0 ? (_c5 = 0, _g = 4 * -_n1 * o) : (_s48 - 2) % 4 == 0 ? (_c5 = o + 4 * _n1 * o, _g = o) : (_s48 - 3) % 4 == 0 && (_c5 = -o, _g = 3 * o + 4 * o * _n1), l && (_c5 = -_c5), u || (_m2 = _c5, _c5 = 0);
             var _v = "rotateX(".concat(u ? 0 : -_r10, "deg) rotateY(").concat(u ? _r10 : 0, "deg) translate3d(").concat(_c5, "px, ").concat(_m2, "px, ").concat(_g, "px)");
             _d5 <= 1 && _d5 > -1 && (f = 90 * _s48 + 90 * _d5, l && (f = 90 * -_s48 - 90 * _d5)), _t50.transform(_v), p.slideShadows && i(_t50, _d5, u);
           }
           if (s.css({
             "-webkit-transform-origin": "50% 50% -".concat(o / 2, "px"),
             "transform-origin": "50% 50% -".concat(o / 2, "px")
           }), p.shadow) if (u) m.transform("translate3d(0px, ".concat(r / 2 + p.shadowOffset, "px, ").concat(-r / 2, "px) rotateX(90deg) rotateZ(0deg) scale(").concat(p.shadowScale, ")"));else {
             var _e80 = Math.abs(f) - 90 * Math.floor(Math.abs(f) / 90),
               _t51 = 1.5 - (Math.sin(2 * _e80 * Math.PI / 360) / 2 + Math.cos(2 * _e80 * Math.PI / 360) / 2),
               _s49 = p.shadowScale,
               _a33 = p.shadowScale / _t51,
               _i19 = p.shadowOffset;
             m.transform("scale3d(".concat(_s49, ", 1, ").concat(_a33, ") translate3d(0px, ").concat(n / 2 + _i19, "px, ").concat(-n / 2 / _a33, "px) rotateX(-90deg)"));
           }
           var g = c.isSafari || c.isWebView ? -o / 2 : 0;
           s.transform("translate3d(0px,0,".concat(g, "px) rotateX(").concat(t.isHorizontal() ? 0 : f, "deg) rotateY(").concat(t.isHorizontal() ? -f : 0, "deg)")), s[0].style.setProperty("--swiper-cube-translate-z", "".concat(g, "px"));
         },
         setTransition: function setTransition(e) {
           var s = t.$el,
             a = t.slides;
           a.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e), t.params.cubeEffect.shadow && !t.isHorizontal() && s.find(".swiper-cube-shadow").transition(e);
         },
         recreateShadows: function recreateShadows() {
           var e = t.isHorizontal();
           t.slides.each(function (t) {
             var s = Math.max(Math.min(t.progress, 1), -1);
             i(d(t), s, e);
           });
         },
         getEffectParams: function getEffectParams() {
           return t.params.cubeEffect;
         },
         perspective: function perspective() {
           return !0;
         },
         overwriteParams: function overwriteParams() {
           return {
             slidesPerView: 1,
             slidesPerGroup: 1,
             watchSlidesProgress: !0,
             resistanceRatio: 0,
             spaceBetween: 0,
             centeredSlides: !1,
             virtualTranslate: !0
           };
         }
       });
     }, function (e) {
       var t = e.swiper,
         s = e.extendParams,
         a = e.on;
       s({
         flipEffect: {
           slideShadows: !0,
           limitRotation: !0,
           transformEl: null
         }
       });
       var i = function i(e, s, a) {
         var i = t.isHorizontal() ? e.find(".swiper-slide-shadow-left") : e.find(".swiper-slide-shadow-top"),
           r = t.isHorizontal() ? e.find(".swiper-slide-shadow-right") : e.find(".swiper-slide-shadow-bottom");
         0 === i.length && (i = ie(a, e, t.isHorizontal() ? "left" : "top")), 0 === r.length && (r = ie(a, e, t.isHorizontal() ? "right" : "bottom")), i.length && (i[0].style.opacity = Math.max(-s, 0)), r.length && (r[0].style.opacity = Math.max(s, 0));
       };
       te({
         effect: "flip",
         swiper: t,
         on: a,
         setTranslate: function setTranslate() {
           var e = t.slides,
             s = t.rtlTranslate,
             a = t.params.flipEffect;
           for (var _r11 = 0; _r11 < e.length; _r11 += 1) {
             var _n10 = e.eq(_r11);
             var _l8 = _n10[0].progress;
             t.params.flipEffect.limitRotation && (_l8 = Math.max(Math.min(_n10[0].progress, 1), -1));
             var _o7 = _n10[0].swiperSlideOffset;
             var _d6 = -180 * _l8,
               _c6 = 0,
               _p3 = t.params.cssMode ? -_o7 - t.translate : -_o7,
               _u5 = 0;
             t.isHorizontal() ? s && (_d6 = -_d6) : (_u5 = _p3, _p3 = 0, _c6 = -_d6, _d6 = 0), _n10[0].style.zIndex = -Math.abs(Math.round(_l8)) + e.length, a.slideShadows && i(_n10, _l8, a);
             var _h2 = "translate3d(".concat(_p3, "px, ").concat(_u5, "px, 0px) rotateX(").concat(_c6, "deg) rotateY(").concat(_d6, "deg)");
             se(a, _n10).transform(_h2);
           }
         },
         setTransition: function setTransition(e) {
           var s = t.params.flipEffect.transformEl;
           (s ? t.slides.find(s) : t.slides).transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e), ae({
             swiper: t,
             duration: e,
             transformEl: s
           });
         },
         recreateShadows: function recreateShadows() {
           var e = t.params.flipEffect;
           t.slides.each(function (s) {
             var a = d(s);
             var r = a[0].progress;
             t.params.flipEffect.limitRotation && (r = Math.max(Math.min(s.progress, 1), -1)), i(a, r, e);
           });
         },
         getEffectParams: function getEffectParams() {
           return t.params.flipEffect;
         },
         perspective: function perspective() {
           return !0;
         },
         overwriteParams: function overwriteParams() {
           return {
             slidesPerView: 1,
             slidesPerGroup: 1,
             watchSlidesProgress: !0,
             spaceBetween: 0,
             virtualTranslate: !t.params.cssMode
           };
         }
       });
     }, function (e) {
       var t = e.swiper,
         s = e.extendParams,
         a = e.on;
       s({
         coverflowEffect: {
           rotate: 50,
           stretch: 0,
           depth: 100,
           scale: 1,
           modifier: 1,
           slideShadows: !0,
           transformEl: null
         }
       }), te({
         effect: "coverflow",
         swiper: t,
         on: a,
         setTranslate: function setTranslate() {
           var e = t.width,
             s = t.height,
             a = t.slides,
             i = t.slidesSizesGrid,
             r = t.params.coverflowEffect,
             n = t.isHorizontal(),
             l = t.translate,
             o = n ? e / 2 - l : s / 2 - l,
             d = n ? r.rotate : -r.rotate,
             c = r.depth;
           for (var _e81 = 0, _t52 = a.length; _e81 < _t52; _e81 += 1) {
             var _t53 = a.eq(_e81),
               _s50 = i[_e81],
               _l9 = (o - _t53[0].swiperSlideOffset - _s50 / 2) / _s50,
               _p4 = "function" == typeof r.modifier ? r.modifier(_l9) : _l9 * r.modifier;
             var _u6 = n ? d * _p4 : 0,
               _h3 = n ? 0 : d * _p4,
               _m3 = -c * Math.abs(_p4),
               _f2 = r.stretch;
             "string" == typeof _f2 && -1 !== _f2.indexOf("%") && (_f2 = parseFloat(r.stretch) / 100 * _s50);
             var _g2 = n ? 0 : _f2 * _p4,
               _v2 = n ? _f2 * _p4 : 0,
               _w = 1 - (1 - r.scale) * Math.abs(_p4);
             Math.abs(_v2) < .001 && (_v2 = 0), Math.abs(_g2) < .001 && (_g2 = 0), Math.abs(_m3) < .001 && (_m3 = 0), Math.abs(_u6) < .001 && (_u6 = 0), Math.abs(_h3) < .001 && (_h3 = 0), Math.abs(_w) < .001 && (_w = 0);
             var _b = "translate3d(".concat(_v2, "px,").concat(_g2, "px,").concat(_m3, "px)  rotateX(").concat(_h3, "deg) rotateY(").concat(_u6, "deg) scale(").concat(_w, ")");
             if (se(r, _t53).transform(_b), _t53[0].style.zIndex = 1 - Math.abs(Math.round(_p4)), r.slideShadows) {
               var _e82 = n ? _t53.find(".swiper-slide-shadow-left") : _t53.find(".swiper-slide-shadow-top"),
                 _s51 = n ? _t53.find(".swiper-slide-shadow-right") : _t53.find(".swiper-slide-shadow-bottom");
               0 === _e82.length && (_e82 = ie(r, _t53, n ? "left" : "top")), 0 === _s51.length && (_s51 = ie(r, _t53, n ? "right" : "bottom")), _e82.length && (_e82[0].style.opacity = _p4 > 0 ? _p4 : 0), _s51.length && (_s51[0].style.opacity = -_p4 > 0 ? -_p4 : 0);
             }
           }
         },
         setTransition: function setTransition(e) {
           var s = t.params.coverflowEffect.transformEl;
           (s ? t.slides.find(s) : t.slides).transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e);
         },
         perspective: function perspective() {
           return !0;
         },
         overwriteParams: function overwriteParams() {
           return {
             watchSlidesProgress: !0
           };
         }
       });
     }, function (e) {
       var t = e.swiper,
         s = e.extendParams,
         a = e.on;
       s({
         creativeEffect: {
           transformEl: null,
           limitProgress: 1,
           shadowPerProgress: !1,
           progressMultiplier: 1,
           perspective: !0,
           prev: {
             translate: [0, 0, 0],
             rotate: [0, 0, 0],
             opacity: 1,
             scale: 1
           },
           next: {
             translate: [0, 0, 0],
             rotate: [0, 0, 0],
             opacity: 1,
             scale: 1
           }
         }
       });
       var i = function i(e) {
         return "string" == typeof e ? e : "".concat(e, "px");
       };
       te({
         effect: "creative",
         swiper: t,
         on: a,
         setTranslate: function setTranslate() {
           var e = t.slides,
             s = t.$wrapperEl,
             a = t.slidesSizesGrid,
             r = t.params.creativeEffect,
             n = r.progressMultiplier,
             l = t.params.centeredSlides;
           if (l) {
             var _e83 = a[0] / 2 - t.params.slidesOffsetBefore || 0;
             s.transform("translateX(calc(50% - ".concat(_e83, "px))"));
           }
           var _loop = function _loop() {
             var a = e.eq(_s52),
               o = a[0].progress,
               d = Math.min(Math.max(a[0].progress, -r.limitProgress), r.limitProgress);
             var c = d;
             l || (c = Math.min(Math.max(a[0].originalProgress, -r.limitProgress), r.limitProgress));
             var p = a[0].swiperSlideOffset,
               u = [t.params.cssMode ? -p - t.translate : -p, 0, 0],
               h = [0, 0, 0];
             var m = !1;
             t.isHorizontal() || (u[1] = u[0], u[0] = 0);
             var f = {
               translate: [0, 0, 0],
               rotate: [0, 0, 0],
               scale: 1,
               opacity: 1
             };
             d < 0 ? (f = r.next, m = !0) : d > 0 && (f = r.prev, m = !0), u.forEach(function (e, t) {
               u[t] = "calc(".concat(e, "px + (").concat(i(f.translate[t]), " * ").concat(Math.abs(d * n), "))");
             }), h.forEach(function (e, t) {
               h[t] = f.rotate[t] * Math.abs(d * n);
             }), a[0].style.zIndex = -Math.abs(Math.round(o)) + e.length;
             var g = u.join(", "),
               v = "rotateX(".concat(h[0], "deg) rotateY(").concat(h[1], "deg) rotateZ(").concat(h[2], "deg)"),
               w = c < 0 ? "scale(".concat(1 + (1 - f.scale) * c * n, ")") : "scale(".concat(1 - (1 - f.scale) * c * n, ")"),
               b = c < 0 ? 1 + (1 - f.opacity) * c * n : 1 - (1 - f.opacity) * c * n,
               x = "translate3d(".concat(g, ") ").concat(v, " ").concat(w);
             if (m && f.shadow || !m) {
               var _e84 = a.children(".swiper-slide-shadow");
               if (0 === _e84.length && f.shadow && (_e84 = ie(r, a)), _e84.length) {
                 var _t54 = r.shadowPerProgress ? d * (1 / r.limitProgress) : d;
                 _e84[0].style.opacity = Math.min(Math.max(Math.abs(_t54), 0), 1);
               }
             }
             var y = se(r, a);
             y.transform(x).css({
               opacity: b
             }), f.origin && y.css("transform-origin", f.origin);
           };
           for (var _s52 = 0; _s52 < e.length; _s52 += 1) {
             _loop();
           }
         },
         setTransition: function setTransition(e) {
           var s = t.params.creativeEffect.transformEl;
           (s ? t.slides.find(s) : t.slides).transition(e).find(".swiper-slide-shadow").transition(e), ae({
             swiper: t,
             duration: e,
             transformEl: s,
             allSlides: !0
           });
         },
         perspective: function perspective() {
           return t.params.creativeEffect.perspective;
         },
         overwriteParams: function overwriteParams() {
           return {
             watchSlidesProgress: !0,
             virtualTranslate: !t.params.cssMode
           };
         }
       });
     }, function (e) {
       var t = e.swiper,
         s = e.extendParams,
         a = e.on;
       s({
         cardsEffect: {
           slideShadows: !0,
           transformEl: null,
           rotate: !0
         }
       }), te({
         effect: "cards",
         swiper: t,
         on: a,
         setTranslate: function setTranslate() {
           var e = t.slides,
             s = t.activeIndex,
             a = t.params.cardsEffect,
             _t$touchEventsData = t.touchEventsData,
             i = _t$touchEventsData.startTranslate,
             r = _t$touchEventsData.isTouched,
             n = t.translate;
           for (var _l0 = 0; _l0 < e.length; _l0 += 1) {
             var _o8 = e.eq(_l0),
               _d7 = _o8[0].progress,
               _c7 = Math.min(Math.max(_d7, -4), 4);
             var _p5 = _o8[0].swiperSlideOffset;
             t.params.centeredSlides && !t.params.cssMode && t.$wrapperEl.transform("translateX(".concat(t.minTranslate(), "px)")), t.params.centeredSlides && t.params.cssMode && (_p5 -= e[0].swiperSlideOffset);
             var _u7 = t.params.cssMode ? -_p5 - t.translate : -_p5,
               _h4 = 0;
             var _m4 = -100 * Math.abs(_c7);
             var _f3 = 1,
               _g3 = -2 * _c7,
               _v3 = 8 - .75 * Math.abs(_c7);
             var _w2 = t.virtual && t.params.virtual.enabled ? t.virtual.from + _l0 : _l0,
               _b2 = (_w2 === s || _w2 === s - 1) && _c7 > 0 && _c7 < 1 && (r || t.params.cssMode) && n < i,
               _x = (_w2 === s || _w2 === s + 1) && _c7 < 0 && _c7 > -1 && (r || t.params.cssMode) && n > i;
             if (_b2 || _x) {
               var _e85 = Math.pow(1 - Math.abs((Math.abs(_c7) - .5) / .5), .5);
               _g3 += -28 * _c7 * _e85, _f3 += -.5 * _e85, _v3 += 96 * _e85, _h4 = -25 * _e85 * Math.abs(_c7) + "%";
             }
             if (_u7 = _c7 < 0 ? "calc(".concat(_u7, "px + (").concat(_v3 * Math.abs(_c7), "%))") : _c7 > 0 ? "calc(".concat(_u7, "px + (-").concat(_v3 * Math.abs(_c7), "%))") : "".concat(_u7, "px"), !t.isHorizontal()) {
               var _e86 = _h4;
               _h4 = _u7, _u7 = _e86;
             }
             var _y = _c7 < 0 ? "" + (1 + (1 - _f3) * _c7) : "" + (1 - (1 - _f3) * _c7),
               _E = "\n        translate3d(".concat(_u7, ", ").concat(_h4, ", ").concat(_m4, "px)\n        rotateZ(").concat(a.rotate ? _g3 : 0, "deg)\n        scale(").concat(_y, ")\n      ");
             if (a.slideShadows) {
               var _e87 = _o8.find(".swiper-slide-shadow");
               0 === _e87.length && (_e87 = ie(a, _o8)), _e87.length && (_e87[0].style.opacity = Math.min(Math.max((Math.abs(_c7) - .5) / .5, 0), 1));
             }
             _o8[0].style.zIndex = -Math.abs(Math.round(_d7)) + e.length;
             se(a, _o8).transform(_E);
           }
         },
         setTransition: function setTransition(e) {
           var s = t.params.cardsEffect.transformEl;
           (s ? t.slides.find(s) : t.slides).transition(e).find(".swiper-slide-shadow").transition(e), ae({
             swiper: t,
             duration: e,
             transformEl: s
           });
         },
         perspective: function perspective() {
           return !0;
         },
         overwriteParams: function overwriteParams() {
           return {
             watchSlidesProgress: !0,
             virtualTranslate: !t.params.cssMode
           };
         }
       });
     }];
     return V.use(re), V;
   });
   
   /***/ }),
   /* 14 */
   /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
   
   "use strict";
   __webpack_require__.r(__webpack_exports__);
   /* harmony export */ __webpack_require__.d(__webpack_exports__, {
   /* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
   /* harmony export */ });
   function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
   function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
   function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
   function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
   function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
   function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
   var VideoController = /*#__PURE__*/function () {
     function VideoController() {
       var _this = this;
       _classCallCheck(this, VideoController);
       this.videos = document.querySelectorAll('.video');
       this.videos.forEach(function (wrapper) {
         return _this.initVideo(wrapper);
       });
     }
     return _createClass(VideoController, [{
       key: "initVideo",
       value: function initVideo(wrapper) {
         var video = wrapper.querySelector('video');
         var toggle = wrapper.querySelector('.sound-on-off');
         var iconOn = toggle === null || toggle === void 0 ? void 0 : toggle.querySelector('.sound-on');
         var iconOff = toggle === null || toggle === void 0 ? void 0 : toggle.querySelector('.sound-off');
         var isManual = wrapper.classList.contains('manual');
         if (!video) return;
   
         // 初期状態：ミュート
         video.muted = true;
         toggle === null || toggle === void 0 || toggle.classList.add('off');
   
         // ── サウンドトグル（共通） ────────────────────────────────────
         if (toggle) {
           toggle.addEventListener('click', function () {
             var isMuted = video.muted;
             video.muted = !isMuted;
             toggle.classList.toggle('off', !isMuted);
             toggle.classList.toggle('on', isMuted);
             if (iconOn) iconOn.style.opacity = isMuted ? '1' : '0';
             if (iconOff) iconOff.style.opacity = isMuted ? '0' : '1';
           });
         }
   
         // ── 手動再生モード ───────────────────────────────────────────
         if (isManual) {
           var played = false;
           wrapper.addEventListener('click', function (e) {
             // サウンドボタンのクリックは再生トリガーに使わない
             if (toggle !== null && toggle !== void 0 && toggle.contains(e.target)) return;
             if (played) return;
             played = true;
             video.play().then(function () {
               var _wrapper$querySelecto;
               var playBtn = (_wrapper$querySelecto = wrapper.querySelector('.video-icon-play')) === null || _wrapper$querySelecto === void 0 ? void 0 : _wrapper$querySelecto.closest('div[class]');
               if (playBtn) {
                 playBtn.style.opacity = '0';
                 playBtn.style.pointerEvents = 'none';
               }
             })["catch"](function (e) {
               return console.error('再生失敗:', e);
             });
           });
         }
       }
     }]);
   }();
   /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (VideoController);
   
   /***/ })
   /******/ 	]);
   /************************************************************************/
   /******/ 	// The module cache
   /******/ 	var __webpack_module_cache__ = {};
   /******/ 	
   /******/ 	// The require function
   /******/ 	function __webpack_require__(moduleId) {
   /******/ 		// Check if module is in cache
   /******/ 		var cachedModule = __webpack_module_cache__[moduleId];
   /******/ 		if (cachedModule !== undefined) {
   /******/ 			return cachedModule.exports;
   /******/ 		}
   /******/ 		// Create a new module (and put it into the cache)
   /******/ 		var module = __webpack_module_cache__[moduleId] = {
   /******/ 			// no module.id needed
   /******/ 			// no module.loaded needed
   /******/ 			exports: {}
   /******/ 		};
   /******/ 	
   /******/ 		// Execute the module function
   /******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
   /******/ 	
   /******/ 		// Return the exports of the module
   /******/ 		return module.exports;
   /******/ 	}
   /******/ 	
   /************************************************************************/
   /******/ 	/* webpack/runtime/compat get default export */
   /******/ 	(() => {
   /******/ 		// getDefaultExport function for compatibility with non-harmony modules
   /******/ 		__webpack_require__.n = (module) => {
   /******/ 			var getter = module && module.__esModule ?
   /******/ 				() => (module['default']) :
   /******/ 				() => (module);
   /******/ 			__webpack_require__.d(getter, { a: getter });
   /******/ 			return getter;
   /******/ 		};
   /******/ 	})();
   /******/ 	
   /******/ 	/* webpack/runtime/define property getters */
   /******/ 	(() => {
   /******/ 		// define getter functions for harmony exports
   /******/ 		__webpack_require__.d = (exports, definition) => {
   /******/ 			for(var key in definition) {
   /******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
   /******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
   /******/ 				}
   /******/ 			}
   /******/ 		};
   /******/ 	})();
   /******/ 	
   /******/ 	/* webpack/runtime/hasOwnProperty shorthand */
   /******/ 	(() => {
   /******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
   /******/ 	})();
   /******/ 	
   /******/ 	/* webpack/runtime/make namespace object */
   /******/ 	(() => {
   /******/ 		// define __esModule on exports
   /******/ 		__webpack_require__.r = (exports) => {
   /******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
   /******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
   /******/ 			}
   /******/ 			Object.defineProperty(exports, '__esModule', { value: true });
   /******/ 		};
   /******/ 	})();
   /******/ 	
   /************************************************************************/
   var __webpack_exports__ = {};
   // This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
   (() => {
   "use strict";
   __webpack_require__.r(__webpack_exports__);
   /* harmony import */ var splitting__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
   /* harmony import */ var splitting__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(splitting__WEBPACK_IMPORTED_MODULE_0__);
   /* harmony import */ var _modules_lenis_controller__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
   /* harmony import */ var _modules_scroll_controller__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10);
   /* harmony import */ var _modules_swiper_controller__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12);
   /* harmony import */ var _modules_video_controller__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14);
   function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
   function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
   function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
   function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
   function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
   function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
   
   
   
   
   
   var main = /*#__PURE__*/function () {
     function main() {
       _classCallCheck(this, main);
       splitting__WEBPACK_IMPORTED_MODULE_0___default()();
       this.root = document.getElementById('lp-gelatopique_star_wars');
       var lenis = new _modules_lenis_controller__WEBPACK_IMPORTED_MODULE_1__["default"]();
       var scrollController = new _modules_scroll_controller__WEBPACK_IMPORTED_MODULE_2__["default"]();
       var swiperController = new _modules_swiper_controller__WEBPACK_IMPORTED_MODULE_3__["default"]();
       var videoController = new _modules_video_controller__WEBPACK_IMPORTED_MODULE_4__["default"]();
       swiperController.init();
       lenis.init();
       this.init();
     }
     return _createClass(main, [{
       key: "init",
       value: function init() {
         this.root.classList.add('loaded');
       }
     }]);
   }();
   window.addEventListener('DOMContentLoaded', function () {
     Promise.resolve(typeof window.__gpInlineStarField === 'function' ? window.__gpInlineStarField() : undefined).then(function () {
       new main();
     });
   });
   })();
   
   /******/ })()
   ;
(function () {
  window.__gpInlineStarField = function inlineStarField() {
    var obj = document.querySelector('#star object.js-color-fill-star');
    if (!obj) return Promise.resolve();
    if (document.querySelector('#star svg.js-color-fill-star')) return Promise.resolve();

    var url = obj.getAttribute('data');
    if (!url) return Promise.resolve();

    return fetch(url, { credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('star-field fetch failed: ' + res.status);
        return res.text();
      })
      .then(function (text) {
        var tpl = document.createElement('template');
        tpl.innerHTML = text.trim();
        var svg = tpl.content.querySelector('svg');
        if (!svg) throw new Error('star-field svg root not found');
        if (!svg.classList.contains('js-color-fill-star')) svg.classList.add('js-color-fill-star');
        svg.setAttribute('aria-hidden', 'true');
        obj.replaceWith(svg);
      })
      .catch(function (err) {
        console.warn('[gp-star-wars] star-field inline failed', err);
      });
  };
})();
